export const espngames2 = [
  {
    "id": 401635525,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-24T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 47998,
    "venueId": 3504,
    "venue": "Aviva Stadium",
    "homeId": 59,
    "homeTeam": "Georgia Tech",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 24,
    "homeLineScores": [
      7,
      7,
      0,
      10
    ],
    "homePostgameWinProbability": 0.9913955304658811,
    "homePregameElo": 1497,
    "homePostgameElo": 1513,
    "awayId": 52,
    "awayTeam": "Florida State",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 21,
    "awayLineScores": [
      8,
      6,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.008604469534118864,
    "awayPregameElo": 1692,
    "awayPostgameElo": 1676,
    "excitementIndex": 7.822223962,
    "highlights": "",
    "notes": "Aer Lingus College Football Classic"
  },
  {
    "id": 401643697,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-24T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 17314,
    "venueId": 3971,
    "venue": "University Stadium (NM)",
    "homeId": 167,
    "homeTeam": "New Mexico",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 31,
    "homeLineScores": [
      10,
      14,
      7,
      0
    ],
    "homePostgameWinProbability": 0.30110066648514766,
    "homePregameElo": 1234,
    "homePostgameElo": 1234,
    "awayId": 147,
    "awayTeam": "Montana State",
    "awayClassification": "fcs",
    "awayConference": "Big Sky",
    "awayPoints": 35,
    "awayLineScores": [
      0,
      14,
      0,
      21
    ],
    "awayPostgameWinProbability": 0.6988993335148523,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.9273181699,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643696,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-25T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 20263,
    "venueId": 3816,
    "venue": "Mackay Stadium",
    "homeId": 2440,
    "homeTeam": "Nevada",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 24,
    "homeLineScores": [
      7,
      10,
      7,
      0
    ],
    "homePostgameWinProbability": 0.1027094743544201,
    "homePregameElo": 1222,
    "homePostgameElo": 1243,
    "awayId": 2567,
    "awayTeam": "SMU",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 29,
    "awayLineScores": [
      0,
      10,
      3,
      16
    ],
    "awayPostgameWinProbability": 0.8972905256455799,
    "awayPregameElo": 1690,
    "awayPostgameElo": 1669,
    "excitementIndex": 7.6714922497,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643858,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-25T03:59:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 12206,
    "venueId": 7220,
    "venue": "Clarence T.C. Ching Athletics Complex",
    "homeId": 62,
    "homeTeam": "Hawai'i",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 35,
    "homeLineScores": [
      14,
      0,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9564689570884497,
    "homePregameElo": 1227,
    "homePostgameElo": 1227,
    "awayId": 2169,
    "awayTeam": "Delaware State",
    "awayClassification": "fcs",
    "awayConference": "MEAC",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      7,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.0435310429115503,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 5.224356278,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628458,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-29T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 47803,
    "venueId": 6577,
    "venue": "SHI Stadium",
    "homeId": 164,
    "homeTeam": "Rutgers",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 44,
    "homeLineScores": [
      7,
      10,
      14,
      13
    ],
    "homePostgameWinProbability": 0.9969831120621432,
    "homePregameElo": 1460,
    "homePostgameElo": 1460,
    "awayId": 47,
    "awayTeam": "Howard",
    "awayClassification": "fcs",
    "awayConference": "MEAC",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.003016887937856816,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.6819518771,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628582,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-29T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 44206,
    "venueId": 3652,
    "venue": "FBC Mortgage Stadium",
    "homeId": 2116,
    "homeTeam": "UCF",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 57,
    "homeLineScores": [
      6,
      23,
      28,
      0
    ],
    "homePostgameWinProbability": 0.9984304429832914,
    "homePregameElo": 1578,
    "homePostgameElo": 1578,
    "awayId": 160,
    "awayTeam": "New Hampshire",
    "awayClassification": "fcs",
    "awayConference": "CAA",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0015695570167085782,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.4992540194,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628581,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-29T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 29450,
    "venueId": 3630,
    "venue": "Allegacy Federal Credit Union Stadium",
    "homeId": 154,
    "homeTeam": "Wake Forest",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 45,
    "homeLineScores": [
      7,
      10,
      21,
      7
    ],
    "homePostgameWinProbability": 0.9025691144714703,
    "homePregameElo": 1431,
    "homePostgameElo": 1431,
    "awayId": 2448,
    "awayTeam": "North Carolina A&T",
    "awayClassification": "fcs",
    "awayConference": "CAA",
    "awayPoints": 13,
    "awayLineScores": [
      7,
      3,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.09743088552852974,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.0055730674,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636387,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-29T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 11145,
    "venueId": 3817,
    "venue": "Malone Stadium",
    "homeId": 2433,
    "homeTeam": "UL Monroe",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 30,
    "homeLineScores": [
      7,
      7,
      7,
      9
    ],
    "homePostgameWinProbability": 0.9698949195350997,
    "homePregameElo": 1156,
    "homePostgameElo": 1156,
    "awayId": 2296,
    "awayTeam": "Jackson State",
    "awayClassification": "fcs",
    "awayConference": "SWAC",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      7,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.030105080464900347,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 6.4645770987,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401634299,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-29T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 56919,
    "venueId": 3670,
    "venue": "Carter-Finley Stadium",
    "homeId": 152,
    "homeTeam": "NC State",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 38,
    "homeLineScores": [
      7,
      7,
      3,
      21
    ],
    "homePostgameWinProbability": 0.9918432913255499,
    "homePregameElo": 1606,
    "homePostgameElo": 1606,
    "awayId": 2717,
    "awayTeam": "Western Carolina",
    "awayClassification": "fcs",
    "awayConference": "Southern",
    "awayPoints": 21,
    "awayLineScores": [
      14,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.008156708674450064,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 7.4610249317,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644727,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-29T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 16400,
    "venueId": 3965,
    "venue": "UB Stadium",
    "homeId": 2084,
    "homeTeam": "Buffalo",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 30,
    "homeLineScores": [
      13,
      3,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9963644776637445,
    "homePregameElo": 1357,
    "homePostgameElo": 1357,
    "awayId": 322,
    "awayTeam": "Lafayette",
    "awayClassification": "fcs",
    "awayConference": "Patriot",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      0,
      6,
      7
    ],
    "awayPostgameWinProbability": 0.0036355223362555256,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.5184667445,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644729,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-29T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 12786,
    "venueId": 3700,
    "venue": "Doyt L. Perry Stadium",
    "homeId": 189,
    "homeTeam": "Bowling Green",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 41,
    "homeLineScores": [
      20,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9928386384421355,
    "homePregameElo": 1431,
    "homePostgameElo": 1431,
    "awayId": 2230,
    "awayTeam": "Fordham",
    "awayClassification": "fcs",
    "awayConference": "Patriot",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      3,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.0071613615578645096,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.6308489164,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644730,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-29T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 18055,
    "venueId": 3786,
    "venue": "Kelly/Shorts Stadium",
    "homeId": 2117,
    "homeTeam": "Central Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 66,
    "homeLineScores": [
      14,
      28,
      24,
      0
    ],
    "homePostgameWinProbability": 0.990740332770375,
    "homePregameElo": 1333,
    "homePostgameElo": 1333,
    "awayId": 2115,
    "awayTeam": "Central Connecticut",
    "awayClassification": "fcs",
    "awayConference": "NEC",
    "awayPoints": 10,
    "awayLineScores": [
      7,
      0,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.009259667229625013,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.5315915573,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644728,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-29T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 23515,
    "venueId": 3739,
    "venue": "Glass Bowl",
    "homeId": 2649,
    "homeTeam": "Toledo",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 49,
    "homeLineScores": [
      21,
      7,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9854090128176071,
    "homePregameElo": 1526,
    "homePostgameElo": 1526,
    "awayId": 2184,
    "awayTeam": "Duquesne",
    "awayClassification": "fcs",
    "awayConference": "NEC",
    "awayPoints": 10,
    "awayLineScores": [
      7,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.014590987182392934,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.6042805247,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628320,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-29T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": false,
    "attendance": 40127,
    "venueId": 3983,
    "venue": "War Memorial Stadium (AR)",
    "homeId": 8,
    "homeTeam": "Arkansas",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 70,
    "homeLineScores": [
      28,
      21,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9989700310726486,
    "homePregameElo": 1454,
    "homePostgameElo": 1454,
    "awayId": 2029,
    "awayTeam": "Arkansas-Pine Bluff",
    "awayClassification": "fcs",
    "awayConference": "SWAC",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.00102996892735141,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.5735528941,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628327,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-30T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 62621,
    "venueId": 3838,
    "venue": "Memorial Stadium",
    "homeId": 142,
    "homeTeam": "Missouri",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 51,
    "homeLineScores": [
      28,
      7,
      10,
      6
    ],
    "homePostgameWinProbability": 0.9989083251415593,
    "homePregameElo": 1744,
    "homePostgameElo": 1744,
    "awayId": 93,
    "awayTeam": "Murray State",
    "awayClassification": "fcs",
    "awayConference": "MVFC",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0010916748584407499,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.1957671965,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628448,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-30T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 50805,
    "venueId": 3953,
    "venue": "Huntington Bank Stadium",
    "homeId": 135,
    "homeTeam": "Minnesota",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 17,
    "homeLineScores": [
      0,
      14,
      0,
      3
    ],
    "homePostgameWinProbability": 0.8741646700190268,
    "homePregameElo": 1492,
    "homePostgameElo": 1492,
    "awayId": 153,
    "awayTeam": "North Carolina",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 19,
    "awayLineScores": [
      0,
      7,
      6,
      6
    ],
    "awayPostgameWinProbability": 0.12583532998097324,
    "awayPregameElo": 1546,
    "awayPostgameElo": 1546,
    "excitementIndex": 8.3966898321,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401634206,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-30T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 49438,
    "venueId": 3726,
    "venue": "Folsom Field",
    "homeId": 38,
    "homeTeam": "Colorado",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 31,
    "homeLineScores": [
      14,
      3,
      7,
      7
    ],
    "homePostgameWinProbability": 0.3704693385585345,
    "homePregameElo": 1324,
    "homePostgameElo": 1324,
    "awayId": 2449,
    "awayTeam": "North Dakota State",
    "awayClassification": "fcs",
    "awayConference": "MVFC",
    "awayPoints": 26,
    "awayLineScores": [
      10,
      10,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.6295306614414655,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 6.0376176228,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636606,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-30T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": false,
    "attendance": 20829,
    "venueId": 3486,
    "venue": "Children's Mercy Park",
    "homeId": 2305,
    "homeTeam": "Kansas",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 48,
    "homeLineScores": [
      7,
      27,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9989701373065328,
    "homePregameElo": 1619,
    "homePostgameElo": 1619,
    "awayId": 2815,
    "awayTeam": "Lindenwood",
    "awayClassification": "fcs",
    "awayConference": "Big South-OVC",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      0,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.001029862693467165,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.001620721,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645317,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-30T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 20143,
    "venueId": 4729,
    "venue": "Yulman Stadium",
    "homeId": 2655,
    "homeTeam": "Tulane",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 52,
    "homeLineScores": [
      7,
      14,
      14,
      17
    ],
    "homePostgameWinProbability": 0.9989668126898874,
    "homePregameElo": 1565,
    "homePostgameElo": 1565,
    "awayId": 2545,
    "awayTeam": "SE Louisiana",
    "awayClassification": "fcs",
    "awayConference": "Southland",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0010331873101125932,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.9545561472,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645318,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-30T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 16483,
    "venueId": 3674,
    "venue": "Chapman Stadium",
    "homeId": 202,
    "homeTeam": "Tulsa",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 62,
    "homeLineScores": [
      14,
      27,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9988522601651243,
    "homePregameElo": 1248,
    "homePostgameElo": 1248,
    "awayId": 2466,
    "awayTeam": "Northwestern State",
    "awayClassification": "fcs",
    "awayConference": "Southland",
    "awayPoints": 28,
    "awayLineScores": [
      14,
      0,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.001147739834875705,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.1619627667,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401640998,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-30T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 18977,
    "venueId": 3662,
    "venue": "AmFirst Stadium",
    "homeId": 55,
    "homeTeam": "Jacksonville State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 27,
    "homeLineScores": [
      3,
      7,
      0,
      17
    ],
    "homePostgameWinProbability": 0.006210418812854204,
    "homePregameElo": 1538,
    "homePostgameElo": 1449,
    "awayId": 324,
    "awayTeam": "Coastal Carolina",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 55,
    "awayLineScores": [
      17,
      14,
      10,
      14
    ],
    "awayPostgameWinProbability": 0.9937895811871458,
    "awayPregameElo": 1448,
    "awayPostgameElo": 1537,
    "excitementIndex": 2.3532792649,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645316,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-30T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 21267,
    "venueId": 7221,
    "venue": "Protective Stadium",
    "homeId": 5,
    "homeTeam": "UAB",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 41,
    "homeLineScores": [
      14,
      14,
      3,
      10
    ],
    "homePostgameWinProbability": 0.998633095814721,
    "homePregameElo": 1363,
    "homePostgameElo": 1363,
    "awayId": 2016,
    "awayTeam": "Alcorn State",
    "awayClassification": "fcs",
    "awayConference": "SWAC",
    "awayPoints": 3,
    "awayLineScores": [
      3,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.001366904185278961,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.2583396559,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401654845,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-30T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 43849,
    "venueId": 3832,
    "venue": "Memorial Stadium (Champaign, IL)",
    "homeId": 356,
    "homeTeam": "Illinois",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 45,
    "homeLineScores": [
      14,
      17,
      7,
      7
    ],
    "homePostgameWinProbability": 0.998775795771694,
    "homePregameElo": 1502,
    "homePostgameElo": 1502,
    "awayId": 2197,
    "awayTeam": "Eastern Illinois",
    "awayClassification": "fcs",
    "awayConference": "Big South-OVC",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0012242042283060472,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.616514081,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636607,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-30T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 52210,
    "venueId": 587,
    "venue": "Rice-Eccles Stadium",
    "homeId": 254,
    "homeTeam": "Utah",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 49,
    "homeLineScores": [
      7,
      28,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9989529148338463,
    "homePregameElo": 1622,
    "homePostgameElo": 1622,
    "awayId": 253,
    "awayTeam": "Southern Utah",
    "awayClassification": "fcs",
    "awayConference": "UAC",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.001047085166153705,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.4892539854,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643698,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-30T02:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 13811,
    "venueId": 3935,
    "venue": "CEFCU Stadium",
    "homeId": 23,
    "homeTeam": "San Jos\u00e9 State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 42,
    "homeLineScores": [
      7,
      7,
      7,
      21
    ],
    "homePostgameWinProbability": 0.9887113561234411,
    "homePregameElo": 1544,
    "homePostgameElo": 1544,
    "awayId": 16,
    "awayTeam": "Sacramento State",
    "awayClassification": "fcs",
    "awayConference": "Big Sky",
    "awayPoints": 24,
    "awayLineScores": [
      14,
      3,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.011288643876558924,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 8.7463456016,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645319,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-30T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 23760,
    "venueId": 3841,
    "venue": "Michie Stadium",
    "homeId": 349,
    "homeTeam": "Army",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 42,
    "homeLineScores": [
      7,
      14,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9979306489300219,
    "homePregameElo": 1425,
    "homePostgameElo": 1425,
    "awayId": 2329,
    "awayTeam": "Lehigh",
    "awayClassification": "fcs",
    "awayConference": "Patriot",
    "awayPoints": 7,
    "awayLineScores": [
      7,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.002069351069978076,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.1009780986,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628453,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-30T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 70271,
    "venueId": 3936,
    "venue": "Spartan Stadium",
    "homeId": 127,
    "homeTeam": "Michigan State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 16,
    "homeLineScores": [
      2,
      14,
      0,
      0
    ],
    "homePostgameWinProbability": 0.8569259339139759,
    "homePregameElo": 1392,
    "homePostgameElo": 1401,
    "awayId": 2226,
    "awayTeam": "Florida Atlantic",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      3,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.14307406608602413,
    "awayPregameElo": 1422,
    "awayPostgameElo": 1413,
    "excitementIndex": 6.7849495035,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628328,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-30T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 83329,
    "venueId": 3835,
    "venue": "Memorial Stadium (Norman, OK)",
    "homeId": 201,
    "homeTeam": "Oklahoma",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 51,
    "homeLineScores": [
      17,
      17,
      3,
      14
    ],
    "homePostgameWinProbability": 0.9967305253633713,
    "homePregameElo": 1786,
    "homePostgameElo": 1849,
    "awayId": 218,
    "awayTeam": "Temple",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      0,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.003269474636628744,
    "awayPregameElo": 1178,
    "awayPostgameElo": 1115,
    "excitementIndex": 2.6725263142,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628584,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-30T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 18466,
    "venueId": 3982,
    "venue": "Wallace Wade Stadium",
    "homeId": 150,
    "homeTeam": "Duke",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 26,
    "homeLineScores": [
      3,
      7,
      9,
      7
    ],
    "homePostgameWinProbability": 0.9964878761250934,
    "homePregameElo": 1602,
    "homePostgameElo": 1602,
    "awayId": 2210,
    "awayTeam": "Elon",
    "awayClassification": "fcs",
    "awayConference": "CAA",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      0,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.0035121238749066253,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.3623822452,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628461,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 75158,
    "venueId": 347,
    "venue": "Camp Randall Stadium",
    "homeId": 275,
    "homeTeam": "Wisconsin",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 28,
    "homeLineScores": [
      0,
      10,
      3,
      15
    ],
    "homePostgameWinProbability": 0.5495450669632155,
    "homePregameElo": 1587,
    "homePostgameElo": 1593,
    "awayId": 2711,
    "awayTeam": "Western Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.4504549330367845,
    "awayPregameElo": 1315,
    "awayPostgameElo": 1309,
    "excitementIndex": 7.098240234,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401634300,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 36026,
    "venueId": 3940,
    "venue": "Stanford Stadium",
    "homeId": 24,
    "homeTeam": "Stanford",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 27,
    "homeLineScores": [
      7,
      10,
      0,
      10
    ],
    "homePostgameWinProbability": 0.10769287584413943,
    "homePregameElo": 1286,
    "homePostgameElo": 1295,
    "awayId": 2628,
    "awayTeam": "TCU",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 34,
    "awayLineScores": [
      7,
      3,
      10,
      14
    ],
    "awayPostgameWinProbability": 0.8923071241558606,
    "awayPregameElo": 1587,
    "awayPostgameElo": 1578,
    "excitementIndex": 9.2635770293,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643703,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T04:00:00.000Z",
    "startTimeTBD": true,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 17037,
    "venueId": 3905,
    "venue": "Maverik Stadium",
    "homeId": 328,
    "homeTeam": "Utah State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 36,
    "homeLineScores": [
      7,
      3,
      10,
      16
    ],
    "homePostgameWinProbability": 0.9971715241134939,
    "homePregameElo": 1346,
    "homePostgameElo": 1346,
    "awayId": 2523,
    "awayTeam": "Robert Morris",
    "awayClassification": "fcs",
    "awayConference": "NEC",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      14,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0028284758865061432,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 6.7617772711,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645322,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 28763,
    "venueId": 3852,
    "venue": "Navy-Marine Corps Memorial Stadium",
    "homeId": 2426,
    "homeTeam": "Navy",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 49,
    "homeLineScores": [
      6,
      22,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9984703617023533,
    "homePregameElo": 1368,
    "homePostgameElo": 1368,
    "awayId": 2083,
    "awayTeam": "Bucknell",
    "awayClassification": "fcs",
    "awayConference": "Patriot",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.0015296382976467404,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.4538485468,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401634305,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 44616,
    "venueId": 3752,
    "venue": "Acrisure Stadium",
    "homeId": 221,
    "homeTeam": "Pittsburgh",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 55,
    "homeLineScores": [
      14,
      14,
      14,
      13
    ],
    "homePostgameWinProbability": 0.9944918416705909,
    "homePregameElo": 1436,
    "homePostgameElo": 1486,
    "awayId": 2309,
    "awayTeam": "Kent State",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      7,
      10,
      0
    ],
    "awayPostgameWinProbability": 0.005508158329409096,
    "awayPregameElo": 1158,
    "awayPostgameElo": 1108,
    "excitementIndex": 4.2275134344,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628333,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": null,
    "venueId": 3973,
    "venue": "FirstBank Stadium",
    "homeId": 238,
    "homeTeam": "Vanderbilt",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 34,
    "homeLineScores": [
      3,
      14,
      3,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9759708097958583,
    "homePregameElo": 1284,
    "homePostgameElo": 1313,
    "awayId": 259,
    "awayTeam": "Virginia Tech",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 27,
    "awayLineScores": [
      0,
      3,
      10,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.024029190204141737,
    "awayPregameElo": 1604,
    "awayPostgameElo": 1575,
    "excitementIndex": 7.7799416184,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628323,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": false,
    "attendance": 78827,
    "venueId": 5348,
    "venue": "Mercedes-Benz Stadium",
    "homeId": 61,
    "homeTeam": "Georgia",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 34,
    "homeLineScores": [
      0,
      6,
      14,
      14
    ],
    "homePostgameWinProbability": 0.996798246718009,
    "homePregameElo": 2015,
    "homePostgameElo": 2066,
    "awayId": 228,
    "awayTeam": "Clemson",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      0,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.0032017532819910155,
    "awayPregameElo": 1676,
    "awayPostgameElo": 1625,
    "excitementIndex": 3.9981808014,
    "highlights": "",
    "notes": "Aflac Kickoff"
  },
  {
    "id": 401634169,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 59488,
    "venueId": 3907,
    "venue": "Ross-Ade Stadium",
    "homeId": 2509,
    "homeTeam": "Purdue",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 49,
    "homeLineScores": [
      7,
      14,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9989614643903625,
    "homePregameElo": 1492,
    "homePostgameElo": 1492,
    "awayId": 282,
    "awayTeam": "Indiana State",
    "awayClassification": "fcs",
    "awayConference": "MVFC",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0010385356096375142,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.120175037,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628450,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 69250,
    "venueId": 3793,
    "venue": "Kinnick Stadium",
    "homeId": 2294,
    "homeTeam": "Iowa",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 40,
    "homeLineScores": [
      3,
      3,
      13,
      21
    ],
    "homePostgameWinProbability": 0.9981064825554675,
    "homePregameElo": 1550,
    "homePostgameElo": 1550,
    "awayId": 2287,
    "awayTeam": "Illinois State",
    "awayClassification": "fcs",
    "awayConference": "MVFC",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0018935174445324776,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.289131329,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628451,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 35421,
    "venueId": 3665,
    "venue": "SECU Stadium",
    "homeId": 120,
    "homeTeam": "Maryland",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 50,
    "homeLineScores": [
      14,
      9,
      13,
      14
    ],
    "homePostgameWinProbability": 0.9988002754401627,
    "homePregameElo": 1630,
    "homePostgameElo": 1703,
    "awayId": 41,
    "awayTeam": "UConn",
    "awayClassification": "fbs",
    "awayConference": "FBS Independents",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.0011997245598373008,
    "awayPregameElo": 1230,
    "awayPostgameElo": 1157,
    "excitementIndex": 3.0293093219,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628457,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 62084,
    "venueId": 3842,
    "venue": "Milan Puskar Stadium",
    "homeId": 277,
    "homeTeam": "West Virginia",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 12,
    "homeLineScores": [
      0,
      6,
      0,
      6
    ],
    "homePostgameWinProbability": 0.0009582824377984128,
    "homePregameElo": 1574,
    "homePostgameElo": 1546,
    "awayId": 213,
    "awayTeam": "Penn State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 34,
    "awayLineScores": [
      0,
      20,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.9990417175622016,
    "awayPregameElo": 1833,
    "awayPostgameElo": 1861,
    "excitementIndex": 3.2059023853,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401632062,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 47067,
    "venueId": 3873,
    "venue": "L&N Federal Credit Union Stadium",
    "homeId": 97,
    "homeTeam": "Louisville",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 62,
    "homeLineScores": [
      10,
      28,
      21,
      3
    ],
    "homePostgameWinProbability": 0.9989252517275378,
    "homePregameElo": 1625,
    "homePostgameElo": 1625,
    "awayId": 2046,
    "awayTeam": "Austin Peay",
    "awayClassification": "fcs",
    "awayConference": "UAC",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0010747482724622337,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.3632203342,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628330,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T16:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 101915,
    "venueId": 3853,
    "venue": "Neyland Stadium",
    "homeId": 2633,
    "homeTeam": "Tennessee",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 69,
    "homeLineScores": [
      24,
      21,
      10,
      14
    ],
    "homePostgameWinProbability": 0.9989676752583595,
    "homePregameElo": 1751,
    "homePostgameElo": 1751,
    "awayId": 236,
    "awayTeam": "Chattanooga",
    "awayClassification": "fcs",
    "awayConference": "Southern",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      0,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.0010323247416405001,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.0752113158,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401634212,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 52202,
    "venueId": 3646,
    "venue": "Boone Pickens Stadium",
    "homeId": 197,
    "homeTeam": "Oklahoma State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 44,
    "homeLineScores": [
      10,
      7,
      21,
      6
    ],
    "homePostgameWinProbability": 0.9918623935187709,
    "homePregameElo": 1522,
    "homePostgameElo": 1522,
    "awayId": 2571,
    "awayTeam": "South Dakota State",
    "awayClassification": "fcs",
    "awayConference": "MVFC",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      6,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.008137606481229076,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.8973240461,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628591,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T18:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 37654,
    "venueId": 3854,
    "venue": "Nippert Stadium",
    "homeId": 2132,
    "homeTeam": "Cincinnati",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 38,
    "homeLineScores": [
      21,
      7,
      10,
      0
    ],
    "homePostgameWinProbability": 0.9988703038356657,
    "homePregameElo": 1394,
    "homePostgameElo": 1394,
    "awayId": 119,
    "awayTeam": "Towson",
    "awayClassification": "fcs",
    "awayConference": "CAA",
    "awayPoints": 20,
    "awayLineScores": [
      3,
      14,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.0011296961643343373,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.0563441295,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401637159,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 20089,
    "venueId": 3820,
    "venue": "Gesa Field",
    "homeId": 265,
    "homeTeam": "Washington State",
    "homeClassification": "fbs",
    "homeConference": "Pac-12",
    "homePoints": 70,
    "homeLineScores": [
      22,
      27,
      14,
      7
    ],
    "homePostgameWinProbability": 0.998969170318451,
    "homePregameElo": 1530,
    "homePostgameElo": 1530,
    "awayId": 2502,
    "awayTeam": "Portland State",
    "awayClassification": "fcs",
    "awayConference": "Big Sky",
    "awayPoints": 30,
    "awayLineScores": [
      7,
      10,
      6,
      7
    ],
    "awayPostgameWinProbability": 0.0010308296815489948,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.9697667045,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628455,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 102011,
    "venueId": 3861,
    "venue": "Ohio Stadium",
    "homeId": 194,
    "homeTeam": "Ohio State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 52,
    "homeLineScores": [
      7,
      10,
      21,
      14
    ],
    "homePostgameWinProbability": 0.9986109107615839,
    "homePregameElo": 1876,
    "homePostgameElo": 1927,
    "awayId": 2006,
    "awayTeam": "Akron",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 6,
    "awayLineScores": [
      3,
      0,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.0013890892384160747,
    "awayPregameElo": 1212,
    "awayPostgameElo": 1161,
    "excitementIndex": 4.3794847589,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628322,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 90544,
    "venueId": 3634,
    "venue": "Ben Hill Griffin Stadium",
    "homeId": 57,
    "homeTeam": "Florida",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 17,
    "homeLineScores": [
      3,
      7,
      0,
      7
    ],
    "homePostgameWinProbability": 0.0005616699198957274,
    "homePregameElo": 1562,
    "homePostgameElo": 1497,
    "awayId": 2390,
    "awayTeam": "Miami",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 41,
    "awayLineScores": [
      7,
      17,
      14,
      3
    ],
    "awayPostgameWinProbability": 0.9994383300801043,
    "awayPregameElo": 1553,
    "awayPostgameElo": 1618,
    "excitementIndex": 2.0699906761,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628449,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 44150,
    "venueId": 3830,
    "venue": "Memorial Stadium (Bloomington, IN)",
    "homeId": 84,
    "homeTeam": "Indiana",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 31,
    "homeLineScores": [
      14,
      7,
      3,
      7
    ],
    "homePostgameWinProbability": 0.9982659319837235,
    "homePregameElo": 1395,
    "homePostgameElo": 1430,
    "awayId": 2229,
    "awayTeam": "Florida International",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0017340680162765132,
    "awayPregameElo": 1164,
    "awayPostgameElo": 1129,
    "excitementIndex": 3.6693137815,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628454,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 86072,
    "venueId": 3834,
    "venue": "Memorial Stadium (Lincoln, NE)",
    "homeId": 158,
    "homeTeam": "Nebraska",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 40,
    "homeLineScores": [
      7,
      23,
      7,
      3
    ],
    "homePostgameWinProbability": 0.9829337715303853,
    "homePregameElo": 1507,
    "homePostgameElo": 1571,
    "awayId": 2638,
    "awayTeam": "UTEP",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 7,
    "awayLineScores": [
      7,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.017066228469614697,
    "awayPregameElo": 1296,
    "awayPostgameElo": 1232,
    "excitementIndex": 3.541056616,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401629039,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 12810,
    "venueId": 3985,
    "venue": "Warren McGuirk Alumni Stadium",
    "homeId": 113,
    "homeTeam": "Massachusetts",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 14,
    "homeLineScores": [
      0,
      0,
      7,
      7
    ],
    "homePostgameWinProbability": 0.20800758182908174,
    "homePregameElo": 1141,
    "homePostgameElo": 1123,
    "awayId": 2199,
    "awayTeam": "Eastern Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 28,
    "awayLineScores": [
      0,
      14,
      3,
      11
    ],
    "awayPostgameWinProbability": 0.7919924181709183,
    "awayPregameElo": 1287,
    "awayPostgameElo": 1305,
    "excitementIndex": 4.0727246661,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401634133,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 36232,
    "venueId": 3792,
    "venue": "Kidd Brewer Stadium",
    "homeId": 2026,
    "homeTeam": "App State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 38,
    "homeLineScores": [
      10,
      7,
      7,
      14
    ],
    "homePostgameWinProbability": 0.8524195016014087,
    "homePregameElo": 1578,
    "homePostgameElo": 1578,
    "awayId": 2193,
    "awayTeam": "East Tennessee State",
    "awayClassification": "fcs",
    "awayConference": "Southern",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      7,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.14758049839859133,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.1701491027,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401634197,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 56148,
    "venueId": 3772,
    "venue": "Jack Trice Stadium",
    "homeId": 66,
    "homeTeam": "Iowa State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 21,
    "homeLineScores": [
      7,
      7,
      0,
      7
    ],
    "homePostgameWinProbability": 0.9926331863922268,
    "homePregameElo": 1612,
    "homePostgameElo": 1612,
    "awayId": 155,
    "awayTeam": "North Dakota",
    "awayClassification": "fcs",
    "awayConference": "MVFC",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.007366813607773248,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 5.4436053185,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401634304,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 37225,
    "venueId": 1964,
    "venue": "JMA Wireless Dome",
    "homeId": 183,
    "homeTeam": "Syracuse",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 38,
    "homeLineScores": [
      0,
      17,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9950656709659383,
    "homePregameElo": 1330,
    "homePostgameElo": 1383,
    "awayId": 195,
    "awayTeam": "Ohio",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 22,
    "awayLineScores": [
      6,
      3,
      7,
      6
    ],
    "awayPostgameWinProbability": 0.0049343290340616575,
    "awayPregameElo": 1522,
    "awayPostgameElo": 1469,
    "excitementIndex": 4.6239333254,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643699,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 31658,
    "venueId": 3713,
    "venue": "Falcon Stadium",
    "homeId": 2005,
    "homeTeam": "Air Force",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 21,
    "homeLineScores": [
      7,
      7,
      0,
      7
    ],
    "homePostgameWinProbability": 0.9455908886537696,
    "homePregameElo": 1572,
    "homePostgameElo": 1572,
    "awayId": 2771,
    "awayTeam": "Merrimack",
    "awayClassification": "fcs",
    "awayConference": "FCS Independents",
    "awayPoints": 6,
    "awayLineScores": [
      0,
      0,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.05440911134623039,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 6.1226509062,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644683,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": false,
    "attendance": 12023,
    "venueId": 5960,
    "venue": "Lanny and Sharon Martin Stadium",
    "homeId": 77,
    "homeTeam": "Northwestern",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 13,
    "homeLineScores": [
      3,
      0,
      7,
      3
    ],
    "homePostgameWinProbability": 0.9619988723257635,
    "homePregameElo": 1498,
    "homePostgameElo": 1514,
    "awayId": 193,
    "awayTeam": "Miami (OH)",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 6,
    "awayLineScores": [
      3,
      0,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.03800112767423647,
    "awayPregameElo": 1506,
    "awayPostgameElo": 1490,
    "excitementIndex": 5.8551319837,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644731,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 10828,
    "venueId": 3764,
    "venue": "Huskie Stadium",
    "homeId": 2459,
    "homeTeam": "Northern Illinois",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 54,
    "homeLineScores": [
      6,
      28,
      13,
      7
    ],
    "homePostgameWinProbability": 0.9989709146104983,
    "homePregameElo": 1446,
    "homePostgameElo": 1446,
    "awayId": 2710,
    "awayTeam": "Western Illinois",
    "awayClassification": "fcs",
    "awayConference": "Big South-OVC",
    "awayPoints": 15,
    "awayLineScores": [
      3,
      0,
      5,
      7
    ],
    "awayPostgameWinProbability": 0.0010290853895017493,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.7345812948,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628331,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 99171,
    "venueId": 3910,
    "venue": "DKR-Texas Memorial Stadium",
    "homeId": 251,
    "homeTeam": "Texas",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 52,
    "homeLineScores": [
      7,
      24,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9985585872365947,
    "homePregameElo": 1850,
    "homePostgameElo": 1939,
    "awayId": 36,
    "awayTeam": "Colorado State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0014414127634052587,
    "awayPregameElo": 1350,
    "awayPostgameElo": 1261,
    "excitementIndex": 2.8170508876,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641015,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 25911,
    "venueId": 3604,
    "venue": "Alamodome",
    "homeId": 2636,
    "homeTeam": "UTSA",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 28,
    "homeLineScores": [
      14,
      7,
      0,
      7
    ],
    "homePostgameWinProbability": 0.9928398385316319,
    "homePregameElo": 1598,
    "homePostgameElo": 1613,
    "awayId": 338,
    "awayTeam": "Kennesaw State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 16,
    "awayLineScores": [
      3,
      3,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.007160161468368065,
    "awayPregameElo": 1500,
    "awayPostgameElo": 1485,
    "excitementIndex": 5.3671875296,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643700,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 24134,
    "venueId": 3608,
    "venue": "Allen E. Paulson Stadium",
    "homeId": 290,
    "homeTeam": "Georgia Southern",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 45,
    "homeLineScores": [
      0,
      16,
      14,
      15
    ],
    "homePostgameWinProbability": 0.00392352239080461,
    "homePregameElo": 1384,
    "homePostgameElo": 1381,
    "awayId": 68,
    "awayTeam": "Boise State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 56,
    "awayLineScores": [
      14,
      14,
      8,
      20
    ],
    "awayPostgameWinProbability": 0.9960764776091954,
    "awayPregameElo": 1626,
    "awayPostgameElo": 1629,
    "excitementIndex": 6.144426114,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628329,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T20:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 78496,
    "venueId": 3994,
    "venue": "Williams-Brice Stadium",
    "homeId": 2579,
    "homeTeam": "South Carolina",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 23,
    "homeLineScores": [
      10,
      3,
      3,
      7
    ],
    "homePostgameWinProbability": 0.8387262463535545,
    "homePregameElo": 1562,
    "homePostgameElo": 1560,
    "awayId": 295,
    "awayTeam": "Old Dominion",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 19,
    "awayLineScores": [
      7,
      0,
      9,
      3
    ],
    "awayPostgameWinProbability": 0.16127375364644547,
    "awayPregameElo": 1406,
    "awayPostgameElo": 1408,
    "excitementIndex": 9.802219213,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401634301,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 32275,
    "venueId": 3831,
    "venue": "California Memorial Stadium",
    "homeId": 25,
    "homeTeam": "California",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 31,
    "homeLineScores": [
      7,
      7,
      10,
      7
    ],
    "homePostgameWinProbability": 0.3995840361236263,
    "homePregameElo": 1483,
    "homePostgameElo": 1483,
    "awayId": 302,
    "awayTeam": "UC Davis",
    "awayClassification": "fcs",
    "awayConference": "Big Sky",
    "awayPoints": 13,
    "awayLineScores": [
      6,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.6004159638763737,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.1654585599,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628590,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 25032,
    "venueId": 3775,
    "venue": "Joan C. Edwards Stadium",
    "homeId": 276,
    "homeTeam": "Marshall",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 45,
    "homeLineScores": [
      7,
      10,
      7,
      21
    ],
    "homePostgameWinProbability": 0.9987033581715669,
    "homePregameElo": 1406,
    "homePostgameElo": 1406,
    "awayId": 2619,
    "awayTeam": "Stony Brook",
    "awayClassification": "fcs",
    "awayConference": "CAA",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      0,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.0012966418284331427,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 5.155172454,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643775,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 15559,
    "venueId": 6526,
    "venue": "Hancock Whitney Stadium",
    "homeId": 6,
    "homeTeam": "South Alabama",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 38,
    "homeLineScores": [
      3,
      16,
      7,
      12
    ],
    "homePostgameWinProbability": 0.2996523883576543,
    "homePregameElo": 1650,
    "homePostgameElo": 1593,
    "awayId": 249,
    "awayTeam": "North Texas",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 52,
    "awayLineScores": [
      7,
      7,
      28,
      10
    ],
    "awayPostgameWinProbability": 0.7003476116423457,
    "awayPregameElo": 1412,
    "awayPostgameElo": 1469,
    "excitementIndex": 5.6675192299,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628589,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 40811,
    "venueId": 3923,
    "venue": "Scott Stadium",
    "homeId": 258,
    "homeTeam": "Virginia",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 34,
    "homeLineScores": [
      17,
      10,
      7,
      0
    ],
    "homePostgameWinProbability": 0.9980843477492788,
    "homePregameElo": 1310,
    "homePostgameElo": 1310,
    "awayId": 257,
    "awayTeam": "Richmond",
    "awayClassification": "fcs",
    "awayConference": "CAA",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      7,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.0019156522507212115,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.7590078828,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628586,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 21573,
    "venueId": 3992,
    "venue": "Williams Stadium (VA)",
    "homeId": 2335,
    "homeTeam": "Liberty",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 41,
    "homeLineScores": [
      7,
      10,
      10,
      14
    ],
    "homePostgameWinProbability": 0.9927279314842183,
    "homePregameElo": 1572,
    "homePostgameElo": 1572,
    "awayId": 2097,
    "awayTeam": "Campbell",
    "awayClassification": "fcs",
    "awayConference": "CAA",
    "awayPoints": 24,
    "awayLineScores": [
      3,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.00727206851578166,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 6.1174720374,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645320,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 36467,
    "venueId": 3699,
    "venue": "Dowdy-Ficklen Stadium",
    "homeId": 151,
    "homeTeam": "East Carolina",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 42,
    "homeLineScores": [
      14,
      14,
      7,
      7
    ],
    "homePostgameWinProbability": 0.996793527864864,
    "homePregameElo": 1404,
    "homePostgameElo": 1404,
    "awayId": 2450,
    "awayTeam": "Norfolk State",
    "awayClassification": "fcs",
    "awayConference": "MEAC",
    "awayPoints": 3,
    "awayLineScores": [
      3,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0032064721351360292,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.9668534019,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628326,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 48724,
    "venueId": 3693,
    "venue": "Davis Wade Stadium",
    "homeId": 344,
    "homeTeam": "Mississippi State",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 56,
    "homeLineScores": [
      14,
      21,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9988566466839199,
    "homePregameElo": 1447,
    "homePostgameElo": 1447,
    "awayId": 2198,
    "awayTeam": "Eastern Kentucky",
    "awayClassification": "fcs",
    "awayConference": "UAC",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0011433533160800646,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.5389409303,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643704,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T22:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 31013,
    "venueId": 3893,
    "venue": "Reser Stadium",
    "homeId": 204,
    "homeTeam": "Oregon State",
    "homeClassification": "fbs",
    "homeConference": "Pac-12",
    "homePoints": 38,
    "homeLineScores": [
      7,
      10,
      14,
      7
    ],
    "homePostgameWinProbability": 0.998356297588382,
    "homePregameElo": 1648,
    "homePostgameElo": 1648,
    "awayId": 304,
    "awayTeam": "Idaho State",
    "awayClassification": "fcs",
    "awayConference": "Big Sky",
    "awayPoints": 15,
    "awayLineScores": [
      9,
      0,
      6,
      0
    ],
    "awayPostgameWinProbability": 0.001643702411618042,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.9860304254,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641023,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 16000,
    "venueId": 3725,
    "venue": "Johnny \"Red\" Floyd Stadium",
    "homeId": 2393,
    "homeTeam": "Middle Tennessee",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 32,
    "homeLineScores": [
      7,
      14,
      0,
      11
    ],
    "homePostgameWinProbability": 0.7402551979282983,
    "homePregameElo": 1400,
    "homePostgameElo": 1400,
    "awayId": 2635,
    "awayTeam": "Tennessee Tech",
    "awayClassification": "fcs",
    "awayConference": "Big South-OVC",
    "awayPoints": 25,
    "awayLineScores": [
      0,
      5,
      6,
      14
    ],
    "awayPostgameWinProbability": 0.2597448020717017,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 5.8962989451,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645321,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 25849,
    "venueId": 3805,
    "venue": "Simmons Bank Liberty Stadium",
    "homeId": 235,
    "homeTeam": "Memphis",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 40,
    "homeLineScores": [
      7,
      24,
      3,
      6
    ],
    "homePostgameWinProbability": 0.9988718236616925,
    "homePregameElo": 1569,
    "homePostgameElo": 1569,
    "awayId": 2453,
    "awayTeam": "North Alabama",
    "awayClassification": "fcs",
    "awayConference": "UAC",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0011281763383075294,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.6543172393,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643701,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 27412,
    "venueId": 3975,
    "venue": "Veterans Memorial Stadium (AL)",
    "homeId": 2653,
    "homeTeam": "Troy",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 26,
    "homeLineScores": [
      7,
      7,
      3,
      9
    ],
    "homePostgameWinProbability": 0.23631786965625518,
    "homePregameElo": 1657,
    "homePostgameElo": 1629,
    "awayId": 2440,
    "awayTeam": "Nevada",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 28,
    "awayLineScores": [
      0,
      6,
      15,
      7
    ],
    "awayPostgameWinProbability": 0.7636821303437449,
    "awayPregameElo": 1243,
    "awayPostgameElo": 1271,
    "excitementIndex": 5.7519487887,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636612,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 51240,
    "venueId": 3636,
    "venue": "Bill Snyder Family Stadium",
    "homeId": 2306,
    "homeTeam": "Kansas State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 41,
    "homeLineScores": [
      14,
      3,
      10,
      14
    ],
    "homePostgameWinProbability": 0.9987372051428841,
    "homePregameElo": 1794,
    "homePostgameElo": 1794,
    "awayId": 2630,
    "awayTeam": "UT Martin",
    "awayClassification": "fcs",
    "awayConference": "Big South-OVC",
    "awayPoints": 6,
    "awayLineScores": [
      0,
      3,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.0012627948571158898,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.5749005334,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628319,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 100077,
    "venueId": 3657,
    "venue": "Bryant-Denny Stadium",
    "homeId": 333,
    "homeTeam": "Alabama",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 63,
    "homeLineScores": [
      21,
      21,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9989712511352644,
    "homePregameElo": 1854,
    "homePostgameElo": 1997,
    "awayId": 98,
    "awayTeam": "Western Kentucky",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0010287488647355847,
    "awayPregameElo": 1466,
    "awayPostgameElo": 1323,
    "excitementIndex": 2.8747278078,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401632064,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 21708,
    "venueId": 3625,
    "venue": "Centennial Bank Stadium",
    "homeId": 2032,
    "homeTeam": "Arkansas State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 34,
    "homeLineScores": [
      6,
      7,
      7,
      14
    ],
    "homePostgameWinProbability": 0.10953996778995322,
    "homePregameElo": 1406,
    "homePostgameElo": 1406,
    "awayId": 2110,
    "awayTeam": "Central Arkansas",
    "awayClassification": "fcs",
    "awayConference": "UAC",
    "awayPoints": 31,
    "awayLineScores": [
      0,
      0,
      10,
      21
    ],
    "awayPostgameWinProbability": 0.8904600322100468,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 7.5174077459,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636363,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": null,
    "venueId": 3886,
    "venue": "Raymond James Stadium",
    "homeId": 58,
    "homeTeam": "South Florida",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 48,
    "homeLineScores": [
      14,
      17,
      17,
      0
    ],
    "homePostgameWinProbability": 0.9988066210712727,
    "homePregameElo": 1442,
    "homePostgameElo": 1442,
    "awayId": 2065,
    "awayTeam": "Bethune-Cookman",
    "awayClassification": "fcs",
    "awayConference": "SWAC",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0011933789287272845,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.4352768308,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636610,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 42272,
    "venueId": 4727,
    "venue": "McLane Stadium",
    "homeId": 239,
    "homeTeam": "Baylor",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 45,
    "homeLineScores": [
      21,
      7,
      7,
      10
    ],
    "homePostgameWinProbability": 0.9981865367574881,
    "homePregameElo": 1422,
    "homePostgameElo": 1422,
    "awayId": 2627,
    "awayTeam": "Tarleton State",
    "awayClassification": "fcs",
    "awayConference": "UAC",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      0,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.001813463242511859,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.2423619189,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636611,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 25750,
    "venueId": 4728,
    "venue": "TDECU Stadium",
    "homeId": 248,
    "homeTeam": "Houston",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 7,
    "homeLineScores": [
      0,
      0,
      0,
      7
    ],
    "homePostgameWinProbability": 0.00044267155029760745,
    "homePregameElo": 1447,
    "homePostgameElo": 1402,
    "awayId": 2439,
    "awayTeam": "UNLV",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 27,
    "awayLineScores": [
      7,
      7,
      10,
      3
    ],
    "awayPostgameWinProbability": 0.9995573284497024,
    "awayPregameElo": 1496,
    "awayPostgameElo": 1541,
    "excitementIndex": 2.6012439626,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628325,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 66105,
    "venueId": 3974,
    "venue": "Vaught-Hemingway Stadium",
    "homeId": 145,
    "homeTeam": "Ole Miss",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 76,
    "homeLineScores": [
      24,
      28,
      21,
      3
    ],
    "homePostgameWinProbability": 0.998970933394839,
    "homePregameElo": 1658,
    "homePostgameElo": 1658,
    "awayId": 231,
    "awayTeam": "Furman",
    "awayClassification": "fcs",
    "awayConference": "Southern",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0010290666051609998,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.3622487127,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641039,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 17298,
    "venueId": 3895,
    "venue": "Rice Stadium",
    "homeId": 242,
    "homeTeam": "Rice",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 14,
    "homeLineScores": [
      0,
      7,
      7,
      0
    ],
    "homePostgameWinProbability": 0.0023638538242473322,
    "homePregameElo": 1362,
    "homePostgameElo": 1314,
    "awayId": 2534,
    "awayTeam": "Sam Houston",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 34,
    "awayLineScores": [
      17,
      7,
      10,
      0
    ],
    "awayPostgameWinProbability": 0.9976361461757527,
    "awayPregameElo": 1388,
    "awayPostgameElo": 1436,
    "excitementIndex": 2.9252659073,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636613,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": null,
    "venueId": 3784,
    "venue": "Jones AT&T Stadium",
    "homeId": 2641,
    "homeTeam": "Texas Tech",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 52,
    "homeLineScores": [
      22,
      10,
      7,
      6,
      7
    ],
    "homePostgameWinProbability": 0.2697185698282507,
    "homePregameElo": 1541,
    "homePostgameElo": 1541,
    "awayId": 2000,
    "awayTeam": "Abilene Christian",
    "awayClassification": "fcs",
    "awayConference": "UAC",
    "awayPoints": 51,
    "awayLineScores": [
      7,
      14,
      7,
      17,
      6
    ],
    "awayPostgameWinProbability": 0.7302814301717493,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 6.7717431708,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628456,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 57435,
    "venueId": 3626,
    "venue": "Autzen Stadium",
    "homeId": 2483,
    "homeTeam": "Oregon",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 24,
    "homeLineScores": [
      7,
      7,
      0,
      10
    ],
    "homePostgameWinProbability": 0.991552038925572,
    "homePregameElo": 1904,
    "homePostgameElo": 1904,
    "awayId": 70,
    "awayTeam": "Idaho",
    "awayClassification": "fcs",
    "awayConference": "Big Sky",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.008447961074428023,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 5.7578449174,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628321,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 88043,
    "venueId": 3785,
    "venue": "Jordan-Hare Stadium",
    "homeId": 2,
    "homeTeam": "Auburn",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 73,
    "homeLineScores": [
      28,
      24,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9989705865931123,
    "homePregameElo": 1556,
    "homePostgameElo": 1556,
    "awayId": 2010,
    "awayTeam": "Alabama A&M",
    "awayClassification": "fcs",
    "awayConference": "SWAC",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0010294134068876692,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 1.80631006,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628459,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 15194,
    "venueId": 7220,
    "venue": "Clarence T.C. Ching Athletics Complex",
    "homeId": 62,
    "homeTeam": "Hawai'i",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 13,
    "homeLineScores": [
      7,
      3,
      3,
      0
    ],
    "homePostgameWinProbability": 0.47610717051073864,
    "homePregameElo": 1227,
    "homePostgameElo": 1242,
    "awayId": 26,
    "awayTeam": "UCLA",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 16,
    "awayLineScores": [
      0,
      0,
      10,
      6
    ],
    "awayPostgameWinProbability": 0.5238928294892613,
    "awayPregameElo": 1568,
    "awayPostgameElo": 1553,
    "excitementIndex": 7.9405032105,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628452,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 110665,
    "venueId": 3558,
    "venue": "Michigan Stadium",
    "homeId": 130,
    "homeTeam": "Michigan",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 30,
    "homeLineScores": [
      7,
      3,
      3,
      17
    ],
    "homePostgameWinProbability": 0.9831756399028116,
    "homePregameElo": 1973,
    "homePostgameElo": 1980,
    "awayId": 278,
    "awayTeam": "Fresno State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      3,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.01682436009718835,
    "awayPregameElo": 1558,
    "awayPostgameElo": 1551,
    "excitementIndex": 5.3344796544,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628332,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": null,
    "venueId": 3795,
    "venue": "Kyle Field",
    "homeId": 245,
    "homeTeam": "Texas A&M",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 13,
    "homeLineScores": [
      3,
      3,
      0,
      7
    ],
    "homePostgameWinProbability": 0.08384600052782992,
    "homePregameElo": 1681,
    "homePostgameElo": 1677,
    "awayId": 87,
    "awayTeam": "Notre Dame",
    "awayClassification": "fbs",
    "awayConference": "FBS Independents",
    "awayPoints": 23,
    "awayLineScores": [
      3,
      3,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.9161539994721701,
    "awayPregameElo": 1884,
    "awayPostgameElo": 1888,
    "excitementIndex": 6.4724625583,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628324,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-08-31T23:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 61627,
    "venueId": 3683,
    "venue": "Kroger Field",
    "homeId": 96,
    "homeTeam": "Kentucky",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 31,
    "homeLineScores": [
      7,
      17,
      7
    ],
    "homePostgameWinProbability": 0.9982728335083515,
    "homePregameElo": 1594,
    "homePostgameElo": 1640,
    "awayId": 2572,
    "awayTeam": "Southern Miss",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0017271664916485019,
    "awayPregameElo": 1276,
    "awayPostgameElo": 1230,
    "excitementIndex": 3.9004694358,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643774,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-09-01T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 15614,
    "venueId": 4418,
    "venue": "Jerry Richardson Stadium",
    "homeId": 2429,
    "homeTeam": "Charlotte",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 7,
    "homeLineScores": [
      0,
      7,
      0,
      0
    ],
    "homePostgameWinProbability": 0.005446284878843067,
    "homePregameElo": 1203,
    "homePostgameElo": 1195,
    "awayId": 256,
    "awayTeam": "James Madison",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 30,
    "awayLineScores": [
      3,
      6,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.994553715121157,
    "awayPregameElo": 1691,
    "awayPostgameElo": 1699,
    "excitementIndex": 3.8697153913,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643702,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-09-01T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 25180,
    "venueId": 7311,
    "venue": "Snapdragon Stadium",
    "homeId": 21,
    "homeTeam": "San Diego State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 45,
    "homeLineScores": [
      3,
      0,
      21,
      21
    ],
    "homePostgameWinProbability": 0.9978571846703512,
    "homePregameElo": 1416,
    "homePostgameElo": 1416,
    "awayId": 2837,
    "awayTeam": "East Texas A&M",
    "awayClassification": "fcs",
    "awayConference": "Southland",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      6,
      8,
      0
    ],
    "awayPostgameWinProbability": 0.002142815329648773,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 5.6614270193,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636380,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-09-01T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 23107,
    "venueId": 3666,
    "venue": "Cajun Field",
    "homeId": 309,
    "homeTeam": "Louisiana",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 40,
    "homeLineScores": [
      7,
      23,
      7,
      3
    ],
    "homePostgameWinProbability": 0.9988776589874298,
    "homePregameElo": 1496,
    "homePostgameElo": 1496,
    "awayId": 2755,
    "awayTeam": "Grambling",
    "awayClassification": "fcs",
    "awayConference": "SWAC",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      0,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.0011223410125702493,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.5698612194,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401634303,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-09-01T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 27080,
    "venueId": 3735,
    "venue": "Gerald J. Ford Stadium",
    "homeId": 2567,
    "homeTeam": "SMU",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 59,
    "homeLineScores": [
      28,
      14,
      7,
      10
    ],
    "homePostgameWinProbability": 0.998969374231022,
    "homePregameElo": 1684,
    "homePostgameElo": 1684,
    "awayId": 2277,
    "awayTeam": "Houston Christian",
    "awayClassification": "fcs",
    "awayConference": "Southland",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0010306257689780551,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.3627806437,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401634240,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-09-01T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 63712,
    "venueId": 3801,
    "venue": "LaVell Edwards Stadium",
    "homeId": 252,
    "homeTeam": "BYU",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 41,
    "homeLineScores": [
      14,
      3,
      14,
      10
    ],
    "homePostgameWinProbability": 0.9980323653718576,
    "homePregameElo": 1409,
    "homePostgameElo": 1409,
    "awayId": 79,
    "awayTeam": "Southern Illinois",
    "awayClassification": "fcs",
    "awayConference": "MVFC",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      6,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.001967634628142423,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 5.4434212792,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401634302,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-09-01T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 40113,
    "venueId": 721,
    "venue": "Bobby Dodd Stadium",
    "homeId": 59,
    "homeTeam": "Georgia Tech",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 35,
    "homeLineScores": [
      7,
      7,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9981187226458276,
    "homePregameElo": 1513,
    "homePostgameElo": 1559,
    "awayId": 2247,
    "awayTeam": "Georgia State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 12,
    "awayLineScores": [
      0,
      3,
      9,
      0
    ],
    "awayPostgameWinProbability": 0.0018812773541724281,
    "awayPregameElo": 1416,
    "awayPostgameElo": 1370,
    "excitementIndex": 4.1428928971,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643776,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-09-01T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 19637,
    "venueId": 3644,
    "venue": "Bobcat Stadium (TX)",
    "homeId": 326,
    "homeTeam": "Texas State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 34,
    "homeLineScores": [
      15,
      3,
      3,
      13
    ],
    "homePostgameWinProbability": 0.9946288599523694,
    "homePregameElo": 1399,
    "homePostgameElo": 1399,
    "awayId": 2320,
    "awayTeam": "Lamar",
    "awayClassification": "fcs",
    "awayConference": "Southland",
    "awayPoints": 27,
    "awayLineScores": [
      0,
      0,
      10,
      17
    ],
    "awayPostgameWinProbability": 0.005371140047630618,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 5.2879661321,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641007,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-09-01T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 16570,
    "venueId": 3776,
    "venue": "Joe Aillet Stadium",
    "homeId": 2348,
    "homeTeam": "Louisiana Tech",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 25,
    "homeLineScores": [
      9,
      6,
      0,
      10
    ],
    "homePostgameWinProbability": 0.9450183889148043,
    "homePregameElo": 1246,
    "homePostgameElo": 1246,
    "awayId": 2447,
    "awayTeam": "Nicholls",
    "awayClassification": "fcs",
    "awayConference": "Southland",
    "awayPoints": 17,
    "awayLineScores": [
      7,
      3,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.054981611085195725,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 8.1544022522,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641032,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-09-01T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 10738,
    "venueId": 3601,
    "venue": "Aggie Memorial Stadium",
    "homeId": 166,
    "homeTeam": "New Mexico State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 23,
    "homeLineScores": [
      0,
      10,
      0,
      13
    ],
    "homePostgameWinProbability": 0.8243471003450671,
    "homePregameElo": 1432,
    "homePostgameElo": 1432,
    "awayId": 2546,
    "awayTeam": "Southeast Missouri State",
    "awayClassification": "fcs",
    "awayConference": "Big South-OVC",
    "awayPoints": 16,
    "awayLineScores": [
      7,
      3,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.17565289965493291,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 9.7322611515,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636609,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-09-01T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 48108,
    "venueId": 3947,
    "venue": "Mountain America Stadium",
    "homeId": 9,
    "homeTeam": "Arizona State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 48,
    "homeLineScores": [
      17,
      10,
      21,
      0
    ],
    "homePostgameWinProbability": 0.9989542679511667,
    "homePregameElo": 1355,
    "homePostgameElo": 1497,
    "awayId": 2751,
    "awayTeam": "Wyoming",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.0010457320488332922,
    "awayPregameElo": 1496,
    "awayPostgameElo": 1354,
    "excitementIndex": 2.7724375138,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636608,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-09-01T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 44748,
    "venueId": 3619,
    "venue": "Arizona Stadium",
    "homeId": 12,
    "homeTeam": "Arizona",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 61,
    "homeLineScores": [
      14,
      13,
      21,
      13
    ],
    "homePostgameWinProbability": 0.9940463387650383,
    "homePregameElo": 1714,
    "homePostgameElo": 1720,
    "awayId": 167,
    "awayTeam": "New Mexico",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 39,
    "awayLineScores": [
      14,
      10,
      7,
      8
    ],
    "awayPostgameWinProbability": 0.00595366123496166,
    "awayPregameElo": 1234,
    "awayPostgameElo": 1228,
    "excitementIndex": 5.3893321194,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628460,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-09-01T03:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 66984,
    "venueId": 3765,
    "venue": "Husky Stadium",
    "homeId": 264,
    "homeTeam": "Washington",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 35,
    "homeLineScores": [
      0,
      14,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9984845341108322,
    "homePregameElo": 1752,
    "homePostgameElo": 1752,
    "awayId": 2692,
    "awayTeam": "Weber State",
    "awayClassification": "fcs",
    "awayConference": "Big Sky",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      0,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.001515465889167844,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.4433315937,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628334,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-09-01T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": false,
    "attendance": 63969,
    "venueId": 6501,
    "venue": "Allegiant Stadium",
    "homeId": 99,
    "homeTeam": "LSU",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 20,
    "homeLineScores": [
      0,
      10,
      7,
      3
    ],
    "homePostgameWinProbability": 0.4234749874329003,
    "homePregameElo": 1823,
    "homePostgameElo": 1803,
    "awayId": 30,
    "awayTeam": "USC",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 27,
    "awayLineScores": [
      0,
      10,
      3,
      14
    ],
    "awayPostgameWinProbability": 0.5765250125670998,
    "awayPregameElo": 1648,
    "awayPostgameElo": 1668,
    "excitementIndex": 6.9147509026,
    "highlights": "",
    "notes": "Modelo Vegas Kickoff Classic"
  },
  {
    "id": 401634306,
    "season": 2024,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2024-09-02T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 51719,
    "venueId": 3697,
    "venue": "Doak Campbell Stadium",
    "homeId": 52,
    "homeTeam": "Florida State",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 13,
    "homeLineScores": [
      0,
      6,
      7,
      0
    ],
    "homePostgameWinProbability": 0.0005637256585448198,
    "homePregameElo": 1676,
    "homePostgameElo": 1610,
    "awayId": 103,
    "awayTeam": "Boston College",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 28,
    "awayLineScores": [
      0,
      14,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.9994362743414552,
    "awayPregameElo": 1396,
    "awayPostgameElo": 1462,
    "excitementIndex": 3.1169184692,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628463,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-06T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 39082,
    "venueId": 3830,
    "venue": "Memorial Stadium (Bloomington, IN)",
    "homeId": 84,
    "homeTeam": "Indiana",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 77,
    "homeLineScores": [
      28,
      14,
      14,
      21
    ],
    "homePostgameWinProbability": 0.9989715517633504,
    "homePregameElo": 1438,
    "homePostgameElo": 1438,
    "awayId": 2710,
    "awayTeam": "Western Illinois",
    "awayClassification": "fcs",
    "awayConference": "Big South-OVC",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.001028448236649604,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.0618410743,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401634765,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-06T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 31172,
    "venueId": 3735,
    "venue": "Gerald J. Ford Stadium",
    "homeId": 2567,
    "homeTeam": "SMU",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 15,
    "homeLineScores": [
      0,
      9,
      3,
      3
    ],
    "homePostgameWinProbability": 0.03912055543029113,
    "homePregameElo": 1669,
    "homePostgameElo": 1648,
    "awayId": 252,
    "awayTeam": "BYU",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 18,
    "awayLineScores": [
      7,
      0,
      8,
      3
    ],
    "awayPostgameWinProbability": 0.9608794445697089,
    "awayPregameElo": 1409,
    "awayPostgameElo": 1430,
    "excitementIndex": 8.4924627245,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635533,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": false,
    "attendance": 11062,
    "venueId": 5960,
    "venue": "Lanny and Sharon Martin Stadium",
    "homeId": 77,
    "homeTeam": "Northwestern",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 20,
    "homeLineScores": [
      3,
      7,
      0,
      3,
      7,
      0
    ],
    "homePostgameWinProbability": 0.15849590116735804,
    "homePregameElo": 1514,
    "homePostgameElo": 1514,
    "awayId": 150,
    "awayTeam": "Duke",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 26,
    "awayLineScores": [
      7,
      0,
      3,
      3,
      7,
      6
    ],
    "awayPostgameWinProbability": 0.841504098832642,
    "awayPregameElo": 1602,
    "awayPostgameElo": 1602,
    "excitementIndex": 9.2114436326,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635538,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 37992,
    "venueId": 3854,
    "venue": "Nippert Stadium",
    "homeId": 2132,
    "homeTeam": "Cincinnati",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 27,
    "homeLineScores": [
      14,
      3,
      10,
      0
    ],
    "homePostgameWinProbability": 0.32614706695662865,
    "homePregameElo": 1394,
    "homePostgameElo": 1397,
    "awayId": 221,
    "awayTeam": "Pittsburgh",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 28,
    "awayLineScores": [
      3,
      3,
      7,
      15
    ],
    "awayPostgameWinProbability": 0.6738529330433713,
    "awayPregameElo": 1486,
    "awayPostgameElo": 1483,
    "excitementIndex": 5.5384302431,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628347,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 111170,
    "venueId": 3558,
    "venue": "Michigan Stadium",
    "homeId": 130,
    "homeTeam": "Michigan",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 12,
    "homeLineScores": [
      0,
      3,
      3,
      6
    ],
    "homePostgameWinProbability": 0.0841280601537834,
    "homePregameElo": 1980,
    "homePostgameElo": 1928,
    "awayId": 251,
    "awayTeam": "Texas",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      17,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.9158719398462166,
    "awayPregameElo": 1939,
    "awayPostgameElo": 1991,
    "excitementIndex": 1.9967699065,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645323,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 21810,
    "venueId": 3715,
    "venue": "FAU Stadium",
    "homeId": 2226,
    "homeTeam": "Florida Atlantic",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 7,
    "homeLineScores": [
      0,
      7,
      0,
      0
    ],
    "homePostgameWinProbability": 0.0013440008178697532,
    "homePregameElo": 1413,
    "homePostgameElo": 1373,
    "awayId": 349,
    "awayTeam": "Army",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 24,
    "awayLineScores": [
      14,
      0,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.9986559991821302,
    "awayPregameElo": 1425,
    "awayPostgameElo": 1465,
    "excitementIndex": 3.0997425534,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628471,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 41021,
    "venueId": 6577,
    "venue": "SHI Stadium",
    "homeId": 164,
    "homeTeam": "Rutgers",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 49,
    "homeLineScores": [
      7,
      14,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9988848023736852,
    "homePregameElo": 1460,
    "homePostgameElo": 1511,
    "awayId": 2006,
    "awayTeam": "Akron",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      3,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.0011151976263148455,
    "awayPregameElo": 1161,
    "awayPostgameElo": 1110,
    "excitementIndex": 4.1757622939,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628466,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 41006,
    "venueId": 3953,
    "venue": "Huntington Bank Stadium",
    "homeId": 135,
    "homeTeam": "Minnesota",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 48,
    "homeLineScores": [
      3,
      14,
      14,
      17
    ],
    "homePostgameWinProbability": 0.9989437664127151,
    "homePregameElo": 1490,
    "homePostgameElo": 1490,
    "awayId": 227,
    "awayTeam": "Rhode Island",
    "awayClassification": "fcs",
    "awayConference": "CAA",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.001056233587284905,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.4773469426,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635534,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 39550,
    "venueId": 1964,
    "venue": "JMA Wireless Dome",
    "homeId": 183,
    "homeTeam": "Syracuse",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 31,
    "homeLineScores": [
      7,
      14,
      3,
      7
    ],
    "homePostgameWinProbability": 0.6174217943538339,
    "homePregameElo": 1383,
    "homePostgameElo": 1386,
    "awayId": 59,
    "awayTeam": "Georgia Tech",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 28,
    "awayLineScores": [
      7,
      7,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.38257820564616607,
    "awayPregameElo": 1559,
    "awayPostgameElo": 1556,
    "excitementIndex": 5.3837781031,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628336,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 52202,
    "venueId": 3646,
    "venue": "Boone Pickens Stadium",
    "homeId": 197,
    "homeTeam": "Oklahoma State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 39,
    "homeLineScores": [
      0,
      7,
      6,
      18,
      0,
      8
    ],
    "homePostgameWinProbability": 0.08043059414355525,
    "homePregameElo": 1522,
    "homePostgameElo": 1530,
    "awayId": 8,
    "awayTeam": "Arkansas",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 31,
    "awayLineScores": [
      14,
      7,
      0,
      10,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.9195694058564448,
    "awayPregameElo": 1454,
    "awayPostgameElo": 1446,
    "excitementIndex": 9.092680782,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636999,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 32351,
    "venueId": 3892,
    "venue": "Pratt & Whitney Stadium",
    "homeId": 41,
    "homeTeam": "UConn",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 63,
    "homeLineScores": [
      35,
      21,
      7,
      0
    ],
    "homePostgameWinProbability": 0.9989708718988313,
    "homePregameElo": 1139,
    "homePostgameElo": 1139,
    "awayId": 2771,
    "awayTeam": "Merrimack",
    "awayClassification": "fcs",
    "awayConference": "FCS Independents",
    "awayPoints": 17,
    "awayLineScores": [
      7,
      0,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.0010291281011687303,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 1.9534937996,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636616,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 25034,
    "venueId": 4729,
    "venue": "Yulman Stadium",
    "homeId": 2655,
    "homeTeam": "Tulane",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 27,
    "homeLineScores": [
      7,
      13,
      0,
      7
    ],
    "homePostgameWinProbability": 0.38751456710504545,
    "homePregameElo": 1565,
    "homePostgameElo": 1569,
    "awayId": 2306,
    "awayTeam": "Kansas State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 34,
    "awayLineScores": [
      3,
      7,
      10,
      14
    ],
    "awayPostgameWinProbability": 0.6124854328949545,
    "awayPregameElo": 1794,
    "awayPostgameElo": 1790,
    "excitementIndex": 7.0148296845,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628470,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 103861,
    "venueId": 3632,
    "venue": "Beaver Stadium",
    "homeId": 213,
    "homeTeam": "Penn State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 34,
    "homeLineScores": [
      7,
      13,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9428297745600484,
    "homePregameElo": 1861,
    "homePostgameElo": 1848,
    "awayId": 189,
    "awayTeam": "Bowling Green",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 27,
    "awayLineScores": [
      10,
      14,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.05717022543995165,
    "awayPregameElo": 1431,
    "awayPostgameElo": 1444,
    "excitementIndex": 6.8874767798,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643784,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 23246,
    "venueId": 3805,
    "venue": "Simmons Bank Liberty Stadium",
    "homeId": 235,
    "homeTeam": "Memphis",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 38,
    "homeLineScores": [
      7,
      14,
      10,
      7
    ],
    "homePostgameWinProbability": 0.5229575853281864,
    "homePregameElo": 1569,
    "homePostgameElo": 1625,
    "awayId": 2653,
    "awayTeam": "Troy",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      7,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.47704241467181363,
    "awayPregameElo": 1629,
    "awayPostgameElo": 1573,
    "excitementIndex": 3.6702839464,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628348,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T16:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 92345,
    "venueId": 3795,
    "venue": "Kyle Field",
    "homeId": 245,
    "homeTeam": "Texas A&M",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 52,
    "homeLineScores": [
      14,
      24,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9989583103364718,
    "homePregameElo": 1666,
    "homePostgameElo": 1666,
    "awayId": 2377,
    "awayTeam": "McNeese",
    "awayClassification": "fcs",
    "awayConference": "Southland",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      0,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.0010416896635282447,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.0495368455,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628339,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 93033,
    "venueId": 3917,
    "venue": "Sanford Stadium",
    "homeId": 61,
    "homeTeam": "Georgia",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 48,
    "homeLineScores": [
      14,
      10,
      21,
      3
    ],
    "homePostgameWinProbability": 0.998904318902456,
    "homePregameElo": 2079,
    "homePostgameElo": 2079,
    "awayId": 2635,
    "awayTeam": "Tennessee Tech",
    "awayClassification": "fcs",
    "awayConference": "Big South-OVC",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      0,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.001095681097543988,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.6404091014,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401634181,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 10018,
    "venueId": 3919,
    "venue": "Scheumann Stadium",
    "homeId": 2050,
    "homeTeam": "Ball State",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 42,
    "homeLineScores": [
      0,
      7,
      7,
      28
    ],
    "homePostgameWinProbability": 0.6619454952329824,
    "homePregameElo": 1341,
    "homePostgameElo": 1341,
    "awayId": 2623,
    "awayTeam": "Missouri State",
    "awayClassification": "fcs",
    "awayConference": "MVFC",
    "awayPoints": 34,
    "awayLineScores": [
      7,
      0,
      7,
      20
    ],
    "awayPostgameWinProbability": 0.3380545047670176,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 6.7901448981,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644732,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T18:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 11585,
    "venueId": 3696,
    "venue": "Dix Stadium",
    "homeId": 2309,
    "homeTeam": "Kent State",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 17,
    "homeLineScores": [
      0,
      14,
      0,
      3
    ],
    "homePostgameWinProbability": 0.008957524777763516,
    "homePregameElo": 1096,
    "homePostgameElo": 1096,
    "awayId": 2598,
    "awayTeam": "St. Francis (PA)",
    "awayClassification": "fcs",
    "awayConference": "NEC",
    "awayPoints": 23,
    "awayLineScores": [
      10,
      10,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.9910424752222364,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.3403909128,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401632071,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 24512,
    "venueId": 6501,
    "venue": "Allegiant Stadium",
    "homeId": 2439,
    "homeTeam": "UNLV",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 72,
    "homeLineScores": [
      28,
      16,
      7,
      21
    ],
    "homePostgameWinProbability": 0.9988876075327624,
    "homePregameElo": 1548,
    "homePostgameElo": 1548,
    "awayId": 3101,
    "awayTeam": "Utah Tech",
    "awayClassification": "fcs",
    "awayConference": "UAC",
    "awayPoints": 14,
    "awayLineScores": [
      7,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.0011123924672375995,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.2093969375,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628340,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 61349,
    "venueId": 3683,
    "venue": "Kroger Field",
    "homeId": 96,
    "homeTeam": "Kentucky",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 6,
    "homeLineScores": [
      0,
      6,
      0,
      0
    ],
    "homePostgameWinProbability": 0.006082209207821032,
    "homePregameElo": 1640,
    "homePostgameElo": 1563,
    "awayId": 2579,
    "awayTeam": "South Carolina",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      3,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.993917790792179,
    "awayPregameElo": 1560,
    "awayPostgameElo": 1637,
    "excitementIndex": 3.9452995446,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643710,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 25070,
    "venueId": 3984,
    "venue": "War Memorial Stadium",
    "homeId": 2751,
    "homeTeam": "Wyoming",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 13,
    "homeLineScores": [
      10,
      0,
      0,
      3
    ],
    "homePostgameWinProbability": 0.4178541664492569,
    "homePregameElo": 1369,
    "homePostgameElo": 1369,
    "awayId": 70,
    "awayTeam": "Idaho",
    "awayClassification": "fcs",
    "awayConference": "Big Sky",
    "awayPoints": 17,
    "awayLineScores": [
      7,
      10,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.5821458335507431,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 7.4414261271,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628474,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 76069,
    "venueId": 347,
    "venue": "Camp Randall Stadium",
    "homeId": 275,
    "homeTeam": "Wisconsin",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 27,
    "homeLineScores": [
      14,
      3,
      3,
      7
    ],
    "homePostgameWinProbability": 0.9941188593552427,
    "homePregameElo": 1601,
    "homePostgameElo": 1601,
    "awayId": 233,
    "awayTeam": "South Dakota",
    "awayClassification": "fcs",
    "awayConference": "MVFC",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      3,
      10,
      0
    ],
    "awayPostgameWinProbability": 0.00588114064475731,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 5.4936784051,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628337,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 88043,
    "venueId": 3785,
    "venue": "Jordan-Hare Stadium",
    "homeId": 2,
    "homeTeam": "Auburn",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 14,
    "homeLineScores": [
      7,
      0,
      0,
      7
    ],
    "homePostgameWinProbability": 0.2525169316190977,
    "homePregameElo": 1556,
    "homePostgameElo": 1537,
    "awayId": 25,
    "awayTeam": "California",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.7474830683809023,
    "awayPregameElo": 1483,
    "awayPostgameElo": 1502,
    "excitementIndex": 6.8038045019,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645324,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 28889,
    "venueId": 3852,
    "venue": "Navy-Marine Corps Memorial Stadium",
    "homeId": 2426,
    "homeTeam": "Navy",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 38,
    "homeLineScores": [
      9,
      14,
      15,
      0
    ],
    "homePostgameWinProbability": 0.9989039411338847,
    "homePregameElo": 1368,
    "homePostgameElo": 1409,
    "awayId": 218,
    "awayTeam": "Temple",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 11,
    "awayLineScores": [
      0,
      3,
      0,
      8
    ],
    "awayPostgameWinProbability": 0.0010960588661153015,
    "awayPregameElo": 1115,
    "awayPostgameElo": 1074,
    "excitementIndex": 3.0955029612,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401629040,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 21668,
    "venueId": 3739,
    "venue": "Glass Bowl",
    "homeId": 2649,
    "homeTeam": "Toledo",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 38,
    "homeLineScores": [
      7,
      10,
      7,
      14
    ],
    "homePostgameWinProbability": 0.09479990994041462,
    "homePregameElo": 1526,
    "homePostgameElo": 1524,
    "awayId": 113,
    "awayTeam": "Massachusetts",
    "awayClassification": "fbs",
    "awayConference": "FBS Independents",
    "awayPoints": 23,
    "awayLineScores": [
      0,
      13,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.9052000900595853,
    "awayPregameElo": 1123,
    "awayPostgameElo": 1125,
    "excitementIndex": 6.6782431738,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635537,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 48431,
    "venueId": 3787,
    "venue": "Kenan Stadium",
    "homeId": 153,
    "homeTeam": "North Carolina",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 38,
    "homeLineScores": [
      14,
      7,
      10,
      7
    ],
    "homePostgameWinProbability": 0.9740641077075093,
    "homePregameElo": 1546,
    "homePostgameElo": 1554,
    "awayId": 2429,
    "awayTeam": "Charlotte",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 20,
    "awayLineScores": [
      3,
      3,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.025935892292490714,
    "awayPregameElo": 1195,
    "awayPostgameElo": 1187,
    "excitementIndex": 3.6549153501,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635531,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 38441,
    "venueId": 3615,
    "venue": "Alumni Stadium (Chestnut Hill, MA)",
    "homeId": 103,
    "homeTeam": "Boston College",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 56,
    "homeLineScores": [
      14,
      28,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9989714428938834,
    "homePregameElo": 1450,
    "homePostgameElo": 1450,
    "awayId": 2184,
    "awayTeam": "Duquesne",
    "awayClassification": "fcs",
    "awayConference": "NEC",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.001028557106116601,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.4533237493,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628473,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 64222,
    "venueId": 3765,
    "venue": "Husky Stadium",
    "homeId": 264,
    "homeTeam": "Washington",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 30,
    "homeLineScores": [
      0,
      21,
      9,
      0
    ],
    "homePostgameWinProbability": 0.998969852945677,
    "homePregameElo": 1752,
    "homePostgameElo": 1759,
    "awayId": 2199,
    "awayTeam": "Eastern Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 9,
    "awayLineScores": [
      3,
      3,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.0010301470543230273,
    "awayPregameElo": 1305,
    "awayPostgameElo": 1298,
    "excitementIndex": 4.1592743707,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636618,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 52827,
    "venueId": 587,
    "venue": "Rice-Eccles Stadium",
    "homeId": 254,
    "homeTeam": "Utah",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 23,
    "homeLineScores": [
      17,
      6,
      0,
      0
    ],
    "homePostgameWinProbability": 0.8942028336702575,
    "homePregameElo": 1622,
    "homePostgameElo": 1627,
    "awayId": 239,
    "awayTeam": "Baylor",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 12,
    "awayLineScores": [
      0,
      3,
      9,
      0
    ],
    "awayPostgameWinProbability": 0.10579716632974245,
    "awayPregameElo": 1422,
    "awayPostgameElo": 1417,
    "excitementIndex": 3.4697381845,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628464,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 69250,
    "venueId": 3793,
    "venue": "Kinnick Stadium",
    "homeId": 2294,
    "homeTeam": "Iowa",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 19,
    "homeLineScores": [
      7,
      6,
      6,
      0
    ],
    "homePostgameWinProbability": 0.22468274134511054,
    "homePregameElo": 1550,
    "homePostgameElo": 1552,
    "awayId": 66,
    "awayTeam": "Iowa State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      0,
      14,
      6
    ],
    "awayPostgameWinProbability": 0.7753172586548894,
    "awayPregameElo": 1612,
    "awayPostgameElo": 1610,
    "excitementIndex": 8.5704413795,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628977,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 77622,
    "venueId": 3855,
    "venue": "Notre Dame Stadium",
    "homeId": 87,
    "homeTeam": "Notre Dame",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 14,
    "homeLineScores": [
      7,
      0,
      7,
      0
    ],
    "homePostgameWinProbability": 0.22276720328304617,
    "homePregameElo": 1888,
    "homePostgameElo": 1858,
    "awayId": 2459,
    "awayTeam": "Northern Illinois",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 16,
    "awayLineScores": [
      10,
      3,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.7772327967169539,
    "awayPregameElo": 1446,
    "awayPostgameElo": 1476,
    "excitementIndex": 4.9100949395,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635535,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 48575,
    "venueId": 3873,
    "venue": "L&N Federal Credit Union Stadium",
    "homeId": 97,
    "homeTeam": "Louisville",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 49,
    "homeLineScores": [
      14,
      14,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9977026560763437,
    "homePregameElo": 1625,
    "homePostgameElo": 1700,
    "awayId": 55,
    "awayTeam": "Jacksonville State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      14,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0022973439236563253,
    "awayPregameElo": 1449,
    "awayPostgameElo": 1374,
    "excitementIndex": 3.1667549545,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628465,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 34819,
    "venueId": 3665,
    "venue": "SECU Stadium",
    "homeId": 120,
    "homeTeam": "Maryland",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 24,
    "homeLineScores": [
      14,
      0,
      3,
      7
    ],
    "homePostgameWinProbability": 0.5134079056281101,
    "homePregameElo": 1703,
    "homePostgameElo": 1679,
    "awayId": 127,
    "awayTeam": "Michigan State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 27,
    "awayLineScores": [
      7,
      10,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.4865920943718899,
    "awayPregameElo": 1401,
    "awayPostgameElo": 1425,
    "excitementIndex": 8.2782012973,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643783,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 28000,
    "venueId": 3644,
    "venue": "Bobcat Stadium (TX)",
    "homeId": 326,
    "homeTeam": "Texas State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 49,
    "homeLineScores": [
      14,
      21,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9975383777137619,
    "homePregameElo": 1399,
    "homePostgameElo": 1545,
    "awayId": 2636,
    "awayTeam": "UTSA",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 10,
    "awayLineScores": [
      3,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.002461622286238141,
    "awayPregameElo": 1613,
    "awayPostgameElo": 1467,
    "excitementIndex": 3.5916870101,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628342,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T20:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 66427,
    "venueId": 3974,
    "venue": "Vaught-Hemingway Stadium",
    "homeId": 145,
    "homeTeam": "Ole Miss",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 52,
    "homeLineScores": [
      17,
      14,
      14,
      7
    ],
    "homePostgameWinProbability": 0.998968017794867,
    "homePregameElo": 1658,
    "homePostgameElo": 1770,
    "awayId": 2393,
    "awayTeam": "Middle Tennessee",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0010319822051330085,
    "awayPregameElo": 1400,
    "awayPostgameElo": 1288,
    "excitementIndex": 2.6354142701,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635540,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 65632,
    "venueId": 3799,
    "venue": "Lane Stadium",
    "homeId": 259,
    "homeTeam": "Virginia Tech",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 31,
    "homeLineScores": [
      7,
      3,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9846356534773444,
    "homePregameElo": 1575,
    "homePostgameElo": 1597,
    "awayId": 276,
    "awayTeam": "Marshall",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      7,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.015364346522655614,
    "awayPregameElo": 1406,
    "awayPostgameElo": 1384,
    "excitementIndex": 7.6305171105,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401640979,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": false,
    "attendance": 17852,
    "venueId": 2031,
    "venue": "Pitbull Stadium",
    "homeId": 2229,
    "homeTeam": "Florida International",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 52,
    "homeLineScores": [
      7,
      21,
      8,
      16
    ],
    "homePostgameWinProbability": 0.9818650371377727,
    "homePregameElo": 1129,
    "homePostgameElo": 1271,
    "awayId": 2117,
    "awayTeam": "Central Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 16,
    "awayLineScores": [
      0,
      8,
      8,
      0
    ],
    "awayPostgameWinProbability": 0.018134962862227266,
    "awayPregameElo": 1333,
    "awayPostgameElo": 1191,
    "excitementIndex": 3.3654068296,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643778,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 21944,
    "venueId": 3918,
    "venue": "S.B. Ballard Stadium",
    "homeId": 295,
    "homeTeam": "Old Dominion",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 14,
    "homeLineScores": [
      0,
      7,
      7,
      0
    ],
    "homePostgameWinProbability": 0.26672239131813047,
    "homePregameElo": 1408,
    "homePostgameElo": 1397,
    "awayId": 151,
    "awayTeam": "East Carolina",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 20,
    "awayLineScores": [
      6,
      0,
      11,
      3
    ],
    "awayPostgameWinProbability": 0.7332776086818695,
    "awayPregameElo": 1404,
    "awayPostgameElo": 1415,
    "excitementIndex": 7.2626005857,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643777,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 24570,
    "venueId": 3651,
    "venue": "Bridgeforth Stadium",
    "homeId": 256,
    "homeTeam": "James Madison",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 13,
    "homeLineScores": [
      0,
      0,
      10,
      3
    ],
    "homePostgameWinProbability": 0.906606081446229,
    "homePregameElo": 1728,
    "homePostgameElo": 1728,
    "awayId": 2241,
    "awayTeam": "Gardner-Webb",
    "awayClassification": "fcs",
    "awayConference": "Big South-OVC",
    "awayPoints": 6,
    "awayLineScores": [
      0,
      3,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.093393918553771,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 5.9057896435,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635536,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 57886,
    "venueId": 3948,
    "venue": "Hard Rock Stadium",
    "homeId": 2390,
    "homeTeam": "Miami",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 56,
    "homeLineScores": [
      15,
      10,
      21,
      10
    ],
    "homePostgameWinProbability": 0.9989304485305625,
    "homePregameElo": 1622,
    "homePostgameElo": 1622,
    "awayId": 50,
    "awayTeam": "Florida A&M",
    "awayClassification": "fcs",
    "awayConference": "SWAC",
    "awayPoints": 9,
    "awayLineScores": [
      3,
      3,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.0010695514694375463,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.8571338182,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643781,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 22158,
    "venueId": 3876,
    "venue": "Peden Stadium",
    "homeId": 195,
    "homeTeam": "Ohio",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 27,
    "homeLineScores": [
      3,
      14,
      7,
      3
    ],
    "homePostgameWinProbability": 0.9525876837264748,
    "homePregameElo": 1469,
    "homePostgameElo": 1486,
    "awayId": 6,
    "awayTeam": "South Alabama",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      10,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.04741231627352516,
    "awayPregameElo": 1593,
    "awayPostgameElo": 1576,
    "excitementIndex": 8.6579097653,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628593,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 50073,
    "venueId": 3842,
    "venue": "Milan Puskar Stadium",
    "homeId": 277,
    "homeTeam": "West Virginia",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 49,
    "homeLineScores": [
      14,
      14,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9986585303886906,
    "homePregameElo": 1527,
    "homePostgameElo": 1527,
    "awayId": 399,
    "awayTeam": "UAlbany",
    "awayClassification": "fcs",
    "awayConference": "CAA",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      14,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0013414696113094315,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.4196493042,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636617,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T22:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 43807,
    "venueId": 3652,
    "venue": "FBC Mortgage Stadium",
    "homeId": 2116,
    "homeTeam": "UCF",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 45,
    "homeLineScores": [
      14,
      10,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9984675152867405,
    "homePregameElo": 1578,
    "homePostgameElo": 1644,
    "awayId": 2534,
    "awayTeam": "Sam Houston",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.0015324847132595076,
    "awayPregameElo": 1436,
    "awayPostgameElo": 1370,
    "excitementIndex": 3.2004794485,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643779,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 19316,
    "venueId": 3625,
    "venue": "Centennial Bank Stadium",
    "homeId": 2032,
    "homeTeam": "Arkansas State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 28,
    "homeLineScores": [
      7,
      0,
      21,
      0
    ],
    "homePostgameWinProbability": 0.682684313677518,
    "homePregameElo": 1406,
    "homePostgameElo": 1404,
    "awayId": 202,
    "awayTeam": "Tulsa",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 24,
    "awayLineScores": [
      3,
      14,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.31731568632248197,
    "awayPregameElo": 1248,
    "awayPostgameElo": 1250,
    "excitementIndex": 6.3543485401,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628335,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 100077,
    "venueId": 3657,
    "venue": "Bryant-Denny Stadium",
    "homeId": 333,
    "homeTeam": "Alabama",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 42,
    "homeLineScores": [
      7,
      7,
      0,
      28
    ],
    "homePostgameWinProbability": 0.9964872219835206,
    "homePregameElo": 1997,
    "homePostgameElo": 2006,
    "awayId": 58,
    "awayTeam": "South Florida",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 16,
    "awayLineScores": [
      3,
      3,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.003512778016479423,
    "awayPregameElo": 1442,
    "awayPostgameElo": 1433,
    "excitementIndex": 8.3492231748,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628462,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 60670,
    "venueId": 3832,
    "venue": "Memorial Stadium (Champaign, IL)",
    "homeId": 356,
    "homeTeam": "Illinois",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 23,
    "homeLineScores": [
      3,
      10,
      0,
      10
    ],
    "homePostgameWinProbability": 0.7973976238859617,
    "homePregameElo": 1502,
    "homePostgameElo": 1515,
    "awayId": 2305,
    "awayTeam": "Kansas",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      10,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.2026023761140383,
    "awayPregameElo": 1619,
    "awayPostgameElo": 1606,
    "excitementIndex": 7.4772522448,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643782,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 22044,
    "venueId": 3815,
    "venue": "M. M. Roberts Stadium",
    "homeId": 2572,
    "homeTeam": "Southern Miss",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 35,
    "homeLineScores": [
      7,
      7,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9977096872842911,
    "homePregameElo": 1217,
    "homePostgameElo": 1217,
    "awayId": 2545,
    "awayTeam": "SE Louisiana",
    "awayClassification": "fcs",
    "awayConference": "Southland",
    "awayPoints": 10,
    "awayLineScores": [
      3,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0022903127157088976,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 7.8335681557,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628338,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 89295,
    "venueId": 3634,
    "venue": "Ben Hill Griffin Stadium",
    "homeId": 57,
    "homeTeam": "Florida",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 45,
    "homeLineScores": [
      7,
      7,
      14,
      17
    ],
    "homePostgameWinProbability": 0.9986559089730632,
    "homePregameElo": 1493,
    "homePostgameElo": 1493,
    "awayId": 2535,
    "awayTeam": "Samford",
    "awayClassification": "fcs",
    "awayConference": "Southern",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.0013440910269367778,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.9831706488,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643705,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 22478,
    "venueId": 3713,
    "venue": "Falcon Stadium",
    "homeId": 2005,
    "homeTeam": "Air Force",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 7,
    "homeLineScores": [
      7,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0.27425759677110456,
    "homePregameElo": 1572,
    "homePostgameElo": 1549,
    "awayId": 23,
    "awayTeam": "San Jos\u00e9 State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 17,
    "awayLineScores": [
      14,
      0,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.7257424032288955,
    "awayPregameElo": 1544,
    "awayPostgameElo": 1567,
    "excitementIndex": 3.6614362236,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643780,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 12327,
    "venueId": 3817,
    "venue": "Malone Stadium",
    "homeId": 2433,
    "homeTeam": "UL Monroe",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 32,
    "homeLineScores": [
      3,
      10,
      9,
      10
    ],
    "homePostgameWinProbability": 0.9604075852198672,
    "homePregameElo": 1156,
    "homePostgameElo": 1249,
    "awayId": 5,
    "awayTeam": "UAB",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 6,
    "awayLineScores": [
      3,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.039592414780132756,
    "awayPregameElo": 1363,
    "awayPostgameElo": 1270,
    "excitementIndex": 6.1979403345,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641016,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 11040,
    "venueId": 4899,
    "venue": "Fifth Third Stadium",
    "homeId": 338,
    "homeTeam": "Kennesaw State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 10,
    "homeLineScores": [
      7,
      0,
      0,
      3
    ],
    "homePostgameWinProbability": 0.12064797831540046,
    "homePregameElo": 1485,
    "homePostgameElo": 1423,
    "awayId": 309,
    "awayTeam": "Louisiana",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 34,
    "awayLineScores": [
      0,
      20,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.8793520216845996,
    "awayPregameElo": 1496,
    "awayPostgameElo": 1558,
    "excitementIndex": 2.8462981643,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401632459,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": null,
    "venueId": 4246,
    "venue": "Center Parc Stadium",
    "homeId": 2247,
    "homeTeam": "Georgia State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 24,
    "homeLineScores": [
      3,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.41424415119961694,
    "homePregameElo": 1369,
    "homePostgameElo": 1369,
    "awayId": 236,
    "awayTeam": "Chattanooga",
    "awayClassification": "fcs",
    "awayConference": "Southern",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.5857558488003831,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 9.3852508068,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645326,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 17760,
    "venueId": 3895,
    "venue": "Rice Stadium",
    "homeId": 242,
    "homeTeam": "Rice",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 69,
    "homeLineScores": [
      14,
      24,
      17,
      14
    ],
    "homePostgameWinProbability": 0.9989284541501057,
    "homePregameElo": 1309,
    "homePostgameElo": 1309,
    "awayId": 2640,
    "awayTeam": "Texas Southern",
    "awayClassification": "fcs",
    "awayConference": "SWAC",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.0010715458498943287,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.2984714394,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643708,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 16245,
    "venueId": 3816,
    "venue": "Mackay Stadium",
    "homeId": 2440,
    "homeTeam": "Nevada",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 17,
    "homeLineScores": [
      14,
      0,
      3,
      0
    ],
    "homePostgameWinProbability": 0.9877788748907659,
    "homePregameElo": 1271,
    "homePostgameElo": 1273,
    "awayId": 290,
    "awayTeam": "Georgia Southern",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 20,
    "awayLineScores": [
      7,
      10,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.012221125109234121,
    "awayPregameElo": 1381,
    "awayPostgameElo": 1379,
    "excitementIndex": 7.3547409027,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401632068,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 16712,
    "venueId": 3796,
    "venue": "Houchens Industries-L.T. Smith Stadium",
    "homeId": 98,
    "homeTeam": "Western Kentucky",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 31,
    "homeLineScores": [
      10,
      7,
      0,
      14
    ],
    "homePostgameWinProbability": 0.37641387441259805,
    "homePregameElo": 1307,
    "homePostgameElo": 1307,
    "awayId": 2198,
    "awayTeam": "Eastern Kentucky",
    "awayClassification": "fcs",
    "awayConference": "UAC",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.623586125587402,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.9055538496,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635639,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 30012,
    "venueId": 3630,
    "venue": "Allegacy Federal Credit Union Stadium",
    "homeId": 154,
    "homeTeam": "Wake Forest",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 30,
    "homeLineScores": [
      10,
      10,
      10,
      0
    ],
    "homePostgameWinProbability": 0.3231116289522079,
    "homePregameElo": 1431,
    "homePostgameElo": 1424,
    "awayId": 258,
    "awayTeam": "Virginia",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 31,
    "awayLineScores": [
      3,
      14,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.6768883710477921,
    "awayPregameElo": 1310,
    "awayPostgameElo": 1317,
    "excitementIndex": 6.5433888584,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643706,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 36573,
    "venueId": 5388,
    "venue": "Canvas Stadium",
    "homeId": 36,
    "homeTeam": "Colorado State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 38,
    "homeLineScores": [
      10,
      14,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9654344872118603,
    "homePregameElo": 1237,
    "homePostgameElo": 1237,
    "awayId": 2458,
    "awayTeam": "Northern Colorado",
    "awayClassification": "fcs",
    "awayConference": "Big Sky",
    "awayPoints": 17,
    "awayLineScores": [
      7,
      0,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.034565512788139685,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.5437808258,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635539,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 22634,
    "venueId": 3940,
    "venue": "Stanford Stadium",
    "homeId": 24,
    "homeTeam": "Stanford",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 41,
    "homeLineScores": [
      7,
      7,
      17,
      10
    ],
    "homePostgameWinProbability": 0.9791731264428654,
    "homePregameElo": 1282,
    "homePostgameElo": 1282,
    "awayId": 13,
    "awayTeam": "Cal Poly",
    "awayClassification": "fcs",
    "awayConference": "Big Sky",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.02082687355713464,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.1003165447,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628603,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 19294,
    "venueId": 3654,
    "venue": "Brooks Stadium (SC)",
    "homeId": 324,
    "homeTeam": "Coastal Carolina",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 40,
    "homeLineScores": [
      14,
      13,
      10,
      3
    ],
    "homePostgameWinProbability": 0.9976415522417889,
    "homePregameElo": 1537,
    "homePostgameElo": 1537,
    "awayId": 2729,
    "awayTeam": "William & Mary",
    "awayClassification": "fcs",
    "awayConference": "CAA",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.0023584477582111463,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.3772758984,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628344,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 62621,
    "venueId": 3838,
    "venue": "Memorial Stadium",
    "homeId": 142,
    "homeTeam": "Missouri",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 38,
    "homeLineScores": [
      3,
      21,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9988863863777315,
    "homePregameElo": 1744,
    "homePostgameElo": 1803,
    "awayId": 2084,
    "awayTeam": "Buffalo",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0011136136222684723,
    "awayPregameElo": 1357,
    "awayPostgameElo": 1298,
    "excitementIndex": 3.2483160685,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628341,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 100242,
    "venueId": 3958,
    "venue": "Tiger Stadium (LA)",
    "homeId": 99,
    "homeTeam": "LSU",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 44,
    "homeLineScores": [
      9,
      14,
      21,
      0
    ],
    "homePostgameWinProbability": 0.2641403564947987,
    "homePregameElo": 1805,
    "homePostgameElo": 1805,
    "awayId": 2447,
    "awayTeam": "Nicholls",
    "awayClassification": "fcs",
    "awayConference": "Southland",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      7,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.7358596435052013,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.5734053957,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628467,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 86906,
    "venueId": 3834,
    "venue": "Memorial Stadium (Lincoln, NE)",
    "homeId": 158,
    "homeTeam": "Nebraska",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 28,
    "homeLineScores": [
      14,
      14,
      0,
      0
    ],
    "homePostgameWinProbability": 0.965196421811165,
    "homePregameElo": 1571,
    "homePostgameElo": 1588,
    "awayId": 38,
    "awayTeam": "Colorado",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      0,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.03480357818883495,
    "awayPregameElo": 1324,
    "awayPostgameElo": 1307,
    "excitementIndex": 3.2682399356,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645325,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 23510,
    "venueId": 3825,
    "venue": "DATCU Stadium",
    "homeId": 249,
    "homeTeam": "North Texas",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 35,
    "homeLineScores": [
      14,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9985735406880482,
    "homePregameElo": 1460,
    "homePostgameElo": 1460,
    "awayId": 2617,
    "awayTeam": "Stephen F. Austin",
    "awayClassification": "fcs",
    "awayConference": "Southland",
    "awayPoints": 20,
    "awayLineScores": [
      10,
      7,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.0014264593119518443,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 6.8718981027,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628346,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": false,
    "attendance": 72730,
    "venueId": 3628,
    "venue": "Bank of America Stadium",
    "homeId": 152,
    "homeTeam": "NC State",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 10,
    "homeLineScores": [
      0,
      3,
      7,
      0
    ],
    "homePostgameWinProbability": 0.0013081611453792652,
    "homePregameElo": 1606,
    "homePostgameElo": 1512,
    "awayId": 2633,
    "awayTeam": "Tennessee",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 51,
    "awayLineScores": [
      7,
      13,
      17,
      14
    ],
    "awayPostgameWinProbability": 0.9986918388546208,
    "awayPregameElo": 1751,
    "awayPostgameElo": 1845,
    "excitementIndex": 2.6876723747,
    "highlights": "",
    "notes": "Duke’s Mayo Classic"
  },
  {
    "id": 401628349,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 24080,
    "venueId": 3973,
    "venue": "FirstBank Stadium",
    "homeId": 238,
    "homeTeam": "Vanderbilt",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 55,
    "homeLineScores": [
      10,
      17,
      7,
      21
    ],
    "homePostgameWinProbability": 0.9989565641578229,
    "homePregameElo": 1303,
    "homePostgameElo": 1303,
    "awayId": 2016,
    "awayTeam": "Alcorn State",
    "awayClassification": "fcs",
    "awayConference": "SWAC",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0010434358421771428,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.6201509074,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628468,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 102665,
    "venueId": 3861,
    "venue": "Ohio Stadium",
    "homeId": 194,
    "homeTeam": "Ohio State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 56,
    "homeLineScores": [
      21,
      14,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9989683362339095,
    "homePregameElo": 1927,
    "homePostgameElo": 2014,
    "awayId": 2711,
    "awayTeam": "Western Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0010316637660905403,
    "awayPregameElo": 1309,
    "awayPostgameElo": 1222,
    "excitementIndex": 2.276632436,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628345,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-07T23:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 83653,
    "venueId": 3835,
    "venue": "Memorial Stadium (Norman, OK)",
    "homeId": 201,
    "homeTeam": "Oklahoma",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 16,
    "homeLineScores": [
      7,
      7,
      0,
      2
    ],
    "homePostgameWinProbability": 0.03463077000202154,
    "homePregameElo": 1849,
    "homePostgameElo": 1840,
    "awayId": 248,
    "awayTeam": "Houston",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 12,
    "awayLineScores": [
      3,
      3,
      6,
      0
    ],
    "awayPostgameWinProbability": 0.9653692299979785,
    "awayPregameElo": 1402,
    "awayPostgameElo": 1411,
    "excitementIndex": 7.4633177224,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636615,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-08T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 44063,
    "venueId": 3616,
    "venue": "Amon G. Carter Stadium",
    "homeId": 2628,
    "homeTeam": "TCU",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 45,
    "homeLineScores": [
      10,
      21,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9988595858130722,
    "homePregameElo": 1591,
    "homePostgameElo": 1591,
    "awayId": 2341,
    "awayTeam": "Long Island University",
    "awayClassification": "fcs",
    "awayConference": "NEC",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.001140414186927785,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.0873170548,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635532,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-08T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 81500,
    "venueId": 3836,
    "venue": "Memorial Stadium (Clemson, SC)",
    "homeId": 228,
    "homeTeam": "Clemson",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 66,
    "homeLineScores": [
      35,
      21,
      10,
      0
    ],
    "homePostgameWinProbability": 0.9989707034282519,
    "homePregameElo": 1625,
    "homePostgameElo": 1757,
    "awayId": 2026,
    "awayTeam": "App State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      13,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.0010292965717481062,
    "awayPregameElo": 1578,
    "awayPostgameElo": 1446,
    "excitementIndex": 2.5044572153,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401632072,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-08T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 41609,
    "venueId": 3946,
    "venue": "Sun Bowl",
    "homeId": 2638,
    "homeTeam": "UTEP",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 24,
    "homeLineScores": [
      14,
      3,
      0,
      7,
      0
    ],
    "homePostgameWinProbability": 0.36967252790505417,
    "homePregameElo": 1224,
    "homePostgameElo": 1224,
    "awayId": 253,
    "awayTeam": "Southern Utah",
    "awayClassification": "fcs",
    "awayConference": "UAC",
    "awayPoints": 27,
    "awayLineScores": [
      6,
      0,
      8,
      10,
      3
    ],
    "awayPostgameWinProbability": 0.6303274720949459,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 8.3814588335,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643707,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-08T02:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 41031,
    "venueId": 3660,
    "venue": "Valley Children's Stadium",
    "homeId": 278,
    "homeTeam": "Fresno State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 46,
    "homeLineScores": [
      18,
      7,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9896657008811013,
    "homePregameElo": 1535,
    "homePostgameElo": 1535,
    "awayId": 16,
    "awayTeam": "Sacramento State",
    "awayClassification": "fcs",
    "awayConference": "Big Sky",
    "awayPoints": 30,
    "awayLineScores": [
      3,
      7,
      7,
      13
    ],
    "awayPostgameWinProbability": 0.010334299118898715,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 5.2341013291,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628469,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-08T02:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 58134,
    "venueId": 3626,
    "venue": "Autzen Stadium",
    "homeId": 2483,
    "homeTeam": "Oregon",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 37,
    "homeLineScores": [
      7,
      7,
      13,
      10
    ],
    "homePostgameWinProbability": 0.9708133111224604,
    "homePregameElo": 1904,
    "homePostgameElo": 1902,
    "awayId": 68,
    "awayTeam": "Boise State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 34,
    "awayLineScores": [
      3,
      17,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.029186688877539613,
    "awayPregameElo": 1629,
    "awayPostgameElo": 1631,
    "excitementIndex": 9.8770288234,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636859,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-08T02:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 27372,
    "venueId": 3820,
    "venue": "Gesa Field",
    "homeId": 265,
    "homeTeam": "Washington State",
    "homeClassification": "fbs",
    "homeConference": "Pac-12",
    "homePoints": 37,
    "homeLineScores": [
      7,
      20,
      7,
      3
    ],
    "homePostgameWinProbability": 0.8654073890186578,
    "homePregameElo": 1530,
    "homePostgameElo": 1581,
    "awayId": 2641,
    "awayTeam": "Texas Tech",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 16,
    "awayLineScores": [
      3,
      7,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.13459261098134223,
    "awayPregameElo": 1541,
    "awayPostgameElo": 1490,
    "excitementIndex": 5.208469346,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636614,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-08T02:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 47746,
    "venueId": 3619,
    "venue": "Arizona Stadium",
    "homeId": 12,
    "homeTeam": "Arizona",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 22,
    "homeLineScores": [
      3,
      3,
      7,
      9
    ],
    "homePostgameWinProbability": 0.9528976534210033,
    "homePregameElo": 1739,
    "homePostgameElo": 1739,
    "awayId": 2464,
    "awayTeam": "Northern Arizona",
    "awayClassification": "fcs",
    "awayConference": "Big Sky",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      10,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0471023465789967,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 6.8354765478,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401640989,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-08T02:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16562,
    "venueId": 3601,
    "venue": "Aggie Memorial Stadium",
    "homeId": 166,
    "homeTeam": "New Mexico State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 24,
    "homeLineScores": [
      10,
      7,
      0,
      7
    ],
    "homePostgameWinProbability": 0.29013704906020665,
    "homePregameElo": 1432,
    "homePostgameElo": 1431,
    "awayId": 2335,
    "awayTeam": "Liberty",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 30,
    "awayLineScores": [
      3,
      6,
      0,
      21
    ],
    "awayPostgameWinProbability": 0.7098629509397933,
    "awayPregameElo": 1572,
    "awayPostgameElo": 1573,
    "excitementIndex": 7.8831258262,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628343,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-08T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 45504,
    "venueId": 3947,
    "venue": "Mountain America Stadium",
    "homeId": 9,
    "homeTeam": "Arizona State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 30,
    "homeLineScores": [
      10,
      17,
      3,
      0
    ],
    "homePostgameWinProbability": 0.7141237504569228,
    "homePregameElo": 1497,
    "homePostgameElo": 1504,
    "awayId": 344,
    "awayTeam": "Mississippi State",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 23,
    "awayLineScores": [
      0,
      3,
      7,
      13
    ],
    "awayPostgameWinProbability": 0.2858762495430772,
    "awayPregameElo": 1447,
    "awayPostgameElo": 1440,
    "excitementIndex": 3.8316762822,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643709,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-08T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 25318,
    "venueId": 7311,
    "venue": "Snapdragon Stadium",
    "homeId": 21,
    "homeTeam": "San Diego State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 0,
    "homeLineScores": [
      0,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0.0031430420540741865,
    "homePregameElo": 1416,
    "homePostgameElo": 1388,
    "awayId": 204,
    "awayTeam": "Oregon State",
    "awayClassification": "fbs",
    "awayConference": "Pac-12",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      0,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.9968569579459258,
    "awayPregameElo": 1648,
    "awayPostgameElo": 1676,
    "excitementIndex": 3.8855356996,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628472,
    "season": 2024,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2024-09-08T03:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 68110,
    "venueId": 477,
    "venue": "Los Angeles Memorial Coliseum",
    "homeId": 30,
    "homeTeam": "USC",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 48,
    "homeLineScores": [
      10,
      17,
      7,
      14
    ],
    "homePostgameWinProbability": 0.998820125395717,
    "homePregameElo": 1668,
    "homePostgameElo": 1768,
    "awayId": 328,
    "awayTeam": "Utah State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0011798746042830377,
    "awayPregameElo": 1346,
    "awayPostgameElo": 1246,
    "excitementIndex": 3.4091592103,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643788,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-12T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": null,
    "venueId": 6526,
    "venue": "Hancock Whitney Stadium",
    "homeId": 6,
    "homeTeam": "South Alabama",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 87,
    "homeLineScores": [
      24,
      28,
      28,
      7
    ],
    "homePostgameWinProbability": 0.99897052875113,
    "homePregameElo": 1581,
    "homePostgameElo": 1581,
    "awayId": 2466,
    "awayTeam": "Northwestern State",
    "awayClassification": "fcs",
    "awayConference": "Southland",
    "awayPoints": 10,
    "awayLineScores": [
      10,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0010294712488699842,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.63048087,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636867,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-12T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 25187,
    "venueId": 3644,
    "venue": "Bobcat Stadium (TX)",
    "homeId": 326,
    "homeTeam": "Texas State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 28,
    "homeLineScores": [
      7,
      14,
      7,
      0
    ],
    "homePostgameWinProbability": 0.11506986599136698,
    "homePregameElo": 1545,
    "homePostgameElo": 1538,
    "awayId": 9,
    "awayTeam": "Arizona State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      14,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.8849301340086331,
    "awayPregameElo": 1504,
    "awayPostgameElo": 1511,
    "excitementIndex": 8.8230147959,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636863,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-13T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": false,
    "attendance": 21493,
    "venueId": 3486,
    "venue": "Children's Mercy Park",
    "homeId": 2305,
    "homeTeam": "Kansas",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 20,
    "homeLineScores": [
      7,
      10,
      0,
      3
    ],
    "homePostgameWinProbability": 0.9904339356746409,
    "homePregameElo": 1606,
    "homePostgameElo": 1603,
    "awayId": 2439,
    "awayTeam": "UNLV",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 23,
    "awayLineScores": [
      3,
      10,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.009566064325359114,
    "awayPregameElo": 1541,
    "awayPostgameElo": 1544,
    "excitementIndex": 6.9236233086,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636864,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 51290,
    "venueId": 3636,
    "venue": "Bill Snyder Family Stadium",
    "homeId": 2306,
    "homeTeam": "Kansas State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 31,
    "homeLineScores": [
      7,
      7,
      14,
      3
    ],
    "homePostgameWinProbability": 0.9893458948837691,
    "homePregameElo": 1790,
    "homePostgameElo": 1842,
    "awayId": 12,
    "awayTeam": "Arizona",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 7,
    "awayLineScores": [
      7,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.010654105116230883,
    "awayPregameElo": 1720,
    "awayPostgameElo": 1668,
    "excitementIndex": 4.5340233474,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628350,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 76323,
    "venueId": 347,
    "venue": "Camp Randall Stadium",
    "homeId": 275,
    "homeTeam": "Wisconsin",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 10,
    "homeLineScores": [
      3,
      0,
      7,
      0
    ],
    "homePostgameWinProbability": 0.0081587932041351,
    "homePregameElo": 1593,
    "homePostgameElo": 1553,
    "awayId": 333,
    "awayTeam": "Alabama",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 42,
    "awayLineScores": [
      7,
      14,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.9918412067958648,
    "awayPregameElo": 2006,
    "awayPostgameElo": 2046,
    "excitementIndex": 2.8137131564,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636869,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 30915,
    "venueId": 3674,
    "venue": "Chapman Stadium",
    "homeId": 202,
    "homeTeam": "Tulsa",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 10,
    "homeLineScores": [
      0,
      0,
      0,
      10
    ],
    "homePostgameWinProbability": 0.0003792225224573761,
    "homePregameElo": 1250,
    "homePostgameElo": 1185,
    "awayId": 197,
    "awayTeam": "Oklahoma State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 45,
    "awayLineScores": [
      7,
      21,
      10,
      7
    ],
    "awayPostgameWinProbability": 0.9996207774775426,
    "awayPregameElo": 1530,
    "awayPostgameElo": 1595,
    "excitementIndex": 1.7699490034,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635542,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 55107,
    "venueId": 3697,
    "venue": "Doak Campbell Stadium",
    "homeId": 52,
    "homeTeam": "Florida State",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 12,
    "homeLineScores": [
      0,
      3,
      6,
      3
    ],
    "homePostgameWinProbability": 0.11682755961610082,
    "homePregameElo": 1610,
    "homePostgameElo": 1596,
    "awayId": 235,
    "awayTeam": "Memphis",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 20,
    "awayLineScores": [
      3,
      10,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.8831724403838992,
    "awayPregameElo": 1625,
    "awayPostgameElo": 1639,
    "excitementIndex": 4.7620557314,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636868,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 57865,
    "venueId": 3784,
    "venue": "Jones AT&T Stadium",
    "homeId": 2641,
    "homeTeam": "Texas Tech",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 66,
    "homeLineScores": [
      17,
      35,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9989666953513109,
    "homePregameElo": 1490,
    "homePostgameElo": 1623,
    "awayId": 249,
    "awayTeam": "North Texas",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.001033304648689115,
    "awayPregameElo": 1469,
    "awayPostgameElo": 1336,
    "excitementIndex": 4.5756445546,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635546,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 56919,
    "venueId": 3670,
    "venue": "Carter-Finley Stadium",
    "homeId": 152,
    "homeTeam": "NC State",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 30,
    "homeLineScores": [
      3,
      3,
      14,
      10
    ],
    "homePostgameWinProbability": 0.9887121904445089,
    "homePregameElo": 1512,
    "homePostgameElo": 1511,
    "awayId": 2348,
    "awayTeam": "Louisiana Tech",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      17,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.011287809555491135,
    "awayPregameElo": 1246,
    "awayPostgameElo": 1247,
    "excitementIndex": 6.9656670091,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636865,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 24717,
    "venueId": 3996,
    "venue": "Yager Stadium",
    "homeId": 193,
    "homeTeam": "Miami (OH)",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 16,
    "homeLineScores": [
      0,
      3,
      7,
      6
    ],
    "homePostgameWinProbability": 0.22661705402857707,
    "homePregameElo": 1490,
    "homePostgameElo": 1458,
    "awayId": 2132,
    "awayTeam": "Cincinnati",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 27,
    "awayLineScores": [
      3,
      7,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.773382945971423,
    "awayPregameElo": 1397,
    "awayPostgameElo": 1429,
    "excitementIndex": 4.2593483439,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628479,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 110250,
    "venueId": 3558,
    "venue": "Michigan Stadium",
    "homeId": 130,
    "homeTeam": "Michigan",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 28,
    "homeLineScores": [
      7,
      14,
      0,
      7
    ],
    "homePostgameWinProbability": 0.99822512163928,
    "homePregameElo": 1928,
    "homePostgameElo": 1911,
    "awayId": 2032,
    "awayTeam": "Arkansas State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 18,
    "awayLineScores": [
      0,
      3,
      0,
      15
    ],
    "awayPostgameWinProbability": 0.0017748783607199892,
    "awayPregameElo": 1404,
    "awayPostgameElo": 1421,
    "excitementIndex": 4.2387123237,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628475,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": null,
    "venueId": 3832,
    "venue": "Memorial Stadium (Champaign, IL)",
    "homeId": 356,
    "homeTeam": "Illinois",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 30,
    "homeLineScores": [
      7,
      6,
      10,
      7
    ],
    "homePostgameWinProbability": 0.9736874201207752,
    "homePregameElo": 1515,
    "homePostgameElo": 1533,
    "awayId": 2117,
    "awayTeam": "Central Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 9,
    "awayLineScores": [
      3,
      3,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.02631257987922475,
    "awayPregameElo": 1191,
    "awayPostgameElo": 1173,
    "excitementIndex": 4.7985291022,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628359,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 79531,
    "venueId": 3994,
    "venue": "Williams-Brice Stadium",
    "homeId": 2579,
    "homeTeam": "South Carolina",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 33,
    "homeLineScores": [
      7,
      17,
      0,
      9
    ],
    "homePostgameWinProbability": 0.8567462764688526,
    "homePregameElo": 1637,
    "homePostgameElo": 1642,
    "awayId": 99,
    "awayTeam": "LSU",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 36,
    "awayLineScores": [
      0,
      16,
      6,
      14
    ],
    "awayPostgameWinProbability": 0.1432537235311474,
    "awayPregameElo": 1803,
    "awayPostgameElo": 1798,
    "excitementIndex": 9.8185936219,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628357,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T16:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 62621,
    "venueId": 3838,
    "venue": "Memorial Stadium",
    "homeId": 142,
    "homeTeam": "Missouri",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 27,
    "homeLineScores": [
      3,
      14,
      7,
      3
    ],
    "homePostgameWinProbability": 0.8685557691100811,
    "homePregameElo": 1803,
    "homePostgameElo": 1795,
    "awayId": 103,
    "awayTeam": "Boston College",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.13144423088991886,
    "awayPregameElo": 1462,
    "awayPostgameElo": 1470,
    "excitementIndex": 5.8006475504,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401629041,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 15204,
    "venueId": 3965,
    "venue": "UB Stadium",
    "homeId": 2084,
    "homeTeam": "Buffalo",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 34,
    "homeLineScores": [
      7,
      3,
      17,
      7
    ],
    "homePostgameWinProbability": 0.9701620326958922,
    "homePregameElo": 1298,
    "homePostgameElo": 1360,
    "awayId": 113,
    "awayTeam": "Massachusetts",
    "awayClassification": "fbs",
    "awayConference": "FBS Independents",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.029837967304107815,
    "awayPregameElo": 1125,
    "awayPostgameElo": 1063,
    "excitementIndex": 5.4328549557,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643786,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 13945,
    "venueId": 3806,
    "venue": "Lincoln Financial Field",
    "homeId": 218,
    "homeTeam": "Temple",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 20,
    "homeLineScores": [
      3,
      7,
      7,
      3
    ],
    "homePostgameWinProbability": 0.1595680350940139,
    "homePregameElo": 1074,
    "homePostgameElo": 1092,
    "awayId": 324,
    "awayTeam": "Coastal Carolina",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 28,
    "awayLineScores": [
      14,
      7,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.8404319649059862,
    "awayPregameElo": 1537,
    "awayPostgameElo": 1519,
    "excitementIndex": 4.01918383,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628978,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 61441,
    "venueId": 3907,
    "venue": "Ross-Ade Stadium",
    "homeId": 2509,
    "homeTeam": "Purdue",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 7,
    "homeLineScores": [
      0,
      0,
      7,
      0
    ],
    "homePostgameWinProbability": 0.0002993282026749188,
    "homePregameElo": 1492,
    "homePostgameElo": 1358,
    "awayId": 87,
    "awayTeam": "Notre Dame",
    "awayClassification": "fbs",
    "awayConference": "FBS Independents",
    "awayPoints": 66,
    "awayLineScores": [
      14,
      28,
      10,
      14
    ],
    "awayPostgameWinProbability": 0.9997006717973251,
    "awayPregameElo": 1858,
    "awayPostgameElo": 1992,
    "excitementIndex": 2.1112922952,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644734,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 20438,
    "venueId": 3876,
    "venue": "Peden Stadium",
    "homeId": 195,
    "homeTeam": "Ohio",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 21,
    "homeLineScores": [
      14,
      0,
      7,
      0
    ],
    "homePostgameWinProbability": 0.9976520547777931,
    "homePregameElo": 1481,
    "homePostgameElo": 1481,
    "awayId": 2415,
    "awayTeam": "Morgan State",
    "awayClassification": "fcs",
    "awayConference": "MEAC",
    "awayPoints": 6,
    "awayLineScores": [
      3,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0023479452222069375,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 7.2518927304,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628481,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 44534,
    "venueId": 3953,
    "venue": "Huntington Bank Stadium",
    "homeId": 135,
    "homeTeam": "Minnesota",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 27,
    "homeLineScores": [
      6,
      14,
      7,
      0
    ],
    "homePostgameWinProbability": 0.9920975348755978,
    "homePregameElo": 1492,
    "homePostgameElo": 1537,
    "awayId": 2440,
    "awayTeam": "Nevada",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.00790246512440218,
    "awayPregameElo": 1273,
    "awayPostgameElo": 1228,
    "excitementIndex": 5.8857044704,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628483,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 38419,
    "venueId": 3893,
    "venue": "Reser Stadium",
    "homeId": 204,
    "homeTeam": "Oregon State",
    "homeClassification": "fbs",
    "homeConference": "Pac-12",
    "homePoints": 14,
    "homeLineScores": [
      7,
      7,
      0,
      0
    ],
    "homePostgameWinProbability": 0.007742937607065228,
    "homePregameElo": 1676,
    "homePostgameElo": 1604,
    "awayId": 2483,
    "awayTeam": "Oregon",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 49,
    "awayLineScores": [
      7,
      15,
      10,
      17
    ],
    "awayPostgameWinProbability": 0.9922570623929348,
    "awayPregameElo": 1902,
    "awayPostgameElo": 1974,
    "excitementIndex": 3.076769043,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628358,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 83325,
    "venueId": 3835,
    "venue": "Memorial Stadium (Norman, OK)",
    "homeId": 201,
    "homeTeam": "Oklahoma",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 34,
    "homeLineScores": [
      7,
      14,
      3,
      10
    ],
    "homePostgameWinProbability": 0.6258604373647714,
    "homePregameElo": 1840,
    "homePostgameElo": 1848,
    "awayId": 2655,
    "awayTeam": "Tulane",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 19,
    "awayLineScores": [
      0,
      6,
      7,
      6
    ],
    "awayPostgameWinProbability": 0.37413956263522863,
    "awayPregameElo": 1569,
    "awayPostgameElo": 1561,
    "excitementIndex": 5.520590328,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628484,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": false,
    "attendance": 57567,
    "venueId": 3673,
    "venue": "Lumen Field",
    "homeId": 264,
    "homeTeam": "Washington",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 19,
    "homeLineScores": [
      7,
      6,
      6,
      0
    ],
    "homePostgameWinProbability": 0.7815755850294251,
    "homePregameElo": 1759,
    "homePostgameElo": 1745,
    "awayId": 265,
    "awayTeam": "Washington State",
    "awayClassification": "fbs",
    "awayConference": "Pac-12",
    "awayPoints": 24,
    "awayLineScores": [
      10,
      7,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.21842441497057485,
    "awayPregameElo": 1581,
    "awayPostgameElo": 1595,
    "excitementIndex": 6.750224187,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635547,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 66087,
    "venueId": 3752,
    "venue": "Acrisure Stadium",
    "homeId": 221,
    "homeTeam": "Pittsburgh",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 38,
    "homeLineScores": [
      10,
      7,
      7,
      14
    ],
    "homePostgameWinProbability": 0.5101699610641375,
    "homePregameElo": 1483,
    "homePostgameElo": 1488,
    "awayId": 277,
    "awayTeam": "West Virginia",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 34,
    "awayLineScores": [
      7,
      10,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.4898300389358625,
    "awayPregameElo": 1546,
    "awayPostgameElo": 1541,
    "excitementIndex": 8.7770249092,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635544,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 51564,
    "venueId": 3948,
    "venue": "Hard Rock Stadium",
    "homeId": 2390,
    "homeTeam": "Miami",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 62,
    "homeLineScores": [
      10,
      21,
      10,
      21
    ],
    "homePostgameWinProbability": 0.9989667124762882,
    "homePregameElo": 1618,
    "homePostgameElo": 1774,
    "awayId": 2050,
    "awayTeam": "Ball State",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.00103328752371179,
    "awayPregameElo": 1341,
    "awayPostgameElo": 1185,
    "excitementIndex": 4.9997511364,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635543,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 31729,
    "venueId": 721,
    "venue": "Bobby Dodd Stadium",
    "homeId": 59,
    "homeTeam": "Georgia Tech",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 59,
    "homeLineScores": [
      17,
      21,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9989672155779504,
    "homePregameElo": 1551,
    "homePostgameElo": 1551,
    "awayId": 2678,
    "awayTeam": "VMI",
    "awayClassification": "fcs",
    "awayConference": "Southern",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.0010327844220495708,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.6239487886,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628480,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 70066,
    "venueId": 3936,
    "venue": "Spartan Stadium",
    "homeId": 127,
    "homeTeam": "Michigan State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 40,
    "homeLineScores": [
      14,
      13,
      3,
      10
    ],
    "homePostgameWinProbability": 0.9989534090095522,
    "homePregameElo": 1418,
    "homePostgameElo": 1418,
    "awayId": 2504,
    "awayTeam": "Prairie View A&M",
    "awayClassification": "fcs",
    "awayConference": "SWAC",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0010465909904477932,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.723501427,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628353,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 89993,
    "venueId": 3634,
    "venue": "Ben Hill Griffin Stadium",
    "homeId": 57,
    "homeTeam": "Florida",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 20,
    "homeLineScores": [
      0,
      0,
      14,
      6
    ],
    "homePostgameWinProbability": 0.005388908230321768,
    "homePregameElo": 1497,
    "homePostgameElo": 1485,
    "awayId": 245,
    "awayTeam": "Texas A&M",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 33,
    "awayLineScores": [
      10,
      10,
      13,
      0
    ],
    "awayPostgameWinProbability": 0.9946110917696782,
    "awayPregameElo": 1677,
    "awayPostgameElo": 1689,
    "excitementIndex": 3.0084883856,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628477,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 69250,
    "venueId": 3793,
    "venue": "Kinnick Stadium",
    "homeId": 2294,
    "homeTeam": "Iowa",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 38,
    "homeLineScores": [
      0,
      10,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9968610497948086,
    "homePregameElo": 1552,
    "homePostgameElo": 1591,
    "awayId": 2653,
    "awayTeam": "Troy",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      14,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.003138950205191393,
    "awayPregameElo": 1573,
    "awayPostgameElo": 1534,
    "excitementIndex": 6.6290795104,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643785,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 46117,
    "venueId": 3699,
    "venue": "Dowdy-Ficklen Stadium",
    "homeId": 151,
    "homeTeam": "East Carolina",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 19,
    "homeLineScores": [
      16,
      0,
      0,
      3
    ],
    "homePostgameWinProbability": 0.32633443593883876,
    "homePregameElo": 1415,
    "homePostgameElo": 1414,
    "awayId": 2026,
    "awayTeam": "App State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      14,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.6736655640611613,
    "awayPregameElo": 1446,
    "awayPostgameElo": 1447,
    "excitementIndex": 8.6747762863,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628351,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T20:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 75021,
    "venueId": 3887,
    "venue": "Razorback Stadium",
    "homeId": 8,
    "homeTeam": "Arkansas",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 37,
    "homeLineScores": [
      3,
      17,
      7,
      10
    ],
    "homePostgameWinProbability": 0.49095215439732587,
    "homePregameElo": 1446,
    "homePostgameElo": 1451,
    "awayId": 5,
    "awayTeam": "UAB",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 27,
    "awayLineScores": [
      10,
      10,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.5090478456026741,
    "awayPregameElo": 1270,
    "awayPostgameElo": 1265,
    "excitementIndex": 6.8537612708,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636870,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": null,
    "venueId": 3905,
    "venue": "Maverik Stadium",
    "homeId": 328,
    "homeTeam": "Utah State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 21,
    "homeLineScores": [
      7,
      7,
      7,
      0
    ],
    "homePostgameWinProbability": 0.09987048764588333,
    "homePregameElo": 1246,
    "homePostgameElo": 1242,
    "awayId": 254,
    "awayTeam": "Utah",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 38,
    "awayLineScores": [
      3,
      14,
      11,
      10
    ],
    "awayPostgameWinProbability": 0.9001295123541166,
    "awayPregameElo": 1627,
    "awayPostgameElo": 1631,
    "excitementIndex": 4.9896212641,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401640990,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 21805,
    "venueId": 3992,
    "venue": "Williams Stadium (VA)",
    "homeId": 2335,
    "homeTeam": "Liberty",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 28,
    "homeLineScores": [
      7,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9983214732342744,
    "homePregameElo": 1573,
    "homePostgameElo": 1582,
    "awayId": 2638,
    "awayTeam": "UTEP",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 10,
    "awayLineScores": [
      3,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.001678526765725552,
    "awayPregameElo": 1232,
    "awayPostgameElo": 1223,
    "excitementIndex": 7.1552804569,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401640980,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 24283,
    "venueId": 3715,
    "venue": "FAU Stadium",
    "homeId": 2226,
    "homeTeam": "Florida Atlantic",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 38,
    "homeLineScores": [
      7,
      17,
      14,
      0
    ],
    "homePostgameWinProbability": 0.991083514939055,
    "homePregameElo": 1373,
    "homePostgameElo": 1403,
    "awayId": 2229,
    "awayTeam": "Florida International",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 20,
    "awayLineScores": [
      7,
      0,
      7,
      6
    ],
    "awayPostgameWinProbability": 0.008916485060945,
    "awayPregameElo": 1271,
    "awayPostgameElo": 1241,
    "excitementIndex": 4.6474244048,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645327,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": null,
    "venueId": 4418,
    "venue": "Jerry Richardson Stadium",
    "homeId": 2429,
    "homeTeam": "Charlotte",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 27,
    "homeLineScores": [
      0,
      3,
      3,
      21
    ],
    "homePostgameWinProbability": 0.3163741009693031,
    "homePregameElo": 1174,
    "homePostgameElo": 1174,
    "awayId": 2241,
    "awayTeam": "Gardner-Webb",
    "awayClassification": "fcs",
    "awayConference": "Big South-OVC",
    "awayPoints": 26,
    "awayLineScores": [
      3,
      14,
      3,
      6
    ],
    "awayPostgameWinProbability": 0.6836258990306969,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 5.3353819557,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644733,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 8932,
    "venueId": 3768,
    "venue": "InfoCision Stadium",
    "homeId": 2006,
    "homeTeam": "Akron",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 31,
    "homeLineScores": [
      7,
      21,
      0,
      3
    ],
    "homePostgameWinProbability": 0.8741212642626452,
    "homePregameElo": 1098,
    "homePostgameElo": 1098,
    "awayId": 2142,
    "awayTeam": "Colgate",
    "awayClassification": "fcs",
    "awayConference": "Patriot",
    "awayPoints": 20,
    "awayLineScores": [
      17,
      0,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.12587873573735475,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 6.4380193612,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401629030,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 20174,
    "venueId": 3982,
    "venue": "Wallace Wade Stadium",
    "homeId": 150,
    "homeTeam": "Duke",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 26,
    "homeLineScores": [
      7,
      10,
      0,
      9
    ],
    "homePostgameWinProbability": 0.3474928526218494,
    "homePregameElo": 1602,
    "homePostgameElo": 1590,
    "awayId": 41,
    "awayTeam": "UConn",
    "awayClassification": "fbs",
    "awayConference": "FBS Independents",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      7,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.6525071473781505,
    "awayPregameElo": 1157,
    "awayPostgameElo": 1169,
    "excitementIndex": 8.9201363026,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643787,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 21617,
    "venueId": 3608,
    "venue": "Allen E. Paulson Stadium",
    "homeId": 290,
    "homeTeam": "Georgia Southern",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 42,
    "homeLineScores": [
      7,
      14,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9908620138574958,
    "homePregameElo": 1383,
    "homePostgameElo": 1383,
    "awayId": 2569,
    "awayTeam": "South Carolina State",
    "awayClassification": "fcs",
    "awayConference": "MEAC",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      7,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.009137986142504162,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.1223384087,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635545,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 45491,
    "venueId": 3787,
    "venue": "Kenan Stadium",
    "homeId": 153,
    "homeTeam": "North Carolina",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 45,
    "homeLineScores": [
      0,
      17,
      0,
      28
    ],
    "homePostgameWinProbability": 0.9974742998884685,
    "homePregameElo": 1567,
    "homePostgameElo": 1567,
    "awayId": 2428,
    "awayTeam": "North Carolina Central",
    "awayClassification": "fcs",
    "awayConference": "MEAC",
    "awayPoints": 10,
    "awayLineScores": [
      7,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.002525700111531526,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 5.996017734,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635548,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 22208,
    "venueId": 3918,
    "venue": "S.B. Ballard Stadium",
    "homeId": 295,
    "homeTeam": "Old Dominion",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 17,
    "homeLineScores": [
      0,
      10,
      0,
      7
    ],
    "homePostgameWinProbability": 0.1309340310766458,
    "homePregameElo": 1397,
    "homePostgameElo": 1368,
    "awayId": 259,
    "awayTeam": "Virginia Tech",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 37,
    "awayLineScores": [
      14,
      0,
      6,
      17
    ],
    "awayPostgameWinProbability": 0.8690659689233542,
    "awayPregameElo": 1597,
    "awayPostgameElo": 1626,
    "excitementIndex": 4.4523144576,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628355,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T22:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 32849,
    "venueId": 3630,
    "venue": "Allegacy Federal Credit Union Stadium",
    "homeId": 154,
    "homeTeam": "Wake Forest",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 6,
    "homeLineScores": [
      3,
      3,
      0,
      0
    ],
    "homePostgameWinProbability": 0.0003568256800009375,
    "homePregameElo": 1424,
    "homePostgameElo": 1370,
    "awayId": 145,
    "awayTeam": "Ole Miss",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 40,
    "awayLineScores": [
      20,
      3,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.999643174319999,
    "awayPregameElo": 1770,
    "awayPostgameElo": 1824,
    "excitementIndex": 3.1835106946,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636364,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T22:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 23476,
    "venueId": 3980,
    "venue": "Waldo Stadium",
    "homeId": 2711,
    "homeTeam": "Western Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 59,
    "homeLineScores": [
      14,
      21,
      14,
      10
    ],
    "homePostgameWinProbability": 0.9989684442331265,
    "homePregameElo": 1193,
    "homePostgameElo": 1193,
    "awayId": 2065,
    "awayTeam": "Bethune-Cookman",
    "awayClassification": "fcs",
    "awayConference": "SWAC",
    "awayPoints": 31,
    "awayLineScores": [
      0,
      14,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.0010315557668735265,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.73963378,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628362,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 14413,
    "venueId": 4246,
    "venue": "Center Parc Stadium",
    "homeId": 2247,
    "homeTeam": "Georgia State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 36,
    "homeLineScores": [
      3,
      9,
      10,
      14
    ],
    "homePostgameWinProbability": 0.4064557580733251,
    "homePregameElo": 1370,
    "homePostgameElo": 1371,
    "awayId": 238,
    "awayTeam": "Vanderbilt",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 32,
    "awayLineScores": [
      0,
      10,
      0,
      22
    ],
    "awayPostgameWinProbability": 0.5935442419266749,
    "awayPregameElo": 1313,
    "awayPostgameElo": 1312,
    "excitementIndex": 8.4948458307,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628361,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 101892,
    "venueId": 3910,
    "venue": "DKR-Texas Memorial Stadium",
    "homeId": 251,
    "homeTeam": "Texas",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 56,
    "homeLineScores": [
      14,
      14,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9988848395909953,
    "homePregameElo": 1991,
    "homePostgameElo": 2068,
    "awayId": 2636,
    "awayTeam": "UTSA",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.001115160409004723,
    "awayPregameElo": 1467,
    "awayPostgameElo": 1390,
    "excitementIndex": 2.909180873,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401640999,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 17501,
    "venueId": 3912,
    "venue": "Rynearson Stadium",
    "homeId": 2199,
    "homeTeam": "Eastern Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 37,
    "homeLineScores": [
      14,
      14,
      3,
      0,
      3,
      3
    ],
    "homePostgameWinProbability": 0.6626094267979739,
    "homePregameElo": 1298,
    "homePostgameElo": 1300,
    "awayId": 55,
    "awayTeam": "Jacksonville State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 34,
    "awayLineScores": [
      7,
      13,
      0,
      11,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.33739057320202614,
    "awayPregameElo": 1374,
    "awayPostgameElo": 1372,
    "excitementIndex": 9.6322925678,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641024,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 12227,
    "venueId": 3725,
    "venue": "Johnny \"Red\" Floyd Stadium",
    "homeId": 2393,
    "homeTeam": "Middle Tennessee",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 21,
    "homeLineScores": [
      0,
      0,
      14,
      7
    ],
    "homePostgameWinProbability": 0.25259863997656923,
    "homePregameElo": 1288,
    "homePostgameElo": 1215,
    "awayId": 98,
    "awayTeam": "Western Kentucky",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 49,
    "awayLineScores": [
      14,
      7,
      21,
      7
    ],
    "awayPostgameWinProbability": 0.7474013600234308,
    "awayPregameElo": 1323,
    "awayPostgameElo": 1396,
    "excitementIndex": 2.2685949947,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641017,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 11090,
    "venueId": 3935,
    "venue": "CEFCU Stadium",
    "homeId": 23,
    "homeTeam": "San Jos\u00e9 State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 31,
    "homeLineScores": [
      0,
      17,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9775274462423851,
    "homePregameElo": 1567,
    "homePostgameElo": 1602,
    "awayId": 338,
    "awayTeam": "Kennesaw State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 10,
    "awayLineScores": [
      3,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.02247255375761492,
    "awayPregameElo": 1423,
    "awayPostgameElo": 1388,
    "excitementIndex": 4.6611245645,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641040,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 15134,
    "venueId": 3647,
    "venue": "Elliott T. Bowers Stadium",
    "homeId": 2534,
    "homeTeam": "Sam Houston",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 31,
    "homeLineScores": [
      7,
      10,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9963204929272254,
    "homePregameElo": 1370,
    "homePostgameElo": 1398,
    "awayId": 62,
    "awayTeam": "Hawai'i",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      3,
      10,
      0
    ],
    "awayPostgameWinProbability": 0.003679507072774646,
    "awayPregameElo": 1242,
    "awayPostgameElo": 1214,
    "excitementIndex": 5.0525911901,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643789,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 23537,
    "venueId": 3815,
    "venue": "M. M. Roberts Stadium",
    "homeId": 2572,
    "homeTeam": "Southern Miss",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 24,
    "homeLineScores": [
      14,
      7,
      0,
      3
    ],
    "homePostgameWinProbability": 0.0758748165356814,
    "homePregameElo": 1230,
    "homePostgameElo": 1187,
    "awayId": 58,
    "awayTeam": "South Florida",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 49,
    "awayLineScores": [
      14,
      14,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.9241251834643186,
    "awayPregameElo": 1433,
    "awayPostgameElo": 1476,
    "excitementIndex": 3.830391038,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628352,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 88043,
    "venueId": 3785,
    "venue": "Jordan-Hare Stadium",
    "homeId": 2,
    "homeTeam": "Auburn",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 45,
    "homeLineScores": [
      14,
      3,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9974030594036278,
    "homePregameElo": 1537,
    "homePostgameElo": 1569,
    "awayId": 167,
    "awayTeam": "New Mexico",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 19,
    "awayLineScores": [
      10,
      3,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.002596940596372166,
    "awayPregameElo": 1228,
    "awayPostgameElo": 1196,
    "excitementIndex": 5.2477113604,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628356,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 47412,
    "venueId": 3693,
    "venue": "Davis Wade Stadium",
    "homeId": 344,
    "homeTeam": "Mississippi State",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 17,
    "homeLineScores": [
      0,
      3,
      7,
      7
    ],
    "homePostgameWinProbability": 0.0004366823800092236,
    "homePregameElo": 1440,
    "homePostgameElo": 1386,
    "awayId": 2649,
    "awayTeam": "Toledo",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 41,
    "awayLineScores": [
      7,
      21,
      7,
      6
    ],
    "awayPostgameWinProbability": 0.9995633176199907,
    "awayPregameElo": 1524,
    "awayPostgameElo": 1578,
    "excitementIndex": 2.3939678093,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636860,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 46212,
    "venueId": 4727,
    "venue": "McLane Stadium",
    "homeId": 239,
    "homeTeam": "Baylor",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 31,
    "homeLineScores": [
      3,
      3,
      17,
      8
    ],
    "homePostgameWinProbability": 0.9958538730603451,
    "homePregameElo": 1417,
    "homePostgameElo": 1507,
    "awayId": 2005,
    "awayTeam": "Air Force",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.004146126939654882,
    "awayPregameElo": 1549,
    "awayPostgameElo": 1459,
    "excitementIndex": 5.1557909361,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636866,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 48889,
    "venueId": 3616,
    "venue": "Amon G. Carter Stadium",
    "homeId": 2628,
    "homeTeam": "TCU",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 34,
    "homeLineScores": [
      14,
      7,
      10,
      3
    ],
    "homePostgameWinProbability": 0.008433595726321992,
    "homePregameElo": 1578,
    "homePostgameElo": 1580,
    "awayId": 2116,
    "awayTeam": "UCF",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 35,
    "awayLineScores": [
      0,
      7,
      13,
      15
    ],
    "awayPostgameWinProbability": 0.991566404273678,
    "awayPregameElo": 1644,
    "awayPostgameElo": 1642,
    "excitementIndex": 6.913846806,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628476,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 47811,
    "venueId": 1056,
    "venue": "Rose Bowl",
    "homeId": 26,
    "homeTeam": "UCLA",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 13,
    "homeLineScores": [
      0,
      7,
      3,
      3
    ],
    "homePostgameWinProbability": 0.001063915461672754,
    "homePregameElo": 1553,
    "homePostgameElo": 1456,
    "awayId": 84,
    "awayTeam": "Indiana",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 42,
    "awayLineScores": [
      14,
      7,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.9989360845383273,
    "awayPregameElo": 1430,
    "awayPostgameElo": 1527,
    "excitementIndex": 2.5796886196,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628482,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 86546,
    "venueId": 3834,
    "venue": "Memorial Stadium (Lincoln, NE)",
    "homeId": 158,
    "homeTeam": "Nebraska",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 34,
    "homeLineScores": [
      7,
      14,
      6,
      7
    ],
    "homePostgameWinProbability": 0.9981665662396725,
    "homePregameElo": 1596,
    "homePostgameElo": 1596,
    "awayId": 2460,
    "awayTeam": "Northern Iowa",
    "awayClassification": "fcs",
    "awayConference": "MVFC",
    "awayPoints": 3,
    "awayLineScores": [
      3,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0018334337603275186,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.0885437485,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628354,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 61663,
    "venueId": 3683,
    "venue": "Kroger Field",
    "homeId": 96,
    "homeTeam": "Kentucky",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 12,
    "homeLineScores": [
      3,
      3,
      3,
      3
    ],
    "homePostgameWinProbability": 0.20705104002487187,
    "homePregameElo": 1563,
    "homePostgameElo": 1583,
    "awayId": 61,
    "awayTeam": "Georgia",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      3,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.7929489599751282,
    "awayPregameElo": 2066,
    "awayPostgameElo": 2046,
    "excitementIndex": 8.9509868466,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401655632,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": false,
    "attendance": 10631,
    "venueId": 5960,
    "venue": "Lanny and Sharon Martin Stadium",
    "homeId": 77,
    "homeTeam": "Northwestern",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 31,
    "homeLineScores": [
      7,
      7,
      10,
      7
    ],
    "homePostgameWinProbability": 0.9954332752862584,
    "homePregameElo": 1508,
    "homePostgameElo": 1508,
    "awayId": 2197,
    "awayTeam": "Eastern Illinois",
    "awayClassification": "fcs",
    "awayConference": "Big South-OVC",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.004566724713741643,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.621228179,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636861,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 40099,
    "venueId": 5388,
    "venue": "Canvas Stadium",
    "homeId": 36,
    "homeTeam": "Colorado State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 9,
    "homeLineScores": [
      3,
      0,
      0,
      6
    ],
    "homePostgameWinProbability": 0.09871601779704506,
    "homePregameElo": 1261,
    "homePostgameElo": 1219,
    "awayId": 38,
    "awayTeam": "Colorado",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 28,
    "awayLineScores": [
      0,
      14,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.9012839822029549,
    "awayPregameElo": 1307,
    "awayPostgameElo": 1349,
    "excitementIndex": 3.2618715605,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628360,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-14T23:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 101915,
    "venueId": 3853,
    "venue": "Neyland Stadium",
    "homeId": 2633,
    "homeTeam": "Tennessee",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 71,
    "homeLineScores": [
      37,
      28,
      3,
      3
    ],
    "homePostgameWinProbability": 0.9989675661261332,
    "homePregameElo": 1845,
    "homePostgameElo": 1964,
    "awayId": 2309,
    "awayTeam": "Kent State",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.001032433873866756,
    "awayPregameElo": 1108,
    "awayPostgameElo": 989,
    "excitementIndex": 2.464570702,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628478,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-15T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": null,
    "venueId": 3923,
    "venue": "Scott Stadium",
    "homeId": 258,
    "homeTeam": "Virginia",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 13,
    "homeLineScores": [
      3,
      10,
      0,
      0
    ],
    "homePostgameWinProbability": 0.2758509731563324,
    "homePregameElo": 1317,
    "homePostgameElo": 1318,
    "awayId": 120,
    "awayTeam": "Maryland",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 27,
    "awayLineScores": [
      0,
      7,
      10,
      10
    ],
    "awayPostgameWinProbability": 0.7241490268436677,
    "awayPregameElo": 1679,
    "awayPostgameElo": 1678,
    "excitementIndex": 7.1114804406,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636862,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-15T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 28146,
    "venueId": 4728,
    "venue": "TDECU Stadium",
    "homeId": 248,
    "homeTeam": "Houston",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 33,
    "homeLineScores": [
      14,
      6,
      6,
      7
    ],
    "homePostgameWinProbability": 0.9986102045526059,
    "homePregameElo": 1411,
    "homePostgameElo": 1466,
    "awayId": 242,
    "awayTeam": "Rice",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.0013897954473941487,
    "awayPregameElo": 1314,
    "awayPostgameElo": 1259,
    "excitementIndex": 3.1802381861,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636871,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-15T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 24513,
    "venueId": 3984,
    "venue": "War Memorial Stadium",
    "homeId": 2751,
    "homeTeam": "Wyoming",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 14,
    "homeLineScores": [
      0,
      7,
      0,
      7
    ],
    "homePostgameWinProbability": 0.001879823761579304,
    "homePregameElo": 1354,
    "homePostgameElo": 1312,
    "awayId": 252,
    "awayTeam": "BYU",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 34,
    "awayLineScores": [
      7,
      10,
      17,
      0
    ],
    "awayPostgameWinProbability": 0.9981201762384206,
    "awayPregameElo": 1430,
    "awayPostgameElo": 1472,
    "excitementIndex": 3.1928097307,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635541,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-15T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 35197,
    "venueId": 3831,
    "venue": "California Memorial Stadium",
    "homeId": 25,
    "homeTeam": "California",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 31,
    "homeLineScores": [
      7,
      0,
      14,
      10
    ],
    "homePostgameWinProbability": 0.9817301561871665,
    "homePregameElo": 1502,
    "homePostgameElo": 1540,
    "awayId": 21,
    "awayTeam": "San Diego State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 10,
    "awayLineScores": [
      3,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.018269843812833475,
    "awayPregameElo": 1388,
    "awayPostgameElo": 1350,
    "excitementIndex": 4.9558040595,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641033,
    "season": 2024,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2024-09-15T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 39079,
    "venueId": 3660,
    "venue": "Valley Children's Stadium",
    "homeId": 278,
    "homeTeam": "Fresno State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 48,
    "homeLineScores": [
      14,
      17,
      17,
      0
    ],
    "homePostgameWinProbability": 0.9989555505271754,
    "homePregameElo": 1551,
    "homePostgameElo": 1680,
    "awayId": 166,
    "awayTeam": "New Mexico State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0010444494728245601,
    "awayPregameElo": 1431,
    "awayPostgameElo": 1302,
    "excitementIndex": 2.6317458936,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643790,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-19T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 34133,
    "venueId": 3792,
    "venue": "Kidd Brewer Stadium",
    "homeId": 2026,
    "homeTeam": "App State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 14,
    "homeLineScores": [
      0,
      7,
      0,
      7
    ],
    "homePostgameWinProbability": 0.000365851741178994,
    "homePregameElo": 1447,
    "homePostgameElo": 1366,
    "awayId": 6,
    "awayTeam": "South Alabama",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 48,
    "awayLineScores": [
      14,
      14,
      13,
      7
    ],
    "awayPostgameWinProbability": 0.999634148258821,
    "awayPregameElo": 1576,
    "awayPostgameElo": 1657,
    "excitementIndex": 1.5723330405,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401634766,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-20T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 39290,
    "venueId": 1964,
    "venue": "JMA Wireless Dome",
    "homeId": 183,
    "homeTeam": "Syracuse",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 24,
    "homeLineScores": [
      0,
      10,
      7,
      7
    ],
    "homePostgameWinProbability": 0.1490440505033184,
    "homePregameElo": 1386,
    "homePostgameElo": 1378,
    "awayId": 24,
    "awayTeam": "Stanford",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 26,
    "awayLineScores": [
      7,
      6,
      7,
      6
    ],
    "awayPostgameWinProbability": 0.8509559494966816,
    "awayPregameElo": 1295,
    "awayPostgameElo": 1303,
    "excitementIndex": 8.569416045,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628485,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 86936,
    "venueId": 3834,
    "venue": "Memorial Stadium (Lincoln, NE)",
    "homeId": 158,
    "homeTeam": "Nebraska",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 24,
    "homeLineScores": [
      10,
      7,
      0,
      7,
      0
    ],
    "homePostgameWinProbability": 0.3547871322306742,
    "homePregameElo": 1588,
    "homePostgameElo": 1570,
    "awayId": 356,
    "awayTeam": "Illinois",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      3,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.6452128677693258,
    "awayPregameElo": 1533,
    "awayPostgameElo": 1551,
    "excitementIndex": 7.7382389903,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643714,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T02:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 24808,
    "venueId": 3820,
    "venue": "Gesa Field",
    "homeId": 265,
    "homeTeam": "Washington State",
    "homeClassification": "fbs",
    "homeConference": "Pac-12",
    "homePoints": 54,
    "homeLineScores": [
      7,
      17,
      0,
      22,
      0,
      8
    ],
    "homePostgameWinProbability": 0.9133358983085522,
    "homePregameElo": 1595,
    "homePostgameElo": 1596,
    "awayId": 23,
    "awayTeam": "San Jos\u00e9 State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 52,
    "awayLineScores": [
      10,
      7,
      21,
      8,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.08666410169144778,
    "awayPregameElo": 1602,
    "awayPostgameElo": 1601,
    "excitementIndex": 10.6427695825,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628492,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 103871,
    "venueId": 3861,
    "venue": "Ohio Stadium",
    "homeId": 194,
    "homeTeam": "Ohio State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 49,
    "homeLineScores": [
      7,
      21,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9988671629158615,
    "homePregameElo": 2014,
    "homePostgameElo": 2038,
    "awayId": 276,
    "awayTeam": "Marshall",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 14,
    "awayLineScores": [
      7,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0011328370841384716,
    "awayPregameElo": 1384,
    "awayPostgameElo": 1360,
    "excitementIndex": 3.6816411505,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643791,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 22534,
    "venueId": 3666,
    "venue": "Cajun Field",
    "homeId": 309,
    "homeTeam": "Louisiana",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 33,
    "homeLineScores": [
      7,
      6,
      13,
      7
    ],
    "homePostgameWinProbability": 0.0059666755760555655,
    "homePregameElo": 1558,
    "homePostgameElo": 1543,
    "awayId": 2655,
    "awayTeam": "Tulane",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 41,
    "awayLineScores": [
      0,
      17,
      21,
      3
    ],
    "awayPostgameWinProbability": 0.9940333244239444,
    "awayPregameElo": 1561,
    "awayPostgameElo": 1576,
    "excitementIndex": 5.6751086353,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636873,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 38007,
    "venueId": 3854,
    "venue": "Nippert Stadium",
    "homeId": 2132,
    "homeTeam": "Cincinnati",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 34,
    "homeLineScores": [
      14,
      10,
      7,
      3
    ],
    "homePostgameWinProbability": 0.9989020702351785,
    "homePregameElo": 1429,
    "homePostgameElo": 1529,
    "awayId": 248,
    "awayTeam": "Houston",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0010979297648214814,
    "awayPregameElo": 1466,
    "awayPostgameElo": 1366,
    "excitementIndex": 2.6636884555,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628488,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 38006,
    "venueId": 3665,
    "venue": "SECU Stadium",
    "homeId": 120,
    "homeTeam": "Maryland",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 38,
    "homeLineScores": [
      17,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9989264610789277,
    "homePregameElo": 1698,
    "homePostgameElo": 1698,
    "awayId": 222,
    "awayTeam": "Villanova",
    "awayClassification": "fcs",
    "awayConference": "CAA",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      0,
      10,
      10
    ],
    "awayPostgameWinProbability": 0.0010735389210723145,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.7164030957,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628486,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 43109,
    "venueId": 3830,
    "venue": "Memorial Stadium (Bloomington, IN)",
    "homeId": 84,
    "homeTeam": "Indiana",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 52,
    "homeLineScores": [
      10,
      21,
      14,
      7
    ],
    "homePostgameWinProbability": 0.998333171707224,
    "homePregameElo": 1527,
    "homePostgameElo": 1592,
    "awayId": 2429,
    "awayTeam": "Charlotte",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      14,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0016668282927759792,
    "awayPregameElo": 1187,
    "awayPostgameElo": 1122,
    "excitementIndex": 3.5424424745,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635556,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 50500,
    "venueId": 3787,
    "venue": "Kenan Stadium",
    "homeId": 153,
    "homeTeam": "North Carolina",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 50,
    "homeLineScores": [
      14,
      7,
      17,
      12
    ],
    "homePostgameWinProbability": 0.14335113072837286,
    "homePregameElo": 1554,
    "homePostgameElo": 1519,
    "awayId": 256,
    "awayTeam": "James Madison",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 70,
    "awayLineScores": [
      25,
      28,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.8566488692716272,
    "awayPregameElo": 1699,
    "awayPostgameElo": 1734,
    "excitementIndex": 3.2030534224,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628367,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 49655,
    "venueId": 3693,
    "venue": "Davis Wade Stadium",
    "homeId": 344,
    "homeTeam": "Mississippi State",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 28,
    "homeLineScores": [
      7,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.13027343637126163,
    "homePregameElo": 1386,
    "homePostgameElo": 1355,
    "awayId": 57,
    "awayTeam": "Florida",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 45,
    "awayLineScores": [
      7,
      21,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.8697265636287383,
    "awayPregameElo": 1485,
    "awayPostgameElo": 1516,
    "excitementIndex": 3.9425420269,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636879,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 52428,
    "venueId": 3842,
    "venue": "Milan Puskar Stadium",
    "homeId": 277,
    "homeTeam": "West Virginia",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 32,
    "homeLineScores": [
      7,
      7,
      3,
      15
    ],
    "homePostgameWinProbability": 0.2702222025040236,
    "homePregameElo": 1541,
    "homePostgameElo": 1546,
    "awayId": 2305,
    "awayTeam": "Kansas",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 28,
    "awayLineScores": [
      0,
      7,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.7297777974959764,
    "awayPregameElo": 1603,
    "awayPostgameElo": 1598,
    "excitementIndex": 8.1653534777,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635552,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 81500,
    "venueId": 3836,
    "venue": "Memorial Stadium (Clemson, SC)",
    "homeId": 228,
    "homeTeam": "Clemson",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 59,
    "homeLineScores": [
      28,
      17,
      14,
      0
    ],
    "homePostgameWinProbability": 0.9830489380863561,
    "homePregameElo": 1757,
    "homePostgameElo": 1790,
    "awayId": 152,
    "awayTeam": "NC State",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 35,
    "awayLineScores": [
      0,
      7,
      7,
      21
    ],
    "awayPostgameWinProbability": 0.016951061913643928,
    "awayPregameElo": 1511,
    "awayPostgameElo": 1478,
    "excitementIndex": 2.0210250501,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645328,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 26654,
    "venueId": 3841,
    "venue": "Michie Stadium",
    "homeId": 349,
    "homeTeam": "Army",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 37,
    "homeLineScores": [
      7,
      21,
      9,
      0
    ],
    "homePostgameWinProbability": 0.9984307056725569,
    "homePregameElo": 1465,
    "homePostgameElo": 1499,
    "awayId": 242,
    "awayTeam": "Rice",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.001569294327443127,
    "awayPregameElo": 1259,
    "awayPostgameElo": 1225,
    "excitementIndex": 2.4401031288,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628364,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T16:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 61783,
    "venueId": 3683,
    "venue": "Kroger Field",
    "homeId": 96,
    "homeTeam": "Kentucky",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 41,
    "homeLineScores": [
      3,
      14,
      10,
      14
    ],
    "homePostgameWinProbability": 0.9986568087619092,
    "homePregameElo": 1583,
    "homePostgameElo": 1668,
    "awayId": 195,
    "awayTeam": "Ohio",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 6,
    "awayLineScores": [
      0,
      0,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.0013431912380907907,
    "awayPregameElo": 1486,
    "awayPostgameElo": 1401,
    "excitementIndex": 3.2291517115,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644735,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 18011,
    "venueId": 3786,
    "venue": "Kelly/Shorts Stadium",
    "homeId": 2117,
    "homeTeam": "Central Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 37,
    "homeLineScores": [
      0,
      23,
      0,
      14
    ],
    "homePostgameWinProbability": 0.9936869782520776,
    "homePregameElo": 1173,
    "homePostgameElo": 1174,
    "awayId": 2050,
    "awayTeam": "Ball State",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 34,
    "awayLineScores": [
      10,
      7,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.006313021747922365,
    "awayPregameElo": 1185,
    "awayPostgameElo": 1184,
    "excitementIndex": 6.6181255883,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643715,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 11384,
    "venueId": 3806,
    "venue": "Lincoln Financial Field",
    "homeId": 218,
    "homeTeam": "Temple",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 45,
    "homeLineScores": [
      0,
      17,
      7,
      21
    ],
    "homePostgameWinProbability": 0.9893971576390547,
    "homePregameElo": 1092,
    "homePostgameElo": 1141,
    "awayId": 328,
    "awayTeam": "Utah State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 29,
    "awayLineScores": [
      0,
      21,
      0,
      8
    ],
    "awayPostgameWinProbability": 0.01060284236094533,
    "awayPregameElo": 1242,
    "awayPostgameElo": 1193,
    "excitementIndex": 8.4879112983,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636875,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 55428,
    "venueId": 3772,
    "venue": "Jack Trice Stadium",
    "homeId": 66,
    "homeTeam": "Iowa State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 52,
    "homeLineScores": [
      14,
      17,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9988623730653208,
    "homePregameElo": 1610,
    "homePostgameElo": 1718,
    "awayId": 2032,
    "awayTeam": "Arkansas State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.0011376269346792256,
    "awayPregameElo": 1421,
    "awayPostgameElo": 1313,
    "excitementIndex": 5.4559009327,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644737,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 15509,
    "venueId": 3912,
    "venue": "Rynearson Stadium",
    "homeId": 2199,
    "homeTeam": "Eastern Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 36,
    "homeLineScores": [
      10,
      3,
      16,
      7
    ],
    "homePostgameWinProbability": null,
    "homePregameElo": 1303,
    "homePostgameElo": 1303,
    "awayId": 2598,
    "awayTeam": "St. Francis (PA)",
    "awayClassification": "fcs",
    "awayConference": "NEC",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": null,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": null,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635558,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 22104,
    "venueId": 3654,
    "venue": "Brooks Stadium (SC)",
    "homeId": 324,
    "homeTeam": "Coastal Carolina",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 24,
    "homeLineScores": [
      3,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.03903624249304642,
    "homePregameElo": 1519,
    "homePostgameElo": 1448,
    "awayId": 258,
    "awayTeam": "Virginia",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 43,
    "awayLineScores": [
      14,
      13,
      10,
      6
    ],
    "awayPostgameWinProbability": 0.9609637575069536,
    "awayPregameElo": 1318,
    "awayPostgameElo": 1389,
    "excitementIndex": 3.3143909632,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643713,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 16399,
    "venueId": 3816,
    "venue": "Mackay Stadium",
    "homeId": 2440,
    "homeTeam": "Nevada",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 49,
    "homeLineScores": [
      14,
      7,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9988172654878082,
    "homePregameElo": 1220,
    "homePostgameElo": 1220,
    "awayId": 331,
    "awayTeam": "Eastern Washington",
    "awayClassification": "fcs",
    "awayConference": "Big Sky",
    "awayPoints": 16,
    "awayLineScores": [
      0,
      3,
      0,
      13
    ],
    "awayPostgameWinProbability": 0.001182734512191752,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.4402235254,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641000,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 21788,
    "venueId": 3662,
    "venue": "AmFirst Stadium",
    "homeId": 55,
    "homeTeam": "Jacksonville State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 44,
    "homeLineScores": [
      14,
      7,
      23,
      0
    ],
    "homePostgameWinProbability": 0.9988923128029182,
    "homePregameElo": 1372,
    "homePostgameElo": 1453,
    "awayId": 2572,
    "awayTeam": "Southern Miss",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0011076871970817637,
    "awayPregameElo": 1187,
    "awayPostgameElo": 1106,
    "excitementIndex": 3.4673349718,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628493,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 109526,
    "venueId": 3632,
    "venue": "Beaver Stadium",
    "homeId": 213,
    "homeTeam": "Penn State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 56,
    "homeLineScores": [
      7,
      21,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9989704274472642,
    "homePregameElo": 1848,
    "homePostgameElo": 1905,
    "awayId": 2309,
    "awayTeam": "Kent State",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0010295725527358357,
    "awayPregameElo": 989,
    "awayPostgameElo": 932,
    "excitementIndex": 3.5624619704,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644736,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 18688,
    "venueId": 3764,
    "venue": "Huskie Stadium",
    "homeId": 2459,
    "homeTeam": "Northern Illinois",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 20,
    "homeLineScores": [
      7,
      7,
      0,
      6,
      0
    ],
    "homePostgameWinProbability": 0.8042575150701324,
    "homePregameElo": 1476,
    "homePostgameElo": 1464,
    "awayId": 2084,
    "awayTeam": "Buffalo",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 23,
    "awayLineScores": [
      0,
      3,
      7,
      10,
      3
    ],
    "awayPostgameWinProbability": 0.19574248492986757,
    "awayPregameElo": 1360,
    "awayPostgameElo": 1372,
    "excitementIndex": 9.4545107191,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401629042,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 10847,
    "venueId": 3985,
    "venue": "Warren McGuirk Alumni Stadium",
    "homeId": 113,
    "homeTeam": "Massachusetts",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 35,
    "homeLineScores": [
      7,
      14,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9965496435866243,
    "homePregameElo": 1057,
    "homePostgameElo": 1057,
    "awayId": 2115,
    "awayTeam": "Central Connecticut",
    "awayClassification": "fcs",
    "awayConference": "NEC",
    "awayPoints": 31,
    "awayLineScores": [
      0,
      21,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.003450356413375655,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 6.5087893456,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628979,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 77622,
    "venueId": 3855,
    "venue": "Notre Dame Stadium",
    "homeId": 87,
    "homeTeam": "Notre Dame",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 28,
    "homeLineScores": [
      0,
      14,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9986494251644964,
    "homePregameElo": 1992,
    "homePostgameElo": 2000,
    "awayId": 193,
    "awayTeam": "Miami (OH)",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.001350574835503604,
    "awayPregameElo": 1458,
    "awayPostgameElo": 1450,
    "excitementIndex": 6.0816618423,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628494,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 65632,
    "venueId": 3799,
    "venue": "Lane Stadium",
    "homeId": 259,
    "homeTeam": "Virginia Tech",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 23,
    "homeLineScores": [
      0,
      7,
      0,
      16
    ],
    "homePostgameWinProbability": 0.1413056103082315,
    "homePregameElo": 1626,
    "homePostgameElo": 1614,
    "awayId": 164,
    "awayTeam": "Rutgers",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 26,
    "awayLineScores": [
      14,
      2,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.8586943896917685,
    "awayPregameElo": 1511,
    "awayPostgameElo": 1523,
    "excitementIndex": 4.7686009891,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628363,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 88043,
    "venueId": 3785,
    "venue": "Jordan-Hare Stadium",
    "homeId": 2,
    "homeTeam": "Auburn",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 14,
    "homeLineScores": [
      0,
      0,
      7,
      7
    ],
    "homePostgameWinProbability": 0.4738599991671969,
    "homePregameElo": 1569,
    "homePostgameElo": 1537,
    "awayId": 8,
    "awayTeam": "Arkansas",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 24,
    "awayLineScores": [
      0,
      7,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.5261400008328031,
    "awayPregameElo": 1451,
    "awayPostgameElo": 1483,
    "excitementIndex": 7.609649793,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645330,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 20973,
    "venueId": 3604,
    "venue": "Alamodome",
    "homeId": 2636,
    "homeTeam": "UTSA",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 45,
    "homeLineScores": [
      10,
      21,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9988113362451293,
    "homePregameElo": 1366,
    "homePostgameElo": 1366,
    "awayId": 2277,
    "awayTeam": "Houston Christian",
    "awayClassification": "fcs",
    "awayConference": "Southland",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0011886637548707002,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.332640735,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628365,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 100315,
    "venueId": 3958,
    "venue": "Tiger Stadium (LA)",
    "homeId": 99,
    "homeTeam": "LSU",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 34,
    "homeLineScores": [
      7,
      10,
      7,
      10
    ],
    "homePostgameWinProbability": 0.985005897829529,
    "homePregameElo": 1798,
    "homePostgameElo": 1805,
    "awayId": 26,
    "awayTeam": "UCLA",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 17,
    "awayLineScores": [
      10,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.014994102170471035,
    "awayPregameElo": 1456,
    "awayPostgameElo": 1449,
    "excitementIndex": 5.785520424,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628489,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 110702,
    "venueId": 3558,
    "venue": "Michigan Stadium",
    "homeId": 130,
    "homeTeam": "Michigan",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 27,
    "homeLineScores": [
      7,
      7,
      6,
      7
    ],
    "homePostgameWinProbability": 0.9585892061787497,
    "homePregameElo": 1911,
    "homePostgameElo": 1910,
    "awayId": 30,
    "awayTeam": "USC",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 24,
    "awayLineScores": [
      0,
      3,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.04141079382125035,
    "awayPregameElo": 1768,
    "awayPostgameElo": 1769,
    "excitementIndex": 8.7964960185,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645329,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 31268,
    "venueId": 3852,
    "venue": "Navy-Marine Corps Memorial Stadium",
    "homeId": 2426,
    "homeTeam": "Navy",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 56,
    "homeLineScores": [
      7,
      21,
      7,
      21
    ],
    "homePostgameWinProbability": 0.9988528789452599,
    "homePregameElo": 1409,
    "homePostgameElo": 1451,
    "awayId": 235,
    "awayTeam": "Memphis",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 44,
    "awayLineScores": [
      14,
      3,
      13,
      14
    ],
    "awayPostgameWinProbability": 0.00114712105474013,
    "awayPregameElo": 1639,
    "awayPostgameElo": 1597,
    "excitementIndex": 5.7624205481,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635554,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 50727,
    "venueId": 3873,
    "venue": "L&N Federal Credit Union Stadium",
    "homeId": 97,
    "homeTeam": "Louisville",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 31,
    "homeLineScores": [
      7,
      10,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9479456067508492,
    "homePregameElo": 1700,
    "homePostgameElo": 1711,
    "awayId": 59,
    "awayTeam": "Georgia Tech",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 19,
    "awayLineScores": [
      7,
      7,
      3,
      2
    ],
    "awayPostgameWinProbability": 0.05205439324915084,
    "awayPregameElo": 1556,
    "awayPostgameElo": 1545,
    "excitementIndex": 6.2185404063,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401634247,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 48437,
    "venueId": 3752,
    "venue": "Acrisure Stadium",
    "homeId": 221,
    "homeTeam": "Pittsburgh",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 73,
    "homeLineScores": [
      21,
      21,
      10,
      21
    ],
    "homePostgameWinProbability": 0.9986907179503097,
    "homePregameElo": 1488,
    "homePostgameElo": 1488,
    "awayId": 2754,
    "awayTeam": "Youngstown State",
    "awayClassification": "fcs",
    "awayConference": "MVFC",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      10,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.0013092820496902746,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.4052480193,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636877,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 58795,
    "venueId": 3784,
    "venue": "Jones AT&T Stadium",
    "homeId": 2641,
    "homeTeam": "Texas Tech",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 30,
    "homeLineScores": [
      14,
      3,
      7,
      6
    ],
    "homePostgameWinProbability": 0.3814853635278148,
    "homePregameElo": 1623,
    "homePostgameElo": 1628,
    "awayId": 9,
    "awayTeam": "Arizona State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 22,
    "awayLineScores": [
      0,
      10,
      6,
      6
    ],
    "awayPostgameWinProbability": 0.6185146364721852,
    "awayPregameElo": 1511,
    "awayPostgameElo": 1506,
    "excitementIndex": 5.9004704465,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636876,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 52202,
    "venueId": 3646,
    "venue": "Boone Pickens Stadium",
    "homeId": 197,
    "homeTeam": "Oklahoma State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 19,
    "homeLineScores": [
      3,
      0,
      0,
      16
    ],
    "homePostgameWinProbability": 0.010408504193486882,
    "homePregameElo": 1595,
    "homePostgameElo": 1593,
    "awayId": 254,
    "awayTeam": "Utah",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 22,
    "awayLineScores": [
      0,
      10,
      3,
      9
    ],
    "awayPostgameWinProbability": 0.9895914958065131,
    "awayPregameElo": 1631,
    "awayPostgameElo": 1633,
    "excitementIndex": 5.0077398301,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635553,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 15209,
    "venueId": 3725,
    "venue": "Johnny \"Red\" Floyd Stadium",
    "homeId": 2393,
    "homeTeam": "Middle Tennessee",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 17,
    "homeLineScores": [
      10,
      0,
      7,
      0
    ],
    "homePostgameWinProbability": 0.0009954820388864655,
    "homePregameElo": 1215,
    "homePostgameElo": 1182,
    "awayId": 150,
    "awayTeam": "Duke",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 45,
    "awayLineScores": [
      28,
      7,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.9990045179611136,
    "awayPregameElo": 1590,
    "awayPostgameElo": 1623,
    "excitementIndex": 2.3648336031,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628368,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T20:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 62621,
    "venueId": 3838,
    "venue": "Memorial Stadium",
    "homeId": 142,
    "homeTeam": "Missouri",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 30,
    "homeLineScores": [
      7,
      3,
      10,
      0,
      10
    ],
    "homePostgameWinProbability": 0.27254257561101886,
    "homePregameElo": 1795,
    "homePostgameElo": 1790,
    "awayId": 238,
    "awayTeam": "Vanderbilt",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 27,
    "awayLineScores": [
      7,
      6,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.7274574243889811,
    "awayPregameElo": 1312,
    "awayPostgameElo": 1317,
    "excitementIndex": 9.619524509,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641028,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 29151,
    "venueId": 5388,
    "venue": "Canvas Stadium",
    "homeId": 36,
    "homeTeam": "Colorado State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 27,
    "homeLineScores": [
      7,
      7,
      10,
      3
    ],
    "homePostgameWinProbability": 0.9704768467372228,
    "homePregameElo": 1219,
    "homePostgameElo": 1236,
    "awayId": 2638,
    "awayTeam": "UTEP",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      3,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.029523153262777213,
    "awayPregameElo": 1223,
    "awayPostgameElo": 1206,
    "excitementIndex": 5.4054991639,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635557,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 33168,
    "venueId": 3735,
    "venue": "Gerald J. Ford Stadium",
    "homeId": 2567,
    "homeTeam": "SMU",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 66,
    "homeLineScores": [
      17,
      24,
      18,
      7
    ],
    "homePostgameWinProbability": 0.981498187675888,
    "homePregameElo": 1648,
    "homePostgameElo": 1700,
    "awayId": 2628,
    "awayTeam": "TCU",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 42,
    "awayLineScores": [
      0,
      21,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.018501812324111966,
    "awayPregameElo": 1580,
    "awayPostgameElo": 1528,
    "excitementIndex": 4.3086547023,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628625,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": false,
    "attendance": 17922,
    "venueId": 2031,
    "venue": "Pitbull Stadium",
    "homeId": 2229,
    "homeTeam": "Florida International",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 42,
    "homeLineScores": [
      14,
      14,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9883645065886499,
    "homePregameElo": 1239,
    "homePostgameElo": 1239,
    "awayId": 2405,
    "awayTeam": "Monmouth",
    "awayClassification": "fcs",
    "awayConference": "CAA",
    "awayPoints": 45,
    "awayLineScores": [
      7,
      14,
      14,
      10
    ],
    "awayPostgameWinProbability": 0.011635493411350062,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 6.3219068126,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401640991,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 24076,
    "venueId": 3992,
    "venue": "Williams Stadium (VA)",
    "homeId": 2335,
    "homeTeam": "Liberty",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 35,
    "homeLineScores": [
      0,
      7,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9941335504778246,
    "homePregameElo": 1582,
    "homePostgameElo": 1589,
    "awayId": 151,
    "awayTeam": "East Carolina",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 24,
    "awayLineScores": [
      14,
      3,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.00586644952217541,
    "awayPregameElo": 1414,
    "awayPostgameElo": 1407,
    "excitementIndex": 6.4427227082,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636374,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 29024,
    "venueId": 3975,
    "venue": "Veterans Memorial Stadium (AL)",
    "homeId": 2653,
    "homeTeam": "Troy",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 34,
    "homeLineScores": [
      7,
      7,
      7,
      13
    ],
    "homePostgameWinProbability": 0.9988587901580321,
    "homePregameElo": 1538,
    "homePostgameElo": 1538,
    "awayId": 50,
    "awayTeam": "Florida A&M",
    "awayClassification": "fcs",
    "awayConference": "SWAC",
    "awayPoints": 12,
    "awayLineScores": [
      6,
      3,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.0011412098419678607,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 5.0048566209,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641037,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 19127,
    "venueId": 3796,
    "venue": "Houchens Industries-L.T. Smith Stadium",
    "homeId": 98,
    "homeTeam": "Western Kentucky",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 26,
    "homeLineScores": [
      0,
      7,
      5,
      14
    ],
    "homePostgameWinProbability": 0.8172534749790489,
    "homePregameElo": 1396,
    "homePostgameElo": 1409,
    "awayId": 2649,
    "awayTeam": "Toledo",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      14,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.18274652502095112,
    "awayPregameElo": 1578,
    "awayPostgameElo": 1565,
    "excitementIndex": 7.5693083783,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641008,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 18152,
    "venueId": 3776,
    "venue": "Joe Aillet Stadium",
    "homeId": 2348,
    "homeTeam": "Louisiana Tech",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 20,
    "homeLineScores": [
      0,
      7,
      0,
      13,
      0
    ],
    "homePostgameWinProbability": 0.29860105174174784,
    "homePregameElo": 1247,
    "homePostgameElo": 1239,
    "awayId": 202,
    "awayTeam": "Tulsa",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 23,
    "awayLineScores": [
      7,
      3,
      7,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.7013989482582521,
    "awayPregameElo": 1185,
    "awayPostgameElo": 1193,
    "excitementIndex": 8.2645819638,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628491,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 69788,
    "venueId": 3765,
    "venue": "Husky Stadium",
    "homeId": 264,
    "homeTeam": "Washington",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 24,
    "homeLineScores": [
      7,
      10,
      0,
      7
    ],
    "homePostgameWinProbability": 0.9989650898845579,
    "homePregameElo": 1745,
    "homePostgameElo": 1766,
    "awayId": 77,
    "awayTeam": "Northwestern",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 5,
    "awayLineScores": [
      0,
      2,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.0010349101154421003,
    "awayPregameElo": 1514,
    "awayPostgameElo": 1493,
    "excitementIndex": 3.6213199876,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641034,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": null,
    "venueId": 3647,
    "venue": "Elliott T. Bowers Stadium",
    "homeId": 2534,
    "homeTeam": "Sam Houston",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 31,
    "homeLineScores": [
      14,
      7,
      0,
      10
    ],
    "homePostgameWinProbability": 0.007016222904642351,
    "homePregameElo": 1398,
    "homePostgameElo": 1435,
    "awayId": 166,
    "awayTeam": "New Mexico State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 11,
    "awayLineScores": [
      3,
      0,
      0,
      8
    ],
    "awayPostgameWinProbability": 0.9929837770953577,
    "awayPregameElo": 1302,
    "awayPostgameElo": 1265,
    "excitementIndex": 3.8631946019,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643716,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 27049,
    "venueId": 3825,
    "venue": "DATCU Stadium",
    "homeId": 249,
    "homeTeam": "North Texas",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 44,
    "homeLineScores": [
      7,
      20,
      14,
      3
    ],
    "homePostgameWinProbability": 0.9980916125191562,
    "homePregameElo": 1336,
    "homePostgameElo": 1403,
    "awayId": 2751,
    "awayTeam": "Wyoming",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 17,
    "awayLineScores": [
      3,
      14,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.001908387480843765,
    "awayPregameElo": 1312,
    "awayPostgameElo": 1245,
    "excitementIndex": 4.0053375224,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635555,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 58616,
    "venueId": 3886,
    "venue": "Raymond James Stadium",
    "homeId": 58,
    "homeTeam": "South Florida",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 15,
    "homeLineScores": [
      9,
      6,
      0,
      0
    ],
    "homePostgameWinProbability": 0.001001368047446176,
    "homePregameElo": 1476,
    "homePostgameElo": 1413,
    "awayId": 2390,
    "awayTeam": "Miami",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 50,
    "awayLineScores": [
      14,
      8,
      14,
      14
    ],
    "awayPostgameWinProbability": 0.9989986319525538,
    "awayPregameElo": 1774,
    "awayPostgameElo": 1837,
    "excitementIndex": 4.3442059452,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635551,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 55107,
    "venueId": 3697,
    "venue": "Doak Campbell Stadium",
    "homeId": 52,
    "homeTeam": "Florida State",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 14,
    "homeLineScores": [
      7,
      0,
      0,
      7
    ],
    "homePostgameWinProbability": 0.5026968974512162,
    "homePregameElo": 1596,
    "homePostgameElo": 1599,
    "awayId": 25,
    "awayTeam": "California",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 9,
    "awayLineScores": [
      0,
      6,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.49730310254878385,
    "awayPregameElo": 1540,
    "awayPostgameElo": 1537,
    "excitementIndex": 9.9143093528,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401629031,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 20144,
    "venueId": 3892,
    "venue": "Pratt & Whitney Stadium",
    "homeId": 41,
    "homeTeam": "UConn",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 48,
    "homeLineScores": [
      3,
      14,
      10,
      21
    ],
    "homePostgameWinProbability": 0.991711905067892,
    "homePregameElo": 1169,
    "homePostgameElo": 1297,
    "awayId": 2226,
    "awayTeam": "Florida Atlantic",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.008288094932108026,
    "awayPregameElo": 1403,
    "awayPostgameElo": 1275,
    "excitementIndex": 3.7160889462,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628370,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 78704,
    "venueId": 3994,
    "venue": "Williams-Brice Stadium",
    "homeId": 2579,
    "homeTeam": "South Carolina",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 50,
    "homeLineScores": [
      15,
      7,
      7,
      21
    ],
    "homePostgameWinProbability": 0.998921525235758,
    "homePregameElo": 1642,
    "homePostgameElo": 1699,
    "awayId": 2006,
    "awayTeam": "Akron",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0010784747642420545,
    "awayPregameElo": 1110,
    "awayPostgameElo": 1053,
    "excitementIndex": 4.4608683407,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628487,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 52048,
    "venueId": 3953,
    "venue": "Huntington Bank Stadium",
    "homeId": 135,
    "homeTeam": "Minnesota",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 14,
    "homeLineScores": [
      0,
      14,
      0,
      0
    ],
    "homePostgameWinProbability": 0.05824283009564871,
    "homePregameElo": 1537,
    "homePostgameElo": 1502,
    "awayId": 2294,
    "awayTeam": "Iowa",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      0,
      17,
      7
    ],
    "awayPostgameWinProbability": 0.9417571699043513,
    "awayPregameElo": 1591,
    "awayPostgameElo": 1626,
    "excitementIndex": 4.8042144941,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628369,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 84701,
    "venueId": 3835,
    "venue": "Memorial Stadium (Norman, OK)",
    "homeId": 201,
    "homeTeam": "Oklahoma",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 15,
    "homeLineScores": [
      3,
      0,
      0,
      12
    ],
    "homePostgameWinProbability": 0.09017369358378567,
    "homePregameElo": 1848,
    "homePostgameElo": 1837,
    "awayId": 2633,
    "awayTeam": "Tennessee",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 25,
    "awayLineScores": [
      10,
      9,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.9098263064162143,
    "awayPregameElo": 1964,
    "awayPostgameElo": 1975,
    "excitementIndex": 4.1458506038,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628372,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 99523,
    "venueId": 3795,
    "venue": "Kyle Field",
    "homeId": 245,
    "homeTeam": "Texas A&M",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 26,
    "homeLineScores": [
      7,
      6,
      7,
      6
    ],
    "homePostgameWinProbability": 0.9745075158794131,
    "homePregameElo": 1689,
    "homePostgameElo": 1685,
    "awayId": 189,
    "awayTeam": "Bowling Green",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      3,
      14,
      3
    ],
    "awayPostgameWinProbability": 0.02549248412058691,
    "awayPregameElo": 1444,
    "awayPostgameElo": 1448,
    "excitementIndex": 6.5177861153,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628366,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-21T23:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 67505,
    "venueId": 3974,
    "venue": "Vaught-Hemingway Stadium",
    "homeId": 145,
    "homeTeam": "Ole Miss",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 52,
    "homeLineScores": [
      17,
      7,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9988444751899406,
    "homePregameElo": 1824,
    "homePostgameElo": 1879,
    "awayId": 290,
    "awayTeam": "Georgia Southern",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      7,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.0011555248100594273,
    "awayPregameElo": 1379,
    "awayPostgameElo": 1324,
    "excitementIndex": 3.7532950843,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628371,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-22T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 102850,
    "venueId": 3910,
    "venue": "DKR-Texas Memorial Stadium",
    "homeId": 251,
    "homeTeam": "Texas",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 51,
    "homeLineScores": [
      21,
      7,
      9,
      14
    ],
    "homePostgameWinProbability": 0.9988528992940259,
    "homePregameElo": 2068,
    "homePostgameElo": 2107,
    "awayId": 2433,
    "awayTeam": "UL Monroe",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0011471007059741245,
    "awayPregameElo": 1249,
    "awayPostgameElo": 1210,
    "excitementIndex": 2.860845681,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636874,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-22T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 52794,
    "venueId": 3726,
    "venue": "Folsom Field",
    "homeId": 38,
    "homeTeam": "Colorado",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 38,
    "homeLineScores": [
      7,
      10,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.3460821362347709,
    "homePregameElo": 1349,
    "homePostgameElo": 1368,
    "awayId": 239,
    "awayTeam": "Baylor",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 31,
    "awayLineScores": [
      3,
      21,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.6539178637652291,
    "awayPregameElo": 1507,
    "awayPostgameElo": 1488,
    "excitementIndex": 8.3588579146,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628490,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-22T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 44500,
    "venueId": 3615,
    "venue": "Alumni Stadium (Chestnut Hill, MA)",
    "homeId": 103,
    "homeTeam": "Boston College",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 23,
    "homeLineScores": [
      0,
      6,
      10,
      7
    ],
    "homePostgameWinProbability": 0.8726267346453923,
    "homePregameElo": 1470,
    "homePostgameElo": 1472,
    "awayId": 127,
    "awayTeam": "Michigan State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 19,
    "awayLineScores": [
      3,
      10,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.1273732653546077,
    "awayPregameElo": 1425,
    "awayPostgameElo": 1423,
    "excitementIndex": 7.9665974973,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643711,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-22T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 18019,
    "venueId": 3971,
    "venue": "University Stadium (NM)",
    "homeId": 167,
    "homeTeam": "New Mexico",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 21,
    "homeLineScores": [
      3,
      7,
      0,
      11
    ],
    "homePostgameWinProbability": 0.27411160912413174,
    "homePregameElo": 1196,
    "homePostgameElo": 1201,
    "awayId": 278,
    "awayTeam": "Fresno State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 38,
    "awayLineScores": [
      8,
      17,
      3,
      10
    ],
    "awayPostgameWinProbability": 0.7258883908758682,
    "awayPregameElo": 1680,
    "awayPostgameElo": 1675,
    "excitementIndex": 3.2033767502,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643717,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-22T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 34340,
    "venueId": 3893,
    "venue": "Reser Stadium",
    "homeId": 204,
    "homeTeam": "Oregon State",
    "homeClassification": "fbs",
    "homeConference": "Pac-12",
    "homePoints": 38,
    "homeLineScores": [
      7,
      10,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9518488125411446,
    "homePregameElo": 1604,
    "homePostgameElo": 1619,
    "awayId": 2509,
    "awayTeam": "Purdue",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      7,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.04815118745885538,
    "awayPregameElo": 1358,
    "awayPostgameElo": 1343,
    "excitementIndex": 5.2980932528,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401637162,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-22T01:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 36972,
    "venueId": 3653,
    "venue": "Albertsons Stadium",
    "homeId": 68,
    "homeTeam": "Boise State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 56,
    "homeLineScores": [
      7,
      21,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9988357251894284,
    "homePregameElo": 1636,
    "homePostgameElo": 1636,
    "awayId": 2502,
    "awayTeam": "Portland State",
    "awayClassification": "fcs",
    "awayConference": "Big Sky",
    "awayPoints": 14,
    "awayLineScores": [
      7,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.001164274810571575,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.2805577738,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636872,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-22T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 64201,
    "venueId": 3801,
    "venue": "LaVell Edwards Stadium",
    "homeId": 252,
    "homeTeam": "BYU",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 38,
    "homeLineScores": [
      0,
      17,
      14,
      7
    ],
    "homePostgameWinProbability": 0.3460414914488405,
    "homePregameElo": 1472,
    "homePostgameElo": 1600,
    "awayId": 2306,
    "awayTeam": "Kansas State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 9,
    "awayLineScores": [
      3,
      3,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.6539585085511594,
    "awayPregameElo": 1842,
    "awayPostgameElo": 1714,
    "excitementIndex": 4.0025471772,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643712,
    "season": 2024,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2024-09-22T03:59:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 11402,
    "venueId": 7220,
    "venue": "Clarence T.C. Ching Athletics Complex",
    "homeId": 62,
    "homeTeam": "Hawai'i",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 36,
    "homeLineScores": [
      15,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9977768458348251,
    "homePregameElo": 1211,
    "homePostgameElo": 1211,
    "awayId": 2460,
    "awayTeam": "Northern Iowa",
    "awayClassification": "fcs",
    "awayConference": "MVFC",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0022231541651749342,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.2067678244,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645331,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-26T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 13255,
    "venueId": 3806,
    "venue": "Lincoln Financial Field",
    "homeId": 218,
    "homeTeam": "Temple",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 14,
    "homeLineScores": [
      0,
      0,
      6,
      8
    ],
    "homePostgameWinProbability": 0.0006732126221154471,
    "homePregameElo": 1141,
    "homePostgameElo": 1106,
    "awayId": 349,
    "awayTeam": "Army",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 42,
    "awayLineScores": [
      7,
      7,
      14,
      14
    ],
    "awayPostgameWinProbability": 0.9993267873778846,
    "awayPregameElo": 1499,
    "awayPostgameElo": 1534,
    "excitementIndex": 2.4520747902,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401634767,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-27T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 59539,
    "venueId": 3948,
    "venue": "Hard Rock Stadium",
    "homeId": 2390,
    "homeTeam": "Miami",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 38,
    "homeLineScores": [
      14,
      3,
      7,
      14
    ],
    "homePostgameWinProbability": 0.8207452615666921,
    "homePregameElo": 1837,
    "homePostgameElo": 1834,
    "awayId": 259,
    "awayTeam": "Virginia Tech",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 34,
    "awayLineScores": [
      7,
      17,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.17925473843330786,
    "awayPregameElo": 1614,
    "awayPostgameElo": 1617,
    "excitementIndex": 7.1089230036,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628501,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 54079,
    "venueId": 6577,
    "venue": "SHI Stadium",
    "homeId": 164,
    "homeTeam": "Rutgers",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 21,
    "homeLineScores": [
      0,
      14,
      0,
      7
    ],
    "homePostgameWinProbability": 0.2796311771252414,
    "homePregameElo": 1523,
    "homePostgameElo": 1527,
    "awayId": 264,
    "awayTeam": "Washington",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 18,
    "awayLineScores": [
      3,
      0,
      7,
      8
    ],
    "awayPostgameWinProbability": 0.7203688228747587,
    "awayPregameElo": 1766,
    "awayPostgameElo": 1762,
    "excitementIndex": 5.3588755655,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636883,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": null,
    "venueId": 3636,
    "venue": "Bill Snyder Family Stadium",
    "homeId": 2306,
    "homeTeam": "Kansas State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 42,
    "homeLineScores": [
      7,
      14,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9987864344506733,
    "homePregameElo": 1714,
    "homePostgameElo": 1754,
    "awayId": 197,
    "awayTeam": "Oklahoma State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 20,
    "awayLineScores": [
      3,
      10,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.0012135655493267228,
    "awayPregameElo": 1593,
    "awayPostgameElo": 1553,
    "excitementIndex": 4.3914478852,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635560,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 41403,
    "venueId": 3615,
    "venue": "Alumni Stadium (Chestnut Hill, MA)",
    "homeId": 103,
    "homeTeam": "Boston College",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 21,
    "homeLineScores": [
      0,
      7,
      0,
      14
    ],
    "homePostgameWinProbability": 0.4690952053969081,
    "homePregameElo": 1472,
    "homePostgameElo": 1471,
    "awayId": 98,
    "awayTeam": "Western Kentucky",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 20,
    "awayLineScores": [
      7,
      10,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.5309047946030919,
    "awayPregameElo": 1409,
    "awayPostgameElo": 1410,
    "excitementIndex": 5.6916084438,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645332,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 21536,
    "venueId": 7221,
    "venue": "Protective Stadium",
    "homeId": 5,
    "homeTeam": "UAB",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 18,
    "homeLineScores": [
      0,
      3,
      7,
      8
    ],
    "homePostgameWinProbability": 0.009568800253246804,
    "homePregameElo": 1265,
    "homePostgameElo": 1226,
    "awayId": 2426,
    "awayTeam": "Navy",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 41,
    "awayLineScores": [
      7,
      14,
      10,
      10
    ],
    "awayPostgameWinProbability": 0.9904311997467532,
    "awayPregameElo": 1451,
    "awayPostgameElo": 1490,
    "excitementIndex": 2.2221170068,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636880,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 39583,
    "venueId": 4727,
    "venue": "McLane Stadium",
    "homeId": 239,
    "homeTeam": "Baylor",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 28,
    "homeLineScores": [
      7,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.2634776024180266,
    "homePregameElo": 1488,
    "homePostgameElo": 1485,
    "awayId": 252,
    "awayTeam": "BYU",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 34,
    "awayLineScores": [
      21,
      10,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.7365223975819735,
    "awayPregameElo": 1600,
    "awayPostgameElo": 1603,
    "excitementIndex": 4.6384675945,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628377,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": null,
    "venueId": 3974,
    "venue": "Vaught-Hemingway Stadium",
    "homeId": 145,
    "homeTeam": "Ole Miss",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 17,
    "homeLineScores": [
      7,
      0,
      10,
      0
    ],
    "homePostgameWinProbability": 0.5076055341165858,
    "homePregameElo": 1879,
    "homePostgameElo": 1861,
    "awayId": 96,
    "awayTeam": "Kentucky",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 20,
    "awayLineScores": [
      3,
      7,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.4923944658834142,
    "awayPregameElo": 1668,
    "awayPostgameElo": 1686,
    "excitementIndex": 8.5683895645,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628497,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 110340,
    "venueId": 3558,
    "venue": "Michigan Stadium",
    "homeId": 130,
    "homeTeam": "Michigan",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 27,
    "homeLineScores": [
      7,
      14,
      3,
      3
    ],
    "homePostgameWinProbability": 0.8368064978953907,
    "homePregameElo": 1910,
    "homePostgameElo": 1906,
    "awayId": 135,
    "awayTeam": "Minnesota",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 24,
    "awayLineScores": [
      0,
      3,
      0,
      21
    ],
    "awayPostgameWinProbability": 0.16319350210460926,
    "awayPregameElo": 1502,
    "awayPostgameElo": 1506,
    "excitementIndex": 4.5968774706,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635564,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 56919,
    "venueId": 3670,
    "venue": "Carter-Finley Stadium",
    "homeId": 152,
    "homeTeam": "NC State",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 24,
    "homeLineScores": [
      7,
      10,
      7,
      0
    ],
    "homePostgameWinProbability": 0.18919331608993545,
    "homePregameElo": 1478,
    "homePostgameElo": 1487,
    "awayId": 2459,
    "awayTeam": "Northern Illinois",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 17,
    "awayLineScores": [
      7,
      7,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.8108066839100645,
    "awayPregameElo": 1464,
    "awayPostgameElo": 1455,
    "excitementIndex": 6.228092864,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628496,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 48323,
    "venueId": 3830,
    "venue": "Memorial Stadium (Bloomington, IN)",
    "homeId": 84,
    "homeTeam": "Indiana",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 42,
    "homeLineScores": [
      0,
      14,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9900167186508116,
    "homePregameElo": 1592,
    "homePostgameElo": 1628,
    "awayId": 120,
    "awayTeam": "Maryland",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 28,
    "awayLineScores": [
      0,
      7,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.009983281349188355,
    "awayPregameElo": 1678,
    "awayPostgameElo": 1642,
    "excitementIndex": 9.5697028927,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645337,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20783,
    "venueId": 4729,
    "venue": "Yulman Stadium",
    "homeId": 2655,
    "homeTeam": "Tulane",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 45,
    "homeLineScores": [
      14,
      17,
      0,
      14
    ],
    "homePostgameWinProbability": 0.9989238107224483,
    "homePregameElo": 1576,
    "homePostgameElo": 1653,
    "awayId": 58,
    "awayTeam": "South Florida",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      7,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.001076189277551709,
    "awayPregameElo": 1413,
    "awayPostgameElo": 1336,
    "excitementIndex": 2.8602920152,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401629032,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 20347,
    "venueId": 3892,
    "venue": "Pratt & Whitney Stadium",
    "homeId": 41,
    "homeTeam": "UConn",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 47,
    "homeLineScores": [
      10,
      13,
      14,
      10
    ],
    "homePostgameWinProbability": 0.9986057117476549,
    "homePregameElo": 1297,
    "homePostgameElo": 1441,
    "awayId": 2084,
    "awayTeam": "Buffalo",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0013942882523451106,
    "awayPregameElo": 1372,
    "awayPostgameElo": 1228,
    "excitementIndex": 3.1734859026,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628499,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 61441,
    "venueId": 3907,
    "venue": "Ross-Ade Stadium",
    "homeId": 2509,
    "homeTeam": "Purdue",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 10,
    "homeLineScores": [
      0,
      0,
      3,
      7
    ],
    "homePostgameWinProbability": 0.007497810628081133,
    "homePregameElo": 1343,
    "homePostgameElo": 1322,
    "awayId": 158,
    "awayTeam": "Nebraska",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 28,
    "awayLineScores": [
      0,
      0,
      7,
      21
    ],
    "awayPostgameWinProbability": 0.9925021893719189,
    "awayPregameElo": 1570,
    "awayPostgameElo": 1591,
    "excitementIndex": 4.3493917902,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635565,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 43455,
    "venueId": 1964,
    "venue": "JMA Wireless Dome",
    "homeId": 183,
    "homeTeam": "Syracuse",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 42,
    "homeLineScores": [
      14,
      14,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9969186912232494,
    "homePregameElo": 1379,
    "homePostgameElo": 1379,
    "awayId": 107,
    "awayTeam": "Holy Cross",
    "awayClassification": "fcs",
    "awayConference": "Patriot",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      14,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.003081308776750613,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.1831330814,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643793,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T17:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 25786,
    "venueId": 3651,
    "venue": "Bridgeforth Stadium",
    "homeId": 256,
    "homeTeam": "James Madison",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 63,
    "homeLineScores": [
      22,
      7,
      20,
      14
    ],
    "homePostgameWinProbability": 0.9989244133362886,
    "homePregameElo": 1734,
    "homePostgameElo": 1830,
    "awayId": 2050,
    "awayTeam": "Ball State",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 7,
    "awayLineScores": [
      7,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0010755866637114364,
    "awayPregameElo": 1184,
    "awayPostgameElo": 1088,
    "excitementIndex": 2.9560341032,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641041,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": false,
    "attendance": 27225,
    "venueId": 3891,
    "venue": "NRG Stadium",
    "homeId": 2534,
    "homeTeam": "Sam Houston",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 40,
    "homeLineScores": [
      0,
      21,
      13,
      6
    ],
    "homePostgameWinProbability": 0.37425486457436213,
    "homePregameElo": 1435,
    "homePostgameElo": 1439,
    "awayId": 326,
    "awayTeam": "Texas State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 39,
    "awayLineScores": [
      22,
      10,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.6257451354256378,
    "awayPregameElo": 1538,
    "awayPostgameElo": 1534,
    "excitementIndex": 6.5419499861,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401629043,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 9542,
    "venueId": 3996,
    "venue": "Yager Stadium",
    "homeId": 193,
    "homeTeam": "Miami (OH)",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 23,
    "homeLineScores": [
      7,
      3,
      7,
      3,
      3
    ],
    "homePostgameWinProbability": 0.7346411537664426,
    "homePregameElo": 1450,
    "homePostgameElo": 1446,
    "awayId": 113,
    "awayTeam": "Massachusetts",
    "awayClassification": "fbs",
    "awayConference": "FBS Independents",
    "awayPoints": 20,
    "awayLineScores": [
      7,
      3,
      0,
      10,
      0
    ],
    "awayPostgameWinProbability": 0.26535884623355743,
    "awayPregameElo": 1063,
    "awayPostgameElo": 1067,
    "excitementIndex": 7.1370501518,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644739,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 10899,
    "venueId": 3696,
    "venue": "Dix Stadium",
    "homeId": 2309,
    "homeTeam": "Kent State",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 33,
    "homeLineScores": [
      7,
      7,
      7,
      12
    ],
    "homePostgameWinProbability": 0.436458240220723,
    "homePregameElo": 932,
    "homePostgameElo": 922,
    "awayId": 2199,
    "awayTeam": "Eastern Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 52,
    "awayLineScores": [
      7,
      14,
      17,
      14
    ],
    "awayPostgameWinProbability": 0.563541759779277,
    "awayPregameElo": 1300,
    "awayPostgameElo": 1310,
    "excitementIndex": 4.5831484742,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628502,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 74118,
    "venueId": 477,
    "venue": "Los Angeles Memorial Coliseum",
    "homeId": 30,
    "homeTeam": "USC",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 38,
    "homeLineScores": [
      7,
      3,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9971495878359863,
    "homePregameElo": 1769,
    "homePostgameElo": 1786,
    "awayId": 275,
    "awayTeam": "Wisconsin",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      14,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.002850412164013716,
    "awayPregameElo": 1553,
    "awayPostgameElo": 1536,
    "excitementIndex": 6.8040912705,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401640992,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": false,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": null,
    "venueId": 3792,
    "venue": "Kidd Brewer Stadium",
    "homeId": 2026,
    "homeTeam": "App State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": null,
    "homeLineScores": null,
    "homePostgameWinProbability": null,
    "homePregameElo": 1251,
    "homePostgameElo": null,
    "awayId": 2335,
    "awayTeam": "Liberty",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": null,
    "awayLineScores": null,
    "awayPostgameWinProbability": null,
    "awayPregameElo": 1441,
    "awayPostgameElo": null,
    "excitementIndex": null,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628980,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 77622,
    "venueId": 3855,
    "venue": "Notre Dame Stadium",
    "homeId": 87,
    "homeTeam": "Notre Dame",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 31,
    "homeLineScores": [
      21,
      3,
      0,
      7
    ],
    "homePostgameWinProbability": 0.8595368472597268,
    "homePregameElo": 2000,
    "homePostgameElo": 1994,
    "awayId": 97,
    "awayTeam": "Louisville",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      7,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.1404631527402732,
    "awayPregameElo": 1711,
    "awayPostgameElo": 1717,
    "excitementIndex": 7.3478032351,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636885,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 45702,
    "venueId": 3652,
    "venue": "FBC Mortgage Stadium",
    "homeId": 2116,
    "homeTeam": "UCF",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 21,
    "homeLineScores": [
      7,
      7,
      7,
      0
    ],
    "homePostgameWinProbability": 0.026031875809581936,
    "homePregameElo": 1642,
    "homePostgameElo": 1531,
    "awayId": 38,
    "awayTeam": "Colorado",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 48,
    "awayLineScores": [
      14,
      13,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.9739681241904181,
    "awayPregameElo": 1368,
    "awayPostgameElo": 1479,
    "excitementIndex": 3.6069366226,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636882,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 47928,
    "venueId": 3622,
    "venue": "GEHA Field at Arrowhead Stadium",
    "homeId": 2305,
    "homeTeam": "Kansas",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 27,
    "homeLineScores": [
      14,
      3,
      7,
      3
    ],
    "homePostgameWinProbability": 0.026585959803630637,
    "homePregameElo": 1598,
    "homePostgameElo": 1575,
    "awayId": 2628,
    "awayTeam": "TCU",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 38,
    "awayLineScores": [
      7,
      14,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.9734140401963693,
    "awayPregameElo": 1528,
    "awayPostgameElo": 1551,
    "excitementIndex": 6.4918006772,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644738,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 21265,
    "venueId": 3876,
    "venue": "Peden Stadium",
    "homeId": 195,
    "homeTeam": "Ohio",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 30,
    "homeLineScores": [
      0,
      14,
      2,
      14
    ],
    "homePostgameWinProbability": 0.9988883496426145,
    "homePregameElo": 1401,
    "homePostgameElo": 1414,
    "awayId": 2006,
    "awayTeam": "Akron",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 10,
    "awayLineScores": [
      3,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0011116503573854741,
    "awayPregameElo": 1053,
    "awayPostgameElo": 1040,
    "excitementIndex": 7.8248100423,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628375,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 88043,
    "venueId": 3785,
    "venue": "Jordan-Hare Stadium",
    "homeId": 2,
    "homeTeam": "Auburn",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 21,
    "homeLineScores": [
      0,
      14,
      0,
      7
    ],
    "homePostgameWinProbability": 0.42386205342807326,
    "homePregameElo": 1537,
    "homePostgameElo": 1547,
    "awayId": 201,
    "awayTeam": "Oklahoma",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 27,
    "awayLineScores": [
      7,
      0,
      3,
      17
    ],
    "awayPostgameWinProbability": 0.5761379465719267,
    "awayPregameElo": 1837,
    "awayPostgameElo": 1827,
    "excitementIndex": 5.7449637367,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643721,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 27072,
    "venueId": 3786,
    "venue": "Kelly/Shorts Stadium",
    "homeId": 2117,
    "homeTeam": "Central Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 22,
    "homeLineScores": [
      10,
      3,
      6,
      3
    ],
    "homePostgameWinProbability": 0.17200744568967752,
    "homePregameElo": 1174,
    "homePostgameElo": 1180,
    "awayId": 21,
    "awayTeam": "San Diego State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      14,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.8279925543103225,
    "awayPregameElo": 1350,
    "awayPostgameElo": 1344,
    "excitementIndex": 6.3296454169,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643792,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 18808,
    "venueId": 4246,
    "venue": "Center Parc Stadium",
    "homeId": 2247,
    "homeTeam": "Georgia State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 21,
    "homeLineScores": [
      7,
      0,
      14,
      0
    ],
    "homePostgameWinProbability": 0.002047395025722414,
    "homePregameElo": 1371,
    "homePostgameElo": 1325,
    "awayId": 290,
    "awayTeam": "Georgia Southern",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 38,
    "awayLineScores": [
      14,
      10,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.9979526049742776,
    "awayPregameElo": 1324,
    "awayPostgameElo": 1370,
    "excitementIndex": 4.6404781078,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643794,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 18723,
    "venueId": 3775,
    "venue": "Joan C. Edwards Stadium",
    "homeId": 276,
    "homeTeam": "Marshall",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 27,
    "homeLineScores": [
      7,
      10,
      3,
      7
    ],
    "homePostgameWinProbability": 0.9823881995672694,
    "homePregameElo": 1360,
    "homePostgameElo": 1362,
    "awayId": 2711,
    "awayTeam": "Western Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 20,
    "awayLineScores": [
      3,
      0,
      14,
      3
    ],
    "awayPostgameWinProbability": 0.017611800432730584,
    "awayPregameElo": 1222,
    "awayPostgameElo": 1220,
    "excitementIndex": 6.6872778536,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635659,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 31061,
    "venueId": 3630,
    "venue": "Allegacy Federal Credit Union Stadium",
    "homeId": 154,
    "homeTeam": "Wake Forest",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 38,
    "homeLineScores": [
      3,
      14,
      14,
      7
    ],
    "homePostgameWinProbability": 0.3500751768896691,
    "homePregameElo": 1370,
    "homePostgameElo": 1376,
    "awayId": 309,
    "awayTeam": "Louisiana",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 41,
    "awayLineScores": [
      14,
      7,
      10,
      10
    ],
    "awayPostgameWinProbability": 0.649924823110331,
    "awayPregameElo": 1543,
    "awayPostgameElo": 1537,
    "excitementIndex": 6.8106814771,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643720,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 24638,
    "venueId": 6501,
    "venue": "Allegiant Stadium",
    "homeId": 2439,
    "homeTeam": "UNLV",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 59,
    "homeLineScores": [
      14,
      7,
      10,
      28
    ],
    "homePostgameWinProbability": 0.9989392775772092,
    "homePregameElo": 1544,
    "homePostgameElo": 1701,
    "awayId": 278,
    "awayTeam": "Fresno State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.0010607224227907608,
    "awayPregameElo": 1675,
    "awayPostgameElo": 1518,
    "excitementIndex": 3.1184691701,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628373,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 60928,
    "venueId": 3687,
    "venue": "AT&T Stadium",
    "homeId": 245,
    "homeTeam": "Texas A&M",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 21,
    "homeLineScores": [
      7,
      7,
      0,
      7
    ],
    "homePostgameWinProbability": 0.36803582088856224,
    "homePregameElo": 1685,
    "homePostgameElo": 1683,
    "awayId": 8,
    "awayTeam": "Arkansas",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 17,
    "awayLineScores": [
      14,
      0,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.6319641791114378,
    "awayPregameElo": 1483,
    "awayPostgameElo": 1485,
    "excitementIndex": 9.688058168,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635562,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 35018,
    "venueId": 3982,
    "venue": "Wallace Wade Stadium",
    "homeId": 150,
    "homeTeam": "Duke",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 21,
    "homeLineScores": [
      0,
      0,
      7,
      14
    ],
    "homePostgameWinProbability": 0.3894131779752124,
    "homePregameElo": 1623,
    "homePostgameElo": 1621,
    "awayId": 153,
    "awayTeam": "North Carolina",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 20,
    "awayLineScores": [
      10,
      7,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.6105868220247876,
    "awayPregameElo": 1519,
    "awayPostgameElo": 1521,
    "excitementIndex": 7.3809862953,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645334,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 41851,
    "venueId": 3699,
    "venue": "Dowdy-Ficklen Stadium",
    "homeId": 151,
    "homeTeam": "East Carolina",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 30,
    "homeLineScores": [
      3,
      7,
      14,
      6
    ],
    "homePostgameWinProbability": 0.7986397981544012,
    "homePregameElo": 1407,
    "homePostgameElo": 1423,
    "awayId": 2636,
    "awayTeam": "UTSA",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 20,
    "awayLineScores": [
      10,
      3,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.20136020184559877,
    "awayPregameElo": 1390,
    "awayPostgameElo": 1374,
    "excitementIndex": 8.4247793035,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628378,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T20:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 101388,
    "venueId": 3910,
    "venue": "DKR-Texas Memorial Stadium",
    "homeId": 251,
    "homeTeam": "Texas",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 35,
    "homeLineScores": [
      7,
      7,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9985122659942977,
    "homePregameElo": 2107,
    "homePostgameElo": 2091,
    "awayId": 344,
    "awayTeam": "Mississippi State",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      6,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.0014877340057023458,
    "awayPregameElo": 1355,
    "awayPostgameElo": 1371,
    "excitementIndex": 5.1491934959,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643795,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 19140,
    "venueId": 3700,
    "venue": "Doyt L. Perry Stadium",
    "homeId": 189,
    "homeTeam": "Bowling Green",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 27,
    "homeLineScores": [
      7,
      7,
      7,
      6
    ],
    "homePostgameWinProbability": 0.6420936325405732,
    "homePregameElo": 1448,
    "homePostgameElo": 1439,
    "awayId": 295,
    "awayTeam": "Old Dominion",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 30,
    "awayLineScores": [
      14,
      3,
      0,
      13
    ],
    "awayPostgameWinProbability": 0.35790636745942683,
    "awayPregameElo": 1368,
    "awayPostgameElo": 1377,
    "excitementIndex": 9.1728984123,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645335,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 21151,
    "venueId": 3715,
    "venue": "FAU Stadium",
    "homeId": 2226,
    "homeTeam": "Florida Atlantic",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 41,
    "homeLineScores": [
      10,
      7,
      10,
      14
    ],
    "homePostgameWinProbability": 0.9987541624897803,
    "homePregameElo": 1295,
    "homePostgameElo": 1295,
    "awayId": 2681,
    "awayTeam": "Wagner",
    "awayClassification": "fcs",
    "awayConference": "NEC",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      10,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0012458375102196717,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.8461161395,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641018,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": null,
    "venueId": 4899,
    "venue": "Fifth Third Stadium",
    "homeId": 338,
    "homeTeam": "Kennesaw State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 13,
    "homeLineScores": [
      0,
      10,
      0,
      3
    ],
    "homePostgameWinProbability": 0.04227476802433221,
    "homePregameElo": 1384,
    "homePostgameElo": 1384,
    "awayId": 2630,
    "awayTeam": "UT Martin",
    "awayClassification": "fcs",
    "awayConference": "Big South-OVC",
    "awayPoints": 24,
    "awayLineScores": [
      0,
      10,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.9577252319756678,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.4773789348,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401640981,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 12425,
    "venueId": 2031,
    "venue": "Pitbull Stadium",
    "homeId": 2229,
    "homeTeam": "Florida International",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 17,
    "homeLineScores": [
      7,
      0,
      7,
      3
    ],
    "homePostgameWinProbability": 0.7814293689581259,
    "homePregameElo": 1241,
    "homePostgameElo": 1257,
    "awayId": 2348,
    "awayTeam": "Louisiana Tech",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      0,
      10,
      0
    ],
    "awayPostgameWinProbability": 0.21857063104187413,
    "awayPregameElo": 1239,
    "awayPostgameElo": 1223,
    "excitementIndex": 7.2473046483,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645333,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 17455,
    "venueId": 3895,
    "venue": "Rice Stadium",
    "homeId": 242,
    "homeTeam": "Rice",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 20,
    "homeLineScores": [
      0,
      10,
      0,
      10
    ],
    "homePostgameWinProbability": 0.48756540856605285,
    "homePregameElo": 1225,
    "homePostgameElo": 1219,
    "awayId": 2429,
    "awayTeam": "Charlotte",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      0,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.5124345914339472,
    "awayPregameElo": 1122,
    "awayPostgameElo": 1128,
    "excitementIndex": 8.1735271205,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636881,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 25138,
    "venueId": 4728,
    "venue": "TDECU Stadium",
    "homeId": 248,
    "homeTeam": "Houston",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 0,
    "homeLineScores": [
      0,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0.024352434845487755,
    "homePregameElo": 1366,
    "homePostgameElo": 1352,
    "awayId": 66,
    "awayTeam": "Iowa State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 20,
    "awayLineScores": [
      3,
      0,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.9756475651545122,
    "awayPregameElo": 1718,
    "awayPostgameElo": 1732,
    "excitementIndex": 4.7937785895,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645336,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 18529,
    "venueId": 3825,
    "venue": "DATCU Stadium",
    "homeId": 249,
    "homeTeam": "North Texas",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 52,
    "homeLineScores": [
      0,
      24,
      21,
      7
    ],
    "homePostgameWinProbability": 0.9988225504813045,
    "homePregameElo": 1403,
    "homePostgameElo": 1464,
    "awayId": 202,
    "awayTeam": "Tulsa",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      3,
      0,
      17
    ],
    "awayPostgameWinProbability": 0.0011774495186954725,
    "awayPregameElo": 1193,
    "awayPostgameElo": 1132,
    "excitementIndex": 5.2818570579,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635561,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 80295,
    "venueId": 3836,
    "venue": "Memorial Stadium (Clemson, SC)",
    "homeId": 228,
    "homeTeam": "Clemson",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 40,
    "homeLineScores": [
      10,
      7,
      10,
      13
    ],
    "homePostgameWinProbability": 0.950885889669523,
    "homePregameElo": 1790,
    "homePostgameElo": 1805,
    "awayId": 24,
    "awayTeam": "Stanford",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.04911411033047697,
    "awayPregameElo": 1303,
    "awayPostgameElo": 1288,
    "excitementIndex": 3.8907327551,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643796,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 21253,
    "venueId": 3975,
    "venue": "Veterans Memorial Stadium (AL)",
    "homeId": 2653,
    "homeTeam": "Troy",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 9,
    "homeLineScores": [
      3,
      3,
      0,
      3
    ],
    "homePostgameWinProbability": 0.8422302320638168,
    "homePregameElo": 1534,
    "homePostgameElo": 1504,
    "awayId": 2433,
    "awayTeam": "UL Monroe",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 13,
    "awayLineScores": [
      3,
      0,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.15776976793618325,
    "awayPregameElo": 1210,
    "awayPostgameElo": 1240,
    "excitementIndex": 5.5552324653,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628498,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 71114,
    "venueId": 3936,
    "venue": "Spartan Stadium",
    "homeId": 127,
    "homeTeam": "Michigan State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 7,
    "homeLineScores": [
      0,
      7,
      0,
      0
    ],
    "homePostgameWinProbability": 0.009834608439806833,
    "homePregameElo": 1423,
    "homePostgameElo": 1407,
    "awayId": 194,
    "awayTeam": "Ohio State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 38,
    "awayLineScores": [
      3,
      21,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.9901653915601931,
    "awayPregameElo": 2038,
    "awayPostgameElo": 2054,
    "excitementIndex": 2.1228177002,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628495,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 109911,
    "venueId": 3632,
    "venue": "Beaver Stadium",
    "homeId": 213,
    "homeTeam": "Penn State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 21,
    "homeLineScores": [
      7,
      0,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9829728595026391,
    "homePregameElo": 1905,
    "homePostgameElo": 1905,
    "awayId": 356,
    "awayTeam": "Illinois",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 7,
    "awayLineScores": [
      7,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.01702714049736087,
    "awayPregameElo": 1551,
    "awayPostgameElo": 1551,
    "excitementIndex": 5.4468011451,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628374,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 100077,
    "venueId": 3657,
    "venue": "Bryant-Denny Stadium",
    "homeId": 333,
    "homeTeam": "Alabama",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 41,
    "homeLineScores": [
      21,
      9,
      3,
      8
    ],
    "homePostgameWinProbability": 0.932477756510748,
    "homePregameElo": 2046,
    "homePostgameElo": 2056,
    "awayId": 61,
    "awayTeam": "Georgia",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 34,
    "awayLineScores": [
      0,
      7,
      8,
      19
    ],
    "awayPostgameWinProbability": 0.06752224348925195,
    "awayPregameElo": 2046,
    "awayPostgameElo": 2036,
    "excitementIndex": 5.7366653406,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641025,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 25266,
    "venueId": 3805,
    "venue": "Simmons Bank Liberty Stadium",
    "homeId": 235,
    "homeTeam": "Memphis",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 24,
    "homeLineScores": [
      0,
      14,
      10,
      0
    ],
    "homePostgameWinProbability": 0.8038560702855952,
    "homePregameElo": 1597,
    "homePostgameElo": 1598,
    "awayId": 2393,
    "awayTeam": "Middle Tennessee",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.19614392971440475,
    "awayPregameElo": 1182,
    "awayPostgameElo": 1181,
    "excitementIndex": 4.7352676058,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628376,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-28T23:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 102143,
    "venueId": 3958,
    "venue": "Tiger Stadium (LA)",
    "homeId": 99,
    "homeTeam": "LSU",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 42,
    "homeLineScores": [
      21,
      14,
      0,
      7
    ],
    "homePostgameWinProbability": 0.9880716871609392,
    "homePregameElo": 1805,
    "homePostgameElo": 1874,
    "awayId": 6,
    "awayTeam": "South Alabama",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      3,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.011928312839060817,
    "awayPregameElo": 1657,
    "awayPostgameElo": 1588,
    "excitementIndex": 2.0744288057,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643718,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-29T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 23068,
    "venueId": 3984,
    "venue": "War Memorial Stadium",
    "homeId": 2751,
    "homeTeam": "Wyoming",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 31,
    "homeLineScores": [
      7,
      0,
      14,
      10
    ],
    "homePostgameWinProbability": 0.8057763429521136,
    "homePregameElo": 1245,
    "homePostgameElo": 1286,
    "awayId": 2005,
    "awayTeam": "Air Force",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 19,
    "awayLineScores": [
      0,
      13,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.19422365704788636,
    "awayPregameElo": 1459,
    "awayPostgameElo": 1418,
    "excitementIndex": 6.004756406,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641035,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-29T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 21062,
    "venueId": 3601,
    "venue": "Aggie Memorial Stadium",
    "homeId": 166,
    "homeTeam": "New Mexico State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 40,
    "homeLineScores": [
      7,
      3,
      7,
      23
    ],
    "homePostgameWinProbability": 0.04136263442755955,
    "homePregameElo": 1265,
    "homePostgameElo": 1238,
    "awayId": 167,
    "awayTeam": "New Mexico",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 50,
    "awayLineScores": [
      7,
      14,
      9,
      20
    ],
    "awayPostgameWinProbability": 0.9586373655724405,
    "awayPregameElo": 1201,
    "awayPostgameElo": 1228,
    "excitementIndex": 3.8931490083,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635563,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-29T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 34879,
    "venueId": 3735,
    "venue": "Gerald J. Ford Stadium",
    "homeId": 2567,
    "homeTeam": "SMU",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 42,
    "homeLineScores": [
      7,
      7,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9984452053229043,
    "homePregameElo": 1700,
    "homePostgameElo": 1755,
    "awayId": 52,
    "awayTeam": "Florida State",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 16,
    "awayLineScores": [
      7,
      2,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.0015547946770957388,
    "awayPregameElo": 1599,
    "awayPostgameElo": 1544,
    "excitementIndex": 5.9469139787,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636884,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-29T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 60229,
    "venueId": 3784,
    "venue": "Jones AT&T Stadium",
    "homeId": 2641,
    "homeTeam": "Texas Tech",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 44,
    "homeLineScores": [
      10,
      14,
      10,
      10
    ],
    "homePostgameWinProbability": 0.6728453484915969,
    "homePregameElo": 1628,
    "homePostgameElo": 1628,
    "awayId": 2132,
    "awayTeam": "Cincinnati",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 41,
    "awayLineScores": [
      14,
      10,
      3,
      14
    ],
    "awayPostgameWinProbability": 0.32715465150840306,
    "awayPregameElo": 1529,
    "awayPostgameElo": 1529,
    "excitementIndex": 6.94809489,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643719,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-29T02:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 37711,
    "venueId": 3653,
    "venue": "Albertsons Stadium",
    "homeId": 68,
    "homeTeam": "Boise State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 45,
    "homeLineScores": [
      7,
      10,
      7,
      21
    ],
    "homePostgameWinProbability": 0.9954413148152679,
    "homePregameElo": 1631,
    "homePostgameElo": 1677,
    "awayId": 265,
    "awayTeam": "Washington State",
    "awayClassification": "fbs",
    "awayConference": "Pac-12",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      3,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.004558685184732125,
    "awayPregameElo": 1596,
    "awayPostgameElo": 1550,
    "excitementIndex": 6.1697474003,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636886,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-29T02:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 52898,
    "venueId": 587,
    "venue": "Rice-Eccles Stadium",
    "homeId": 254,
    "homeTeam": "Utah",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 10,
    "homeLineScores": [
      0,
      3,
      0,
      7
    ],
    "homePostgameWinProbability": 0.10144441304707315,
    "homePregameElo": 1633,
    "homePostgameElo": 1607,
    "awayId": 12,
    "awayTeam": "Arizona",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 23,
    "awayLineScores": [
      3,
      7,
      6,
      7
    ],
    "awayPostgameWinProbability": 0.8985555869529268,
    "awayPregameElo": 1668,
    "awayPostgameElo": 1694,
    "excitementIndex": 4.2397863389,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628500,
    "season": 2024,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2024-09-29T03:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 43051,
    "venueId": 1056,
    "venue": "Rose Bowl",
    "homeId": 26,
    "homeTeam": "UCLA",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 13,
    "homeLineScores": [
      3,
      7,
      3,
      0
    ],
    "homePostgameWinProbability": 0.010279806711309637,
    "homePregameElo": 1449,
    "homePostgameElo": 1449,
    "awayId": 2483,
    "awayTeam": "Oregon",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 34,
    "awayLineScores": [
      7,
      21,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.9897201932886903,
    "awayPregameElo": 1974,
    "awayPostgameElo": 1974,
    "excitementIndex": 2.682969671,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643797,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-03T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20349,
    "venueId": 3975,
    "venue": "Veterans Memorial Stadium (AL)",
    "homeId": 2653,
    "homeTeam": "Troy",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 17,
    "homeLineScores": [
      0,
      10,
      7,
      0
    ],
    "homePostgameWinProbability": 0.15409304049935388,
    "homePregameElo": 1504,
    "homePostgameElo": 1454,
    "awayId": 326,
    "awayTeam": "Texas State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 38,
    "awayLineScores": [
      14,
      14,
      10,
      0
    ],
    "awayPostgameWinProbability": 0.8459069595006461,
    "awayPregameElo": 1534,
    "awayPostgameElo": 1584,
    "excitementIndex": 2.6453458217,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641029,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-04T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 14454,
    "venueId": 3946,
    "venue": "Sun Bowl",
    "homeId": 2638,
    "homeTeam": "UTEP",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 21,
    "homeLineScores": [
      0,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.006751532371953858,
    "homePregameElo": 1206,
    "homePostgameElo": 1181,
    "awayId": 2534,
    "awayTeam": "Sam Houston",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 41,
    "awayLineScores": [
      7,
      10,
      21,
      3
    ],
    "awayPostgameWinProbability": 0.9932484676280462,
    "awayPregameElo": 1439,
    "awayPostgameElo": 1464,
    "excitementIndex": 3.5368655542,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641001,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-04T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 10029,
    "venueId": 4899,
    "venue": "Fifth Third Stadium",
    "homeId": 338,
    "homeTeam": "Kennesaw State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 24,
    "homeLineScores": [
      3,
      14,
      0,
      7
    ],
    "homePostgameWinProbability": 0.08121356033334157,
    "homePregameElo": 1388,
    "homePostgameElo": 1281,
    "awayId": 55,
    "awayTeam": "Jacksonville State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 63,
    "awayLineScores": [
      7,
      14,
      21,
      21
    ],
    "awayPostgameWinProbability": 0.9187864396666584,
    "awayPregameElo": 1453,
    "awayPostgameElo": 1560,
    "excitementIndex": 3.725170872,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636891,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-04T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 44211,
    "venueId": 3616,
    "venue": "Amon G. Carter Stadium",
    "homeId": 2628,
    "homeTeam": "TCU",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 19,
    "homeLineScores": [
      0,
      6,
      6,
      7
    ],
    "homePostgameWinProbability": 0.0811553352620264,
    "homePregameElo": 1551,
    "homePostgameElo": 1508,
    "awayId": 248,
    "awayTeam": "Houston",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 30,
    "awayLineScores": [
      7,
      17,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.9188446647379735,
    "awayPregameElo": 1352,
    "awayPostgameElo": 1395,
    "excitementIndex": 3.0999034496,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628506,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 59802,
    "venueId": 3626,
    "venue": "Autzen Stadium",
    "homeId": 2483,
    "homeTeam": "Oregon",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 31,
    "homeLineScores": [
      7,
      14,
      3,
      7
    ],
    "homePostgameWinProbability": 0.9935499233498072,
    "homePregameElo": 1974,
    "homePostgameElo": 1971,
    "awayId": 127,
    "awayTeam": "Michigan State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      0,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.006450076650192815,
    "awayPregameElo": 1407,
    "awayPostgameElo": 1410,
    "excitementIndex": 3.5938577823,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401634779,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 31329,
    "venueId": 6501,
    "venue": "Allegiant Stadium",
    "homeId": 2439,
    "homeTeam": "UNLV",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 41,
    "homeLineScores": [
      0,
      21,
      10,
      7,
      3
    ],
    "homePostgameWinProbability": 0.9875073669077074,
    "homePregameElo": 1701,
    "homePostgameElo": 1675,
    "awayId": 183,
    "awayTeam": "Syracuse",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 44,
    "awayLineScores": [
      14,
      3,
      14,
      7,
      6
    ],
    "awayPostgameWinProbability": 0.012492633092292649,
    "awayPregameElo": 1378,
    "awayPostgameElo": 1404,
    "excitementIndex": 7.9048309471,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635567,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 38285,
    "venueId": 3923,
    "venue": "Scott Stadium",
    "homeId": 258,
    "homeTeam": "Virginia",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 24,
    "homeLineScores": [
      0,
      6,
      0,
      18
    ],
    "homePostgameWinProbability": 0.4938901368867562,
    "homePregameElo": 1389,
    "homePostgameElo": 1412,
    "awayId": 103,
    "awayTeam": "Boston College",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 14,
    "awayLineScores": [
      7,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.5061098631132438,
    "awayPregameElo": 1471,
    "awayPostgameElo": 1448,
    "excitementIndex": 6.6243461073,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628509,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 76091,
    "venueId": 347,
    "venue": "Camp Randall Stadium",
    "homeId": 275,
    "homeTeam": "Wisconsin",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 52,
    "homeLineScores": [
      14,
      7,
      21,
      10
    ],
    "homePostgameWinProbability": 0.9988566905205731,
    "homePregameElo": 1536,
    "homePostgameElo": 1644,
    "awayId": 2509,
    "awayTeam": "Purdue",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 6,
    "awayLineScores": [
      0,
      6,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0011433094794268683,
    "awayPregameElo": 1322,
    "awayPostgameElo": 1214,
    "excitementIndex": 3.165178334,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628510,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 110047,
    "venueId": 3632,
    "venue": "Beaver Stadium",
    "homeId": 213,
    "homeTeam": "Penn State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 27,
    "homeLineScores": [
      0,
      14,
      10,
      3
    ],
    "homePostgameWinProbability": 0.9881167331327723,
    "homePregameElo": 1905,
    "homePostgameElo": 1901,
    "awayId": 26,
    "awayTeam": "UCLA",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 11,
    "awayLineScores": [
      0,
      3,
      0,
      8
    ],
    "awayPostgameWinProbability": 0.011883266867227738,
    "awayPregameElo": 1449,
    "awayPostgameElo": 1453,
    "excitementIndex": 3.2668282196,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401629044,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 12466,
    "venueId": 3764,
    "venue": "Huskie Stadium",
    "homeId": 2459,
    "homeTeam": "Northern Illinois",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 34,
    "homeLineScores": [
      7,
      0,
      6,
      21
    ],
    "homePostgameWinProbability": 0.9954385438836776,
    "homePregameElo": 1455,
    "homePostgameElo": 1452,
    "awayId": 113,
    "awayTeam": "Massachusetts",
    "awayClassification": "fbs",
    "awayConference": "FBS Independents",
    "awayPoints": 20,
    "awayLineScores": [
      7,
      6,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.004561456116322415,
    "awayPregameElo": 1067,
    "awayPostgameElo": 1070,
    "excitementIndex": 6.4049143498,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628383,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 97049,
    "venueId": 3795,
    "venue": "Kyle Field",
    "homeId": 245,
    "homeTeam": "Texas A&M",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 41,
    "homeLineScores": [
      10,
      14,
      10,
      7
    ],
    "homePostgameWinProbability": 0.9988618929265699,
    "homePregameElo": 1683,
    "homePostgameElo": 1781,
    "awayId": 142,
    "awayTeam": "Missouri",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      0,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.0011381070734300947,
    "awayPregameElo": 1790,
    "awayPostgameElo": 1692,
    "excitementIndex": 2.4205755334,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635571,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 50254,
    "venueId": 3873,
    "venue": "L&N Federal Credit Union Stadium",
    "homeId": 97,
    "homeTeam": "Louisville",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 27,
    "homeLineScores": [
      10,
      3,
      14,
      0
    ],
    "homePostgameWinProbability": 0.12259642780226156,
    "homePregameElo": 1717,
    "homePostgameElo": 1707,
    "awayId": 2567,
    "awayTeam": "SMU",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 34,
    "awayLineScores": [
      14,
      10,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.8774035721977385,
    "awayPregameElo": 1755,
    "awayPostgameElo": 1765,
    "excitementIndex": 7.163661777,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635572,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 46033,
    "venueId": 3787,
    "venue": "Kenan Stadium",
    "homeId": 153,
    "homeTeam": "North Carolina",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 24,
    "homeLineScores": [
      7,
      10,
      7,
      0
    ],
    "homePostgameWinProbability": 0.08994281640453619,
    "homePregameElo": 1521,
    "homePostgameElo": 1497,
    "awayId": 221,
    "awayTeam": "Pittsburgh",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 34,
    "awayLineScores": [
      3,
      14,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.9100571835954638,
    "awayPregameElo": 1488,
    "awayPostgameElo": 1512,
    "excitementIndex": 7.4430200756,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635638,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 56919,
    "venueId": 3670,
    "venue": "Carter-Finley Stadium",
    "homeId": 152,
    "homeTeam": "NC State",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 30,
    "homeLineScores": [
      3,
      13,
      7,
      7
    ],
    "homePostgameWinProbability": 0.686979207588141,
    "homePregameElo": 1487,
    "homePostgameElo": 1473,
    "awayId": 154,
    "awayTeam": "Wake Forest",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 34,
    "awayLineScores": [
      10,
      7,
      3,
      14
    ],
    "awayPostgameWinProbability": 0.313020792411859,
    "awayPregameElo": 1376,
    "awayPostgameElo": 1390,
    "excitementIndex": 7.0816037197,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643722,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 39441,
    "venueId": 3713,
    "venue": "Falcon Stadium",
    "homeId": 2005,
    "homeTeam": "Air Force",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 7,
    "homeLineScores": [
      0,
      7,
      0,
      0
    ],
    "homePostgameWinProbability": 0.05184426176894664,
    "homePregameElo": 1418,
    "homePostgameElo": 1353,
    "awayId": 2426,
    "awayTeam": "Navy",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 34,
    "awayLineScores": [
      14,
      7,
      6,
      7
    ],
    "awayPostgameWinProbability": 0.9481557382310534,
    "awayPregameElo": 1490,
    "awayPostgameElo": 1555,
    "excitementIndex": 1.894636792,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645339,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": null,
    "venueId": 3674,
    "venue": "Chapman Stadium",
    "homeId": 202,
    "homeTeam": "Tulsa",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 7,
    "homeLineScores": [
      7,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0.0003178918284539511,
    "homePregameElo": 1132,
    "homePostgameElo": 1060,
    "awayId": 349,
    "awayTeam": "Army",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 49,
    "awayLineScores": [
      7,
      14,
      21,
      7
    ],
    "awayPostgameWinProbability": 0.999682108171546,
    "awayPregameElo": 1534,
    "awayPostgameElo": 1606,
    "excitementIndex": 2.6035307253,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645338,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 19724,
    "venueId": 7221,
    "venue": "Protective Stadium",
    "homeId": 5,
    "homeTeam": "UAB",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 20,
    "homeLineScores": [
      6,
      0,
      0,
      14
    ],
    "homePostgameWinProbability": 0.0005259456416550542,
    "homePregameElo": 1226,
    "homePostgameElo": 1128,
    "awayId": 2655,
    "awayTeam": "Tulane",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 71,
    "awayLineScores": [
      20,
      17,
      20,
      14
    ],
    "awayPostgameWinProbability": 0.9994740543583449,
    "awayPregameElo": 1653,
    "awayPostgameElo": 1751,
    "excitementIndex": 1.5932468249,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644741,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 10342,
    "venueId": 3919,
    "venue": "Scheumann Stadium",
    "homeId": 2050,
    "homeTeam": "Ball State",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 42,
    "homeLineScores": [
      14,
      7,
      14,
      7
    ],
    "homePostgameWinProbability": 0.42578317805850324,
    "homePregameElo": 1088,
    "homePostgameElo": 1091,
    "awayId": 2711,
    "awayTeam": "Western Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 45,
    "awayLineScores": [
      21,
      0,
      10,
      14
    ],
    "awayPostgameWinProbability": 0.5742168219414967,
    "awayPregameElo": 1220,
    "awayPostgameElo": 1217,
    "excitementIndex": 5.4083795661,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635573,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 36277,
    "venueId": 3940,
    "venue": "Stanford Stadium",
    "homeId": 24,
    "homeTeam": "Stanford",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 7,
    "homeLineScores": [
      0,
      0,
      7,
      0
    ],
    "homePostgameWinProbability": 0.03557608201719444,
    "homePregameElo": 1288,
    "homePostgameElo": 1261,
    "awayId": 259,
    "awayTeam": "Virginia Tech",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      7,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.9644239179828056,
    "awayPregameElo": 1617,
    "awayPostgameElo": 1644,
    "excitementIndex": 2.2904037043,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644684,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 25027,
    "venueId": 3739,
    "venue": "Glass Bowl",
    "homeId": 2649,
    "homeTeam": "Toledo",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 30,
    "homeLineScores": [
      14,
      6,
      3,
      7
    ],
    "homePostgameWinProbability": 0.9057294659383401,
    "homePregameElo": 1565,
    "homePostgameElo": 1574,
    "awayId": 193,
    "awayTeam": "Miami (OH)",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 20,
    "awayLineScores": [
      3,
      3,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.09427053406165986,
    "awayPregameElo": 1446,
    "awayPostgameElo": 1437,
    "excitementIndex": 4.3592185682,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628503,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 12023,
    "venueId": 5960,
    "venue": "Lanny and Sharon Martin Stadium",
    "homeId": 77,
    "homeTeam": "Northwestern",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 24,
    "homeLineScores": [
      0,
      10,
      7,
      7
    ],
    "homePostgameWinProbability": 0.0018232646309650244,
    "homePregameElo": 1493,
    "homePostgameElo": 1473,
    "awayId": 84,
    "awayTeam": "Indiana",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 41,
    "awayLineScores": [
      7,
      10,
      7,
      17
    ],
    "awayPostgameWinProbability": 0.998176735369035,
    "awayPregameElo": 1628,
    "awayPostgameElo": 1648,
    "excitementIndex": 4.5474735945,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628504,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 105135,
    "venueId": 3861,
    "venue": "Ohio Stadium",
    "homeId": 194,
    "homeTeam": "Ohio State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 35,
    "homeLineScores": [
      7,
      0,
      21,
      7
    ],
    "homePostgameWinProbability": 0.9984027844674853,
    "homePregameElo": 2054,
    "homePostgameElo": 2080,
    "awayId": 2294,
    "awayTeam": "Iowa",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.0015972155325146842,
    "awayPregameElo": 1626,
    "awayPostgameElo": 1600,
    "excitementIndex": 3.5455149433,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644740,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 9337,
    "venueId": 3768,
    "venue": "InfoCision Stadium",
    "homeId": 2006,
    "homeTeam": "Akron",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 20,
    "homeLineScores": [
      10,
      0,
      0,
      10
    ],
    "homePostgameWinProbability": 0.04462931906899563,
    "homePregameElo": 1040,
    "homePostgameElo": 1055,
    "awayId": 189,
    "awayTeam": "Bowling Green",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 27,
    "awayLineScores": [
      7,
      10,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.9553706809310044,
    "awayPregameElo": 1439,
    "awayPostgameElo": 1424,
    "excitementIndex": 7.5400355311,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628381,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 93033,
    "venueId": 3917,
    "venue": "Sanford Stadium",
    "homeId": 61,
    "homeTeam": "Georgia",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 31,
    "homeLineScores": [
      7,
      7,
      7,
      10
    ],
    "homePostgameWinProbability": 0.9274264938830571,
    "homePregameElo": 2036,
    "homePostgameElo": 2033,
    "awayId": 2,
    "awayTeam": "Auburn",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 13,
    "awayLineScores": [
      3,
      0,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.07257350611694291,
    "awayPregameElo": 1547,
    "awayPostgameElo": 1550,
    "excitementIndex": 4.5969947957,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628382,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 79837,
    "venueId": 3994,
    "venue": "Williams-Brice Stadium",
    "homeId": 2579,
    "homeTeam": "South Carolina",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 3,
    "homeLineScores": [
      0,
      3,
      0,
      0
    ],
    "homePostgameWinProbability": 0.04410312984767961,
    "homePregameElo": 1699,
    "homePostgameElo": 1654,
    "awayId": 145,
    "awayTeam": "Ole Miss",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 27,
    "awayLineScores": [
      14,
      10,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.9558968701523204,
    "awayPregameElo": 1861,
    "awayPostgameElo": 1906,
    "excitementIndex": 2.2922238837,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643799,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 28023,
    "venueId": 3775,
    "venue": "Joan C. Edwards Stadium",
    "homeId": 276,
    "homeTeam": "Marshall",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 52,
    "homeLineScores": [
      7,
      21,
      10,
      14
    ],
    "homePostgameWinProbability": 0.9636293233549902,
    "homePregameElo": 1362,
    "homePostgameElo": 1394,
    "awayId": 2026,
    "awayTeam": "App State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 37,
    "awayLineScores": [
      3,
      14,
      7,
      13
    ],
    "awayPostgameWinProbability": 0.036370676645009814,
    "awayPregameElo": 1366,
    "awayPostgameElo": 1334,
    "excitementIndex": 6.0777663141,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401629033,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 28921,
    "venueId": 3892,
    "venue": "Pratt & Whitney Stadium",
    "homeId": 41,
    "homeTeam": "UConn",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 29,
    "homeLineScores": [
      3,
      6,
      7,
      13
    ],
    "homePostgameWinProbability": 0.9360119962351842,
    "homePregameElo": 1441,
    "homePostgameElo": 1434,
    "awayId": 218,
    "awayTeam": "Temple",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      7,
      6,
      7
    ],
    "awayPostgameWinProbability": 0.06398800376481584,
    "awayPregameElo": 1106,
    "awayPostgameElo": 1113,
    "excitementIndex": 11.3886983401,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645340,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 17102,
    "venueId": 4418,
    "venue": "Jerry Richardson Stadium",
    "homeId": 2429,
    "homeTeam": "Charlotte",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 55,
    "homeLineScores": [
      14,
      17,
      3,
      21
    ],
    "homePostgameWinProbability": 0.9738885644204506,
    "homePregameElo": 1128,
    "homePostgameElo": 1253,
    "awayId": 151,
    "awayTeam": "East Carolina",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 24,
    "awayLineScores": [
      3,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.026111435579549425,
    "awayPregameElo": 1423,
    "awayPostgameElo": 1298,
    "excitementIndex": 4.3002896284,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628508,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 87464,
    "venueId": 3834,
    "venue": "Memorial Stadium (Lincoln, NE)",
    "homeId": 158,
    "homeTeam": "Nebraska",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 14,
    "homeLineScores": [
      7,
      7,
      0,
      0
    ],
    "homePostgameWinProbability": 0.993724974384019,
    "homePregameElo": 1591,
    "homePostgameElo": 1597,
    "awayId": 164,
    "awayTeam": "Rutgers",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.006275025615981034,
    "awayPregameElo": 1527,
    "awayPostgameElo": 1521,
    "excitementIndex": 4.5514531358,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636890,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 52202,
    "venueId": 3646,
    "venue": "Boone Pickens Stadium",
    "homeId": 197,
    "homeTeam": "Oklahoma State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 14,
    "homeLineScores": [
      0,
      7,
      0,
      7
    ],
    "homePostgameWinProbability": 0.007877304103749191,
    "homePregameElo": 1553,
    "homePostgameElo": 1489,
    "awayId": 277,
    "awayTeam": "West Virginia",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 38,
    "awayLineScores": [
      10,
      21,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.9921226958962508,
    "awayPregameElo": 1546,
    "awayPostgameElo": 1610,
    "excitementIndex": 1.9380782632,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628384,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T20:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 28934,
    "venueId": 3973,
    "venue": "FirstBank Stadium",
    "homeId": 238,
    "homeTeam": "Vanderbilt",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 40,
    "homeLineScores": [
      13,
      10,
      7,
      10
    ],
    "homePostgameWinProbability": 0.8807790275067171,
    "homePregameElo": 1317,
    "homePostgameElo": 1359,
    "awayId": 333,
    "awayTeam": "Alabama",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 35,
    "awayLineScores": [
      7,
      7,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.1192209724932829,
    "awayPregameElo": 2056,
    "awayPostgameElo": 2014,
    "excitementIndex": 7.6288286297,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643724,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T22:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 46433,
    "venueId": 3893,
    "venue": "Reser Stadium",
    "homeId": 204,
    "homeTeam": "Oregon State",
    "homeClassification": "fbs",
    "homeConference": "Pac-12",
    "homePoints": 39,
    "homeLineScores": [
      0,
      14,
      0,
      10,
      7,
      8
    ],
    "homePostgameWinProbability": 0.5371609191611808,
    "homePregameElo": 1619,
    "homePostgameElo": 1609,
    "awayId": 36,
    "awayTeam": "Colorado State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      3,
      0,
      14,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.4628390808388192,
    "awayPregameElo": 1236,
    "awayPostgameElo": 1246,
    "excitementIndex": 9.3514269246,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635569,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 55107,
    "venueId": 3697,
    "venue": "Doak Campbell Stadium",
    "homeId": 52,
    "homeTeam": "Florida State",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 13,
    "homeLineScores": [
      0,
      7,
      0,
      6
    ],
    "homePostgameWinProbability": 0.04595850599760115,
    "homePregameElo": 1544,
    "homePostgameElo": 1532,
    "awayId": 228,
    "awayTeam": "Clemson",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 29,
    "awayLineScores": [
      17,
      6,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.9540414940023989,
    "awayPregameElo": 1805,
    "awayPostgameElo": 1817,
    "excitementIndex": 3.5276060514,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643801,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 19976,
    "venueId": 3817,
    "venue": "Malone Stadium",
    "homeId": 2433,
    "homeTeam": "UL Monroe",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 21,
    "homeLineScores": [
      0,
      14,
      0,
      7
    ],
    "homePostgameWinProbability": 0.8810814130757101,
    "homePregameElo": 1240,
    "homePostgameElo": 1247,
    "awayId": 256,
    "awayTeam": "James Madison",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 19,
    "awayLineScores": [
      10,
      3,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.11891858692428992,
    "awayPregameElo": 1830,
    "awayPostgameElo": 1823,
    "excitementIndex": 7.4299653764,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643798,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 18552,
    "venueId": 3654,
    "venue": "Brooks Stadium (SC)",
    "homeId": 324,
    "homeTeam": "Coastal Carolina",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 45,
    "homeLineScores": [
      7,
      14,
      14,
      10
    ],
    "homePostgameWinProbability": 0.9883943887615158,
    "homePregameElo": 1448,
    "homePostgameElo": 1456,
    "awayId": 295,
    "awayTeam": "Old Dominion",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 37,
    "awayLineScores": [
      7,
      10,
      7,
      13
    ],
    "awayPostgameWinProbability": 0.011605611238484248,
    "awayPregameElo": 1377,
    "awayPostgameElo": 1369,
    "excitementIndex": 6.8407614586,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643802,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 24041,
    "venueId": 3815,
    "venue": "M. M. Roberts Stadium",
    "homeId": 2572,
    "homeTeam": "Southern Miss",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 13,
    "homeLineScores": [
      0,
      13,
      0,
      0
    ],
    "homePostgameWinProbability": 0.08284809267446264,
    "homePregameElo": 1106,
    "homePostgameElo": 1120,
    "awayId": 309,
    "awayTeam": "Louisiana",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 23,
    "awayLineScores": [
      3,
      14,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.9171519073255374,
    "awayPregameElo": 1537,
    "awayPostgameElo": 1523,
    "excitementIndex": 3.8168976361,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643800,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 21427,
    "venueId": 3625,
    "venue": "Centennial Bank Stadium",
    "homeId": 2032,
    "homeTeam": "Arkansas State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 18,
    "homeLineScores": [
      3,
      3,
      3,
      9
    ],
    "homePostgameWinProbability": 0.5303647221727372,
    "homePregameElo": 1313,
    "homePostgameElo": 1317,
    "awayId": 6,
    "awayTeam": "South Alabama",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 16,
    "awayLineScores": [
      0,
      3,
      7,
      6
    ],
    "awayPostgameWinProbability": 0.4696352778272628,
    "awayPregameElo": 1588,
    "awayPostgameElo": 1584,
    "excitementIndex": 7.7066051805,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643723,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 37210,
    "venueId": 3653,
    "venue": "Albertsons Stadium",
    "homeId": 68,
    "homeTeam": "Boise State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 62,
    "homeLineScores": [
      14,
      35,
      6,
      7
    ],
    "homePostgameWinProbability": 0.9988310034033747,
    "homePregameElo": 1677,
    "homePostgameElo": 1708,
    "awayId": 328,
    "awayTeam": "Utah State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 30,
    "awayLineScores": [
      3,
      14,
      7,
      6
    ],
    "awayPostgameWinProbability": 0.0011689965966252824,
    "awayPregameElo": 1193,
    "awayPostgameElo": 1162,
    "excitementIndex": 3.5827132309,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628379,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 75573,
    "venueId": 3887,
    "venue": "Razorback Stadium",
    "homeId": 8,
    "homeTeam": "Arkansas",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 19,
    "homeLineScores": [
      3,
      0,
      7,
      9
    ],
    "homePostgameWinProbability": 0.853422504219712,
    "homePregameElo": 1485,
    "homePostgameElo": 1513,
    "awayId": 2633,
    "awayTeam": "Tennessee",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      0,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.146577495780288,
    "awayPregameElo": 1975,
    "awayPostgameElo": 1947,
    "excitementIndex": 9.4409572777,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628505,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 72132,
    "venueId": 3765,
    "venue": "Husky Stadium",
    "homeId": 264,
    "homeTeam": "Washington",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 27,
    "homeLineScores": [
      7,
      7,
      0,
      13
    ],
    "homePostgameWinProbability": 0.47528760860669517,
    "homePregameElo": 1762,
    "homePostgameElo": 1790,
    "awayId": 130,
    "awayTeam": "Michigan",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      10,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.5247123913933048,
    "awayPregameElo": 1906,
    "awayPostgameElo": 1878,
    "excitementIndex": 7.6758718425,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628507,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 50913,
    "venueId": 3953,
    "venue": "Huntington Bank Stadium",
    "homeId": 135,
    "homeTeam": "Minnesota",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 24,
    "homeLineScores": [
      3,
      7,
      0,
      14
    ],
    "homePostgameWinProbability": 0.8824886018679423,
    "homePregameElo": 1506,
    "homePostgameElo": 1533,
    "awayId": 30,
    "awayTeam": "USC",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      10,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.11751139813205769,
    "awayPregameElo": 1786,
    "awayPostgameElo": 1759,
    "excitementIndex": 7.2819043392,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643726,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 17099,
    "venueId": 3935,
    "venue": "CEFCU Stadium",
    "homeId": 23,
    "homeTeam": "San Jos\u00e9 State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 35,
    "homeLineScores": [
      7,
      14,
      7,
      7
    ],
    "homePostgameWinProbability": 0.4058203903025504,
    "homePregameElo": 1601,
    "homePostgameElo": 1594,
    "awayId": 2440,
    "awayTeam": "Nevada",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      14,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.5941796096974497,
    "awayPregameElo": 1228,
    "awayPostgameElo": 1235,
    "excitementIndex": 7.2694649698,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636889,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 61500,
    "venueId": 3772,
    "venue": "Jack Trice Stadium",
    "homeId": 66,
    "homeTeam": "Iowa State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 43,
    "homeLineScores": [
      3,
      16,
      14,
      10
    ],
    "homePostgameWinProbability": 0.9961608558338894,
    "homePregameElo": 1732,
    "homePostgameElo": 1760,
    "awayId": 239,
    "awayTeam": "Baylor",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      7,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.003839144166110642,
    "awayPregameElo": 1485,
    "awayPostgameElo": 1457,
    "excitementIndex": 6.6113908141,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628380,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-05T23:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 90369,
    "venueId": 3634,
    "venue": "Ben Hill Griffin Stadium",
    "homeId": 57,
    "homeTeam": "Florida",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 24,
    "homeLineScores": [
      7,
      17,
      0,
      0
    ],
    "homePostgameWinProbability": 0.9065111632798241,
    "homePregameElo": 1516,
    "homePostgameElo": 1537,
    "awayId": 2116,
    "awayTeam": "UCF",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 13,
    "awayLineScores": [
      3,
      0,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.09348883672017594,
    "awayPregameElo": 1531,
    "awayPostgameElo": 1510,
    "excitementIndex": 3.6080238557,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643725,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-06T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 31307,
    "venueId": 7311,
    "venue": "Snapdragon Stadium",
    "homeId": 21,
    "homeTeam": "San Diego State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 27,
    "homeLineScores": [
      3,
      14,
      3,
      7
    ],
    "homePostgameWinProbability": 0.4864534347971009,
    "homePregameElo": 1344,
    "homePostgameElo": 1343,
    "awayId": 62,
    "awayTeam": "Hawai'i",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 24,
    "awayLineScores": [
      3,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.5135465652028991,
    "awayPregameElo": 1214,
    "awayPostgameElo": 1215,
    "excitementIndex": 8.0987997655,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635570,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-06T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 37287,
    "venueId": 721,
    "venue": "Bobby Dodd Stadium",
    "homeId": 59,
    "homeTeam": "Georgia Tech",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 24,
    "homeLineScores": [
      7,
      3,
      0,
      14
    ],
    "homePostgameWinProbability": 0.9902065561311496,
    "homePregameElo": 1545,
    "homePostgameElo": 1568,
    "awayId": 150,
    "awayTeam": "Duke",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      7,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.009793443868850393,
    "awayPregameElo": 1621,
    "awayPostgameElo": 1598,
    "excitementIndex": 7.5892318041,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636888,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-06T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 54639,
    "venueId": 3947,
    "venue": "Mountain America Stadium",
    "homeId": 9,
    "homeTeam": "Arizona State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 35,
    "homeLineScores": [
      7,
      7,
      0,
      21
    ],
    "homePostgameWinProbability": 0.9515028850251191,
    "homePregameElo": 1506,
    "homePostgameElo": 1511,
    "awayId": 2305,
    "awayTeam": "Kansas",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      7,
      3,
      14
    ],
    "awayPostgameWinProbability": 0.04849711497488085,
    "awayPregameElo": 1575,
    "awayPostgameElo": 1570,
    "excitementIndex": 9.7370534837,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635568,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-06T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 52428,
    "venueId": 3831,
    "venue": "California Memorial Stadium",
    "homeId": 25,
    "homeTeam": "California",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 38,
    "homeLineScores": [
      7,
      14,
      14,
      3
    ],
    "homePostgameWinProbability": 0.7941413267896873,
    "homePregameElo": 1537,
    "homePostgameElo": 1549,
    "awayId": 2390,
    "awayTeam": "Miami",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 39,
    "awayLineScores": [
      7,
      3,
      8,
      21
    ],
    "awayPostgameWinProbability": 0.2058586732103127,
    "awayPregameElo": 1834,
    "awayPostgameElo": 1822,
    "excitementIndex": 5.080224193,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636887,
    "season": 2024,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2024-10-06T03:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 45773,
    "venueId": 3619,
    "venue": "Arizona Stadium",
    "homeId": 12,
    "homeTeam": "Arizona",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 22,
    "homeLineScores": [
      3,
      0,
      13,
      6
    ],
    "homePostgameWinProbability": 0.13349258042688492,
    "homePregameElo": 1694,
    "homePostgameElo": 1678,
    "awayId": 2641,
    "awayTeam": "Texas Tech",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 28,
    "awayLineScores": [
      7,
      11,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.8665074195731151,
    "awayPregameElo": 1628,
    "awayPostgameElo": 1644,
    "excitementIndex": 6.9843712378,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401640982,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-08T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16343,
    "venueId": 3992,
    "venue": "Williams Stadium (VA)",
    "homeId": 2335,
    "homeTeam": "Liberty",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 31,
    "homeLineScores": [
      3,
      14,
      0,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9047516629611938,
    "homePregameElo": 1589,
    "homePostgameElo": 1581,
    "awayId": 2229,
    "awayTeam": "Florida International",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 24,
    "awayLineScores": [
      3,
      7,
      0,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.0952483370388062,
    "awayPregameElo": 1257,
    "awayPostgameElo": 1265,
    "excitementIndex": 6.9751142566,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641002,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-09T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16555,
    "venueId": 3662,
    "venue": "AmFirst Stadium",
    "homeId": 55,
    "homeTeam": "Jacksonville State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 54,
    "homeLineScores": [
      7,
      26,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9978677358817323,
    "homePregameElo": 1560,
    "homePostgameElo": 1637,
    "awayId": 166,
    "awayTeam": "New Mexico State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 13,
    "awayLineScores": [
      3,
      3,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.0021322641182677238,
    "awayPregameElo": 1238,
    "awayPostgameElo": 1161,
    "excitementIndex": 4.0273285537,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643803,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-10T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 25622,
    "venueId": 3651,
    "venue": "Bridgeforth Stadium",
    "homeId": 256,
    "homeTeam": "James Madison",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 39,
    "homeLineScores": [
      7,
      22,
      7,
      3
    ],
    "homePostgameWinProbability": 0.9985012233417523,
    "homePregameElo": 1823,
    "homePostgameElo": 1866,
    "awayId": 324,
    "awayTeam": "Coastal Carolina",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 7,
    "awayLineScores": [
      7,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0014987766582477136,
    "awayPregameElo": 1456,
    "awayPostgameElo": 1413,
    "excitementIndex": 3.3083165831,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641030,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-11T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 12723,
    "venueId": 3796,
    "venue": "Houchens Industries-L.T. Smith Stadium",
    "homeId": 98,
    "homeTeam": "Western Kentucky",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 44,
    "homeLineScores": [
      14,
      13,
      7,
      10
    ],
    "homePostgameWinProbability": 0.96571573710875,
    "homePregameElo": 1410,
    "homePostgameElo": 1454,
    "awayId": 2638,
    "awayTeam": "UTEP",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 17,
    "awayLineScores": [
      7,
      0,
      10,
      0
    ],
    "awayPostgameWinProbability": 0.03428426289124997,
    "awayPregameElo": 1181,
    "awayPostgameElo": 1137,
    "excitementIndex": 4.3428064771,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641009,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-11T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 15072,
    "venueId": 3776,
    "venue": "Joe Aillet Stadium",
    "homeId": 2348,
    "homeTeam": "Louisiana Tech",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 48,
    "homeLineScores": [
      20,
      14,
      14,
      0
    ],
    "homePostgameWinProbability": 0.9988574732534925,
    "homePregameElo": 1223,
    "homePostgameElo": 1288,
    "awayId": 2393,
    "awayTeam": "Middle Tennessee",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 21,
    "awayLineScores": [
      14,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.0011425267465074995,
    "awayPregameElo": 1181,
    "awayPostgameElo": 1116,
    "excitementIndex": 3.5734309396,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628513,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 39371,
    "venueId": 3665,
    "venue": "SECU Stadium",
    "homeId": 120,
    "homeTeam": "Maryland",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 10,
    "homeLineScores": [
      0,
      7,
      0,
      3
    ],
    "homePostgameWinProbability": 0.009091774784083226,
    "homePregameElo": 1642,
    "homePostgameElo": 1546,
    "awayId": 77,
    "awayTeam": "Northwestern",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 37,
    "awayLineScores": [
      7,
      10,
      0,
      20
    ],
    "awayPostgameWinProbability": 0.9909082252159168,
    "awayPregameElo": 1473,
    "awayPostgameElo": 1569,
    "excitementIndex": 3.6586426589,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643733,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20295,
    "venueId": 3905,
    "venue": "Maverik Stadium",
    "homeId": 328,
    "homeTeam": "Utah State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 34,
    "homeLineScores": [
      7,
      0,
      14,
      13
    ],
    "homePostgameWinProbability": 0.04963835271708906,
    "homePregameElo": 1162,
    "homePostgameElo": 1172,
    "awayId": 2439,
    "awayTeam": "UNLV",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 50,
    "awayLineScores": [
      14,
      27,
      6,
      3
    ],
    "awayPostgameWinProbability": 0.950361647282911,
    "awayPregameElo": 1675,
    "awayPostgameElo": 1665,
    "excitementIndex": 2.0762387963,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636892,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 45310,
    "venueId": 3947,
    "venue": "Mountain America Stadium",
    "homeId": 9,
    "homeTeam": "Arizona State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 27,
    "homeLineScores": [
      6,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9935560386041525,
    "homePregameElo": 1511,
    "homePostgameElo": 1529,
    "awayId": 254,
    "awayTeam": "Utah",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 19,
    "awayLineScores": [
      6,
      3,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.006443961395847464,
    "awayPregameElo": 1607,
    "awayPostgameElo": 1589,
    "excitementIndex": 6.7368652973,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644745,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 13996,
    "venueId": 3965,
    "venue": "UB Stadium",
    "homeId": 2084,
    "homeTeam": "Buffalo",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 30,
    "homeLineScores": [
      7,
      0,
      14,
      9
    ],
    "homePostgameWinProbability": 0.9758903942086857,
    "homePregameElo": 1228,
    "homePostgameElo": 1294,
    "awayId": 2649,
    "awayTeam": "Toledo",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 15,
    "awayLineScores": [
      0,
      0,
      7,
      8
    ],
    "awayPostgameWinProbability": 0.02410960579131427,
    "awayPregameElo": 1574,
    "awayPostgameElo": 1508,
    "excitementIndex": 4.9612405286,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628517,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 50111,
    "venueId": 6577,
    "venue": "SHI Stadium",
    "homeId": 164,
    "homeTeam": "Rutgers",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 7,
    "homeLineScores": [
      0,
      0,
      0,
      7
    ],
    "homePostgameWinProbability": 0.000627244070593527,
    "homePregameElo": 1521,
    "homePostgameElo": 1436,
    "awayId": 275,
    "awayTeam": "Wisconsin",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 42,
    "awayLineScores": [
      14,
      0,
      14,
      14
    ],
    "awayPostgameWinProbability": 0.9993727559294064,
    "awayPregameElo": 1644,
    "awayPostgameElo": 1729,
    "excitementIndex": 2.6905520773,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628512,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 69250,
    "venueId": 3793,
    "venue": "Kinnick Stadium",
    "homeId": 2294,
    "homeTeam": "Iowa",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 40,
    "homeLineScores": [
      7,
      13,
      3,
      17
    ],
    "homePostgameWinProbability": 0.961693357357087,
    "homePregameElo": 1600,
    "homePostgameElo": 1683,
    "awayId": 264,
    "awayTeam": "Washington",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 16,
    "awayLineScores": [
      0,
      10,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.03830664264291295,
    "awayPregameElo": 1790,
    "awayPostgameElo": 1707,
    "excitementIndex": 4.542836881,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645342,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 29002,
    "venueId": 3841,
    "venue": "Michie Stadium",
    "homeId": 349,
    "homeTeam": "Army",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 44,
    "homeLineScores": [
      20,
      14,
      7,
      3
    ],
    "homePostgameWinProbability": 0.9983120962535629,
    "homePregameElo": 1606,
    "homePostgameElo": 1643,
    "awayId": 5,
    "awayTeam": "UAB",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 10,
    "awayLineScores": [
      3,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.001687903746437125,
    "awayPregameElo": 1128,
    "awayPostgameElo": 1091,
    "excitementIndex": 4.9031007378,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644743,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 7322,
    "venueId": 3696,
    "venue": "Dix Stadium",
    "homeId": 2309,
    "homeTeam": "Kent State",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 35,
    "homeLineScores": [
      0,
      7,
      7,
      21
    ],
    "homePostgameWinProbability": 0.6066052948611376,
    "homePregameElo": 922,
    "homePostgameElo": 928,
    "awayId": 2050,
    "awayTeam": "Ball State",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 37,
    "awayLineScores": [
      10,
      10,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.39339470513886243,
    "awayPregameElo": 1091,
    "awayPostgameElo": 1085,
    "excitementIndex": 4.9770357306,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628385,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 100077,
    "venueId": 3657,
    "venue": "Bryant-Denny Stadium",
    "homeId": 333,
    "homeTeam": "Alabama",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 27,
    "homeLineScores": [
      7,
      7,
      0,
      13
    ],
    "homePostgameWinProbability": 0.5317165485267156,
    "homePregameElo": 2014,
    "homePostgameElo": 2010,
    "awayId": 2579,
    "awayTeam": "South Carolina",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 25,
    "awayLineScores": [
      0,
      12,
      7,
      6
    ],
    "awayPostgameWinProbability": 0.46828345147328443,
    "awayPregameElo": 1654,
    "awayPostgameElo": 1658,
    "excitementIndex": 8.337485999,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635577,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 44482,
    "venueId": 3787,
    "venue": "Kenan Stadium",
    "homeId": 153,
    "homeTeam": "North Carolina",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 34,
    "homeLineScores": [
      7,
      7,
      10,
      10
    ],
    "homePostgameWinProbability": 0.030260657172875353,
    "homePregameElo": 1497,
    "homePostgameElo": 1489,
    "awayId": 59,
    "awayTeam": "Georgia Tech",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 41,
    "awayLineScores": [
      7,
      13,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.9697393428271246,
    "awayPregameElo": 1568,
    "awayPostgameElo": 1576,
    "excitementIndex": 6.0512376645,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635576,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 31553,
    "venueId": 3630,
    "venue": "Allegacy Federal Credit Union Stadium",
    "homeId": 154,
    "homeTeam": "Wake Forest",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 14,
    "homeLineScores": [
      7,
      7,
      0,
      0
    ],
    "homePostgameWinProbability": 0.002023896064461671,
    "homePregameElo": 1390,
    "homePostgameElo": 1343,
    "awayId": 228,
    "awayTeam": "Clemson",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 49,
    "awayLineScores": [
      0,
      28,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.9979761039355384,
    "awayPregameElo": 1817,
    "awayPostgameElo": 1864,
    "excitementIndex": 3.1665894345,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628389,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 16102,
    "venueId": 3985,
    "venue": "Warren McGuirk Alumni Stadium",
    "homeId": 113,
    "homeTeam": "Massachusetts",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 3,
    "homeLineScores": [
      0,
      3,
      0,
      0
    ],
    "homePostgameWinProbability": 0.0007590125928680845,
    "homePregameElo": 1070,
    "homePostgameElo": 1025,
    "awayId": 142,
    "awayTeam": "Missouri",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 45,
    "awayLineScores": [
      14,
      10,
      21,
      0
    ],
    "awayPostgameWinProbability": 0.999240987407132,
    "awayPregameElo": 1692,
    "awayPostgameElo": 1737,
    "excitementIndex": 1.6773361622,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644685,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16903,
    "venueId": 3912,
    "venue": "Rynearson Stadium",
    "homeId": 2199,
    "homeTeam": "Eastern Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 14,
    "homeLineScores": [
      7,
      0,
      7,
      0
    ],
    "homePostgameWinProbability": 0.0010620786593712346,
    "homePregameElo": 1310,
    "homePostgameElo": 1261,
    "awayId": 193,
    "awayTeam": "Miami (OH)",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 38,
    "awayLineScores": [
      7,
      14,
      0,
      17
    ],
    "awayPostgameWinProbability": 0.9989379213406288,
    "awayPregameElo": 1437,
    "awayPostgameElo": 1486,
    "excitementIndex": 3.1111097465,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643732,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 23155,
    "venueId": 3984,
    "venue": "War Memorial Stadium",
    "homeId": 2751,
    "homeTeam": "Wyoming",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 24,
    "homeLineScores": [
      7,
      7,
      3,
      7
    ],
    "homePostgameWinProbability": 0.06401850648385274,
    "homePregameElo": 1286,
    "homePostgameElo": 1285,
    "awayId": 21,
    "awayTeam": "San Diego State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 27,
    "awayLineScores": [
      10,
      7,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.9359814935161472,
    "awayPregameElo": 1343,
    "awayPostgameElo": 1344,
    "excitementIndex": 10.4092775134,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644744,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 9559,
    "venueId": 3700,
    "venue": "Doyt L. Perry Stadium",
    "homeId": 189,
    "homeTeam": "Bowling Green",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 7,
    "homeLineScores": [
      7,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0.04975983510212746,
    "homePregameElo": 1424,
    "homePostgameElo": 1406,
    "awayId": 2459,
    "awayTeam": "Northern Illinois",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 17,
    "awayLineScores": [
      3,
      3,
      0,
      11
    ],
    "awayPostgameWinProbability": 0.9502401648978726,
    "awayPregameElo": 1452,
    "awayPostgameElo": 1470,
    "excitementIndex": 6.1012555101,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645341,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 3365,
    "venueId": 4013,
    "venue": "Camping World Stadium",
    "homeId": 58,
    "homeTeam": "South Florida",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 3,
    "homeLineScores": [
      0,
      3,
      0,
      0
    ],
    "homePostgameWinProbability": 0.08555942373820803,
    "homePregameElo": 1336,
    "homePostgameElo": 1325,
    "awayId": 235,
    "awayTeam": "Memphis",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 21,
    "awayLineScores": [
      14,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.914440576261792,
    "awayPregameElo": 1598,
    "awayPostgameElo": 1609,
    "excitementIndex": 3.1570242762,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636895,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 42611,
    "venueId": 3652,
    "venue": "FBC Mortgage Stadium",
    "homeId": 2116,
    "homeTeam": "UCF",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 13,
    "homeLineScores": [
      0,
      3,
      7,
      3
    ],
    "homePostgameWinProbability": 0.9084805679531813,
    "homePregameElo": 1510,
    "homePostgameElo": 1501,
    "awayId": 2132,
    "awayTeam": "Cincinnati",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 19,
    "awayLineScores": [
      3,
      7,
      3,
      6
    ],
    "awayPostgameWinProbability": 0.09151943204681867,
    "awayPregameElo": 1529,
    "awayPostgameElo": 1538,
    "excitementIndex": 6.3428883403,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644742,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 19507,
    "venueId": 3980,
    "venue": "Waldo Stadium",
    "homeId": 2711,
    "homeTeam": "Western Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 34,
    "homeLineScores": [
      0,
      24,
      7,
      3
    ],
    "homePostgameWinProbability": 0.5147599779693116,
    "homePregameElo": 1217,
    "homePostgameElo": 1223,
    "awayId": 2006,
    "awayTeam": "Akron",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 24,
    "awayLineScores": [
      10,
      7,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.4852400220306884,
    "awayPregameElo": 1055,
    "awayPostgameElo": 1049,
    "excitementIndex": 7.2173027465,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628516,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 75250,
    "venueId": 477,
    "venue": "Los Angeles Memorial Coliseum",
    "homeId": 30,
    "homeTeam": "USC",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 30,
    "homeLineScores": [
      7,
      13,
      3,
      7,
      0
    ],
    "homePostgameWinProbability": 0.20837337912491963,
    "homePregameElo": 1759,
    "homePostgameElo": 1763,
    "awayId": 213,
    "awayTeam": "Penn State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 33,
    "awayLineScores": [
      3,
      3,
      14,
      10,
      3
    ],
    "awayPostgameWinProbability": 0.7916266208750804,
    "awayPregameElo": 1901,
    "awayPostgameElo": 1897,
    "excitementIndex": 8.3940337001,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628511,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 55815,
    "venueId": 3832,
    "venue": "Memorial Stadium (Champaign, IL)",
    "homeId": 356,
    "homeTeam": "Illinois",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 50,
    "homeLineScores": [
      10,
      14,
      3,
      16,
      7
    ],
    "homePostgameWinProbability": 0.3115410769519463,
    "homePregameElo": 1551,
    "homePostgameElo": 1541,
    "awayId": 2509,
    "awayTeam": "Purdue",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 49,
    "awayLineScores": [
      0,
      3,
      17,
      23,
      6
    ],
    "awayPostgameWinProbability": 0.6884589230480537,
    "awayPregameElo": 1214,
    "awayPostgameElo": 1224,
    "excitementIndex": 5.786479558,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643729,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 27280,
    "venueId": 5388,
    "venue": "Canvas Stadium",
    "homeId": 36,
    "homeTeam": "Colorado State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 31,
    "homeLineScores": [
      7,
      7,
      7,
      10
    ],
    "homePostgameWinProbability": 0.5713446702126063,
    "homePregameElo": 1246,
    "homePostgameElo": 1277,
    "awayId": 23,
    "awayTeam": "San Jos\u00e9 State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      7,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.42865532978739374,
    "awayPregameElo": 1594,
    "awayPostgameElo": 1563,
    "excitementIndex": 7.0620941823,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628981,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 77622,
    "venueId": 3855,
    "venue": "Notre Dame Stadium",
    "homeId": 87,
    "homeTeam": "Notre Dame",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 49,
    "homeLineScores": [
      7,
      14,
      21,
      7
    ],
    "homePostgameWinProbability": 0.9986558260894001,
    "homePregameElo": 1994,
    "homePostgameElo": 2026,
    "awayId": 24,
    "awayTeam": "Stanford",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 7,
    "awayLineScores": [
      7,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0013441739105999329,
    "awayPregameElo": 1261,
    "awayPostgameElo": 1229,
    "excitementIndex": 4.7673246003,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628390,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 92100,
    "venueId": 499,
    "venue": "Cotton Bowl",
    "homeId": 201,
    "homeTeam": "Oklahoma",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 3,
    "homeLineScores": [
      3,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0.06185499673879433,
    "homePregameElo": 1827,
    "homePostgameElo": 1780,
    "awayId": 251,
    "awayTeam": "Texas",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 34,
    "awayLineScores": [
      0,
      21,
      3,
      10
    ],
    "awayPostgameWinProbability": 0.9381450032612056,
    "awayPregameElo": 2091,
    "awayPostgameElo": 2138,
    "excitementIndex": 3.020050815,
    "highlights": "",
    "notes": "Allstate Red River Rivalry"
  },
  {
    "id": 401643805,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 12280,
    "venueId": 4246,
    "venue": "Center Parc Stadium",
    "homeId": 2247,
    "homeTeam": "Georgia State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 14,
    "homeLineScores": [
      0,
      7,
      0,
      7
    ],
    "homePostgameWinProbability": 0.00473580660101157,
    "homePregameElo": 1325,
    "homePostgameElo": 1315,
    "awayId": 295,
    "awayTeam": "Old Dominion",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.9952641933989884,
    "awayPregameElo": 1369,
    "awayPostgameElo": 1379,
    "excitementIndex": 6.2593362665,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635575,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 49773,
    "venueId": 3752,
    "venue": "Acrisure Stadium",
    "homeId": 221,
    "homeTeam": "Pittsburgh",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 17,
    "homeLineScores": [
      7,
      10,
      0,
      0
    ],
    "homePostgameWinProbability": 0.46069799211883156,
    "homePregameElo": 1512,
    "homePostgameElo": 1513,
    "awayId": 25,
    "awayTeam": "California",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 15,
    "awayLineScores": [
      6,
      3,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.5393020078811684,
    "awayPregameElo": 1549,
    "awayPostgameElo": 1548,
    "excitementIndex": 7.8548971552,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635578,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 32688,
    "venueId": 3923,
    "venue": "Scott Stadium",
    "homeId": 258,
    "homeTeam": "Virginia",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 20,
    "homeLineScores": [
      7,
      0,
      6,
      7
    ],
    "homePostgameWinProbability": 0.03742634144200225,
    "homePregameElo": 1412,
    "homePostgameElo": 1424,
    "awayId": 97,
    "awayTeam": "Louisville",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 24,
    "awayLineScores": [
      0,
      7,
      10,
      7
    ],
    "awayPostgameWinProbability": 0.9625736585579977,
    "awayPregameElo": 1707,
    "awayPostgameElo": 1695,
    "excitementIndex": 6.6794409164,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636893,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 64420,
    "venueId": 3801,
    "venue": "LaVell Edwards Stadium",
    "homeId": 252,
    "homeTeam": "BYU",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 41,
    "homeLineScores": [
      0,
      14,
      13,
      14
    ],
    "homePostgameWinProbability": 0.9548870029482884,
    "homePregameElo": 1603,
    "homePostgameElo": 1665,
    "awayId": 12,
    "awayTeam": "Arizona",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 19,
    "awayLineScores": [
      7,
      0,
      3,
      9
    ],
    "awayPostgameWinProbability": 0.04511299705171157,
    "awayPregameElo": 1678,
    "awayPostgameElo": 1616,
    "excitementIndex": 5.9837855097,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644746,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 22437,
    "venueId": 3786,
    "venue": "Kelly/Shorts Stadium",
    "homeId": 2117,
    "homeTeam": "Central Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 25,
    "homeLineScores": [
      0,
      0,
      8,
      17
    ],
    "homePostgameWinProbability": 0.3825064856677301,
    "homePregameElo": 1180,
    "homePostgameElo": 1189,
    "awayId": 195,
    "awayTeam": "Ohio",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 27,
    "awayLineScores": [
      3,
      21,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.61749351433227,
    "awayPregameElo": 1414,
    "awayPostgameElo": 1405,
    "excitementIndex": 3.9729999858,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628386,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T20:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 93033,
    "venueId": 3917,
    "venue": "Sanford Stadium",
    "homeId": 61,
    "homeTeam": "Georgia",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 41,
    "homeLineScores": [
      10,
      17,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9860373811833222,
    "homePregameElo": 2033,
    "homePostgameElo": 2009,
    "awayId": 344,
    "awayTeam": "Mississippi State",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 31,
    "awayLineScores": [
      3,
      7,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.013962618816677819,
    "awayPregameElo": 1371,
    "awayPostgameElo": 1395,
    "excitementIndex": 4.7759123974,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643807,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 22645,
    "venueId": 3817,
    "venue": "Malone Stadium",
    "homeId": 2433,
    "homeTeam": "UL Monroe",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 38,
    "homeLineScores": [
      7,
      7,
      3,
      21
    ],
    "homePostgameWinProbability": 0.997794711057732,
    "homePregameElo": 1247,
    "homePostgameElo": 1272,
    "awayId": 2572,
    "awayTeam": "Southern Miss",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 21,
    "awayLineScores": [
      3,
      3,
      8,
      7
    ],
    "awayPostgameWinProbability": 0.0022052889422680133,
    "awayPregameElo": 1120,
    "awayPostgameElo": 1095,
    "excitementIndex": 7.4434294551,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645344,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 18660,
    "venueId": 3895,
    "venue": "Rice Stadium",
    "homeId": 242,
    "homeTeam": "Rice",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 29,
    "homeLineScores": [
      0,
      9,
      14,
      6
    ],
    "homePostgameWinProbability": 0.6286843240968248,
    "homePregameElo": 1219,
    "homePostgameElo": 1222,
    "awayId": 2636,
    "awayTeam": "UTSA",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 27,
    "awayLineScores": [
      0,
      10,
      3,
      14
    ],
    "awayPostgameWinProbability": 0.37131567590317516,
    "awayPregameElo": 1374,
    "awayPostgameElo": 1371,
    "excitementIndex": 7.4202433524,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645343,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 14576,
    "venueId": 3715,
    "venue": "FAU Stadium",
    "homeId": 2226,
    "homeTeam": "Florida Atlantic",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 37,
    "homeLineScores": [
      7,
      20,
      7,
      3
    ],
    "homePostgameWinProbability": 0.9641209152573771,
    "homePregameElo": 1275,
    "homePostgameElo": 1280,
    "awayId": 249,
    "awayTeam": "North Texas",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 41,
    "awayLineScores": [
      14,
      3,
      10,
      14
    ],
    "awayPostgameWinProbability": 0.03587908474262291,
    "awayPregameElo": 1464,
    "awayPostgameElo": 1459,
    "excitementIndex": 8.8765236442,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643730,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 41031,
    "venueId": 3660,
    "venue": "Valley Children's Stadium",
    "homeId": 278,
    "homeTeam": "Fresno State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 17,
    "homeLineScores": [
      7,
      0,
      7,
      3
    ],
    "homePostgameWinProbability": 0.40267405483796054,
    "homePregameElo": 1518,
    "homePostgameElo": 1505,
    "awayId": 265,
    "awayTeam": "Washington State",
    "awayClassification": "fbs",
    "awayConference": "Pac-12",
    "awayPoints": 25,
    "awayLineScores": [
      13,
      0,
      3,
      9
    ],
    "awayPostgameWinProbability": 0.5973259451620394,
    "awayPregameElo": 1550,
    "awayPostgameElo": 1563,
    "excitementIndex": 5.9016419656,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628391,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 101915,
    "venueId": 3853,
    "venue": "Neyland Stadium",
    "homeId": 2633,
    "homeTeam": "Tennessee",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 23,
    "homeLineScores": [
      0,
      0,
      10,
      7,
      6
    ],
    "homePostgameWinProbability": 0.7931088508179842,
    "homePregameElo": 1947,
    "homePostgameElo": 1936,
    "awayId": 57,
    "awayTeam": "Florida",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 17,
    "awayLineScores": [
      3,
      0,
      7,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.2068911491820158,
    "awayPregameElo": 1537,
    "awayPostgameElo": 1548,
    "excitementIndex": 7.2760140012,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643808,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 28000,
    "venueId": 3644,
    "venue": "Bobcat Stadium (TX)",
    "homeId": 326,
    "homeTeam": "Texas State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 41,
    "homeLineScores": [
      14,
      3,
      14,
      10
    ],
    "homePostgameWinProbability": 0.9989243249265435,
    "homePregameElo": 1584,
    "homePostgameElo": 1639,
    "awayId": 2032,
    "awayTeam": "Arkansas State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 9,
    "awayLineScores": [
      3,
      6,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0010756750734565168,
    "awayPregameElo": 1317,
    "awayPostgameElo": 1262,
    "excitementIndex": 6.4407139338,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643727,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 15561,
    "venueId": 3971,
    "venue": "University Stadium (NM)",
    "homeId": 167,
    "homeTeam": "New Mexico",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 52,
    "homeLineScores": [
      7,
      21,
      17,
      7
    ],
    "homePostgameWinProbability": 0.42925120003031486,
    "homePregameElo": 1228,
    "homePostgameElo": 1271,
    "awayId": 2005,
    "awayTeam": "Air Force",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 37,
    "awayLineScores": [
      3,
      14,
      0,
      20
    ],
    "awayPostgameWinProbability": 0.5707487999696852,
    "awayPregameElo": 1353,
    "awayPostgameElo": 1310,
    "excitementIndex": 3.8889638923,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628388,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 102212,
    "venueId": 3958,
    "venue": "Tiger Stadium (LA)",
    "homeId": 99,
    "homeTeam": "LSU",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 29,
    "homeLineScores": [
      0,
      13,
      3,
      7,
      6
    ],
    "homePostgameWinProbability": 0.26681076882312127,
    "homePregameElo": 1874,
    "homePostgameElo": 1875,
    "awayId": 145,
    "awayTeam": "Ole Miss",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 26,
    "awayLineScores": [
      0,
      17,
      3,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.7331892311768787,
    "awayPregameElo": 1906,
    "awayPostgameElo": 1905,
    "excitementIndex": 8.6586387449,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643806,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 14058,
    "venueId": 3666,
    "venue": "Cajun Field",
    "homeId": 309,
    "homeTeam": "Louisiana",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 34,
    "homeLineScores": [
      3,
      14,
      3,
      14
    ],
    "homePostgameWinProbability": 0.9365368199640138,
    "homePregameElo": 1523,
    "homePostgameElo": 1527,
    "awayId": 2026,
    "awayTeam": "App State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 24,
    "awayLineScores": [
      0,
      14,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.06346318003598617,
    "awayPregameElo": 1334,
    "awayPostgameElo": 1330,
    "excitementIndex": 8.0453459026,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628515,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 60129,
    "venueId": 3626,
    "venue": "Autzen Stadium",
    "homeId": 2483,
    "homeTeam": "Oregon",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 32,
    "homeLineScores": [
      6,
      16,
      0,
      10
    ],
    "homePostgameWinProbability": 0.182106615223062,
    "homePregameElo": 1971,
    "homePostgameElo": 1975,
    "awayId": 194,
    "awayTeam": "Ohio State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      14,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.817893384776938,
    "awayPregameElo": 2080,
    "awayPostgameElo": 2076,
    "excitementIndex": 8.0652480128,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643731,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 21541,
    "venueId": 3816,
    "venue": "Mackay Stadium",
    "homeId": 2440,
    "homeTeam": "Nevada",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 42,
    "homeLineScores": [
      7,
      7,
      7,
      21
    ],
    "homePostgameWinProbability": 0.9836714649264696,
    "homePregameElo": 1235,
    "homePostgameElo": 1257,
    "awayId": 204,
    "awayTeam": "Oregon State",
    "awayClassification": "fbs",
    "awayConference": "Pac-12",
    "awayPoints": 37,
    "awayLineScores": [
      7,
      10,
      7,
      13
    ],
    "awayPostgameWinProbability": 0.01632853507353038,
    "awayPregameElo": 1609,
    "awayPostgameElo": 1587,
    "excitementIndex": 6.1530453858,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628387,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-12T23:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 62120,
    "venueId": 3683,
    "venue": "Kroger Field",
    "homeId": 96,
    "homeTeam": "Kentucky",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 13,
    "homeLineScores": [
      0,
      7,
      0,
      6
    ],
    "homePostgameWinProbability": 0.3874286012685711,
    "homePregameElo": 1686,
    "homePostgameElo": 1645,
    "awayId": 238,
    "awayTeam": "Vanderbilt",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 20,
    "awayLineScores": [
      7,
      7,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.612571398731429,
    "awayPregameElo": 1359,
    "awayPostgameElo": 1400,
    "excitementIndex": 4.0517060383,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643804,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-13T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 24048,
    "venueId": 3608,
    "venue": "Allen E. Paulson Stadium",
    "homeId": 290,
    "homeTeam": "Georgia Southern",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 24,
    "homeLineScores": [
      3,
      0,
      0,
      21
    ],
    "homePostgameWinProbability": 0.14621745082441648,
    "homePregameElo": 1370,
    "homePostgameElo": 1371,
    "awayId": 276,
    "awayTeam": "Marshall",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 23,
    "awayLineScores": [
      6,
      10,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.8537825491755835,
    "awayPregameElo": 1394,
    "awayPostgameElo": 1393,
    "excitementIndex": 5.549789888,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636896,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-13T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 55202,
    "venueId": 3842,
    "venue": "Milan Puskar Stadium",
    "homeId": 277,
    "homeTeam": "West Virginia",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 16,
    "homeLineScores": [
      7,
      3,
      0,
      6
    ],
    "homePostgameWinProbability": 0.3990910706499141,
    "homePregameElo": 1610,
    "homePostgameElo": 1597,
    "awayId": 66,
    "awayTeam": "Iowa State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 28,
    "awayLineScores": [
      0,
      14,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.6009089293500859,
    "awayPregameElo": 1760,
    "awayPostgameElo": 1773,
    "excitementIndex": 5.1948260351,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635574,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-13T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 56919,
    "venueId": 3670,
    "venue": "Carter-Finley Stadium",
    "homeId": 152,
    "homeTeam": "NC State",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 17,
    "homeLineScores": [
      0,
      7,
      0,
      10
    ],
    "homePostgameWinProbability": 0.9266980715866883,
    "homePregameElo": 1473,
    "homePostgameElo": 1454,
    "awayId": 183,
    "awayTeam": "Syracuse",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 24,
    "awayLineScores": [
      3,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.07330192841331173,
    "awayPregameElo": 1404,
    "awayPostgameElo": 1423,
    "excitementIndex": 3.9177136803,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628514,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-13T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 42012,
    "venueId": 1056,
    "venue": "Rose Bowl",
    "homeId": 26,
    "homeTeam": "UCLA",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 17,
    "homeLineScores": [
      7,
      3,
      0,
      7
    ],
    "homePostgameWinProbability": 0.7465767503234393,
    "homePregameElo": 1453,
    "homePostgameElo": 1452,
    "awayId": 135,
    "awayTeam": "Minnesota",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      0,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.2534232496765607,
    "awayPregameElo": 1533,
    "awayPostgameElo": 1534,
    "excitementIndex": 7.5181060735,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636894,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-13T02:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 53972,
    "venueId": 3726,
    "venue": "Folsom Field",
    "homeId": 38,
    "homeTeam": "Colorado",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 28,
    "homeLineScores": [
      7,
      0,
      7,
      14
    ],
    "homePostgameWinProbability": 0.16484188971234043,
    "homePregameElo": 1479,
    "homePostgameElo": 1490,
    "awayId": 2306,
    "awayTeam": "Kansas State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      7,
      10,
      7
    ],
    "awayPostgameWinProbability": 0.8351581102876595,
    "awayPregameElo": 1754,
    "awayPostgameElo": 1743,
    "excitementIndex": 5.4904680701,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643728,
    "season": 2024,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2024-10-13T03:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 15194,
    "venueId": 7220,
    "venue": "Clarence T.C. Ching Athletics Complex",
    "homeId": 62,
    "homeTeam": "Hawai'i",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 7,
    "homeLineScores": [
      0,
      7,
      0,
      0
    ],
    "homePostgameWinProbability": 0.0008570178272357902,
    "homePregameElo": 1215,
    "homePostgameElo": 1212,
    "awayId": 68,
    "awayTeam": "Boise State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 28,
    "awayLineScores": [
      10,
      3,
      0,
      15
    ],
    "awayPostgameWinProbability": 0.9991429821727642,
    "awayPregameElo": 1708,
    "awayPostgameElo": 1711,
    "excitementIndex": 4.7514122487,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643809,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-15T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 25450,
    "venueId": 6526,
    "venue": "Hancock Whitney Stadium",
    "homeId": 6,
    "homeTeam": "South Alabama",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 25,
    "homeLineScores": [
      3,
      16,
      6,
      0
    ],
    "homePostgameWinProbability": 0.9945437605484078,
    "homePregameElo": 1584,
    "homePostgameElo": 1606,
    "awayId": 2653,
    "awayTeam": "Troy",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 9,
    "awayLineScores": [
      0,
      3,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.0054562394515922374,
    "awayPregameElo": 1454,
    "awayPostgameElo": 1432,
    "excitementIndex": 3.9580282947,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641019,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-16T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 10200,
    "venueId": 3725,
    "venue": "Johnny \"Red\" Floyd Stadium",
    "homeId": 2393,
    "homeTeam": "Middle Tennessee",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 14,
    "homeLineScores": [
      7,
      0,
      7,
      0
    ],
    "homePostgameWinProbability": 0.9049817924550686,
    "homePregameElo": 1116,
    "homePostgameElo": 1142,
    "awayId": 338,
    "awayTeam": "Kennesaw State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 5,
    "awayLineScores": [
      2,
      0,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.0950182075449314,
    "awayPregameElo": 1281,
    "awayPostgameElo": 1255,
    "excitementIndex": 6.9414266345,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641010,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-16T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 9671,
    "venueId": 3601,
    "venue": "Aggie Memorial Stadium",
    "homeId": 166,
    "homeTeam": "New Mexico State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 33,
    "homeLineScores": [
      0,
      10,
      7,
      7,
      3,
      6
    ],
    "homePostgameWinProbability": 0.8718204039938436,
    "homePregameElo": 1161,
    "homePostgameElo": 1164,
    "awayId": 2348,
    "awayTeam": "Louisiana Tech",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 30,
    "awayLineScores": [
      0,
      14,
      0,
      10,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.12817959600615636,
    "awayPregameElo": 1288,
    "awayPostgameElo": 1285,
    "excitementIndex": 9.3626669943,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641038,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-16T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 8914,
    "venueId": 3647,
    "venue": "Elliott T. Bowers Stadium",
    "homeId": 2534,
    "homeTeam": "Sam Houston",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 14,
    "homeLineScores": [
      0,
      14,
      0,
      0
    ],
    "homePostgameWinProbability": 0.11889855219772984,
    "homePregameElo": 1464,
    "homePostgameElo": 1422,
    "awayId": 98,
    "awayTeam": "Western Kentucky",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      10,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.8811014478022702,
    "awayPregameElo": 1454,
    "awayPostgameElo": 1496,
    "excitementIndex": 5.4621880902,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401640983,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-17T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 11373,
    "venueId": 3946,
    "venue": "Sun Bowl",
    "homeId": 2638,
    "homeTeam": "UTEP",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 30,
    "homeLineScores": [
      3,
      14,
      3,
      10
    ],
    "homePostgameWinProbability": 0.9674477478290233,
    "homePregameElo": 1137,
    "homePostgameElo": 1161,
    "awayId": 2229,
    "awayTeam": "Florida International",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      7,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.03255225217097668,
    "awayPregameElo": 1265,
    "awayPostgameElo": 1241,
    "excitementIndex": 8.2034186576,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643810,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-17T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20703,
    "venueId": 3775,
    "venue": "Joan C. Edwards Stadium",
    "homeId": 276,
    "homeTeam": "Marshall",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 35,
    "homeLineScores": [
      11,
      14,
      0,
      10
    ],
    "homePostgameWinProbability": 0.9758281058907349,
    "homePregameElo": 1393,
    "homePostgameElo": 1417,
    "awayId": 2247,
    "awayTeam": "Georgia State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      10,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.024171894109265124,
    "awayPregameElo": 1315,
    "awayPostgameElo": 1291,
    "excitementIndex": 7.2140104615,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401634768,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-17T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 65632,
    "venueId": 3799,
    "venue": "Lane Stadium",
    "homeId": 259,
    "homeTeam": "Virginia Tech",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 42,
    "homeLineScores": [
      14,
      14,
      0,
      14
    ],
    "homePostgameWinProbability": 0.9977482470947416,
    "homePregameElo": 1644,
    "homePostgameElo": 1674,
    "awayId": 103,
    "awayTeam": "Boston College",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      0,
      21,
      0
    ],
    "awayPostgameWinProbability": 0.002251752905258364,
    "awayPregameElo": 1448,
    "awayPostgameElo": 1418,
    "excitementIndex": 3.8724888286,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401634769,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-18T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 30735,
    "venueId": 3982,
    "venue": "Wallace Wade Stadium",
    "homeId": 150,
    "homeTeam": "Duke",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 23,
    "homeLineScores": [
      7,
      10,
      3,
      3
    ],
    "homePostgameWinProbability": 0.909404387085186,
    "homePregameElo": 1598,
    "homePostgameElo": 1604,
    "awayId": 52,
    "awayTeam": "Florida State",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 16,
    "awayLineScores": [
      3,
      3,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.090595612914814,
    "awayPregameElo": 1532,
    "awayPostgameElo": 1526,
    "excitementIndex": 6.7798954406,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628523,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 57463,
    "venueId": 3907,
    "venue": "Ross-Ade Stadium",
    "homeId": 2509,
    "homeTeam": "Purdue",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 0,
    "homeLineScores": [
      0,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0.028372627967429485,
    "homePregameElo": 1224,
    "homePostgameElo": 1212,
    "awayId": 2483,
    "awayTeam": "Oregon",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 35,
    "awayLineScores": [
      14,
      7,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.9716273720325705,
    "awayPregameElo": 1975,
    "awayPostgameElo": 1987,
    "excitementIndex": 1.8239107218,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636898,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T02:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 62841,
    "venueId": 3801,
    "venue": "LaVell Edwards Stadium",
    "homeId": 252,
    "homeTeam": "BYU",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 38,
    "homeLineScores": [
      7,
      7,
      14,
      10
    ],
    "homePostgameWinProbability": 0.22809458726106233,
    "homePregameElo": 1665,
    "homePostgameElo": 1664,
    "awayId": 197,
    "awayTeam": "Oklahoma State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 35,
    "awayLineScores": [
      7,
      14,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.7719054127389376,
    "awayPregameElo": 1489,
    "awayPostgameElo": 1490,
    "excitementIndex": 8.013022214,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643735,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 18319,
    "venueId": 3816,
    "venue": "Mackay Stadium",
    "homeId": 2440,
    "homeTeam": "Nevada",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 21,
    "homeLineScores": [
      7,
      14,
      0,
      0
    ],
    "homePostgameWinProbability": 0.3307928190088539,
    "homePregameElo": 1257,
    "homePostgameElo": 1267,
    "awayId": 278,
    "awayTeam": "Fresno State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 24,
    "awayLineScores": [
      3,
      14,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.6692071809911462,
    "awayPregameElo": 1505,
    "awayPostgameElo": 1495,
    "excitementIndex": 6.5051562633,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636899,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 38007,
    "venueId": 3854,
    "venue": "Nippert Stadium",
    "homeId": 2132,
    "homeTeam": "Cincinnati",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 24,
    "homeLineScores": [
      10,
      14,
      0,
      0
    ],
    "homePostgameWinProbability": 0.5634009123671583,
    "homePregameElo": 1538,
    "homePostgameElo": 1554,
    "awayId": 9,
    "awayTeam": "Arizona State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 14,
    "awayLineScores": [
      7,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.4365990876328417,
    "awayPregameElo": 1529,
    "awayPostgameElo": 1513,
    "excitementIndex": 5.3005294427,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628519,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 53082,
    "venueId": 3830,
    "venue": "Memorial Stadium (Bloomington, IN)",
    "homeId": 84,
    "homeTeam": "Indiana",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 56,
    "homeLineScores": [
      7,
      21,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9988809780822313,
    "homePregameElo": 1648,
    "homePostgameElo": 1791,
    "awayId": 158,
    "awayTeam": "Nebraska",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0011190219177686922,
    "awayPregameElo": 1597,
    "awayPostgameElo": 1454,
    "excitementIndex": 5.1549081579,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628522,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 12023,
    "venueId": 5960,
    "venue": "Lanny and Sharon Martin Stadium",
    "homeId": 77,
    "homeTeam": "Northwestern",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 3,
    "homeLineScores": [
      0,
      0,
      3,
      0
    ],
    "homePostgameWinProbability": 0.0059807059089865165,
    "homePregameElo": 1569,
    "homePostgameElo": 1543,
    "awayId": 275,
    "awayTeam": "Wisconsin",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 23,
    "awayLineScores": [
      0,
      14,
      7,
      2
    ],
    "awayPostgameWinProbability": 0.9940192940910135,
    "awayPregameElo": 1729,
    "awayPostgameElo": 1755,
    "excitementIndex": 3.6478457494,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635588,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 80100,
    "venueId": 3836,
    "venue": "Memorial Stadium (Clemson, SC)",
    "homeId": 228,
    "homeTeam": "Clemson",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 48,
    "homeLineScores": [
      3,
      14,
      21,
      10
    ],
    "homePostgameWinProbability": 0.9823551899632083,
    "homePregameElo": 1864,
    "homePostgameElo": 1863,
    "awayId": 258,
    "awayTeam": "Virginia",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 31,
    "awayLineScores": [
      3,
      7,
      0,
      21
    ],
    "awayPostgameWinProbability": 0.017644810036791747,
    "awayPregameElo": 1424,
    "awayPostgameElo": 1425,
    "excitementIndex": 4.5901434844,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628395,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 62621,
    "venueId": 3838,
    "venue": "Memorial Stadium",
    "homeId": 142,
    "homeTeam": "Missouri",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 21,
    "homeLineScores": [
      3,
      0,
      3,
      15
    ],
    "homePostgameWinProbability": 0.23393596298858255,
    "homePregameElo": 1737,
    "homePostgameElo": 1735,
    "awayId": 2,
    "awayTeam": "Auburn",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      3,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.7660640370114175,
    "awayPregameElo": 1550,
    "awayPostgameElo": 1552,
    "excitementIndex": 8.0479951949,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643811,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 17812,
    "venueId": 3654,
    "venue": "Brooks Stadium (SC)",
    "homeId": 324,
    "homeTeam": "Coastal Carolina",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 24,
    "homeLineScores": [
      0,
      14,
      3,
      7
    ],
    "homePostgameWinProbability": 0.03764825621181366,
    "homePregameElo": 1413,
    "homePostgameElo": 1402,
    "awayId": 309,
    "awayTeam": "Louisiana",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 34,
    "awayLineScores": [
      7,
      10,
      0,
      17
    ],
    "awayPostgameWinProbability": 0.9623517437881863,
    "awayPregameElo": 1527,
    "awayPostgameElo": 1538,
    "excitementIndex": 6.4922501001,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645346,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 23044,
    "venueId": 3841,
    "venue": "Michie Stadium",
    "homeId": 349,
    "homeTeam": "Army",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 45,
    "homeLineScores": [
      7,
      17,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9987804022637891,
    "homePregameElo": 1643,
    "homePostgameElo": 1649,
    "awayId": 151,
    "awayTeam": "East Carolina",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 28,
    "awayLineScores": [
      0,
      0,
      7,
      21
    ],
    "awayPostgameWinProbability": 0.0012195977362109423,
    "awayPregameElo": 1298,
    "awayPostgameElo": 1292,
    "excitementIndex": 2.7027059183,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401629034,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 30122,
    "venueId": 3892,
    "venue": "Pratt & Whitney Stadium",
    "homeId": 41,
    "homeTeam": "UConn",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 20,
    "homeLineScores": [
      3,
      3,
      7,
      7
    ],
    "homePostgameWinProbability": 0.4670717104797056,
    "homePregameElo": 1434,
    "homePostgameElo": 1424,
    "awayId": 154,
    "awayTeam": "Wake Forest",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 23,
    "awayLineScores": [
      3,
      10,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.5329282895202945,
    "awayPregameElo": 1343,
    "awayPostgameElo": 1353,
    "excitementIndex": 5.3772320815,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635589,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 59115,
    "venueId": 3873,
    "venue": "L&N Federal Credit Union Stadium",
    "homeId": 97,
    "homeTeam": "Louisville",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 45,
    "homeLineScores": [
      7,
      10,
      14,
      14
    ],
    "homePostgameWinProbability": 0.03784710405827017,
    "homePregameElo": 1695,
    "homePostgameElo": 1691,
    "awayId": 2390,
    "awayTeam": "Miami",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 52,
    "awayLineScores": [
      10,
      14,
      14,
      14
    ],
    "awayPostgameWinProbability": 0.9621528959417298,
    "awayPregameElo": 1822,
    "awayPostgameElo": 1826,
    "excitementIndex": 5.9727968944,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628524,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 53726,
    "venueId": 6577,
    "venue": "SHI Stadium",
    "homeId": 164,
    "homeTeam": "Rutgers",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 32,
    "homeLineScores": [
      7,
      3,
      9,
      13
    ],
    "homePostgameWinProbability": 0.3651614765917936,
    "homePregameElo": 1436,
    "homePostgameElo": 1432,
    "awayId": 26,
    "awayTeam": "UCLA",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 35,
    "awayLineScores": [
      7,
      14,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.6348385234082063,
    "awayPregameElo": 1452,
    "awayPostgameElo": 1456,
    "excitementIndex": 4.6407360434,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628396,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T16:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 83331,
    "venueId": 3835,
    "venue": "Memorial Stadium (Norman, OK)",
    "homeId": 201,
    "homeTeam": "Oklahoma",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 9,
    "homeLineScores": [
      0,
      3,
      6,
      0
    ],
    "homePostgameWinProbability": 0.15115189282518085,
    "homePregameElo": 1780,
    "homePostgameElo": 1694,
    "awayId": 2579,
    "awayTeam": "South Carolina",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 35,
    "awayLineScores": [
      21,
      11,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.8488481071748192,
    "awayPregameElo": 1658,
    "awayPostgameElo": 1744,
    "excitementIndex": 1.9556014898,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644750,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 17974,
    "venueId": 3912,
    "venue": "Rynearson Stadium",
    "homeId": 2199,
    "homeTeam": "Eastern Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 38,
    "homeLineScores": [
      10,
      6,
      0,
      22
    ],
    "homePostgameWinProbability": 0.29660334443869896,
    "homePregameElo": 1261,
    "homePostgameElo": 1262,
    "awayId": 2117,
    "awayTeam": "Central Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 34,
    "awayLineScores": [
      0,
      14,
      13,
      7
    ],
    "awayPostgameWinProbability": 0.703396655561301,
    "awayPregameElo": 1189,
    "awayPostgameElo": 1188,
    "excitementIndex": 5.8688084781,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645351,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 18721,
    "venueId": 3806,
    "venue": "Lincoln Financial Field",
    "homeId": 218,
    "homeTeam": "Temple",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 20,
    "homeLineScores": [
      3,
      14,
      0,
      3
    ],
    "homePostgameWinProbability": 0.7351173510637877,
    "homePregameElo": 1113,
    "homePostgameElo": 1126,
    "awayId": 202,
    "awayTeam": "Tulsa",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      0,
      10,
      0
    ],
    "awayPostgameWinProbability": 0.2648826489362123,
    "awayPregameElo": 1060,
    "awayPostgameElo": 1047,
    "excitementIndex": 5.1372556766,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643736,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 25112,
    "venueId": 3820,
    "venue": "Gesa Field",
    "homeId": 265,
    "homeTeam": "Washington State",
    "homeClassification": "fbs",
    "homeConference": "Pac-12",
    "homePoints": 42,
    "homeLineScores": [
      7,
      14,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9939290990880877,
    "homePregameElo": 1563,
    "homePostgameElo": 1608,
    "awayId": 62,
    "awayTeam": "Hawai'i",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 10,
    "awayLineScores": [
      3,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.006070900911912314,
    "awayPregameElo": 1212,
    "awayPostgameElo": 1167,
    "excitementIndex": 3.8445017635,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644686,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 17021,
    "venueId": 3996,
    "venue": "Yager Stadium",
    "homeId": 193,
    "homeTeam": "Miami (OH)",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 30,
    "homeLineScores": [
      3,
      13,
      14,
      0
    ],
    "homePostgameWinProbability": 0.9962786246160845,
    "homePregameElo": 1486,
    "homePostgameElo": 1497,
    "awayId": 195,
    "awayTeam": "Ohio",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      0,
      6,
      14
    ],
    "awayPostgameWinProbability": 0.0037213753839154817,
    "awayPregameElo": 1405,
    "awayPostgameElo": 1394,
    "excitementIndex": 4.0145384804,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628397,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 101915,
    "venueId": 3853,
    "venue": "Neyland Stadium",
    "homeId": 2633,
    "homeTeam": "Tennessee",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 24,
    "homeLineScores": [
      0,
      0,
      14,
      10
    ],
    "homePostgameWinProbability": 0.9341870502227599,
    "homePregameElo": 1936,
    "homePostgameElo": 1950,
    "awayId": 333,
    "awayTeam": "Alabama",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      7,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.06581294977724006,
    "awayPregameElo": 2010,
    "awayPostgameElo": 1996,
    "excitementIndex": 9.9902493945,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644749,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 18487,
    "venueId": 3965,
    "venue": "UB Stadium",
    "homeId": 2084,
    "homeTeam": "Buffalo",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 41,
    "homeLineScores": [
      10,
      7,
      7,
      17
    ],
    "homePostgameWinProbability": 0.2982382134854651,
    "homePregameElo": 1294,
    "homePostgameElo": 1275,
    "awayId": 2711,
    "awayTeam": "Western Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 48,
    "awayLineScores": [
      7,
      21,
      7,
      13
    ],
    "awayPostgameWinProbability": 0.7017617865145349,
    "awayPregameElo": 1223,
    "awayPostgameElo": 1242,
    "excitementIndex": 7.7487243344,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636901,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 38619,
    "venueId": 3622,
    "venue": "GEHA Field at Arrowhead Stadium",
    "homeId": 2305,
    "homeTeam": "Kansas",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 42,
    "homeLineScores": [
      14,
      14,
      0,
      14
    ],
    "homePostgameWinProbability": 0.9989293852618795,
    "homePregameElo": 1570,
    "homePostgameElo": 1631,
    "awayId": 248,
    "awayTeam": "Houston",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      14,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0010706147381205344,
    "awayPregameElo": 1395,
    "awayPostgameElo": 1334,
    "excitementIndex": 3.6377894158,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628982,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": false,
    "attendance": 59021,
    "venueId": 5348,
    "venue": "Mercedes-Benz Stadium",
    "homeId": 59,
    "homeTeam": "Georgia Tech",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 13,
    "homeLineScores": [
      7,
      0,
      0,
      6
    ],
    "homePostgameWinProbability": 0.02331751273391456,
    "homePregameElo": 1576,
    "homePostgameElo": 1581,
    "awayId": 87,
    "awayTeam": "Notre Dame",
    "awayClassification": "fbs",
    "awayConference": "FBS Independents",
    "awayPoints": 31,
    "awayLineScores": [
      0,
      14,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.9766824872660854,
    "awayPregameElo": 2026,
    "awayPostgameElo": 2021,
    "excitementIndex": 3.2628132664,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645345,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 28154,
    "venueId": 3886,
    "venue": "Raymond James Stadium",
    "homeId": 58,
    "homeTeam": "South Florida",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 35,
    "homeLineScores": [
      0,
      7,
      13,
      15
    ],
    "homePostgameWinProbability": 0.7660914083651577,
    "homePregameElo": 1325,
    "homePostgameElo": 1326,
    "awayId": 5,
    "awayTeam": "UAB",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 25,
    "awayLineScores": [
      3,
      6,
      10,
      6
    ],
    "awayPostgameWinProbability": 0.23390859163484234,
    "awayPregameElo": 1091,
    "awayPostgameElo": 1090,
    "excitementIndex": 9.5463592111,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635587,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 35303,
    "venueId": 3831,
    "venue": "California Memorial Stadium",
    "homeId": 25,
    "homeTeam": "California",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 23,
    "homeLineScores": [
      7,
      6,
      10,
      0
    ],
    "homePostgameWinProbability": 0.10409129339187954,
    "homePregameElo": 1548,
    "homePostgameElo": 1542,
    "awayId": 152,
    "awayTeam": "NC State",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 24,
    "awayLineScores": [
      3,
      7,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.8959087066081205,
    "awayPregameElo": 1454,
    "awayPostgameElo": 1460,
    "excitementIndex": 7.188961357,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645350,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 22897,
    "venueId": 4729,
    "venue": "Yulman Stadium",
    "homeId": 2655,
    "homeTeam": "Tulane",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 24,
    "homeLineScores": [
      3,
      7,
      0,
      14
    ],
    "homePostgameWinProbability": 0.9786910744981652,
    "homePregameElo": 1751,
    "homePostgameElo": 1738,
    "awayId": 242,
    "awayTeam": "Rice",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      7,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.02130892550183483,
    "awayPregameElo": 1222,
    "awayPostgameElo": 1235,
    "excitementIndex": 8.2930453716,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628518,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 60670,
    "venueId": 3832,
    "venue": "Memorial Stadium (Champaign, IL)",
    "homeId": 356,
    "homeTeam": "Illinois",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 21,
    "homeLineScores": [
      3,
      10,
      8,
      0
    ],
    "homePostgameWinProbability": 0.9095558884803752,
    "homePregameElo": 1541,
    "homePostgameElo": 1602,
    "awayId": 130,
    "awayTeam": "Michigan",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.09044411151962484,
    "awayPregameElo": 1878,
    "awayPostgameElo": 1817,
    "excitementIndex": 4.8074629555,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644748,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20858,
    "venueId": 3700,
    "venue": "Doyt L. Perry Stadium",
    "homeId": 189,
    "homeTeam": "Bowling Green",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 27,
    "homeLineScores": [
      10,
      10,
      0,
      7
    ],
    "homePostgameWinProbability": 0.99883526969678,
    "homePregameElo": 1406,
    "homePostgameElo": 1410,
    "awayId": 2309,
    "awayTeam": "Kent State",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 6,
    "awayLineScores": [
      3,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0011647303032199519,
    "awayPregameElo": 928,
    "awayPostgameElo": 924,
    "excitementIndex": 4.1788126186,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645348,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20802,
    "venueId": 3604,
    "venue": "Alamodome",
    "homeId": 2636,
    "homeTeam": "UTSA",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 38,
    "homeLineScores": [
      3,
      14,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9971200957487705,
    "homePregameElo": 1371,
    "homePostgameElo": 1391,
    "awayId": 2226,
    "awayTeam": "Florida Atlantic",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      10,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.002879904251229526,
    "awayPregameElo": 1280,
    "awayPostgameElo": 1260,
    "excitementIndex": 9.4002835488,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643813,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 19129,
    "venueId": 3918,
    "venue": "S.B. Ballard Stadium",
    "homeId": 295,
    "homeTeam": "Old Dominion",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 24,
    "homeLineScores": [
      7,
      7,
      0,
      10
    ],
    "homePostgameWinProbability": 0.9074426670592894,
    "homePregameElo": 1379,
    "homePostgameElo": 1416,
    "awayId": 326,
    "awayTeam": "Texas State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.09255733294071056,
    "awayPregameElo": 1639,
    "awayPostgameElo": 1602,
    "excitementIndex": 6.364009365,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645347,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 35094,
    "venueId": 3852,
    "venue": "Navy-Marine Corps Memorial Stadium",
    "homeId": 2426,
    "homeTeam": "Navy",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 51,
    "homeLineScores": [
      24,
      14,
      13,
      0
    ],
    "homePostgameWinProbability": 0.9982078256810092,
    "homePregameElo": 1555,
    "homePostgameElo": 1612,
    "awayId": 2429,
    "awayTeam": "Charlotte",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      10,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.0017921743189908135,
    "awayPregameElo": 1253,
    "awayPostgameElo": 1196,
    "excitementIndex": 2.064588811,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644751,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 18350,
    "venueId": 3764,
    "venue": "Huskie Stadium",
    "homeId": 2459,
    "homeTeam": "Northern Illinois",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 6,
    "homeLineScores": [
      3,
      3,
      0,
      0
    ],
    "homePostgameWinProbability": 0.9699869159030086,
    "homePregameElo": 1470,
    "homePostgameElo": 1460,
    "awayId": 2649,
    "awayTeam": "Toledo",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      7,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.030013084096991438,
    "awayPregameElo": 1508,
    "awayPostgameElo": 1518,
    "excitementIndex": 7.3746354167,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636897,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 50724,
    "venueId": 3619,
    "venue": "Arizona Stadium",
    "homeId": 12,
    "homeTeam": "Arizona",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 7,
    "homeLineScores": [
      7,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0.006891693069847433,
    "homePregameElo": 1616,
    "homePostgameElo": 1526,
    "awayId": 38,
    "awayTeam": "Colorado",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 34,
    "awayLineScores": [
      14,
      14,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.9931083069301526,
    "awayPregameElo": 1490,
    "awayPostgameElo": 1580,
    "excitementIndex": 2.6237318254,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636902,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 60229,
    "venueId": 3784,
    "venue": "Jones AT&T Stadium",
    "homeId": 2641,
    "homeTeam": "Texas Tech",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 35,
    "homeLineScores": [
      7,
      7,
      7,
      14
    ],
    "homePostgameWinProbability": 0.1697865673129431,
    "homePregameElo": 1644,
    "homePostgameElo": 1556,
    "awayId": 239,
    "awayTeam": "Baylor",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 59,
    "awayLineScores": [
      7,
      17,
      14,
      21
    ],
    "awayPostgameWinProbability": 0.8302134326870569,
    "awayPregameElo": 1457,
    "awayPostgameElo": 1545,
    "excitementIndex": 4.0008700067,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643737,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 14584,
    "venueId": 3905,
    "venue": "Maverik Stadium",
    "homeId": 328,
    "homeTeam": "Utah State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 45,
    "homeLineScores": [
      14,
      10,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9988764389108926,
    "homePregameElo": 1172,
    "homePostgameElo": 1170,
    "awayId": 167,
    "awayTeam": "New Mexico",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 50,
    "awayLineScores": [
      0,
      15,
      14,
      21
    ],
    "awayPostgameWinProbability": 0.0011235610891073833,
    "awayPregameElo": 1271,
    "awayPostgameElo": 1273,
    "excitementIndex": 1.661834419,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643738,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 17101,
    "venueId": 3935,
    "venue": "CEFCU Stadium",
    "homeId": 23,
    "homeTeam": "San Jos\u00e9 State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 24,
    "homeLineScores": [
      7,
      7,
      3,
      7
    ],
    "homePostgameWinProbability": 0.9894037666903412,
    "homePregameElo": 1563,
    "homePostgameElo": 1561,
    "awayId": 2751,
    "awayTeam": "Wyoming",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.010596233309658754,
    "awayPregameElo": 1285,
    "awayPostgameElo": 1287,
    "excitementIndex": 5.8111963945,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628521,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 43013,
    "venueId": 3665,
    "venue": "SECU Stadium",
    "homeId": 120,
    "homeTeam": "Maryland",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 29,
    "homeLineScores": [
      0,
      7,
      7,
      15
    ],
    "homePostgameWinProbability": 0.2091783369745479,
    "homePregameElo": 1546,
    "homePostgameElo": 1553,
    "awayId": 30,
    "awayTeam": "USC",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 28,
    "awayLineScores": [
      7,
      14,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.7908216630254521,
    "awayPregameElo": 1763,
    "awayPostgameElo": 1756,
    "excitementIndex": 7.3526882152,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643812,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20153,
    "venueId": 3608,
    "venue": "Allen E. Paulson Stadium",
    "homeId": 290,
    "homeTeam": "Georgia Southern",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 28,
    "homeLineScores": [
      7,
      14,
      7,
      0
    ],
    "homePostgameWinProbability": 0.9924757699604869,
    "homePregameElo": 1371,
    "homePostgameElo": 1449,
    "awayId": 256,
    "awayTeam": "James Madison",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.00752423003951308,
    "awayPregameElo": 1866,
    "awayPostgameElo": 1788,
    "excitementIndex": 5.185532857,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628394,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T20:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 50127,
    "venueId": 3693,
    "venue": "Davis Wade Stadium",
    "homeId": 344,
    "homeTeam": "Mississippi State",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 24,
    "homeLineScores": [
      7,
      10,
      0,
      7
    ],
    "homePostgameWinProbability": 0.027039430126155475,
    "homePregameElo": 1395,
    "homePostgameElo": 1405,
    "awayId": 245,
    "awayTeam": "Texas A&M",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 34,
    "awayLineScores": [
      7,
      14,
      10,
      3
    ],
    "awayPostgameWinProbability": 0.9729605698738445,
    "awayPregameElo": 1781,
    "awayPostgameElo": 1771,
    "excitementIndex": 4.4843261843,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643814,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 24542,
    "venueId": 3815,
    "venue": "M. M. Roberts Stadium",
    "homeId": 2572,
    "homeTeam": "Southern Miss",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 28,
    "homeLineScores": [
      7,
      14,
      0,
      7
    ],
    "homePostgameWinProbability": 0.3361108480627349,
    "homePregameElo": 1095,
    "homePostgameElo": 1074,
    "awayId": 2032,
    "awayTeam": "Arkansas State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 44,
    "awayLineScores": [
      21,
      7,
      13,
      3
    ],
    "awayPostgameWinProbability": 0.6638891519372652,
    "awayPregameElo": 1262,
    "awayPostgameElo": 1283,
    "excitementIndex": 2.8706302613,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628392,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 75893,
    "venueId": 3887,
    "venue": "Razorback Stadium",
    "homeId": 8,
    "homeTeam": "Arkansas",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 10,
    "homeLineScores": [
      0,
      7,
      3,
      0
    ],
    "homePostgameWinProbability": 0.07073032520246239,
    "homePregameElo": 1513,
    "homePostgameElo": 1490,
    "awayId": 99,
    "awayTeam": "LSU",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 34,
    "awayLineScores": [
      10,
      6,
      8,
      10
    ],
    "awayPostgameWinProbability": 0.9292696747975376,
    "awayPregameElo": 1875,
    "awayPostgameElo": 1898,
    "excitementIndex": 3.2139788267,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628399,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 27884,
    "venueId": 3973,
    "venue": "FirstBank Stadium",
    "homeId": 238,
    "homeTeam": "Vanderbilt",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 24,
    "homeLineScores": [
      3,
      11,
      0,
      10
    ],
    "homePostgameWinProbability": 0.9042891884815737,
    "homePregameElo": 1400,
    "homePostgameElo": 1396,
    "awayId": 2050,
    "awayTeam": "Ball State",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 14,
    "awayLineScores": [
      7,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.09571081151842631,
    "awayPregameElo": 1085,
    "awayPostgameElo": 1089,
    "excitementIndex": 7.2337044479,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628520,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 69682,
    "venueId": 3936,
    "venue": "Spartan Stadium",
    "homeId": 127,
    "homeTeam": "Michigan State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 32,
    "homeLineScores": [
      6,
      6,
      7,
      13
    ],
    "homePostgameWinProbability": 0.9557414380827481,
    "homePregameElo": 1410,
    "homePostgameElo": 1456,
    "awayId": 2294,
    "awayTeam": "Iowa",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      0,
      14,
      6
    ],
    "awayPostgameWinProbability": 0.04425856191725186,
    "awayPregameElo": 1683,
    "awayPostgameElo": 1637,
    "excitementIndex": 7.4059458969,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636904,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 54327,
    "venueId": 3842,
    "venue": "Milan Puskar Stadium",
    "homeId": 277,
    "homeTeam": "West Virginia",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 18,
    "homeLineScores": [
      3,
      7,
      0,
      8
    ],
    "homePostgameWinProbability": 0.0014782509169596408,
    "homePregameElo": 1597,
    "homePostgameElo": 1541,
    "awayId": 2306,
    "awayTeam": "Kansas State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 45,
    "awayLineScores": [
      10,
      7,
      14,
      14
    ],
    "awayPostgameWinProbability": 0.9985217490830404,
    "awayPregameElo": 1743,
    "awayPostgameElo": 1799,
    "excitementIndex": 3.3283212537,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628398,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 105215,
    "venueId": 3910,
    "venue": "DKR-Texas Memorial Stadium",
    "homeId": 251,
    "homeTeam": "Texas",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 15,
    "homeLineScores": [
      0,
      0,
      15,
      0
    ],
    "homePostgameWinProbability": 0.012471064367557372,
    "homePregameElo": 2138,
    "homePostgameElo": 2089,
    "awayId": 61,
    "awayTeam": "Georgia",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 30,
    "awayLineScores": [
      7,
      16,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.9875289356324426,
    "awayPregameElo": 2009,
    "awayPostgameElo": 2058,
    "excitementIndex": 3.975470081,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636900,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 61500,
    "venueId": 3772,
    "venue": "Jack Trice Stadium",
    "homeId": 66,
    "homeTeam": "Iowa State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 38,
    "homeLineScores": [
      14,
      0,
      13,
      11
    ],
    "homePostgameWinProbability": 0.18105925521125116,
    "homePregameElo": 1773,
    "homePostgameElo": 1771,
    "awayId": 2116,
    "awayTeam": "UCF",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 35,
    "awayLineScores": [
      7,
      14,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.8189407447887489,
    "awayPregameElo": 1501,
    "awayPostgameElo": 1503,
    "excitementIndex": 6.6619437928,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645349,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 24110,
    "venueId": 3805,
    "venue": "Simmons Bank Liberty Stadium",
    "homeId": 235,
    "homeTeam": "Memphis",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 52,
    "homeLineScores": [
      14,
      14,
      7,
      17
    ],
    "homePostgameWinProbability": 0.6543228416072232,
    "homePregameElo": 1609,
    "homePostgameElo": 1612,
    "awayId": 249,
    "awayTeam": "North Texas",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 44,
    "awayLineScores": [
      21,
      3,
      7,
      13
    ],
    "awayPostgameWinProbability": 0.3456771583927768,
    "awayPregameElo": 1459,
    "awayPostgameElo": 1456,
    "excitementIndex": 9.4808104849,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628393,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-19T23:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": null,
    "venueId": 3634,
    "venue": "Ben Hill Griffin Stadium",
    "homeId": 57,
    "homeTeam": "Florida",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 48,
    "homeLineScores": [
      3,
      24,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9984042579380444,
    "homePregameElo": 1548,
    "homePostgameElo": 1634,
    "awayId": 96,
    "awayTeam": "Kentucky",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      13,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.001595742061955563,
    "awayPregameElo": 1645,
    "awayPostgameElo": 1559,
    "excitementIndex": 4.47219541,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643734,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-20T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 27598,
    "venueId": 3713,
    "venue": "Falcon Stadium",
    "homeId": 2005,
    "homeTeam": "Air Force",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 13,
    "homeLineScores": [
      0,
      0,
      0,
      13
    ],
    "homePostgameWinProbability": 0.11179793645465892,
    "homePregameElo": 1310,
    "homePostgameElo": 1292,
    "awayId": 36,
    "awayTeam": "Colorado State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      14,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.888202063545341,
    "awayPregameElo": 1277,
    "awayPostgameElo": 1295,
    "excitementIndex": 2.2864929496,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635590,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-20T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 19117,
    "venueId": 3940,
    "venue": "Stanford Stadium",
    "homeId": 24,
    "homeTeam": "Stanford",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 10,
    "homeLineScores": [
      0,
      7,
      3,
      0
    ],
    "homePostgameWinProbability": 0.0010941051437557486,
    "homePregameElo": 1229,
    "homePostgameElo": 1208,
    "awayId": 2567,
    "awayTeam": "SMU",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 40,
    "awayLineScores": [
      21,
      10,
      0,
      9
    ],
    "awayPostgameWinProbability": 0.9989058948562443,
    "awayPregameElo": 1765,
    "awayPostgameElo": 1786,
    "excitementIndex": 1.9449475062,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643739,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-20T02:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 35195,
    "venueId": 3893,
    "venue": "Reser Stadium",
    "homeId": 204,
    "homeTeam": "Oregon State",
    "homeClassification": "fbs",
    "homeConference": "Pac-12",
    "homePoints": 25,
    "homeLineScores": [
      3,
      14,
      0,
      8
    ],
    "homePostgameWinProbability": 0.11654927784012334,
    "homePregameElo": 1587,
    "homePostgameElo": 1578,
    "awayId": 2439,
    "awayTeam": "UNLV",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 33,
    "awayLineScores": [
      3,
      13,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.8834507221598766,
    "awayPregameElo": 1665,
    "awayPostgameElo": 1674,
    "excitementIndex": 6.3198973757,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636903,
    "season": 2024,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2024-10-20T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 53299,
    "venueId": 587,
    "venue": "Rice-Eccles Stadium",
    "homeId": 254,
    "homeTeam": "Utah",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 7,
    "homeLineScores": [
      0,
      0,
      7,
      0
    ],
    "homePostgameWinProbability": 0.13682359203079916,
    "homePregameElo": 1589,
    "homePostgameElo": 1572,
    "awayId": 2628,
    "awayTeam": "TCU",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      10,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.8631764079692008,
    "awayPregameElo": 1508,
    "awayPostgameElo": 1525,
    "excitementIndex": 5.8298706704,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401640984,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-22T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 10625,
    "venueId": 2031,
    "venue": "Pitbull Stadium",
    "homeId": 2229,
    "homeTeam": "Florida International",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 7,
    "homeLineScores": [
      0,
      0,
      0,
      7
    ],
    "homePostgameWinProbability": 0.19536670511217263,
    "homePregameElo": 1241,
    "homePostgameElo": 1248,
    "awayId": 2534,
    "awayTeam": "Sam Houston",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      0,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.8046332948878274,
    "awayPregameElo": 1422,
    "awayPostgameElo": 1415,
    "excitementIndex": 6.2564066649,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641011,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-23T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 15168,
    "venueId": 3776,
    "venue": "Joe Aillet Stadium",
    "homeId": 2348,
    "homeTeam": "Louisiana Tech",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 14,
    "homeLineScores": [
      0,
      7,
      0,
      7
    ],
    "homePostgameWinProbability": 0.2380926029097199,
    "homePregameElo": 1285,
    "homePostgameElo": 1284,
    "awayId": 2638,
    "awayTeam": "UTEP",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 10,
    "awayLineScores": [
      7,
      0,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.7619073970902801,
    "awayPregameElo": 1161,
    "awayPostgameElo": 1162,
    "excitementIndex": 7.9673966467,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401640993,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-23T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 8209,
    "venueId": 4899,
    "venue": "Fifth Third Stadium",
    "homeId": 338,
    "homeTeam": "Kennesaw State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 27,
    "homeLineScores": [
      7,
      7,
      7,
      6
    ],
    "homePostgameWinProbability": 0.8126782234588759,
    "homePregameElo": 1255,
    "homePostgameElo": 1261,
    "awayId": 2335,
    "awayTeam": "Liberty",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      7,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.18732177654112414,
    "awayPregameElo": 1581,
    "awayPostgameElo": 1575,
    "excitementIndex": 6.7893700745,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641003,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-23T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 17988,
    "venueId": 3662,
    "venue": "AmFirst Stadium",
    "homeId": 55,
    "homeTeam": "Jacksonville State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 42,
    "homeLineScores": [
      14,
      0,
      21,
      7
    ],
    "homePostgameWinProbability": 0.9979171313360833,
    "homePregameElo": 1637,
    "homePostgameElo": 1642,
    "awayId": 2393,
    "awayTeam": "Middle Tennessee",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 20,
    "awayLineScores": [
      10,
      0,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.002082868663916715,
    "awayPregameElo": 1142,
    "awayPostgameElo": 1137,
    "excitementIndex": 4.4853387656,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643815,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-24T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 18281,
    "venueId": 3918,
    "venue": "S.B. Ballard Stadium",
    "homeId": 295,
    "homeTeam": "Old Dominion",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 47,
    "homeLineScores": [
      13,
      17,
      14,
      3
    ],
    "homePostgameWinProbability": 0.9974108670334393,
    "homePregameElo": 1416,
    "homePostgameElo": 1494,
    "awayId": 290,
    "awayTeam": "Georgia Southern",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 19,
    "awayLineScores": [
      0,
      7,
      6,
      6
    ],
    "awayPostgameWinProbability": 0.0025891329665607143,
    "awayPregameElo": 1449,
    "awayPostgameElo": 1371,
    "excitementIndex": 3.0235251829,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401634770,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-24T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 47266,
    "venueId": 3752,
    "venue": "Acrisure Stadium",
    "homeId": 221,
    "homeTeam": "Pittsburgh",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 41,
    "homeLineScores": [
      17,
      14,
      0,
      10
    ],
    "homePostgameWinProbability": 0.9904003635493842,
    "homePregameElo": 1513,
    "homePostgameElo": 1576,
    "awayId": 183,
    "awayTeam": "Syracuse",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      0,
      6,
      7
    ],
    "awayPostgameWinProbability": 0.00959963645061579,
    "awayPregameElo": 1423,
    "awayPostgameElo": 1360,
    "excitementIndex": 3.0968306165,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401634771,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-25T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 42887,
    "venueId": 3615,
    "venue": "Alumni Stadium (Chestnut Hill, MA)",
    "homeId": 103,
    "homeTeam": "Boston College",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 27,
    "homeLineScores": [
      7,
      13,
      7,
      0
    ],
    "homePostgameWinProbability": 0.09695111535074864,
    "homePregameElo": 1418,
    "homePostgameElo": 1428,
    "awayId": 97,
    "awayTeam": "Louisville",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 31,
    "awayLineScores": [
      0,
      7,
      10,
      14
    ],
    "awayPostgameWinProbability": 0.9030488846492514,
    "awayPregameElo": 1691,
    "awayPostgameElo": 1681,
    "excitementIndex": 6.229607411,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643740,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 42228,
    "venueId": 6501,
    "venue": "Allegiant Stadium",
    "homeId": 2439,
    "homeTeam": "UNLV",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 24,
    "homeLineScores": [
      10,
      0,
      14,
      0
    ],
    "homePostgameWinProbability": 0.6578167644895134,
    "homePregameElo": 1674,
    "homePostgameElo": 1668,
    "awayId": 68,
    "awayTeam": "Boise State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 29,
    "awayLineScores": [
      3,
      17,
      3,
      6
    ],
    "awayPostgameWinProbability": 0.34218323551048657,
    "awayPregameElo": 1711,
    "awayPostgameElo": 1717,
    "excitementIndex": 6.3665972191,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628532,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T03:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 63404,
    "venueId": 477,
    "venue": "Los Angeles Memorial Coliseum",
    "homeId": 30,
    "homeTeam": "USC",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 42,
    "homeLineScores": [
      14,
      14,
      14,
      0
    ],
    "homePostgameWinProbability": 0.9975996655845599,
    "homePregameElo": 1756,
    "homePostgameElo": 1776,
    "awayId": 164,
    "awayTeam": "Rutgers",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 20,
    "awayLineScores": [
      3,
      9,
      8,
      0
    ],
    "awayPostgameWinProbability": 0.002400334415440075,
    "awayPregameElo": 1432,
    "awayPostgameElo": 1412,
    "excitementIndex": 4.0025479742,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645354,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 23138,
    "venueId": 3825,
    "venue": "DATCU Stadium",
    "homeId": 249,
    "homeTeam": "North Texas",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 37,
    "homeLineScores": [
      3,
      14,
      7,
      13
    ],
    "homePostgameWinProbability": 0.02960944458906513,
    "homePregameElo": 1456,
    "homePostgameElo": 1462,
    "awayId": 2655,
    "awayTeam": "Tulane",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 45,
    "awayLineScores": [
      21,
      10,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.9703905554109349,
    "awayPregameElo": 1738,
    "awayPostgameElo": 1732,
    "excitementIndex": 3.0583480339,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628530,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 104830,
    "venueId": 3861,
    "venue": "Ohio Stadium",
    "homeId": 194,
    "homeTeam": "Ohio State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 21,
    "homeLineScores": [
      7,
      7,
      0,
      7
    ],
    "homePostgameWinProbability": 0.9923267213044521,
    "homePregameElo": 2076,
    "homePostgameElo": 2063,
    "awayId": 158,
    "awayTeam": "Nebraska",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      6,
      3,
      8
    ],
    "awayPostgameWinProbability": 0.007673278695547903,
    "awayPregameElo": 1454,
    "awayPostgameElo": 1467,
    "excitementIndex": 7.447834909,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645353,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 25478,
    "venueId": 3805,
    "venue": "Simmons Bank Liberty Stadium",
    "homeId": 235,
    "homeTeam": "Memphis",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 33,
    "homeLineScores": [
      0,
      7,
      14,
      12
    ],
    "homePostgameWinProbability": 0.2327610924219729,
    "homePregameElo": 1612,
    "homePostgameElo": 1601,
    "awayId": 2429,
    "awayTeam": "Charlotte",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 28,
    "awayLineScores": [
      7,
      0,
      0,
      21
    ],
    "awayPostgameWinProbability": 0.767238907578027,
    "awayPregameElo": 1196,
    "awayPostgameElo": 1207,
    "excitementIndex": 8.5391064277,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628402,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 67926,
    "venueId": 3974,
    "venue": "Vaught-Hemingway Stadium",
    "homeId": 145,
    "homeTeam": "Ole Miss",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 26,
    "homeLineScores": [
      7,
      3,
      13,
      3
    ],
    "homePostgameWinProbability": 0.9353244521332963,
    "homePregameElo": 1905,
    "homePostgameElo": 1911,
    "awayId": 201,
    "awayTeam": "Oklahoma",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 14,
    "awayLineScores": [
      7,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.06467554786670371,
    "awayPregameElo": 1694,
    "awayPostgameElo": 1688,
    "excitementIndex": 5.9986776529,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628526,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 53082,
    "venueId": 3830,
    "venue": "Memorial Stadium (Bloomington, IN)",
    "homeId": 84,
    "homeTeam": "Indiana",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 31,
    "homeLineScores": [
      7,
      10,
      7,
      7
    ],
    "homePostgameWinProbability": 0.8790682117437898,
    "homePregameElo": 1791,
    "homePostgameElo": 1812,
    "awayId": 264,
    "awayTeam": "Washington",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      7,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.1209317882562102,
    "awayPregameElo": 1707,
    "awayPostgameElo": 1686,
    "excitementIndex": 7.7075789872,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635597,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 65633,
    "venueId": 3799,
    "venue": "Lane Stadium",
    "homeId": 259,
    "homeTeam": "Virginia Tech",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 21,
    "homeLineScores": [
      0,
      14,
      7,
      0
    ],
    "homePostgameWinProbability": 0.8793186325489889,
    "homePregameElo": 1674,
    "homePostgameElo": 1697,
    "awayId": 59,
    "awayTeam": "Georgia Tech",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 6,
    "awayLineScores": [
      3,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.1206813674510111,
    "awayPregameElo": 1581,
    "awayPostgameElo": 1558,
    "excitementIndex": 5.3299489511,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628983,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": false,
    "attendance": 76112,
    "venueId": 3839,
    "venue": "MetLife Stadium",
    "homeId": 2426,
    "homeTeam": "Navy",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 14,
    "homeLineScores": [
      0,
      7,
      7,
      0
    ],
    "homePostgameWinProbability": 0.31432345100351905,
    "homePregameElo": 1612,
    "homePostgameElo": 1564,
    "awayId": 87,
    "awayTeam": "Notre Dame",
    "awayClassification": "fbs",
    "awayConference": "FBS Independents",
    "awayPoints": 51,
    "awayLineScores": [
      14,
      17,
      13,
      7
    ],
    "awayPostgameWinProbability": 0.6856765489964809,
    "awayPregameElo": 2021,
    "awayPostgameElo": 2069,
    "excitementIndex": 2.5478290735,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644755,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16048,
    "venueId": 3876,
    "venue": "Peden Stadium",
    "homeId": 195,
    "homeTeam": "Ohio",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 47,
    "homeLineScores": [
      3,
      21,
      9,
      14
    ],
    "homePostgameWinProbability": 0.9987090316324378,
    "homePregameElo": 1394,
    "homePostgameElo": 1463,
    "awayId": 2084,
    "awayTeam": "Buffalo",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 16,
    "awayLineScores": [
      0,
      10,
      6,
      0
    ],
    "awayPostgameWinProbability": 0.0012909683675621508,
    "awayPregameElo": 1275,
    "awayPostgameElo": 1206,
    "excitementIndex": 5.050823092,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635598,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 44550,
    "venueId": 3923,
    "venue": "Scott Stadium",
    "homeId": 258,
    "homeTeam": "Virginia",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 14,
    "homeLineScores": [
      3,
      3,
      0,
      8
    ],
    "homePostgameWinProbability": 0.0004351908298032505,
    "homePregameElo": 1425,
    "homePostgameElo": 1359,
    "awayId": 153,
    "awayTeam": "North Carolina",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 41,
    "awayLineScores": [
      7,
      17,
      14,
      3
    ],
    "awayPostgameWinProbability": 0.9995648091701967,
    "awayPregameElo": 1489,
    "awayPostgameElo": 1555,
    "excitementIndex": 2.755188739,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628403,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T16:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 49303,
    "venueId": 3693,
    "venue": "Davis Wade Stadium",
    "homeId": 344,
    "homeTeam": "Mississippi State",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 25,
    "homeLineScores": [
      7,
      3,
      15,
      0
    ],
    "homePostgameWinProbability": 0.0034349712327201836,
    "homePregameElo": 1405,
    "homePostgameElo": 1322,
    "awayId": 8,
    "awayTeam": "Arkansas",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 58,
    "awayLineScores": [
      17,
      14,
      10,
      17
    ],
    "awayPostgameWinProbability": 0.9965650287672798,
    "awayPregameElo": 1490,
    "awayPostgameElo": 1573,
    "excitementIndex": 2.4655127937,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643816,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 33783,
    "venueId": 3792,
    "venue": "Kidd Brewer Stadium",
    "homeId": 2026,
    "homeTeam": "App State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 33,
    "homeLineScores": [
      2,
      16,
      7,
      8
    ],
    "homePostgameWinProbability": 0.9117630693246408,
    "homePregameElo": 1330,
    "homePostgameElo": 1337,
    "awayId": 2247,
    "awayTeam": "Georgia State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 26,
    "awayLineScores": [
      0,
      16,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.0882369306753592,
    "awayPregameElo": 1291,
    "awayPostgameElo": 1284,
    "excitementIndex": 6.3790269201,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644687,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 10661,
    "venueId": 3996,
    "venue": "Yager Stadium",
    "homeId": 193,
    "homeTeam": "Miami (OH)",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 46,
    "homeLineScores": [
      3,
      13,
      10,
      20
    ],
    "homePostgameWinProbability": 0.9803101001347525,
    "homePregameElo": 1497,
    "homePostgameElo": 1569,
    "awayId": 2117,
    "awayTeam": "Central Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 7,
    "awayLineScores": [
      7,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.019689899865247495,
    "awayPregameElo": 1188,
    "awayPostgameElo": 1116,
    "excitementIndex": 4.4323295747,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645352,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 33744,
    "venueId": 3699,
    "venue": "Dowdy-Ficklen Stadium",
    "homeId": 151,
    "homeTeam": "East Carolina",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 56,
    "homeLineScores": [
      13,
      14,
      29,
      0
    ],
    "homePostgameWinProbability": 0.9873955243219903,
    "homePregameElo": 1292,
    "homePostgameElo": 1328,
    "awayId": 218,
    "awayTeam": "Temple",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 34,
    "awayLineScores": [
      14,
      7,
      7,
      6
    ],
    "awayPostgameWinProbability": 0.012604475678009708,
    "awayPregameElo": 1126,
    "awayPostgameElo": 1090,
    "excitementIndex": 4.8834929966,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628528,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 48696,
    "venueId": 3953,
    "venue": "Huntington Bank Stadium",
    "homeId": 135,
    "homeTeam": "Minnesota",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 48,
    "homeLineScores": [
      21,
      13,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9970971140811259,
    "homePregameElo": 1534,
    "homePostgameElo": 1599,
    "awayId": 120,
    "awayTeam": "Maryland",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 23,
    "awayLineScores": [
      0,
      10,
      0,
      13
    ],
    "awayPostgameWinProbability": 0.0029028859188741096,
    "awayPregameElo": 1553,
    "awayPostgameElo": 1488,
    "excitementIndex": 2.7298827738,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644756,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 23537,
    "venueId": 3980,
    "venue": "Waldo Stadium",
    "homeId": 2711,
    "homeTeam": "Western Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 52,
    "homeLineScores": [
      14,
      24,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9989648557142671,
    "homePregameElo": 1242,
    "homePostgameElo": 1288,
    "awayId": 2309,
    "awayTeam": "Kent State",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      7,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.0010351442857329252,
    "awayPregameElo": 924,
    "awayPostgameElo": 878,
    "excitementIndex": 2.4884996685,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628400,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 100077,
    "venueId": 3657,
    "venue": "Bryant-Denny Stadium",
    "homeId": 333,
    "homeTeam": "Alabama",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 34,
    "homeLineScores": [
      3,
      10,
      14,
      7
    ],
    "homePostgameWinProbability": 0.998260781485511,
    "homePregameElo": 1996,
    "homePostgameElo": 2058,
    "awayId": 142,
    "awayTeam": "Missouri",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0017392185144889938,
    "awayPregameElo": 1735,
    "awayPostgameElo": 1673,
    "excitementIndex": 3.6589486898,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628525,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 59830,
    "venueId": 3626,
    "venue": "Autzen Stadium",
    "homeId": 2483,
    "homeTeam": "Oregon",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 38,
    "homeLineScores": [
      14,
      21,
      0,
      3
    ],
    "homePostgameWinProbability": 0.9988782056162032,
    "homePregameElo": 1987,
    "homePostgameElo": 2020,
    "awayId": 356,
    "awayTeam": "Illinois",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 9,
    "awayLineScores": [
      3,
      0,
      6,
      0
    ],
    "awayPostgameWinProbability": 0.0011217943837967814,
    "awayPregameElo": 1602,
    "awayPostgameElo": 1569,
    "excitementIndex": 2.7313233829,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645308,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 14374,
    "venueId": 3985,
    "venue": "Warren McGuirk Alumni Stadium",
    "homeId": 113,
    "homeTeam": "Massachusetts",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 35,
    "homeLineScores": [
      7,
      14,
      0,
      14
    ],
    "homePostgameWinProbability": 0.9750378003346585,
    "homePregameElo": 986,
    "homePostgameElo": 986,
    "awayId": 2681,
    "awayTeam": "Wagner",
    "awayClassification": "fcs",
    "awayConference": "NEC",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.024962199665341522,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.5456108691,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628527,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 69250,
    "venueId": 3793,
    "venue": "Kinnick Stadium",
    "homeId": 2294,
    "homeTeam": "Iowa",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 40,
    "homeLineScores": [
      3,
      9,
      28,
      0
    ],
    "homePostgameWinProbability": 0.9887751918036539,
    "homePregameElo": 1637,
    "homePostgameElo": 1693,
    "awayId": 77,
    "awayTeam": "Northwestern",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.011224808196346081,
    "awayPregameElo": 1543,
    "awayPostgameElo": 1487,
    "excitementIndex": 5.1362712138,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401629035,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 23711,
    "venueId": 3892,
    "venue": "Pratt & Whitney Stadium",
    "homeId": 41,
    "homeTeam": "UConn",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 17,
    "homeLineScores": [
      0,
      0,
      7,
      10
    ],
    "homePostgameWinProbability": 0.9799536976195187,
    "homePregameElo": 1424,
    "homePostgameElo": 1423,
    "awayId": 242,
    "awayTeam": "Rice",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 10,
    "awayLineScores": [
      3,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.02004630238048133,
    "awayPregameElo": 1235,
    "awayPostgameElo": 1236,
    "excitementIndex": 6.1783739785,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645355,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 17439,
    "venueId": 3674,
    "venue": "Chapman Stadium",
    "homeId": 202,
    "homeTeam": "Tulsa",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 46,
    "homeLineScores": [
      0,
      7,
      17,
      22
    ],
    "homePostgameWinProbability": 0.7968330724487508,
    "homePregameElo": 1047,
    "homePostgameElo": 1057,
    "awayId": 2636,
    "awayTeam": "UTSA",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 45,
    "awayLineScores": [
      14,
      21,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.2031669275512492,
    "awayPregameElo": 1391,
    "awayPostgameElo": 1381,
    "excitementIndex": 6.0190795343,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644754,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 29697,
    "venueId": 3739,
    "venue": "Glass Bowl",
    "homeId": 2649,
    "homeTeam": "Toledo",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 26,
    "homeLineScores": [
      7,
      13,
      6,
      0
    ],
    "homePostgameWinProbability": 0.13080836565884166,
    "homePregameElo": 1518,
    "homePostgameElo": 1472,
    "awayId": 189,
    "awayTeam": "Bowling Green",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 41,
    "awayLineScores": [
      14,
      14,
      3,
      10
    ],
    "awayPostgameWinProbability": 0.8691916343411583,
    "awayPregameElo": 1410,
    "awayPostgameElo": 1456,
    "excitementIndex": 5.4645428296,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635599,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 23471,
    "venueId": 3940,
    "venue": "Stanford Stadium",
    "homeId": 24,
    "homeTeam": "Stanford",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 24,
    "homeLineScores": [
      0,
      17,
      0,
      7
    ],
    "homePostgameWinProbability": 0.32026565036279786,
    "homePregameElo": 1208,
    "homePostgameElo": 1212,
    "awayId": 154,
    "awayTeam": "Wake Forest",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 27,
    "awayLineScores": [
      14,
      10,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.6797343496372021,
    "awayPregameElo": 1353,
    "awayPostgameElo": 1349,
    "excitementIndex": 6.1936628219,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636906,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 44987,
    "venueId": 4727,
    "venue": "McLane Stadium",
    "homeId": 239,
    "homeTeam": "Baylor",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 38,
    "homeLineScores": [
      3,
      14,
      7,
      14
    ],
    "homePostgameWinProbability": 0.998212140898507,
    "homePregameElo": 1545,
    "homePostgameElo": 1558,
    "awayId": 197,
    "awayTeam": "Oklahoma State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 28,
    "awayLineScores": [
      3,
      14,
      3,
      8
    ],
    "awayPostgameWinProbability": 0.001787859101493039,
    "awayPregameElo": 1490,
    "awayPostgameElo": 1477,
    "excitementIndex": 7.6685131792,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636910,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 42144,
    "venueId": 3616,
    "venue": "Amon G. Carter Stadium",
    "homeId": 2628,
    "homeTeam": "TCU",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 35,
    "homeLineScores": [
      14,
      0,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9478216451126138,
    "homePregameElo": 1525,
    "homePostgameElo": 1527,
    "awayId": 2641,
    "awayTeam": "Texas Tech",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 34,
    "awayLineScores": [
      3,
      14,
      14,
      3
    ],
    "awayPostgameWinProbability": 0.0521783548873862,
    "awayPregameElo": 1556,
    "awayPostgameElo": 1554,
    "excitementIndex": 7.7070856477,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636911,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 42144,
    "venueId": 3652,
    "venue": "FBC Mortgage Stadium",
    "homeId": 2116,
    "homeTeam": "UCF",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 24,
    "homeLineScores": [
      0,
      10,
      0,
      14
    ],
    "homePostgameWinProbability": 0.03313314175584659,
    "homePregameElo": 1503,
    "homePostgameElo": 1489,
    "awayId": 252,
    "awayTeam": "BYU",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 37,
    "awayLineScores": [
      7,
      17,
      10,
      3
    ],
    "awayPostgameWinProbability": 0.9668668582441534,
    "awayPregameElo": 1664,
    "awayPostgameElo": 1678,
    "excitementIndex": 2.3743109221,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644753,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 15318,
    "venueId": 3919,
    "venue": "Scheumann Stadium",
    "homeId": 2050,
    "homeTeam": "Ball State",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 25,
    "homeLineScores": [
      7,
      12,
      0,
      6
    ],
    "homePostgameWinProbability": 0.8486636054422304,
    "homePregameElo": 1089,
    "homePostgameElo": 1094,
    "awayId": 2459,
    "awayTeam": "Northern Illinois",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 23,
    "awayLineScores": [
      7,
      7,
      0,
      9
    ],
    "awayPostgameWinProbability": 0.1513363945577696,
    "awayPregameElo": 1460,
    "awayPostgameElo": 1455,
    "excitementIndex": 7.8588104996,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644752,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 4277,
    "venueId": 3768,
    "venue": "InfoCision Stadium",
    "homeId": 2006,
    "homeTeam": "Akron",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 25,
    "homeLineScores": [
      8,
      10,
      0,
      7
    ],
    "homePostgameWinProbability": 0.8402397523324775,
    "homePregameElo": 1049,
    "homePostgameElo": 1059,
    "awayId": 2199,
    "awayTeam": "Eastern Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      0,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.1597602476675225,
    "awayPregameElo": 1262,
    "awayPostgameElo": 1252,
    "excitementIndex": 7.7669740021,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643817,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 25399,
    "venueId": 3651,
    "venue": "Bridgeforth Stadium",
    "homeId": 256,
    "homeTeam": "James Madison",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 32,
    "homeLineScores": [
      0,
      17,
      8,
      7
    ],
    "homePostgameWinProbability": 0.9863226260269137,
    "homePregameElo": 1788,
    "homePostgameElo": 1766,
    "awayId": 2572,
    "awayTeam": "Southern Miss",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 15,
    "awayLineScores": [
      3,
      6,
      6,
      0
    ],
    "awayPostgameWinProbability": 0.013677373973086326,
    "awayPregameElo": 1074,
    "awayPostgameElo": 1096,
    "excitementIndex": 6.320345473,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635594,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 33090,
    "venueId": 3831,
    "venue": "California Memorial Stadium",
    "homeId": 25,
    "homeTeam": "California",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 44,
    "homeLineScores": [
      14,
      17,
      10,
      3
    ],
    "homePostgameWinProbability": 0.9989034675798805,
    "homePregameElo": 1542,
    "homePostgameElo": 1653,
    "awayId": 204,
    "awayTeam": "Oregon State",
    "awayClassification": "fbs",
    "awayConference": "Pac-12",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.0010965324201195337,
    "awayPregameElo": 1578,
    "awayPostgameElo": 1467,
    "excitementIndex": 4.1242971369,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628405,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T20:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 28934,
    "venueId": 3973,
    "venue": "FirstBank Stadium",
    "homeId": 238,
    "homeTeam": "Vanderbilt",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 24,
    "homeLineScores": [
      7,
      3,
      7,
      7
    ],
    "homePostgameWinProbability": 0.4011376899370136,
    "homePregameElo": 1396,
    "homePostgameElo": 1428,
    "awayId": 251,
    "awayTeam": "Texas",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 27,
    "awayLineScores": [
      14,
      7,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.5988623100629864,
    "awayPregameElo": 2089,
    "awayPostgameElo": 2057,
    "excitementIndex": 4.1653351519,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643819,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16746,
    "venueId": 6526,
    "venue": "Hancock Whitney Stadium",
    "homeId": 6,
    "homeTeam": "South Alabama",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 46,
    "homeLineScores": [
      7,
      5,
      20,
      14
    ],
    "homePostgameWinProbability": 0.9418698506478463,
    "homePregameElo": 1606,
    "homePostgameElo": 1644,
    "awayId": 2433,
    "awayTeam": "UL Monroe",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 17,
    "awayLineScores": [
      7,
      10,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.05813014935215366,
    "awayPregameElo": 1272,
    "awayPostgameElo": 1234,
    "excitementIndex": 6.0528725941,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643741,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 36980,
    "venueId": 5388,
    "venue": "Canvas Stadium",
    "homeId": 36,
    "homeTeam": "Colorado State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 17,
    "homeLineScores": [
      0,
      17,
      0,
      0
    ],
    "homePostgameWinProbability": 0.9115852563177875,
    "homePregameElo": 1295,
    "homePostgameElo": 1313,
    "awayId": 167,
    "awayTeam": "New Mexico",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 6,
    "awayLineScores": [
      0,
      3,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.08841474368221247,
    "awayPregameElo": 1273,
    "awayPostgameElo": 1255,
    "excitementIndex": 4.9296393321,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635596,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 66200,
    "venueId": 3948,
    "venue": "Hard Rock Stadium",
    "homeId": 2390,
    "homeTeam": "Miami",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 36,
    "homeLineScores": [
      7,
      10,
      6,
      13
    ],
    "homePostgameWinProbability": 0.9909618573800546,
    "homePregameElo": 1826,
    "homePostgameElo": 1848,
    "awayId": 52,
    "awayTeam": "Florida State",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.0090381426199454,
    "awayPregameElo": 1526,
    "awayPostgameElo": 1504,
    "excitementIndex": 6.0033018293,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636905,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 49888,
    "venueId": 3619,
    "venue": "Arizona Stadium",
    "homeId": 12,
    "homeTeam": "Arizona",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 26,
    "homeLineScores": [
      0,
      7,
      6,
      13
    ],
    "homePostgameWinProbability": 0.21146441783186035,
    "homePregameElo": 1526,
    "homePostgameElo": 1518,
    "awayId": 277,
    "awayTeam": "West Virginia",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 31,
    "awayLineScores": [
      10,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.7885355821681397,
    "awayPregameElo": 1541,
    "awayPostgameElo": 1549,
    "excitementIndex": 3.4809917974,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643818,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 17162,
    "venueId": 3625,
    "venue": "Centennial Bank Stadium",
    "homeId": 2032,
    "homeTeam": "Arkansas State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 34,
    "homeLineScores": [
      13,
      10,
      3,
      8
    ],
    "homePostgameWinProbability": 0.33265760871550765,
    "homePregameElo": 1283,
    "homePostgameElo": 1286,
    "awayId": 2653,
    "awayTeam": "Troy",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 31,
    "awayLineScores": [
      0,
      3,
      21,
      7
    ],
    "awayPostgameWinProbability": 0.6673423912844924,
    "awayPregameElo": 1432,
    "awayPostgameElo": 1429,
    "excitementIndex": 7.7146827131,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643745,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 17724,
    "venueId": 3984,
    "venue": "War Memorial Stadium",
    "homeId": 2751,
    "homeTeam": "Wyoming",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 25,
    "homeLineScores": [
      3,
      7,
      6,
      9
    ],
    "homePostgameWinProbability": 0.876798881373885,
    "homePregameElo": 1287,
    "homePostgameElo": 1278,
    "awayId": 328,
    "awayTeam": "Utah State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 27,
    "awayLineScores": [
      7,
      10,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.12320111862611505,
    "awayPregameElo": 1170,
    "awayPostgameElo": 1179,
    "excitementIndex": 8.0133648224,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636908,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 28251,
    "venueId": 4728,
    "venue": "TDECU Stadium",
    "homeId": 248,
    "homeTeam": "Houston",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 17,
    "homeLineScores": [
      0,
      7,
      0,
      10
    ],
    "homePostgameWinProbability": 0.8441237004950815,
    "homePregameElo": 1334,
    "homePostgameElo": 1338,
    "awayId": 254,
    "awayTeam": "Utah",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 14,
    "awayLineScores": [
      7,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.15587629950491855,
    "awayPregameElo": 1572,
    "awayPostgameElo": 1568,
    "excitementIndex": 8.2922591272,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628404,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 108852,
    "venueId": 3795,
    "venue": "Kyle Field",
    "homeId": 245,
    "homeTeam": "Texas A&M",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 38,
    "homeLineScores": [
      7,
      0,
      14,
      17
    ],
    "homePostgameWinProbability": 0.9018287792367656,
    "homePregameElo": 1771,
    "homePostgameElo": 1814,
    "awayId": 99,
    "awayTeam": "LSU",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 23,
    "awayLineScores": [
      10,
      7,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.09817122076323437,
    "awayPregameElo": 1898,
    "awayPostgameElo": 1855,
    "excitementIndex": 6.6754087222,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628529,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 110849,
    "venueId": 3558,
    "venue": "Michigan Stadium",
    "homeId": 130,
    "homeTeam": "Michigan",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 24,
    "homeLineScores": [
      0,
      9,
      7,
      8
    ],
    "homePostgameWinProbability": 0.6235374783179265,
    "homePregameElo": 1817,
    "homePostgameElo": 1808,
    "awayId": 127,
    "awayTeam": "Michigan State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 17,
    "awayLineScores": [
      7,
      0,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.3764625216820735,
    "awayPregameElo": 1456,
    "awayPostgameElo": 1465,
    "excitementIndex": 7.0561258048,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628531,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 76403,
    "venueId": 347,
    "venue": "Camp Randall Stadium",
    "homeId": 275,
    "homeTeam": "Wisconsin",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 13,
    "homeLineScores": [
      3,
      7,
      3,
      0
    ],
    "homePostgameWinProbability": 0.0025452049103736733,
    "homePregameElo": 1755,
    "homePostgameElo": 1734,
    "awayId": 213,
    "awayTeam": "Penn State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 28,
    "awayLineScores": [
      0,
      7,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.9974547950896263,
    "awayPregameElo": 1897,
    "awayPostgameElo": 1918,
    "excitementIndex": 6.5260801875,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628401,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-26T23:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 60605,
    "venueId": 3683,
    "venue": "Kroger Field",
    "homeId": 96,
    "homeTeam": "Kentucky",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 10,
    "homeLineScores": [
      10,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0.0014103188259993993,
    "homePregameElo": 1559,
    "homePostgameElo": 1526,
    "awayId": 2,
    "awayTeam": "Auburn",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 24,
    "awayLineScores": [
      0,
      10,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.9985896811740006,
    "awayPregameElo": 1552,
    "awayPostgameElo": 1585,
    "excitementIndex": 4.3559521997,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643742,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-27T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 41343,
    "venueId": 3660,
    "venue": "Valley Children's Stadium",
    "homeId": 278,
    "homeTeam": "Fresno State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 33,
    "homeLineScores": [
      3,
      17,
      7,
      6
    ],
    "homePostgameWinProbability": 0.9262399371758028,
    "homePregameElo": 1495,
    "homePostgameElo": 1559,
    "awayId": 23,
    "awayTeam": "San Jos\u00e9 State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 10,
    "awayLineScores": [
      7,
      0,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.07376006282419723,
    "awayPregameElo": 1561,
    "awayPostgameElo": 1497,
    "excitementIndex": 6.4113726518,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636909,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-27T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 52074,
    "venueId": 3636,
    "venue": "Bill Snyder Family Stadium",
    "homeId": 2306,
    "homeTeam": "Kansas State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 29,
    "homeLineScores": [
      0,
      16,
      7,
      6
    ],
    "homePostgameWinProbability": 0.40494031006190556,
    "homePregameElo": 1799,
    "homePostgameElo": 1797,
    "awayId": 2305,
    "awayTeam": "Kansas",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 27,
    "awayLineScores": [
      7,
      7,
      13,
      0
    ],
    "awayPostgameWinProbability": 0.5950596899380944,
    "awayPregameElo": 1631,
    "awayPostgameElo": 1633,
    "excitementIndex": 9.2963759892,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635595,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-27T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 30241,
    "venueId": 3982,
    "venue": "Wallace Wade Stadium",
    "homeId": 150,
    "homeTeam": "Duke",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 27,
    "homeLineScores": [
      7,
      0,
      6,
      8,
      6
    ],
    "homePostgameWinProbability": 0.05043302114683991,
    "homePregameElo": 1604,
    "homePostgameElo": 1611,
    "awayId": 2567,
    "awayTeam": "SMU",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 28,
    "awayLineScores": [
      0,
      14,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.9495669788531601,
    "awayPregameElo": 1786,
    "awayPostgameElo": 1779,
    "excitementIndex": 7.2331183406,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636907,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-27T02:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 53202,
    "venueId": 3726,
    "venue": "Folsom Field",
    "homeId": 38,
    "homeTeam": "Colorado",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 34,
    "homeLineScores": [
      14,
      10,
      7,
      3
    ],
    "homePostgameWinProbability": 0.7238632794092985,
    "homePregameElo": 1580,
    "homePostgameElo": 1598,
    "awayId": 2132,
    "awayTeam": "Cincinnati",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 23,
    "awayLineScores": [
      7,
      7,
      0,
      9
    ],
    "awayPostgameWinProbability": 0.2761367205907015,
    "awayPregameElo": 1554,
    "awayPostgameElo": 1536,
    "excitementIndex": 4.9811711598,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643744,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-27T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 26937,
    "venueId": 7311,
    "venue": "Snapdragon Stadium",
    "homeId": 21,
    "homeTeam": "San Diego State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 26,
    "homeLineScores": [
      6,
      6,
      7,
      7
    ],
    "homePostgameWinProbability": 0.07168529000815156,
    "homePregameElo": 1344,
    "homePostgameElo": 1355,
    "awayId": 265,
    "awayTeam": "Washington State",
    "awayClassification": "fbs",
    "awayConference": "Pac-12",
    "awayPoints": 29,
    "awayLineScores": [
      7,
      7,
      0,
      15
    ],
    "awayPostgameWinProbability": 0.9283147099918484,
    "awayPregameElo": 1608,
    "awayPostgameElo": 1597,
    "excitementIndex": 7.3872889871,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643743,
    "season": 2024,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2024-10-27T03:59:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 12006,
    "venueId": 7220,
    "venue": "Clarence T.C. Ching Athletics Complex",
    "homeId": 62,
    "homeTeam": "Hawai'i",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 34,
    "homeLineScores": [
      14,
      3,
      7,
      10
    ],
    "homePostgameWinProbability": 0.9803126790918862,
    "homePregameElo": 1167,
    "homePostgameElo": 1228,
    "awayId": 2440,
    "awayTeam": "Nevada",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      0,
      7,
      6
    ],
    "awayPostgameWinProbability": 0.01968732090811376,
    "awayPregameElo": 1267,
    "awayPostgameElo": 1206,
    "excitementIndex": 4.6788166203,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401640985,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-10-29T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 9103,
    "venueId": 2031,
    "venue": "Pitbull Stadium",
    "homeId": 2229,
    "homeTeam": "Florida International",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 34,
    "homeLineScores": [
      0,
      7,
      13,
      14
    ],
    "homePostgameWinProbability": 0.9987978636225876,
    "homePregameElo": 1248,
    "homePostgameElo": 1297,
    "awayId": 166,
    "awayTeam": "New Mexico State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      6,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.0012021363774123994,
    "awayPregameElo": 1164,
    "awayPostgameElo": 1115,
    "excitementIndex": 6.3519560546,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643820,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-10-29T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16831,
    "venueId": 3644,
    "venue": "Bobcat Stadium (TX)",
    "homeId": 326,
    "homeTeam": "Texas State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 17,
    "homeLineScores": [
      6,
      0,
      8,
      3
    ],
    "homePostgameWinProbability": 0.24266100411613284,
    "homePregameElo": 1602,
    "homePostgameElo": 1586,
    "awayId": 309,
    "awayTeam": "Louisiana",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 23,
    "awayLineScores": [
      7,
      7,
      3,
      6
    ],
    "awayPostgameWinProbability": 0.7573389958838672,
    "awayPregameElo": 1538,
    "awayPostgameElo": 1554,
    "excitementIndex": 5.7318149573,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641012,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-10-30T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 9128,
    "venueId": 3647,
    "venue": "Elliott T. Bowers Stadium",
    "homeId": 2534,
    "homeTeam": "Sam Houston",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 9,
    "homeLineScores": [
      2,
      0,
      7,
      0
    ],
    "homePostgameWinProbability": 0.9658381558453739,
    "homePregameElo": 1415,
    "homePostgameElo": 1416,
    "awayId": 2348,
    "awayTeam": "Louisiana Tech",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 3,
    "awayLineScores": [
      3,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.034161844154626086,
    "awayPregameElo": 1284,
    "awayPostgameElo": 1283,
    "excitementIndex": 6.8158413768,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401640994,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-10-30T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 18069,
    "venueId": 3992,
    "venue": "Williams Stadium (VA)",
    "homeId": 2335,
    "homeTeam": "Liberty",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 21,
    "homeLineScores": [
      7,
      7,
      0,
      7
    ],
    "homePostgameWinProbability": 0.1592485617629869,
    "homePregameElo": 1575,
    "homePostgameElo": 1560,
    "awayId": 55,
    "awayTeam": "Jacksonville State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      7,
      10,
      7
    ],
    "awayPostgameWinProbability": 0.8407514382370131,
    "awayPregameElo": 1642,
    "awayPostgameElo": 1657,
    "excitementIndex": 5.5404093676,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641020,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-10-30T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 14547,
    "venueId": 3796,
    "venue": "Houchens Industries-L.T. Smith Stadium",
    "homeId": 98,
    "homeTeam": "Western Kentucky",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 31,
    "homeLineScores": [
      21,
      3,
      0,
      7
    ],
    "homePostgameWinProbability": 0.9978478668182061,
    "homePregameElo": 1496,
    "homePostgameElo": 1512,
    "awayId": 338,
    "awayTeam": "Kennesaw State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 14,
    "awayLineScores": [
      7,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.0021521331817938583,
    "awayPregameElo": 1261,
    "awayPostgameElo": 1245,
    "excitementIndex": 4.1074294555,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645356,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-10-31T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 12268,
    "venueId": 4418,
    "venue": "Jerry Richardson Stadium",
    "homeId": 2429,
    "homeTeam": "Charlotte",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 3,
    "homeLineScores": [
      0,
      3,
      0,
      0
    ],
    "homePostgameWinProbability": 0.0004302629522892325,
    "homePregameElo": 1207,
    "homePostgameElo": 1182,
    "awayId": 2655,
    "awayTeam": "Tulane",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 34,
    "awayLineScores": [
      3,
      7,
      10,
      14
    ],
    "awayPostgameWinProbability": 0.9995697370477108,
    "awayPregameElo": 1732,
    "awayPostgameElo": 1757,
    "excitementIndex": 2.7032661126,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401629036,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-01T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 22028,
    "venueId": 3892,
    "venue": "Pratt & Whitney Stadium",
    "homeId": 41,
    "homeTeam": "UConn",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 34,
    "homeLineScores": [
      10,
      3,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9524868849171059,
    "homePregameElo": 1423,
    "homePostgameElo": 1425,
    "awayId": 2247,
    "awayTeam": "Georgia State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 27,
    "awayLineScores": [
      0,
      10,
      3,
      14
    ],
    "awayPostgameWinProbability": 0.04751311508289413,
    "awayPregameElo": 1284,
    "awayPostgameElo": 1282,
    "excitementIndex": 6.4596963464,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645357,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-01T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20111,
    "venueId": 3715,
    "venue": "FAU Stadium",
    "homeId": 2226,
    "homeTeam": "Florida Atlantic",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 21,
    "homeLineScores": [
      7,
      7,
      7,
      0
    ],
    "homePostgameWinProbability": 0.05572316655248034,
    "homePregameElo": 1260,
    "homePostgameElo": 1207,
    "awayId": 58,
    "awayTeam": "South Florida",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 44,
    "awayLineScores": [
      0,
      7,
      24,
      13
    ],
    "awayPostgameWinProbability": 0.9442768334475197,
    "awayPregameElo": 1326,
    "awayPostgameElo": 1379,
    "excitementIndex": 6.9351106836,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643747,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 36838,
    "venueId": 3653,
    "venue": "Albertsons Stadium",
    "homeId": 68,
    "homeTeam": "Boise State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 56,
    "homeLineScores": [
      21,
      14,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9989695752354796,
    "homePregameElo": 1717,
    "homePostgameElo": 1761,
    "awayId": 21,
    "awayTeam": "San Diego State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 24,
    "awayLineScores": [
      0,
      10,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.0010304247645204212,
    "awayPregameElo": 1355,
    "awayPostgameElo": 1311,
    "excitementIndex": 2.582577739,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628533,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 58088,
    "venueId": 3832,
    "venue": "Memorial Stadium (Champaign, IL)",
    "homeId": 356,
    "homeTeam": "Illinois",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 17,
    "homeLineScores": [
      0,
      10,
      0,
      7
    ],
    "homePostgameWinProbability": 0.505560602657274,
    "homePregameElo": 1569,
    "homePostgameElo": 1556,
    "awayId": 135,
    "awayTeam": "Minnesota",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 25,
    "awayLineScores": [
      3,
      10,
      3,
      9
    ],
    "awayPostgameWinProbability": 0.494439397342726,
    "awayPregameElo": 1599,
    "awayPostgameElo": 1612,
    "excitementIndex": 6.2528566502,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643746,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 30046,
    "venueId": 3841,
    "venue": "Michie Stadium",
    "homeId": 349,
    "homeTeam": "Army",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 20,
    "homeLineScores": [
      3,
      3,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9633326060577443,
    "homePregameElo": 1649,
    "homePostgameElo": 1654,
    "awayId": 2005,
    "awayTeam": "Air Force",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.03666739394225571,
    "awayPregameElo": 1292,
    "awayPostgameElo": 1287,
    "excitementIndex": 4.7319735434,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635516,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 56919,
    "venueId": 3670,
    "venue": "Carter-Finley Stadium",
    "homeId": 152,
    "homeTeam": "NC State",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 59,
    "homeLineScores": [
      14,
      17,
      21,
      7
    ],
    "homePostgameWinProbability": 0.9980640612718844,
    "homePregameElo": 1460,
    "homePostgameElo": 1514,
    "awayId": 24,
    "awayTeam": "Stanford",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 28,
    "awayLineScores": [
      7,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.0019359387281155938,
    "awayPregameElo": 1212,
    "awayPostgameElo": 1158,
    "excitementIndex": 3.6194951636,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628410,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 82831,
    "venueId": 3835,
    "venue": "Memorial Stadium (Norman, OK)",
    "homeId": 201,
    "homeTeam": "Oklahoma",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 59,
    "homeLineScores": [
      7,
      28,
      14,
      10
    ],
    "homePostgameWinProbability": 0.9989428838230759,
    "homePregameElo": 1682,
    "homePostgameElo": 1682,
    "awayId": 311,
    "awayTeam": "Maine",
    "awayClassification": "fcs",
    "awayConference": "CAA",
    "awayPoints": 14,
    "awayLineScores": [
      7,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.0010571161769240556,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.2441705147,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628538,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 61141,
    "venueId": 3907,
    "venue": "Ross-Ade Stadium",
    "homeId": 2509,
    "homeTeam": "Purdue",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 20,
    "homeLineScores": [
      3,
      7,
      3,
      7,
      0
    ],
    "homePostgameWinProbability": 0.026807942074695553,
    "homePregameElo": 1212,
    "homePostgameElo": 1220,
    "awayId": 77,
    "awayTeam": "Northwestern",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 26,
    "awayLineScores": [
      10,
      7,
      0,
      3,
      6
    ],
    "awayPostgameWinProbability": 0.9731920579253045,
    "awayPregameElo": 1487,
    "awayPostgameElo": 1479,
    "excitementIndex": 7.1001722357,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628539,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 111030,
    "venueId": 3632,
    "venue": "Beaver Stadium",
    "homeId": 213,
    "homeTeam": "Penn State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 13,
    "homeLineScores": [
      10,
      0,
      3,
      0
    ],
    "homePostgameWinProbability": 0.060240787459640795,
    "homePregameElo": 1918,
    "homePostgameElo": 1916,
    "awayId": 194,
    "awayTeam": "Ohio State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 20,
    "awayLineScores": [
      7,
      7,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.9397592125403592,
    "awayPregameElo": 2063,
    "awayPostgameElo": 2065,
    "excitementIndex": 4.9702867862,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628406,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 72894,
    "venueId": 3887,
    "venue": "Razorback Stadium",
    "homeId": 8,
    "homeTeam": "Arkansas",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 31,
    "homeLineScores": [
      3,
      7,
      14,
      7
    ],
    "homePostgameWinProbability": 0.018898573183159847,
    "homePregameElo": 1573,
    "homePostgameElo": 1524,
    "awayId": 145,
    "awayTeam": "Ole Miss",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 63,
    "awayLineScores": [
      7,
      28,
      21,
      7
    ],
    "awayPostgameWinProbability": 0.9811014268168402,
    "awayPregameElo": 1911,
    "awayPostgameElo": 1960,
    "excitementIndex": 2.2293838949,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635601,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 60189,
    "venueId": 3948,
    "venue": "Hard Rock Stadium",
    "homeId": 2390,
    "homeTeam": "Miami",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 53,
    "homeLineScores": [
      14,
      3,
      15,
      21
    ],
    "homePostgameWinProbability": 0.647674742762091,
    "homePregameElo": 1848,
    "homePostgameElo": 1877,
    "awayId": 150,
    "awayTeam": "Duke",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      14,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.352325257237909,
    "awayPregameElo": 1611,
    "awayPostgameElo": 1582,
    "excitementIndex": 6.5023390558,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645359,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 17198,
    "venueId": 3604,
    "venue": "Alamodome",
    "homeId": 2636,
    "homeTeam": "UTSA",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 44,
    "homeLineScores": [
      14,
      10,
      10,
      10
    ],
    "homePostgameWinProbability": 0.6137697230939547,
    "homePregameElo": 1381,
    "homePostgameElo": 1408,
    "awayId": 235,
    "awayTeam": "Memphis",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 36,
    "awayLineScores": [
      10,
      14,
      0,
      12
    ],
    "awayPostgameWinProbability": 0.3862302769060453,
    "awayPregameElo": 1601,
    "awayPostgameElo": 1574,
    "excitementIndex": 6.1679760926,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644757,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 4610,
    "venueId": 3768,
    "venue": "InfoCision Stadium",
    "homeId": 2006,
    "homeTeam": "Akron",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 30,
    "homeLineScores": [
      7,
      0,
      0,
      23
    ],
    "homePostgameWinProbability": 0.053870442245811695,
    "homePregameElo": 1059,
    "homePostgameElo": 1048,
    "awayId": 2084,
    "awayTeam": "Buffalo",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 41,
    "awayLineScores": [
      14,
      10,
      14,
      3
    ],
    "awayPostgameWinProbability": 0.9461295577541883,
    "awayPregameElo": 1206,
    "awayPostgameElo": 1217,
    "excitementIndex": 4.8255888139,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644758,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 13044,
    "venueId": 3912,
    "venue": "Rynearson Stadium",
    "homeId": 2199,
    "homeTeam": "Eastern Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 28,
    "homeLineScores": [
      7,
      3,
      9,
      9
    ],
    "homePostgameWinProbability": 0.42060547224993694,
    "homePregameElo": 1252,
    "homePostgameElo": 1261,
    "awayId": 2649,
    "awayTeam": "Toledo",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 29,
    "awayLineScores": [
      0,
      7,
      0,
      22
    ],
    "awayPostgameWinProbability": 0.5793945277500631,
    "awayPregameElo": 1472,
    "awayPostgameElo": 1463,
    "excitementIndex": 6.6184400987,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635604,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 38454,
    "venueId": 1964,
    "venue": "JMA Wireless Dome",
    "homeId": 183,
    "homeTeam": "Syracuse",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 38,
    "homeLineScores": [
      0,
      3,
      15,
      13,
      7
    ],
    "homePostgameWinProbability": 0.10978376037100246,
    "homePregameElo": 1360,
    "homePostgameElo": 1391,
    "awayId": 259,
    "awayTeam": "Virginia Tech",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 31,
    "awayLineScores": [
      14,
      0,
      7,
      10,
      0
    ],
    "awayPostgameWinProbability": 0.8902162396289975,
    "awayPregameElo": 1697,
    "awayPostgameElo": 1666,
    "excitementIndex": 7.0122394034,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628407,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T16:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 88043,
    "venueId": 3785,
    "venue": "Jordan-Hare Stadium",
    "homeId": 2,
    "homeTeam": "Auburn",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 7,
    "homeLineScores": [
      0,
      7,
      0,
      0
    ],
    "homePostgameWinProbability": 0.6765525361341936,
    "homePregameElo": 1585,
    "homePostgameElo": 1550,
    "awayId": 238,
    "awayTeam": "Vanderbilt",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 17,
    "awayLineScores": [
      7,
      0,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.32344746386580636,
    "awayPregameElo": 1428,
    "awayPostgameElo": 1463,
    "excitementIndex": 6.1417242135,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645358,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T18:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 17944,
    "venueId": 7221,
    "venue": "Protective Stadium",
    "homeId": 5,
    "homeTeam": "UAB",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 59,
    "homeLineScores": [
      21,
      24,
      14,
      0
    ],
    "homePostgameWinProbability": 0.9984194481059699,
    "homePregameElo": 1090,
    "homePostgameElo": 1195,
    "awayId": 202,
    "awayTeam": "Tulsa",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.0015805518940300578,
    "awayPregameElo": 1057,
    "awayPostgameElo": 952,
    "excitementIndex": 2.2607475667,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643821,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T18:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 34954,
    "venueId": 3792,
    "venue": "Kidd Brewer Stadium",
    "homeId": 2026,
    "homeTeam": "App State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 28,
    "homeLineScores": [
      7,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.8755821837173045,
    "homePregameElo": 1337,
    "homePostgameElo": 1359,
    "awayId": 295,
    "awayTeam": "Old Dominion",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 20,
    "awayLineScores": [
      3,
      14,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.12441781628269555,
    "awayPregameElo": 1494,
    "awayPostgameElo": 1472,
    "excitementIndex": 6.602430075,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643822,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 21478,
    "venueId": 3775,
    "venue": "Joan C. Edwards Stadium",
    "homeId": 276,
    "homeTeam": "Marshall",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 28,
    "homeLineScores": [
      7,
      7,
      0,
      14
    ],
    "homePostgameWinProbability": 0.28710058433552904,
    "homePregameElo": 1417,
    "homePostgameElo": 1415,
    "awayId": 2433,
    "awayTeam": "UL Monroe",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 23,
    "awayLineScores": [
      7,
      7,
      0,
      9
    ],
    "awayPostgameWinProbability": 0.712899415664471,
    "awayPregameElo": 1234,
    "awayPostgameElo": 1236,
    "excitementIndex": 6.6169647572,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635602,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 55107,
    "venueId": 3697,
    "venue": "Doak Campbell Stadium",
    "homeId": 52,
    "homeTeam": "Florida State",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 11,
    "homeLineScores": [
      3,
      0,
      8,
      0
    ],
    "homePostgameWinProbability": 0.0006741219753864182,
    "homePregameElo": 1504,
    "homePostgameElo": 1447,
    "awayId": 153,
    "awayTeam": "North Carolina",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 35,
    "awayLineScores": [
      0,
      14,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.9993258780246136,
    "awayPregameElo": 1555,
    "awayPostgameElo": 1612,
    "excitementIndex": 3.4343611299,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641026,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 14775,
    "venueId": 3946,
    "venue": "Sun Bowl",
    "homeId": 2638,
    "homeTeam": "UTEP",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 13,
    "homeLineScores": [
      3,
      7,
      3,
      0
    ],
    "homePostgameWinProbability": 0.5420947423894649,
    "homePregameElo": 1162,
    "homePostgameElo": 1147,
    "awayId": 2393,
    "awayTeam": "Middle Tennessee",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 20,
    "awayLineScores": [
      3,
      7,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.45790525761053513,
    "awayPregameElo": 1137,
    "awayPostgameElo": 1152,
    "excitementIndex": 8.7961969822,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636916,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 42110,
    "venueId": 3652,
    "venue": "FBC Mortgage Stadium",
    "homeId": 2116,
    "homeTeam": "UCF",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 56,
    "homeLineScores": [
      14,
      21,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9987704823612363,
    "homePregameElo": 1489,
    "homePostgameElo": 1625,
    "awayId": 12,
    "awayTeam": "Arizona",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 12,
    "awayLineScores": [
      0,
      6,
      6,
      0
    ],
    "awayPostgameWinProbability": 0.0012295176387636664,
    "awayPregameElo": 1518,
    "awayPostgameElo": 1382,
    "excitementIndex": 2.9223236571,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636913,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 23085,
    "venueId": 4728,
    "venue": "TDECU Stadium",
    "homeId": 248,
    "homeTeam": "Houston",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 24,
    "homeLineScores": [
      0,
      10,
      0,
      14
    ],
    "homePostgameWinProbability": 0.8327611468803445,
    "homePregameElo": 1338,
    "homePostgameElo": 1364,
    "awayId": 2306,
    "awayTeam": "Kansas State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 19,
    "awayLineScores": [
      3,
      13,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.16723885311965547,
    "awayPregameElo": 1797,
    "awayPostgameElo": 1771,
    "excitementIndex": 6.9058300992,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636915,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 52202,
    "venueId": 3646,
    "venue": "Boone Pickens Stadium",
    "homeId": 197,
    "homeTeam": "Oklahoma State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 21,
    "homeLineScores": [
      0,
      14,
      0,
      7
    ],
    "homePostgameWinProbability": 0.0017301732987625102,
    "homePregameElo": 1477,
    "homePostgameElo": 1427,
    "awayId": 9,
    "awayTeam": "Arizona State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 42,
    "awayLineScores": [
      7,
      14,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.9982698267012375,
    "awayPregameElo": 1513,
    "awayPostgameElo": 1563,
    "excitementIndex": 3.5309041035,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628534,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 68423,
    "venueId": 3936,
    "venue": "Spartan Stadium",
    "homeId": 127,
    "homeTeam": "Michigan State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 10,
    "homeLineScores": [
      10,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0.009606986273236702,
    "homePregameElo": 1465,
    "homePostgameElo": 1402,
    "awayId": 84,
    "awayTeam": "Indiana",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 47,
    "awayLineScores": [
      0,
      21,
      12,
      14
    ],
    "awayPostgameWinProbability": 0.9903930137267632,
    "awayPregameElo": 1812,
    "awayPostgameElo": 1875,
    "excitementIndex": 3.3369924068,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628536,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 110576,
    "venueId": 3558,
    "venue": "Michigan Stadium",
    "homeId": 130,
    "homeTeam": "Michigan",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 17,
    "homeLineScores": [
      7,
      3,
      7,
      0
    ],
    "homePostgameWinProbability": 0.026839761370403302,
    "homePregameElo": 1808,
    "homePostgameElo": 1778,
    "awayId": 2483,
    "awayTeam": "Oregon",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 38,
    "awayLineScores": [
      7,
      21,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.9731602386295967,
    "awayPregameElo": 2020,
    "awayPostgameElo": 2050,
    "excitementIndex": 3.2552169408,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628537,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 87453,
    "venueId": 3834,
    "venue": "Memorial Stadium (Lincoln, NE)",
    "homeId": 158,
    "homeTeam": "Nebraska",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 20,
    "homeLineScores": [
      0,
      7,
      7,
      6
    ],
    "homePostgameWinProbability": 0.00765968479251004,
    "homePregameElo": 1467,
    "homePostgameElo": 1453,
    "awayId": 26,
    "awayTeam": "UCLA",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 27,
    "awayLineScores": [
      3,
      10,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.99234031520749,
    "awayPregameElo": 1456,
    "awayPostgameElo": 1470,
    "excitementIndex": 4.0336124602,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628408,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 76307,
    "venueId": 3712,
    "venue": "EverBank Stadium",
    "homeId": 61,
    "homeTeam": "Georgia",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 34,
    "homeLineScores": [
      3,
      3,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9697807568208445,
    "homePregameElo": 2058,
    "homePostgameElo": 2057,
    "awayId": 57,
    "awayTeam": "Florida",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      13,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.030219243179155475,
    "awayPregameElo": 1634,
    "awayPostgameElo": 1635,
    "excitementIndex": 9.0550589741,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636914,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 61500,
    "venueId": 3772,
    "venue": "Jack Trice Stadium",
    "homeId": 66,
    "homeTeam": "Iowa State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 22,
    "homeLineScores": [
      3,
      10,
      0,
      9
    ],
    "homePostgameWinProbability": 0.48596865208953,
    "homePregameElo": 1771,
    "homePostgameElo": 1759,
    "awayId": 2641,
    "awayTeam": "Texas Tech",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 23,
    "awayLineScores": [
      10,
      0,
      7,
      6
    ],
    "awayPostgameWinProbability": 0.51403134791047,
    "awayPregameElo": 1554,
    "awayPostgameElo": 1566,
    "excitementIndex": 6.4834102391,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645360,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 21253,
    "venueId": 3895,
    "venue": "Rice Stadium",
    "homeId": 242,
    "homeTeam": "Rice",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 24,
    "homeLineScores": [
      14,
      3,
      7,
      0
    ],
    "homePostgameWinProbability": 0.4629824703551783,
    "homePregameElo": 1236,
    "homePostgameElo": 1296,
    "awayId": 2426,
    "awayTeam": "Navy",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      7,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.5370175296448216,
    "awayPregameElo": 1564,
    "awayPostgameElo": 1504,
    "excitementIndex": 3.9986166134,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643824,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 24223,
    "venueId": 3975,
    "venue": "Veterans Memorial Stadium (AL)",
    "homeId": 2653,
    "homeTeam": "Troy",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 38,
    "homeLineScores": [
      7,
      21,
      7,
      3
    ],
    "homePostgameWinProbability": 0.9968836682729194,
    "homePregameElo": 1429,
    "homePostgameElo": 1455,
    "awayId": 324,
    "awayTeam": "Coastal Carolina",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      0,
      17,
      0
    ],
    "awayPostgameWinProbability": 0.00311633172708059,
    "awayPregameElo": 1402,
    "awayPostgameElo": 1376,
    "excitementIndex": 6.0846892671,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643750,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 15046,
    "venueId": 3971,
    "venue": "University Stadium (NM)",
    "homeId": 167,
    "homeTeam": "New Mexico",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 45,
    "homeLineScores": [
      13,
      22,
      10,
      0
    ],
    "homePostgameWinProbability": 0.08663613272417485,
    "homePregameElo": 1255,
    "homePostgameElo": 1250,
    "awayId": 2751,
    "awayTeam": "Wyoming",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 49,
    "awayLineScores": [
      14,
      21,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.9133638672758252,
    "awayPregameElo": 1278,
    "awayPostgameElo": 1283,
    "excitementIndex": 7.3534857185,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628409,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T20:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 48617,
    "venueId": 3693,
    "venue": "Davis Wade Stadium",
    "homeId": 344,
    "homeTeam": "Mississippi State",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 45,
    "homeLineScores": [
      0,
      21,
      14,
      10
    ],
    "homePostgameWinProbability": 0.7819472347062157,
    "homePregameElo": 1322,
    "homePostgameElo": 1353,
    "awayId": 113,
    "awayTeam": "Massachusetts",
    "awayClassification": "fbs",
    "awayConference": "FBS Independents",
    "awayPoints": 20,
    "awayLineScores": [
      10,
      0,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.21805276529378426,
    "awayPregameElo": 1025,
    "awayPostgameElo": 994,
    "excitementIndex": 4.0898992303,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643749,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 41575,
    "venueId": 3660,
    "venue": "Valley Children's Stadium",
    "homeId": 278,
    "homeTeam": "Fresno State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 20,
    "homeLineScores": [
      7,
      6,
      7,
      0
    ],
    "homePostgameWinProbability": 0.4175894403697216,
    "homePregameElo": 1559,
    "homePostgameElo": 1540,
    "awayId": 62,
    "awayTeam": "Hawai'i",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      0,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.5824105596302784,
    "awayPregameElo": 1228,
    "awayPostgameElo": 1247,
    "excitementIndex": 7.1825140572,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628411,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 80298,
    "venueId": 3994,
    "venue": "Williams-Brice Stadium",
    "homeId": 2579,
    "homeTeam": "South Carolina",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 44,
    "homeLineScores": [
      14,
      6,
      10,
      14
    ],
    "homePostgameWinProbability": 0.9430706784421996,
    "homePregameElo": 1744,
    "homePostgameElo": 1812,
    "awayId": 245,
    "awayTeam": "Texas A&M",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 20,
    "awayLineScores": [
      3,
      17,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.056929321557800394,
    "awayPregameElo": 1814,
    "awayPostgameElo": 1746,
    "excitementIndex": 5.9248578889,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635600,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 80446,
    "venueId": 3836,
    "venue": "Memorial Stadium (Clemson, SC)",
    "homeId": 228,
    "homeTeam": "Clemson",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 21,
    "homeLineScores": [
      7,
      0,
      0,
      14
    ],
    "homePostgameWinProbability": 0.6049979350595786,
    "homePregameElo": 1863,
    "homePostgameElo": 1819,
    "awayId": 97,
    "awayTeam": "Louisville",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 33,
    "awayLineScores": [
      3,
      14,
      9,
      7
    ],
    "awayPostgameWinProbability": 0.39500206494042145,
    "awayPregameElo": 1681,
    "awayPostgameElo": 1725,
    "excitementIndex": 4.2410658048,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628540,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 71251,
    "venueId": 3765,
    "venue": "Husky Stadium",
    "homeId": 264,
    "homeTeam": "Washington",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 26,
    "homeLineScores": [
      10,
      10,
      0,
      6
    ],
    "homePostgameWinProbability": 0.8116719776024703,
    "homePregameElo": 1686,
    "homePostgameElo": 1695,
    "awayId": 30,
    "awayTeam": "USC",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      7,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.18832802239752966,
    "awayPregameElo": 1776,
    "awayPostgameElo": 1767,
    "excitementIndex": 8.0922618356,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628535,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 69250,
    "venueId": 3793,
    "venue": "Kinnick Stadium",
    "homeId": 2294,
    "homeTeam": "Iowa",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 42,
    "homeLineScores": [
      0,
      14,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9987136888626663,
    "homePregameElo": 1693,
    "homePostgameElo": 1786,
    "awayId": 275,
    "awayTeam": "Wisconsin",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 10,
    "awayLineScores": [
      3,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.0012863111373336844,
    "awayPregameElo": 1734,
    "awayPostgameElo": 1641,
    "excitementIndex": 3.7719334733,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643823,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 19667,
    "venueId": 6526,
    "venue": "Hancock Whitney Stadium",
    "homeId": 6,
    "homeTeam": "South Alabama",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 30,
    "homeLineScores": [
      3,
      10,
      17,
      0
    ],
    "homePostgameWinProbability": 0.6027765635894256,
    "homePregameElo": 1644,
    "homePostgameElo": 1618,
    "awayId": 290,
    "awayTeam": "Georgia Southern",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 34,
    "awayLineScores": [
      7,
      7,
      0,
      20
    ],
    "awayPostgameWinProbability": 0.39722343641057445,
    "awayPregameElo": 1371,
    "awayPostgameElo": 1397,
    "excitementIndex": 4.9050448692,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628412,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-02T23:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 101915,
    "venueId": 3853,
    "venue": "Neyland Stadium",
    "homeId": 2633,
    "homeTeam": "Tennessee",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 28,
    "homeLineScores": [
      0,
      7,
      14,
      7
    ],
    "homePostgameWinProbability": 0.957040303957247,
    "homePregameElo": 1950,
    "homePostgameElo": 1939,
    "awayId": 96,
    "awayTeam": "Kentucky",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 18,
    "awayLineScores": [
      7,
      3,
      0,
      8
    ],
    "awayPostgameWinProbability": 0.04295969604275296,
    "awayPregameElo": 1526,
    "awayPostgameElo": 1537,
    "excitementIndex": 8.1829708813,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636912,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-03T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 44171,
    "venueId": 4727,
    "venue": "McLane Stadium",
    "homeId": 239,
    "homeTeam": "Baylor",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 37,
    "homeLineScores": [
      7,
      6,
      7,
      17
    ],
    "homePostgameWinProbability": 0.43434377789501794,
    "homePregameElo": 1558,
    "homePostgameElo": 1559,
    "awayId": 2628,
    "awayTeam": "TCU",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 34,
    "awayLineScores": [
      7,
      10,
      10,
      7
    ],
    "awayPostgameWinProbability": 0.5656562221049821,
    "awayPregameElo": 1527,
    "awayPostgameElo": 1526,
    "excitementIndex": 8.663106695,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643748,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-03T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16019,
    "venueId": 3816,
    "venue": "Mackay Stadium",
    "homeId": 2440,
    "homeTeam": "Nevada",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 21,
    "homeLineScores": [
      0,
      0,
      7,
      14
    ],
    "homePostgameWinProbability": 0.5782702651320293,
    "homePregameElo": 1206,
    "homePostgameElo": 1176,
    "awayId": 36,
    "awayTeam": "Colorado State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 38,
    "awayLineScores": [
      14,
      3,
      11,
      10
    ],
    "awayPostgameWinProbability": 0.4217297348679707,
    "awayPregameElo": 1313,
    "awayPostgameElo": 1343,
    "excitementIndex": 1.7841988898,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635627,
    "season": 2024,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2024-11-03T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 34648,
    "venueId": 3735,
    "venue": "Gerald J. Ford Stadium",
    "homeId": 2567,
    "homeTeam": "SMU",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 48,
    "homeLineScores": [
      7,
      24,
      3,
      14
    ],
    "homePostgameWinProbability": 0.9986669764618659,
    "homePregameElo": 1779,
    "homePostgameElo": 1814,
    "awayId": 221,
    "awayTeam": "Pittsburgh",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 25,
    "awayLineScores": [
      3,
      0,
      8,
      14
    ],
    "awayPostgameWinProbability": 0.001333023538134137,
    "awayPregameElo": 1576,
    "awayPostgameElo": 1541,
    "excitementIndex": 3.5768602725,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644760,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-06T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 7832,
    "venueId": 3786,
    "venue": "Kelly/Shorts Stadium",
    "homeId": 2117,
    "homeTeam": "Central Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 13,
    "homeLineScores": [
      0,
      7,
      0,
      6
    ],
    "homePostgameWinProbability": 0.5514883502083159,
    "homePregameElo": 1116,
    "homePostgameElo": 1123,
    "awayId": 189,
    "awayTeam": "Bowling Green",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 23,
    "awayLineScores": [
      3,
      6,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.4485116497916841,
    "awayPregameElo": 1456,
    "awayPostgameElo": 1449,
    "excitementIndex": 3.4628314861,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644688,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-06T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 6412,
    "venueId": 3919,
    "venue": "Scheumann Stadium",
    "homeId": 2050,
    "homeTeam": "Ball State",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 21,
    "homeLineScores": [
      7,
      6,
      8,
      0
    ],
    "homePostgameWinProbability": 0.45153305370366215,
    "homePregameElo": 1094,
    "homePostgameElo": 1115,
    "awayId": 193,
    "awayTeam": "Miami (OH)",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 27,
    "awayLineScores": [
      7,
      14,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.5484669462963379,
    "awayPregameElo": 1569,
    "awayPostgameElo": 1548,
    "excitementIndex": 5.7940036645,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644761,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-07T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 5662,
    "venueId": 3696,
    "venue": "Dix Stadium",
    "homeId": 2309,
    "homeTeam": "Kent State",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 0,
    "homeLineScores": [
      0,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0.001342140821977892,
    "homePregameElo": 878,
    "homePostgameElo": 831,
    "awayId": 195,
    "awayTeam": "Ohio",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 41,
    "awayLineScores": [
      10,
      10,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.9986578591780221,
    "awayPregameElo": 1463,
    "awayPostgameElo": 1510,
    "excitementIndex": 2.7053808295,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644762,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-07T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 10346,
    "venueId": 3980,
    "venue": "Waldo Stadium",
    "homeId": 2711,
    "homeTeam": "Western Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 28,
    "homeLineScores": [
      7,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.07115971646594085,
    "homePregameElo": 1288,
    "homePostgameElo": 1272,
    "awayId": 2459,
    "awayTeam": "Northern Illinois",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 42,
    "awayLineScores": [
      0,
      21,
      21,
      0
    ],
    "awayPostgameWinProbability": 0.9288402835340591,
    "awayPregameElo": 1455,
    "awayPostgameElo": 1471,
    "excitementIndex": 3.6264519232,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643825,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-08T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 19415,
    "venueId": 3654,
    "venue": "Brooks Stadium (SC)",
    "homeId": 324,
    "homeTeam": "Coastal Carolina",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 38,
    "homeLineScores": [
      14,
      3,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9451358835042454,
    "homePregameElo": 1376,
    "homePostgameElo": 1403,
    "awayId": 2026,
    "awayTeam": "App State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 24,
    "awayLineScores": [
      0,
      10,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.05486411649575462,
    "awayPregameElo": 1359,
    "awayPostgameElo": 1332,
    "excitementIndex": 4.4861180165,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645361,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-08T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 30573,
    "venueId": 3699,
    "venue": "Dowdy-Ficklen Stadium",
    "homeId": 151,
    "homeTeam": "East Carolina",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 49,
    "homeLineScores": [
      21,
      14,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9989689193958727,
    "homePregameElo": 1328,
    "homePostgameElo": 1410,
    "awayId": 2226,
    "awayTeam": "Florida Atlantic",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.0010310806041272658,
    "awayPregameElo": 1207,
    "awayPostgameElo": 1125,
    "excitementIndex": 2.7443729107,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401634773,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 28455,
    "venueId": 3630,
    "venue": "Allegacy Federal Credit Union Stadium",
    "homeId": 154,
    "homeTeam": "Wake Forest",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 36,
    "homeLineScores": [
      7,
      7,
      7,
      15
    ],
    "homePostgameWinProbability": 0.18697994028614287,
    "homePregameElo": 1349,
    "homePostgameElo": 1353,
    "awayId": 25,
    "awayTeam": "California",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 46,
    "awayLineScores": [
      10,
      19,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.8130200597138572,
    "awayPregameElo": 1653,
    "awayPostgameElo": 1649,
    "excitementIndex": 6.1989117704,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645362,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T02:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 23692,
    "venueId": 3805,
    "venue": "Simmons Bank Liberty Stadium",
    "homeId": 235,
    "homeTeam": "Memphis",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 27,
    "homeLineScores": [
      0,
      17,
      0,
      10
    ],
    "homePostgameWinProbability": 0.9068114738286155,
    "homePregameElo": 1574,
    "homePostgameElo": 1569,
    "awayId": 242,
    "awayTeam": "Rice",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 20,
    "awayLineScores": [
      6,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.09318852617138451,
    "awayPregameElo": 1296,
    "awayPostgameElo": 1301,
    "excitementIndex": 6.8754092893,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628542,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T02:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 53467,
    "venueId": 1056,
    "venue": "Rose Bowl",
    "homeId": 26,
    "homeTeam": "UCLA",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 20,
    "homeLineScores": [
      0,
      17,
      0,
      3
    ],
    "homePostgameWinProbability": 0.3388965363628089,
    "homePregameElo": 1470,
    "homePostgameElo": 1476,
    "awayId": 2294,
    "awayTeam": "Iowa",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 17,
    "awayLineScores": [
      10,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.6611034636371911,
    "awayPregameElo": 1786,
    "awayPostgameElo": 1780,
    "excitementIndex": 7.1761600379,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643754,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T03:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 21832,
    "venueId": 7311,
    "venue": "Snapdragon Stadium",
    "homeId": 21,
    "homeTeam": "San Diego State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 16,
    "homeLineScores": [
      3,
      10,
      3,
      0
    ],
    "homePostgameWinProbability": 0.10908058895713622,
    "homePregameElo": 1311,
    "homePostgameElo": 1298,
    "awayId": 167,
    "awayTeam": "New Mexico",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 21,
    "awayLineScores": [
      14,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.8909194110428638,
    "awayPregameElo": 1250,
    "awayPostgameElo": 1263,
    "excitementIndex": 8.2243428827,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628544,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 44120,
    "venueId": 6577,
    "venue": "SHI Stadium",
    "homeId": 164,
    "homeTeam": "Rutgers",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 26,
    "homeLineScores": [
      7,
      7,
      0,
      12
    ],
    "homePostgameWinProbability": 0.8959742511255365,
    "homePregameElo": 1412,
    "homePostgameElo": 1434,
    "awayId": 135,
    "awayTeam": "Minnesota",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 19,
    "awayLineScores": [
      9,
      0,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.10402574887446348,
    "awayPregameElo": 1612,
    "awayPostgameElo": 1590,
    "excitementIndex": 8.7593936175,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628417,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 103375,
    "venueId": 3910,
    "venue": "DKR-Texas Memorial Stadium",
    "homeId": 251,
    "homeTeam": "Texas",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 49,
    "homeLineScores": [
      14,
      21,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9980931582450592,
    "homePregameElo": 2057,
    "homePostgameElo": 2094,
    "awayId": 57,
    "awayTeam": "Florida",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      0,
      10,
      7
    ],
    "awayPostgameWinProbability": 0.0019068417549408245,
    "awayPregameElo": 1635,
    "awayPostgameElo": 1598,
    "excitementIndex": 2.8719110777,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635606,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 44500,
    "venueId": 3615,
    "venue": "Alumni Stadium (Chestnut Hill, MA)",
    "homeId": 103,
    "homeTeam": "Boston College",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 37,
    "homeLineScores": [
      7,
      7,
      16,
      7
    ],
    "homePostgameWinProbability": 0.9268653681577986,
    "homePregameElo": 1428,
    "homePostgameElo": 1433,
    "awayId": 183,
    "awayTeam": "Syracuse",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 31,
    "awayLineScores": [
      0,
      14,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.07313463184220137,
    "awayPregameElo": 1391,
    "awayPostgameElo": 1386,
    "excitementIndex": 7.5663226546,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636918,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 38007,
    "venueId": 3854,
    "venue": "Nippert Stadium",
    "homeId": 2132,
    "homeTeam": "Cincinnati",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 24,
    "homeLineScores": [
      7,
      0,
      7,
      10
    ],
    "homePostgameWinProbability": 0.7799606946109937,
    "homePregameElo": 1536,
    "homePostgameElo": 1524,
    "awayId": 277,
    "awayTeam": "West Virginia",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 31,
    "awayLineScores": [
      0,
      17,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.2200393053890063,
    "awayPregameElo": 1549,
    "awayPostgameElo": 1561,
    "excitementIndex": 4.7838847338,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643828,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 13720,
    "venueId": 3817,
    "venue": "Malone Stadium",
    "homeId": 2433,
    "homeTeam": "UL Monroe",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 17,
    "homeLineScores": [
      0,
      0,
      14,
      3
    ],
    "homePostgameWinProbability": 0.09601844559715932,
    "homePregameElo": 1236,
    "homePostgameElo": 1220,
    "awayId": 326,
    "awayTeam": "Texas State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 38,
    "awayLineScores": [
      14,
      14,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.9039815544028407,
    "awayPregameElo": 1586,
    "awayPostgameElo": 1602,
    "excitementIndex": 1.7130948336,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645363,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 34091,
    "venueId": 3886,
    "venue": "Raymond James Stadium",
    "homeId": 58,
    "homeTeam": "South Florida",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 7,
    "homeLineScores": [
      0,
      0,
      0,
      7
    ],
    "homePostgameWinProbability": 0.0011647592581131266,
    "homePregameElo": 1379,
    "homePostgameElo": 1339,
    "awayId": 2426,
    "awayTeam": "Navy",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 28,
    "awayLineScores": [
      14,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.9988352407418869,
    "awayPregameElo": 1504,
    "awayPostgameElo": 1544,
    "excitementIndex": 2.5427475106,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635609,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 47358,
    "venueId": 721,
    "venue": "Bobby Dodd Stadium",
    "homeId": 59,
    "homeTeam": "Georgia Tech",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 28,
    "homeLineScores": [
      7,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9672381758930633,
    "homePregameElo": 1558,
    "homePostgameElo": 1577,
    "awayId": 2390,
    "awayTeam": "Miami",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 23,
    "awayLineScores": [
      10,
      0,
      6,
      7
    ],
    "awayPostgameWinProbability": 0.03276182410693673,
    "awayPregameElo": 1877,
    "awayPostgameElo": 1858,
    "excitementIndex": 6.3333845141,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628545,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 103463,
    "venueId": 3861,
    "venue": "Ohio Stadium",
    "homeId": 194,
    "homeTeam": "Ohio State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 45,
    "homeLineScores": [
      7,
      14,
      17,
      7
    ],
    "homePostgameWinProbability": 0.9989544595971486,
    "homePregameElo": 2065,
    "homePostgameElo": 2093,
    "awayId": 2509,
    "awayTeam": "Purdue",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0010455404028514304,
    "awayPregameElo": 1220,
    "awayPostgameElo": 1192,
    "excitementIndex": 3.116888687,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401640995,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 13500,
    "venueId": 3725,
    "venue": "Johnny \"Red\" Floyd Stadium",
    "homeId": 2393,
    "homeTeam": "Middle Tennessee",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 17,
    "homeLineScores": [
      7,
      0,
      0,
      10
    ],
    "homePostgameWinProbability": 0.0013902106480170547,
    "homePregameElo": 1152,
    "homePostgameElo": 1144,
    "awayId": 2335,
    "awayTeam": "Liberty",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 37,
    "awayLineScores": [
      7,
      20,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.998609789351983,
    "awayPregameElo": 1560,
    "awayPostgameElo": 1568,
    "excitementIndex": 3.0078832387,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401629037,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 18351,
    "venueId": 7221,
    "venue": "Protective Stadium",
    "homeId": 5,
    "homeTeam": "UAB",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 23,
    "homeLineScores": [
      3,
      17,
      3,
      0
    ],
    "homePostgameWinProbability": 0.011210213562088256,
    "homePregameElo": 1195,
    "homePostgameElo": 1197,
    "awayId": 41,
    "awayTeam": "UConn",
    "awayClassification": "fbs",
    "awayConference": "FBS Independents",
    "awayPoints": 31,
    "awayLineScores": [
      3,
      0,
      7,
      21
    ],
    "awayPostgameWinProbability": 0.9887897864379117,
    "awayPregameElo": 1425,
    "awayPostgameElo": 1423,
    "excitementIndex": 6.2548161297,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643829,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20502,
    "venueId": 3815,
    "venue": "M. M. Roberts Stadium",
    "homeId": 2572,
    "homeTeam": "Southern Miss",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 3,
    "homeLineScores": [
      0,
      3,
      0,
      0
    ],
    "homePostgameWinProbability": 0.0005957322042091129,
    "homePregameElo": 1096,
    "homePostgameElo": 1039,
    "awayId": 276,
    "awayTeam": "Marshall",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 37,
    "awayLineScores": [
      3,
      14,
      17,
      3
    ],
    "awayPostgameWinProbability": 0.9994042677957908,
    "awayPregameElo": 1415,
    "awayPostgameElo": 1472,
    "excitementIndex": 2.9966561677,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643755,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 37187,
    "venueId": 3893,
    "venue": "Reser Stadium",
    "homeId": 204,
    "homeTeam": "Oregon State",
    "homeClassification": "fbs",
    "homeConference": "Pac-12",
    "homePoints": 13,
    "homeLineScores": [
      0,
      10,
      3,
      0
    ],
    "homePostgameWinProbability": 0.02295216129831264,
    "homePregameElo": 1467,
    "homePostgameElo": 1446,
    "awayId": 23,
    "awayTeam": "San Jos\u00e9 State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 24,
    "awayLineScores": [
      0,
      10,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.9770478387016873,
    "awayPregameElo": 1497,
    "awayPostgameElo": 1518,
    "excitementIndex": 6.717181704,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635608,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 56919,
    "venueId": 3670,
    "venue": "Carter-Finley Stadium",
    "homeId": 152,
    "homeTeam": "NC State",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 19,
    "homeLineScores": [
      0,
      9,
      3,
      7
    ],
    "homePostgameWinProbability": 0.09583674388955982,
    "homePregameElo": 1514,
    "homePostgameElo": 1499,
    "awayId": 150,
    "awayTeam": "Duke",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 29,
    "awayLineScores": [
      12,
      0,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.9041632561104402,
    "awayPregameElo": 1582,
    "awayPostgameElo": 1597,
    "excitementIndex": 4.7482868814,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643826,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 25709,
    "venueId": 3651,
    "venue": "Bridgeforth Stadium",
    "homeId": 256,
    "homeTeam": "James Madison",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 38,
    "homeLineScores": [
      14,
      14,
      10,
      0
    ],
    "homePostgameWinProbability": 0.9955390489494149,
    "homePregameElo": 1766,
    "homePostgameElo": 1794,
    "awayId": 2247,
    "awayTeam": "Georgia State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0044609510505850825,
    "awayPregameElo": 1282,
    "awayPostgameElo": 1254,
    "excitementIndex": 3.907631635,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635607,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 65632,
    "venueId": 3799,
    "venue": "Lane Stadium",
    "homeId": 259,
    "homeTeam": "Virginia Tech",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 14,
    "homeLineScores": [
      0,
      7,
      0,
      7
    ],
    "homePostgameWinProbability": 0.1293131036116478,
    "homePregameElo": 1666,
    "homePostgameElo": 1658,
    "awayId": 228,
    "awayTeam": "Clemson",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 24,
    "awayLineScores": [
      0,
      0,
      14,
      10
    ],
    "awayPostgameWinProbability": 0.8706868963883522,
    "awayPregameElo": 1819,
    "awayPostgameElo": 1827,
    "excitementIndex": 5.6559177666,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628414,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 68126,
    "venueId": 3974,
    "venue": "Vaught-Hemingway Stadium",
    "homeId": 145,
    "homeTeam": "Ole Miss",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 28,
    "homeLineScores": [
      10,
      6,
      6,
      6
    ],
    "homePostgameWinProbability": 0.9945842356898992,
    "homePregameElo": 1960,
    "homePostgameElo": 2010,
    "awayId": 61,
    "awayTeam": "Georgia",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 10,
    "awayLineScores": [
      7,
      0,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.0054157643101008235,
    "awayPregameElo": 2057,
    "awayPostgameElo": 2007,
    "excitementIndex": 4.7063643223,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636919,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 51109,
    "venueId": 3622,
    "venue": "GEHA Field at Arrowhead Stadium",
    "homeId": 2305,
    "homeTeam": "Kansas",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 45,
    "homeLineScores": [
      14,
      17,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9694120836337419,
    "homePregameElo": 1633,
    "homePostgameElo": 1664,
    "awayId": 66,
    "awayTeam": "Iowa State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 36,
    "awayLineScores": [
      7,
      6,
      7,
      16
    ],
    "awayPostgameWinProbability": 0.030587916366258128,
    "awayPregameElo": 1759,
    "awayPostgameElo": 1728,
    "excitementIndex": 4.0134143921,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401629045,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 28519,
    "venueId": 3825,
    "venue": "DATCU Stadium",
    "homeId": 249,
    "homeTeam": "North Texas",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 3,
    "homeLineScores": [
      3,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0.0007455516011613515,
    "homePregameElo": 1462,
    "homePostgameElo": 1455,
    "awayId": 349,
    "awayTeam": "Army",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 14,
    "awayLineScores": [
      7,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.9992544483988387,
    "awayPregameElo": 1654,
    "awayPostgameElo": 1661,
    "excitementIndex": 3.8212731033,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628541,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 53082,
    "venueId": 3830,
    "venue": "Memorial Stadium (Bloomington, IN)",
    "homeId": 84,
    "homeTeam": "Indiana",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 20,
    "homeLineScores": [
      7,
      10,
      0,
      3
    ],
    "homePostgameWinProbability": 0.9045271523255871,
    "homePregameElo": 1875,
    "homePostgameElo": 1876,
    "awayId": 130,
    "awayTeam": "Michigan",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 15,
    "awayLineScores": [
      3,
      0,
      6,
      6
    ],
    "awayPostgameWinProbability": 0.09547284767441289,
    "awayPregameElo": 1778,
    "awayPostgameElo": 1777,
    "excitementIndex": 5.8572108001,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636921,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 60229,
    "venueId": 3784,
    "venue": "Jones AT&T Stadium",
    "homeId": 2641,
    "homeTeam": "Texas Tech",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 27,
    "homeLineScores": [
      13,
      0,
      7,
      7
    ],
    "homePostgameWinProbability": 0.26464738039038926,
    "homePregameElo": 1566,
    "homePostgameElo": 1537,
    "awayId": 38,
    "awayTeam": "Colorado",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 41,
    "awayLineScores": [
      0,
      10,
      21,
      10
    ],
    "awayPostgameWinProbability": 0.7353526196096107,
    "awayPregameElo": 1598,
    "awayPostgameElo": 1627,
    "excitementIndex": 5.6687912611,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645364,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 30000,
    "venueId": 4729,
    "venue": "Yulman Stadium",
    "homeId": 2655,
    "homeTeam": "Tulane",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 52,
    "homeLineScores": [
      7,
      21,
      14,
      10
    ],
    "homePostgameWinProbability": 0.9989675061198742,
    "homePregameElo": 1757,
    "homePostgameElo": 1807,
    "awayId": 218,
    "awayTeam": "Temple",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 6,
    "awayLineScores": [
      0,
      0,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.0010324938801258288,
    "awayPregameElo": 1090,
    "awayPostgameElo": 1040,
    "excitementIndex": 2.7719410032,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641021,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 14728,
    "venueId": 3946,
    "venue": "Sun Bowl",
    "homeId": 2638,
    "homeTeam": "UTEP",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 43,
    "homeLineScores": [
      7,
      7,
      7,
      7,
      7,
      8
    ],
    "homePostgameWinProbability": 0.9954500724529952,
    "homePregameElo": 1147,
    "homePostgameElo": 1165,
    "awayId": 338,
    "awayTeam": "Kennesaw State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 35,
    "awayLineScores": [
      7,
      0,
      14,
      7,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.004549927547004784,
    "awayPregameElo": 1245,
    "awayPostgameElo": 1227,
    "excitementIndex": 10.8527197235,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628418,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T21:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 28934,
    "venueId": 3973,
    "venue": "FirstBank Stadium",
    "homeId": 238,
    "homeTeam": "Vanderbilt",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 7,
    "homeLineScores": [
      0,
      0,
      7,
      0
    ],
    "homePostgameWinProbability": 0.00047113410599616216,
    "homePregameElo": 1463,
    "homePostgameElo": 1446,
    "awayId": 2579,
    "awayTeam": "South Carolina",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 28,
    "awayLineScores": [
      0,
      7,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.9995288658940038,
    "awayPregameElo": 1812,
    "awayPostgameElo": 1829,
    "excitementIndex": 3.7723916141,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641004,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T21:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16345,
    "venueId": 3776,
    "venue": "Joe Aillet Stadium",
    "homeId": 2348,
    "homeTeam": "Louisiana Tech",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 37,
    "homeLineScores": [
      7,
      14,
      9,
      7,
      0
    ],
    "homePostgameWinProbability": 0.32288960811291323,
    "homePregameElo": 1283,
    "homePostgameElo": 1297,
    "awayId": 55,
    "awayTeam": "Jacksonville State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 44,
    "awayLineScores": [
      7,
      21,
      0,
      9,
      7
    ],
    "awayPostgameWinProbability": 0.6771103918870868,
    "awayPregameElo": 1657,
    "awayPostgameElo": 1643,
    "excitementIndex": 7.792374014,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643827,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16451,
    "venueId": 3666,
    "venue": "Cajun Field",
    "homeId": 309,
    "homeTeam": "Louisiana",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 55,
    "homeLineScores": [
      10,
      21,
      17,
      7
    ],
    "homePostgameWinProbability": 0.9966026128794084,
    "homePregameElo": 1554,
    "homePostgameElo": 1621,
    "awayId": 2032,
    "awayTeam": "Arkansas State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 19,
    "awayLineScores": [
      0,
      6,
      6,
      7
    ],
    "awayPostgameWinProbability": 0.0033973871205915662,
    "awayPregameElo": 1286,
    "awayPostgameElo": 1219,
    "excitementIndex": 2.6501837172,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641036,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-09T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 12710,
    "venueId": 3601,
    "venue": "Aggie Memorial Stadium",
    "homeId": 166,
    "homeTeam": "New Mexico State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 28,
    "homeLineScores": [
      7,
      0,
      14,
      7
    ],
    "homePostgameWinProbability": 0.41310645754636394,
    "homePregameElo": 1115,
    "homePostgameElo": 1121,
    "awayId": 98,
    "awayTeam": "Western Kentucky",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 41,
    "awayLineScores": [
      14,
      10,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.5868935424536361,
    "awayPregameElo": 1512,
    "awayPostgameElo": 1506,
    "excitementIndex": 3.7419052406,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628543,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-10T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 59245,
    "venueId": 3626,
    "venue": "Autzen Stadium",
    "homeId": 2483,
    "homeTeam": "Oregon",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 39,
    "homeLineScores": [
      7,
      14,
      8,
      10
    ],
    "homePostgameWinProbability": 0.9983741121151635,
    "homePregameElo": 2050,
    "homePostgameElo": 2047,
    "awayId": 120,
    "awayTeam": "Maryland",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 18,
    "awayLineScores": [
      3,
      7,
      0,
      8
    ],
    "awayPostgameWinProbability": 0.00162588788483653,
    "awayPregameElo": 1488,
    "awayPostgameElo": 1491,
    "excitementIndex": 5.0597159335,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636920,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-10T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 45348,
    "venueId": 3616,
    "venue": "Amon G. Carter Stadium",
    "homeId": 2628,
    "homeTeam": "TCU",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 38,
    "homeLineScores": [
      10,
      14,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9634056053080869,
    "homePregameElo": 1526,
    "homePostgameElo": 1578,
    "awayId": 197,
    "awayTeam": "Oklahoma State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      0,
      6,
      7
    ],
    "awayPostgameWinProbability": 0.03659439469191306,
    "awayPregameElo": 1427,
    "awayPostgameElo": 1375,
    "excitementIndex": 3.5054858606,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628416,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-10T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 101915,
    "venueId": 3853,
    "venue": "Neyland Stadium",
    "homeId": 2633,
    "homeTeam": "Tennessee",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 33,
    "homeLineScores": [
      7,
      13,
      10,
      3
    ],
    "homePostgameWinProbability": 0.9685622489341695,
    "homePregameElo": 1939,
    "homePostgameElo": 1930,
    "awayId": 344,
    "awayTeam": "Mississippi State",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      7,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.031437751065830466,
    "awayPregameElo": 1353,
    "awayPostgameElo": 1362,
    "excitementIndex": 8.3072896155,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636917,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-10T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 44940,
    "venueId": 3947,
    "venue": "Mountain America Stadium",
    "homeId": 9,
    "homeTeam": "Arizona State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 35,
    "homeLineScores": [
      7,
      14,
      7,
      7
    ],
    "homePostgameWinProbability": 0.21722126854343723,
    "homePregameElo": 1563,
    "homePostgameElo": 1568,
    "awayId": 2116,
    "awayTeam": "UCF",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      10,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.7827787314565627,
    "awayPregameElo": 1625,
    "awayPostgameElo": 1620,
    "excitementIndex": 8.7814541459,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628413,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-10T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 102283,
    "venueId": 3958,
    "venue": "Tiger Stadium (LA)",
    "homeId": 99,
    "homeTeam": "LSU",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 13,
    "homeLineScores": [
      3,
      3,
      0,
      7
    ],
    "homePostgameWinProbability": 0.0007481401510463615,
    "homePregameElo": 1855,
    "homePostgameElo": 1800,
    "awayId": 333,
    "awayTeam": "Alabama",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 42,
    "awayLineScores": [
      14,
      7,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.9992518598489536,
    "awayPregameElo": 2058,
    "awayPostgameElo": 2113,
    "excitementIndex": 3.3003434762,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628984,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-10T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 77622,
    "venueId": 3855,
    "venue": "Notre Dame Stadium",
    "homeId": 87,
    "homeTeam": "Notre Dame",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 52,
    "homeLineScores": [
      7,
      14,
      10,
      21
    ],
    "homePostgameWinProbability": 0.9979936321773281,
    "homePregameElo": 2069,
    "homePostgameElo": 2133,
    "awayId": 52,
    "awayTeam": "Florida State",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 3,
    "awayLineScores": [
      3,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0020063678226719395,
    "awayPregameElo": 1447,
    "awayPostgameElo": 1383,
    "excitementIndex": 6.1236018995,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628415,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-10T00:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 62621,
    "venueId": 3838,
    "venue": "Memorial Stadium",
    "homeId": 142,
    "homeTeam": "Missouri",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 30,
    "homeLineScores": [
      0,
      3,
      7,
      20
    ],
    "homePostgameWinProbability": 0.7676031624758273,
    "homePregameElo": 1673,
    "homePostgameElo": 1683,
    "awayId": 201,
    "awayTeam": "Oklahoma",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 23,
    "awayLineScores": [
      0,
      9,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.23239683752417273,
    "awayPregameElo": 1688,
    "awayPostgameElo": 1678,
    "excitementIndex": 8.4845676125,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643752,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-10T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 37143,
    "venueId": 3653,
    "venue": "Albertsons Stadium",
    "homeId": 68,
    "homeTeam": "Boise State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 28,
    "homeLineScores": [
      14,
      0,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9068377676743614,
    "homePregameElo": 1761,
    "homePostgameElo": 1741,
    "awayId": 2440,
    "awayTeam": "Nevada",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.09316223232563858,
    "awayPregameElo": 1176,
    "awayPostgameElo": 1196,
    "excitementIndex": 6.2330369427,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628546,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-10T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 110233,
    "venueId": 3632,
    "venue": "Beaver Stadium",
    "homeId": 213,
    "homeTeam": "Penn State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 35,
    "homeLineScores": [
      7,
      21,
      0,
      7
    ],
    "homePostgameWinProbability": 0.9986744458079607,
    "homePregameElo": 1916,
    "homePostgameElo": 1967,
    "awayId": 264,
    "awayTeam": "Washington",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 6,
    "awayLineScores": [
      0,
      0,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.00132555419203928,
    "awayPregameElo": 1695,
    "awayPostgameElo": 1644,
    "excitementIndex": 3.3476755478,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635610,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-10T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 56693,
    "venueId": 3752,
    "venue": "Acrisure Stadium",
    "homeId": 221,
    "homeTeam": "Pittsburgh",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 19,
    "homeLineScores": [
      0,
      13,
      0,
      6
    ],
    "homePostgameWinProbability": 0.20914032954089304,
    "homePregameElo": 1541,
    "homePostgameElo": 1519,
    "awayId": 258,
    "awayTeam": "Virginia",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 24,
    "awayLineScores": [
      0,
      7,
      14,
      3
    ],
    "awayPostgameWinProbability": 0.790859670459107,
    "awayPregameElo": 1359,
    "awayPostgameElo": 1381,
    "excitementIndex": 7.3938992017,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643753,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-10T02:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 12691,
    "venueId": 7220,
    "venue": "Clarence T.C. Ching Athletics Complex",
    "homeId": 62,
    "homeTeam": "Hawai'i",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 27,
    "homeLineScores": [
      7,
      3,
      10,
      7
    ],
    "homePostgameWinProbability": 0.40713149992716013,
    "homePregameElo": 1247,
    "homePostgameElo": 1265,
    "awayId": 2439,
    "awayTeam": "UNLV",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 29,
    "awayLineScores": [
      12,
      0,
      10,
      7
    ],
    "awayPostgameWinProbability": 0.5928685000728399,
    "awayPregameElo": 1668,
    "awayPostgameElo": 1650,
    "excitementIndex": 8.2365350129,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643751,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-10T02:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 14794,
    "venueId": 3713,
    "venue": "Falcon Stadium",
    "homeId": 2005,
    "homeTeam": "Air Force",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 36,
    "homeLineScores": [
      7,
      10,
      9,
      10
    ],
    "homePostgameWinProbability": 0.9407530778712846,
    "homePregameElo": 1287,
    "homePostgameElo": 1316,
    "awayId": 278,
    "awayTeam": "Fresno State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 28,
    "awayLineScores": [
      7,
      14,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.05924692212871541,
    "awayPregameElo": 1540,
    "awayPostgameElo": 1511,
    "excitementIndex": 6.232952863,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636922,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-10T03:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 54383,
    "venueId": 587,
    "venue": "Rice-Eccles Stadium",
    "homeId": 254,
    "homeTeam": "Utah",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 21,
    "homeLineScores": [
      0,
      21,
      0,
      0
    ],
    "homePostgameWinProbability": 0.711458986690349,
    "homePregameElo": 1568,
    "homePostgameElo": 1572,
    "awayId": 252,
    "awayTeam": "BYU",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 22,
    "awayLineScores": [
      3,
      7,
      3,
      9
    ],
    "awayPostgameWinProbability": 0.288541013309651,
    "awayPregameElo": 1678,
    "awayPostgameElo": 1674,
    "excitementIndex": 6.4814276102,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643756,
    "season": 2024,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2024-11-10T03:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 20011,
    "venueId": 3820,
    "venue": "Gesa Field",
    "homeId": 265,
    "homeTeam": "Washington State",
    "homeClassification": "fbs",
    "homeConference": "Pac-12",
    "homePoints": 49,
    "homeLineScores": [
      7,
      14,
      14,
      14
    ],
    "homePostgameWinProbability": 0.996625517050503,
    "homePregameElo": 1597,
    "homePostgameElo": 1606,
    "awayId": 328,
    "awayTeam": "Utah State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 28,
    "awayLineScores": [
      7,
      0,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.0033744829494970485,
    "awayPregameElo": 1179,
    "awayPostgameElo": 1170,
    "excitementIndex": 4.7296645388,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644765,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-13T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 14661,
    "venueId": 3739,
    "venue": "Glass Bowl",
    "homeId": 2649,
    "homeTeam": "Toledo",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 37,
    "homeLineScores": [
      7,
      20,
      7,
      3
    ],
    "homePostgameWinProbability": 0.9981858508738058,
    "homePregameElo": 1463,
    "homePostgameElo": 1495,
    "awayId": 2117,
    "awayTeam": "Central Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 10,
    "awayLineScores": [
      3,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.0018141491261941534,
    "awayPregameElo": 1123,
    "awayPostgameElo": 1091,
    "excitementIndex": 3.9677424339,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644763,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-13T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 12708,
    "venueId": 3965,
    "venue": "UB Stadium",
    "homeId": 2084,
    "homeTeam": "Buffalo",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 51,
    "homeLineScores": [
      7,
      17,
      7,
      14,
      6
    ],
    "homePostgameWinProbability": 0.5372519914964371,
    "homePregameElo": 1217,
    "homePostgameElo": 1217,
    "awayId": 2050,
    "awayTeam": "Ball State",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 48,
    "awayLineScores": [
      7,
      21,
      7,
      10,
      3
    ],
    "awayPostgameWinProbability": 0.4627480085035629,
    "awayPregameElo": 1115,
    "awayPostgameElo": 1115,
    "excitementIndex": 7.8944491597,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644764,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-13T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 1156,
    "venueId": 3700,
    "venue": "Doyt L. Perry Stadium",
    "homeId": 189,
    "homeTeam": "Bowling Green",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 31,
    "homeLineScores": [
      3,
      14,
      14,
      0
    ],
    "homePostgameWinProbability": 0.9962211567439763,
    "homePregameElo": 1449,
    "homePostgameElo": 1472,
    "awayId": 2711,
    "awayTeam": "Western Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      7,
      6,
      0
    ],
    "awayPostgameWinProbability": 0.003778843256023734,
    "awayPregameElo": 1272,
    "awayPostgameElo": 1249,
    "excitementIndex": 4.4086505192,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644767,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-14T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 14133,
    "venueId": 3876,
    "venue": "Peden Stadium",
    "homeId": 195,
    "homeTeam": "Ohio",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 35,
    "homeLineScores": [
      0,
      14,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9985919690578666,
    "homePregameElo": 1510,
    "homePostgameElo": 1546,
    "awayId": 2199,
    "awayTeam": "Eastern Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      7,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.0014080309421333759,
    "awayPregameElo": 1261,
    "awayPostgameElo": 1225,
    "excitementIndex": 6.412877157,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644689,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-14T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 5328,
    "venueId": 3996,
    "venue": "Yager Stadium",
    "homeId": 193,
    "homeTeam": "Miami (OH)",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 34,
    "homeLineScores": [
      10,
      7,
      14,
      3
    ],
    "homePostgameWinProbability": null,
    "homePregameElo": 1548,
    "homePostgameElo": 1544,
    "awayId": 2309,
    "awayTeam": "Kent State",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 7,
    "awayLineScores": [
      7,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": null,
    "awayPregameElo": 831,
    "awayPostgameElo": 835,
    "excitementIndex": null,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644766,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-14T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 6795,
    "venueId": 3764,
    "venue": "Huskie Stadium",
    "homeId": 2459,
    "homeTeam": "Northern Illinois",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 29,
    "homeLineScores": [
      17,
      6,
      0,
      6
    ],
    "homePostgameWinProbability": 0.998337728406925,
    "homePregameElo": 1471,
    "homePostgameElo": 1464,
    "awayId": 2006,
    "awayTeam": "Akron",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 16,
    "awayLineScores": [
      6,
      10,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.001662271593074971,
    "awayPregameElo": 1048,
    "awayPostgameElo": 1055,
    "excitementIndex": 8.1149102449,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645365,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-15T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 17979,
    "venueId": 3674,
    "venue": "Chapman Stadium",
    "homeId": 202,
    "homeTeam": "Tulsa",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 31,
    "homeLineScores": [
      3,
      14,
      7,
      7
    ],
    "homePostgameWinProbability": 0.052563064473721964,
    "homePregameElo": 952,
    "homePostgameElo": 971,
    "awayId": 151,
    "awayTeam": "East Carolina",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 38,
    "awayLineScores": [
      7,
      10,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.9474369355262781,
    "awayPregameElo": 1410,
    "awayPostgameElo": 1391,
    "excitementIndex": 9.0698727819,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643759,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 36720,
    "venueId": 5388,
    "venue": "Canvas Stadium",
    "homeId": 36,
    "homeTeam": "Colorado State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 24,
    "homeLineScores": [
      14,
      3,
      7,
      0
    ],
    "homePostgameWinProbability": 0.9983913140900289,
    "homePregameElo": 1343,
    "homePostgameElo": 1366,
    "awayId": 2751,
    "awayTeam": "Wyoming",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      3,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.001608685909971097,
    "awayPregameElo": 1283,
    "awayPostgameElo": 1260,
    "excitementIndex": 4.2170813191,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645366,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 21350,
    "venueId": 3604,
    "venue": "Alamodome",
    "homeId": 2636,
    "homeTeam": "UTSA",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 48,
    "homeLineScores": [
      14,
      13,
      3,
      18
    ],
    "homePostgameWinProbability": 0.9924460223407064,
    "homePregameElo": 1408,
    "homePostgameElo": 1463,
    "awayId": 249,
    "awayTeam": "North Texas",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 27,
    "awayLineScores": [
      0,
      7,
      13,
      7
    ],
    "awayPostgameWinProbability": 0.007553977659293554,
    "awayPregameElo": 1455,
    "awayPostgameElo": 1400,
    "excitementIndex": 4.4650091603,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628553,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T02:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 68811,
    "venueId": 3765,
    "venue": "Husky Stadium",
    "homeId": 264,
    "homeTeam": "Washington",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 31,
    "homeLineScores": [
      7,
      7,
      3,
      14
    ],
    "homePostgameWinProbability": 0.8477243937188877,
    "homePregameElo": 1644,
    "homePostgameElo": 1654,
    "awayId": 26,
    "awayTeam": "UCLA",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 19,
    "awayLineScores": [
      0,
      10,
      3,
      6
    ],
    "awayPostgameWinProbability": 0.15227560628111225,
    "awayPregameElo": 1476,
    "awayPostgameElo": 1466,
    "excitementIndex": 5.9580083077,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636923,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T03:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 38538,
    "venueId": 3619,
    "venue": "Arizona Stadium",
    "homeId": 12,
    "homeTeam": "Arizona",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 27,
    "homeLineScores": [
      7,
      3,
      17,
      0
    ],
    "homePostgameWinProbability": 0.9517441364487145,
    "homePregameElo": 1382,
    "homePostgameElo": 1440,
    "awayId": 248,
    "awayTeam": "Houston",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.04825586355128553,
    "awayPregameElo": 1364,
    "awayPostgameElo": 1306,
    "excitementIndex": 4.4978273245,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628550,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 38147,
    "venueId": 4250,
    "venue": "Wrigley Field",
    "homeId": 77,
    "homeTeam": "Northwestern",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 7,
    "homeLineScores": [
      0,
      7,
      0,
      0
    ],
    "homePostgameWinProbability": 0.0047227490781524065,
    "homePregameElo": 1479,
    "homePostgameElo": 1486,
    "awayId": 194,
    "awayTeam": "Ohio State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 31,
    "awayLineScores": [
      0,
      21,
      10,
      0
    ],
    "awayPostgameWinProbability": 0.9952772509218476,
    "awayPregameElo": 2093,
    "awayPostgameElo": 2086,
    "excitementIndex": 2.7808929633,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401629046,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 9115,
    "venueId": 3985,
    "venue": "Warren McGuirk Alumni Stadium",
    "homeId": 113,
    "homeTeam": "Massachusetts",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 34,
    "homeLineScores": [
      7,
      13,
      0,
      8,
      6
    ],
    "homePostgameWinProbability": 0.29384254862932685,
    "homePregameElo": 994,
    "homePostgameElo": 1017,
    "awayId": 2335,
    "awayTeam": "Liberty",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 35,
    "awayLineScores": [
      0,
      7,
      7,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.7061574513706732,
    "awayPregameElo": 1568,
    "awayPostgameElo": 1545,
    "excitementIndex": 8.8553013202,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628419,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 74929,
    "venueId": 3887,
    "venue": "Razorback Stadium",
    "homeId": 8,
    "homeTeam": "Arkansas",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 10,
    "homeLineScores": [
      0,
      0,
      7,
      3
    ],
    "homePostgameWinProbability": 0.12650835218280748,
    "homePregameElo": 1524,
    "homePostgameElo": 1547,
    "awayId": 251,
    "awayTeam": "Texas",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 20,
    "awayLineScores": [
      7,
      3,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.8734916478171926,
    "awayPregameElo": 2094,
    "awayPostgameElo": 2071,
    "excitementIndex": 5.199472338,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635582,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 58667,
    "venueId": 3752,
    "venue": "Acrisure Stadium",
    "homeId": 221,
    "homeTeam": "Pittsburgh",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 20,
    "homeLineScores": [
      7,
      0,
      0,
      13
    ],
    "homePostgameWinProbability": 0.12168609862905368,
    "homePregameElo": 1519,
    "homePostgameElo": 1531,
    "awayId": 228,
    "awayTeam": "Clemson",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      10,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.8783139013709463,
    "awayPregameElo": 1827,
    "awayPostgameElo": 1815,
    "excitementIndex": 5.9101362314,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636925,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 54646,
    "venueId": 3726,
    "venue": "Folsom Field",
    "homeId": 38,
    "homeTeam": "Colorado",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 49,
    "homeLineScores": [
      14,
      7,
      7,
      21
    ],
    "homePostgameWinProbability": 0.9847781812601605,
    "homePregameElo": 1627,
    "homePostgameElo": 1684,
    "awayId": 254,
    "awayTeam": "Utah",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 24,
    "awayLineScores": [
      3,
      6,
      7,
      8
    ],
    "awayPostgameWinProbability": 0.015221818739839521,
    "awayPregameElo": 1572,
    "awayPostgameElo": 1515,
    "excitementIndex": 5.0676713463,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645370,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 38914,
    "venueId": 3852,
    "venue": "Navy-Marine Corps Memorial Stadium",
    "homeId": 2426,
    "homeTeam": "Navy",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 0,
    "homeLineScores": [
      0,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0.0003781563619851414,
    "homePregameElo": 1544,
    "homePostgameElo": 1477,
    "awayId": 2655,
    "awayTeam": "Tulane",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 35,
    "awayLineScores": [
      7,
      7,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.9996218436380149,
    "awayPregameElo": 1807,
    "awayPostgameElo": 1874,
    "excitementIndex": 2.5201108119,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641013,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 13312,
    "venueId": 3796,
    "venue": "Houchens Industries-L.T. Smith Stadium",
    "homeId": 98,
    "homeTeam": "Western Kentucky",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 7,
    "homeLineScores": [
      0,
      7,
      0,
      0
    ],
    "homePostgameWinProbability": 0.29488992600726116,
    "homePregameElo": 1506,
    "homePostgameElo": 1482,
    "awayId": 2348,
    "awayTeam": "Louisiana Tech",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 12,
    "awayLineScores": [
      3,
      6,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.7051100739927388,
    "awayPregameElo": 1297,
    "awayPostgameElo": 1321,
    "excitementIndex": 6.4233035371,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628426,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T17:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 88043,
    "venueId": 3785,
    "venue": "Jordan-Hare Stadium",
    "homeId": 2,
    "homeTeam": "Auburn",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 48,
    "homeLineScores": [
      10,
      14,
      14,
      10
    ],
    "homePostgameWinProbability": 0.9982394798783483,
    "homePregameElo": 1550,
    "homePostgameElo": 1604,
    "awayId": 2433,
    "awayTeam": "UL Monroe",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.0017605201216517319,
    "awayPregameElo": 1220,
    "awayPostgameElo": 1166,
    "excitementIndex": 2.9019414298,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643832,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 24175,
    "venueId": 3775,
    "venue": "Joan C. Edwards Stadium",
    "homeId": 276,
    "homeTeam": "Marshall",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 31,
    "homeLineScores": [
      3,
      14,
      7,
      7
    ],
    "homePostgameWinProbability": 0.8907232528989656,
    "homePregameElo": 1472,
    "homePostgameElo": 1489,
    "awayId": 324,
    "awayTeam": "Coastal Carolina",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 19,
    "awayLineScores": [
      7,
      0,
      0,
      12
    ],
    "awayPostgameWinProbability": 0.10927674710103441,
    "awayPregameElo": 1403,
    "awayPostgameElo": 1386,
    "excitementIndex": 6.5761499991,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628422,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T18:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 48370,
    "venueId": 3683,
    "venue": "Kroger Field",
    "homeId": 96,
    "homeTeam": "Kentucky",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 48,
    "homeLineScores": [
      14,
      10,
      10,
      14
    ],
    "homePostgameWinProbability": 0.9989151043390855,
    "homePregameElo": 1527,
    "homePostgameElo": 1527,
    "awayId": 93,
    "awayTeam": "Murray State",
    "awayClassification": "fcs",
    "awayConference": "MVFC",
    "awayPoints": 6,
    "awayLineScores": [
      0,
      0,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.00108489566091452,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.2196359238,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628425,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 100077,
    "venueId": 3657,
    "venue": "Bryant-Denny Stadium",
    "homeId": 333,
    "homeTeam": "Alabama",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 52,
    "homeLineScores": [
      14,
      17,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9989495569406649,
    "homePregameElo": 2130,
    "homePostgameElo": 2130,
    "awayId": 2382,
    "awayTeam": "Mercer",
    "awayClassification": "fcs",
    "awayConference": "Southern",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0010504430593351044,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.0558763384,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401640986,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 17688,
    "venueId": 3662,
    "venue": "AmFirst Stadium",
    "homeId": 55,
    "homeTeam": "Jacksonville State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 34,
    "homeLineScores": [
      3,
      17,
      0,
      14
    ],
    "homePostgameWinProbability": 0.48224014442684765,
    "homePregameElo": 1643,
    "homePostgameElo": 1640,
    "awayId": 2229,
    "awayTeam": "Florida International",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 31,
    "awayLineScores": [
      3,
      14,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.5177598555731524,
    "awayPregameElo": 1297,
    "awayPostgameElo": 1300,
    "excitementIndex": 9.6577777256,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645369,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 12291,
    "venueId": 3806,
    "venue": "Lincoln Financial Field",
    "homeId": 218,
    "homeTeam": "Temple",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 18,
    "homeLineScores": [
      3,
      0,
      3,
      9,
      3
    ],
    "homePostgameWinProbability": 0.5248474893336113,
    "homePregameElo": 1040,
    "homePostgameElo": 1042,
    "awayId": 2226,
    "awayTeam": "Florida Atlantic",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 15,
    "awayLineScores": [
      0,
      7,
      0,
      8,
      0
    ],
    "awayPostgameWinProbability": 0.47515251066638875,
    "awayPregameElo": 1125,
    "awayPostgameElo": 1123,
    "excitementIndex": 8.0225794468,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628547,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 52660,
    "venueId": 3832,
    "venue": "Memorial Stadium (Champaign, IL)",
    "homeId": 356,
    "homeTeam": "Illinois",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 38,
    "homeLineScores": [
      14,
      7,
      3,
      14
    ],
    "homePostgameWinProbability": 0.9539072866695786,
    "homePregameElo": 1556,
    "homePostgameElo": 1593,
    "awayId": 127,
    "awayTeam": "Michigan State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 16,
    "awayLineScores": [
      6,
      3,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.04609271333042142,
    "awayPregameElo": 1402,
    "awayPostgameElo": 1365,
    "excitementIndex": 5.2826732171,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635581,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 33493,
    "venueId": 3831,
    "venue": "California Memorial Stadium",
    "homeId": 25,
    "homeTeam": "California",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 25,
    "homeLineScores": [
      0,
      7,
      7,
      11
    ],
    "homePostgameWinProbability": 0.19998453357890436,
    "homePregameElo": 1649,
    "homePostgameElo": 1610,
    "awayId": 183,
    "awayTeam": "Syracuse",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 33,
    "awayLineScores": [
      6,
      21,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.8000154664210957,
    "awayPregameElo": 1386,
    "awayPostgameElo": 1425,
    "excitementIndex": 2.3380423537,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641022,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 7736,
    "venueId": 4899,
    "venue": "Fifth Third Stadium",
    "homeId": 338,
    "homeTeam": "Kennesaw State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 17,
    "homeLineScores": [
      0,
      3,
      7,
      7,
      0
    ],
    "homePostgameWinProbability": 0.7095863659064612,
    "homePregameElo": 1227,
    "homePostgameElo": 1230,
    "awayId": 2534,
    "awayTeam": "Sam Houston",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 23,
    "awayLineScores": [
      0,
      3,
      7,
      7,
      6
    ],
    "awayPostgameWinProbability": 0.2904136340935388,
    "awayPregameElo": 1416,
    "awayPostgameElo": 1413,
    "excitementIndex": 7.3070686911,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643760,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": null,
    "venueId": 3905,
    "venue": "Maverik Stadium",
    "homeId": 328,
    "homeTeam": "Utah State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 55,
    "homeLineScores": [
      17,
      7,
      21,
      10
    ],
    "homePostgameWinProbability": 0.9984432794352859,
    "homePregameElo": 1170,
    "homePostgameElo": 1321,
    "awayId": 62,
    "awayTeam": "Hawai'i",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      3,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.0015567205647141202,
    "awayPregameElo": 1265,
    "awayPostgameElo": 1114,
    "excitementIndex": 3.0037985427,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645368,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 15030,
    "venueId": 4418,
    "venue": "Jerry Richardson Stadium",
    "homeId": 2429,
    "homeTeam": "Charlotte",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 24,
    "homeLineScores": [
      7,
      3,
      7,
      7
    ],
    "homePostgameWinProbability": 0.010981965757693606,
    "homePregameElo": 1182,
    "homePostgameElo": 1101,
    "awayId": 58,
    "awayTeam": "South Florida",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 59,
    "awayLineScores": [
      7,
      7,
      31,
      14
    ],
    "awayPostgameWinProbability": 0.9890180342423064,
    "awayPregameElo": 1339,
    "awayPostgameElo": 1420,
    "excitementIndex": 4.4247113788,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635517,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 18685,
    "venueId": 3940,
    "venue": "Stanford Stadium",
    "homeId": 24,
    "homeTeam": "Stanford",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 38,
    "homeLineScores": [
      10,
      3,
      8,
      17
    ],
    "homePostgameWinProbability": 0.5560877255633588,
    "homePregameElo": 1158,
    "homePostgameElo": 1168,
    "awayId": 97,
    "awayTeam": "Louisville",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 35,
    "awayLineScores": [
      7,
      14,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.44391227443664116,
    "awayPregameElo": 1725,
    "awayPostgameElo": 1715,
    "excitementIndex": 4.9982210658,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628985,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 77622,
    "venueId": 3855,
    "venue": "Notre Dame Stadium",
    "homeId": 87,
    "homeTeam": "Notre Dame",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 35,
    "homeLineScores": [
      7,
      21,
      7,
      0
    ],
    "homePostgameWinProbability": 0.9970737339138372,
    "homePregameElo": 2133,
    "homePostgameElo": 2115,
    "awayId": 258,
    "awayTeam": "Virginia",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.0029262660861627543,
    "awayPregameElo": 1381,
    "awayPostgameElo": 1399,
    "excitementIndex": 5.9709010393,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628420,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 90067,
    "venueId": 3634,
    "venue": "Ben Hill Griffin Stadium",
    "homeId": 57,
    "homeTeam": "Florida",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 27,
    "homeLineScores": [
      7,
      3,
      3,
      14
    ],
    "homePostgameWinProbability": 0.8552429166497523,
    "homePregameElo": 1598,
    "homePostgameElo": 1634,
    "awayId": 99,
    "awayTeam": "LSU",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 16,
    "awayLineScores": [
      0,
      10,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.14475708335024773,
    "awayPregameElo": 1800,
    "awayPostgameElo": 1764,
    "excitementIndex": 7.8136556145,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643757,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 21385,
    "venueId": 3713,
    "venue": "Falcon Stadium",
    "homeId": 2005,
    "homeTeam": "Air Force",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 28,
    "homeLineScores": [
      7,
      7,
      0,
      14
    ],
    "homePostgameWinProbability": 0.998945049341131,
    "homePregameElo": 1316,
    "homePostgameElo": 1406,
    "awayId": 204,
    "awayTeam": "Oregon State",
    "awayClassification": "fbs",
    "awayConference": "Pac-12",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0010549506588689583,
    "awayPregameElo": 1446,
    "awayPostgameElo": 1356,
    "excitementIndex": 3.907187339,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635580,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 34438,
    "venueId": 3735,
    "venue": "Gerald J. Ford Stadium",
    "homeId": 2567,
    "homeTeam": "SMU",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 38,
    "homeLineScores": [
      10,
      10,
      11,
      7
    ],
    "homePostgameWinProbability": 0.6933461738842422,
    "homePregameElo": 1814,
    "homePostgameElo": 1806,
    "awayId": 103,
    "awayTeam": "Boston College",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 28,
    "awayLineScores": [
      0,
      14,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.30665382611575775,
    "awayPregameElo": 1433,
    "awayPostgameElo": 1441,
    "excitementIndex": 7.8413553085,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628552,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 58346,
    "venueId": 3907,
    "venue": "Ross-Ade Stadium",
    "homeId": 2509,
    "homeTeam": "Purdue",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 10,
    "homeLineScores": [
      0,
      3,
      0,
      7
    ],
    "homePostgameWinProbability": 0.000837622019717758,
    "homePregameElo": 1192,
    "homePostgameElo": 1172,
    "awayId": 213,
    "awayTeam": "Penn State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 49,
    "awayLineScores": [
      14,
      7,
      21,
      7
    ],
    "awayPostgameWinProbability": 0.9991623779802823,
    "awayPregameElo": 1967,
    "awayPostgameElo": 1987,
    "excitementIndex": 1.8035917166,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636929,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 52376,
    "venueId": 3842,
    "venue": "Milan Puskar Stadium",
    "homeId": 277,
    "homeTeam": "West Virginia",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 35,
    "homeLineScores": [
      7,
      21,
      0,
      7
    ],
    "homePostgameWinProbability": 0.02505320784828458,
    "homePregameElo": 1561,
    "homePostgameElo": 1529,
    "awayId": 239,
    "awayTeam": "Baylor",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 49,
    "awayLineScores": [
      14,
      21,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.9749467921517154,
    "awayPregameElo": 1559,
    "awayPostgameElo": 1591,
    "excitementIndex": 5.2564139931,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643830,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 21762,
    "venueId": 3608,
    "venue": "Allen E. Paulson Stadium",
    "homeId": 290,
    "homeTeam": "Georgia Southern",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 20,
    "homeLineScores": [
      7,
      3,
      7,
      3
    ],
    "homePostgameWinProbability": 0.0011709459571212116,
    "homePregameElo": 1397,
    "homePostgameElo": 1386,
    "awayId": 2653,
    "awayTeam": "Troy",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 28,
    "awayLineScores": [
      0,
      7,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.9988290540428788,
    "awayPregameElo": 1455,
    "awayPostgameElo": 1466,
    "excitementIndex": 6.376703024,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643833,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 21984,
    "venueId": 3918,
    "venue": "S.B. Ballard Stadium",
    "homeId": 295,
    "homeTeam": "Old Dominion",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 32,
    "homeLineScores": [
      7,
      17,
      0,
      8
    ],
    "homePostgameWinProbability": 0.41225598505539546,
    "homePregameElo": 1472,
    "homePostgameElo": 1486,
    "awayId": 256,
    "awayTeam": "James Madison",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 35,
    "awayLineScores": [
      7,
      14,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.5877440149446045,
    "awayPregameElo": 1794,
    "awayPostgameElo": 1780,
    "excitementIndex": 8.3624957585,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628549,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 75304,
    "venueId": 477,
    "venue": "Los Angeles Memorial Coliseum",
    "homeId": 30,
    "homeTeam": "USC",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 28,
    "homeLineScores": [
      7,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.995826166219086,
    "homePregameElo": 1767,
    "homePostgameElo": 1761,
    "awayId": 158,
    "awayTeam": "Nebraska",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 20,
    "awayLineScores": [
      7,
      7,
      6,
      0
    ],
    "awayPostgameWinProbability": 0.00417383378091396,
    "awayPregameElo": 1453,
    "awayPostgameElo": 1459,
    "excitementIndex": 7.8481713683,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628423,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T21:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 79361,
    "venueId": 3994,
    "venue": "Williams-Brice Stadium",
    "homeId": 2579,
    "homeTeam": "South Carolina",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 34,
    "homeLineScores": [
      7,
      14,
      0,
      13
    ],
    "homePostgameWinProbability": 0.8032895830087494,
    "homePregameElo": 1829,
    "homePostgameElo": 1828,
    "awayId": 142,
    "awayTeam": "Missouri",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 30,
    "awayLineScores": [
      6,
      0,
      6,
      18
    ],
    "awayPostgameWinProbability": 0.19671041699125058,
    "awayPregameElo": 1683,
    "awayPostgameElo": 1684,
    "excitementIndex": 6.4487806706,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643831,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 14047,
    "venueId": 4246,
    "venue": "Center Parc Stadium",
    "homeId": 2247,
    "homeTeam": "Georgia State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 20,
    "homeLineScores": [
      7,
      0,
      7,
      6
    ],
    "homePostgameWinProbability": 0.04484336522551811,
    "homePregameElo": 1254,
    "homePostgameElo": 1238,
    "awayId": 2032,
    "awayTeam": "Arkansas State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 27,
    "awayLineScores": [
      7,
      0,
      10,
      10
    ],
    "awayPostgameWinProbability": 0.9551566347744819,
    "awayPregameElo": 1219,
    "awayPostgameElo": 1235,
    "excitementIndex": 6.9087473194,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628548,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-16T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 31433,
    "venueId": 3665,
    "venue": "SECU Stadium",
    "homeId": 120,
    "homeTeam": "Maryland",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 17,
    "homeLineScores": [
      3,
      7,
      7,
      0
    ],
    "homePostgameWinProbability": 0.009584806456856852,
    "homePregameElo": 1491,
    "homePostgameElo": 1453,
    "awayId": 164,
    "awayTeam": "Rutgers",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 31,
    "awayLineScores": [
      0,
      14,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.9904151935431431,
    "awayPregameElo": 1434,
    "awayPostgameElo": 1472,
    "excitementIndex": 5.5597463729,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643758,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-17T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20517,
    "venueId": 3935,
    "venue": "CEFCU Stadium",
    "homeId": 23,
    "homeTeam": "San Jos\u00e9 State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 21,
    "homeLineScores": [
      7,
      7,
      7,
      0
    ],
    "homePostgameWinProbability": 0.05683987582393824,
    "homePregameElo": 1518,
    "homePostgameElo": 1489,
    "awayId": 68,
    "awayTeam": "Boise State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 42,
    "awayLineScores": [
      0,
      14,
      14,
      14
    ],
    "awayPostgameWinProbability": 0.9431601241760618,
    "awayPregameElo": 1741,
    "awayPostgameElo": 1770,
    "excitementIndex": 4.6743704896,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643834,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-17T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16063,
    "venueId": 3666,
    "venue": "Cajun Field",
    "homeId": 309,
    "homeTeam": "Louisiana",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 22,
    "homeLineScores": [
      0,
      3,
      3,
      16
    ],
    "homePostgameWinProbability": 0.6575060217689207,
    "homePregameElo": 1621,
    "homePostgameElo": 1618,
    "awayId": 6,
    "awayTeam": "South Alabama",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      17,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.3424939782310793,
    "awayPregameElo": 1618,
    "awayPostgameElo": 1621,
    "excitementIndex": 3.6911164886,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643835,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-17T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 22618,
    "venueId": 3644,
    "venue": "Bobcat Stadium (TX)",
    "homeId": 326,
    "homeTeam": "Texas State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 58,
    "homeLineScores": [
      21,
      13,
      17,
      7
    ],
    "homePostgameWinProbability": 0.9989551735653182,
    "homePregameElo": 1602,
    "homePostgameElo": 1693,
    "awayId": 2572,
    "awayTeam": "Southern Miss",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0010448264346818448,
    "awayPregameElo": 1039,
    "awayPostgameElo": 948,
    "excitementIndex": 3.0177317569,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636927,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-17T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 51880,
    "venueId": 3636,
    "venue": "Bill Snyder Family Stadium",
    "homeId": 2306,
    "homeTeam": "Kansas State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 14,
    "homeLineScores": [
      0,
      0,
      6,
      8
    ],
    "homePostgameWinProbability": 0.16738662361819984,
    "homePregameElo": 1771,
    "homePostgameElo": 1731,
    "awayId": 9,
    "awayTeam": "Arizona State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      14,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.8326133763818002,
    "awayPregameElo": 1568,
    "awayPostgameElo": 1608,
    "excitementIndex": 2.8937242133,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628551,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-17T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 76298,
    "venueId": 347,
    "venue": "Camp Randall Stadium",
    "homeId": 275,
    "homeTeam": "Wisconsin",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 13,
    "homeLineScores": [
      0,
      10,
      3,
      0
    ],
    "homePostgameWinProbability": 0.1357708985729445,
    "homePregameElo": 1641,
    "homePostgameElo": 1659,
    "awayId": 2483,
    "awayTeam": "Oregon",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 16,
    "awayLineScores": [
      6,
      0,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.8642291014270556,
    "awayPregameElo": 2047,
    "awayPostgameElo": 2029,
    "excitementIndex": 9.1650230893,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628421,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-17T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 93033,
    "venueId": 3917,
    "venue": "Sanford Stadium",
    "homeId": 61,
    "homeTeam": "Georgia",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 31,
    "homeLineScores": [
      0,
      17,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9403962789332209,
    "homePregameElo": 2007,
    "homePostgameElo": 2029,
    "awayId": 2633,
    "awayTeam": "Tennessee",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 17,
    "awayLineScores": [
      10,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.059603721066779136,
    "awayPregameElo": 1930,
    "awayPostgameElo": 1908,
    "excitementIndex": 6.9384073058,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628424,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-17T00:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 105815,
    "venueId": 3795,
    "venue": "Kyle Field",
    "homeId": 245,
    "homeTeam": "Texas A&M",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 38,
    "homeLineScores": [
      17,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.998807050189291,
    "homePregameElo": 1746,
    "homePostgameElo": 1770,
    "awayId": 166,
    "awayTeam": "New Mexico State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      0,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.0011929498107090541,
    "awayPregameElo": 1121,
    "awayPostgameElo": 1097,
    "excitementIndex": 2.6871951399,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635583,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-17T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 48364,
    "venueId": 3787,
    "venue": "Kenan Stadium",
    "homeId": 153,
    "homeTeam": "North Carolina",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 31,
    "homeLineScores": [
      0,
      10,
      14,
      7
    ],
    "homePostgameWinProbability": 0.848101063189074,
    "homePregameElo": 1612,
    "homePostgameElo": 1608,
    "awayId": 154,
    "awayTeam": "Wake Forest",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 24,
    "awayLineScores": [
      3,
      0,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.15189893681092603,
    "awayPregameElo": 1353,
    "awayPostgameElo": 1357,
    "excitementIndex": 9.1776074687,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636926,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-17T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 52881,
    "venueId": 3772,
    "venue": "Jack Trice Stadium",
    "homeId": 66,
    "homeTeam": "Iowa State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 34,
    "homeLineScores": [
      7,
      3,
      10,
      14
    ],
    "homePostgameWinProbability": 0.37561146084741104,
    "homePregameElo": 1728,
    "homePostgameElo": 1746,
    "awayId": 2132,
    "awayTeam": "Cincinnati",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 17,
    "awayLineScores": [
      7,
      3,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.624388539152589,
    "awayPregameElo": 1524,
    "awayPostgameElo": 1506,
    "excitementIndex": 7.617443607,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645367,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-17T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 24225,
    "venueId": 3805,
    "venue": "Simmons Bank Liberty Stadium",
    "homeId": 235,
    "homeTeam": "Memphis",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 53,
    "homeLineScores": [
      11,
      7,
      7,
      28
    ],
    "homePostgameWinProbability": 0.9984351077215874,
    "homePregameElo": 1569,
    "homePostgameElo": 1621,
    "awayId": 5,
    "awayTeam": "UAB",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 18,
    "awayLineScores": [
      0,
      8,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.0015648922784126107,
    "awayPregameElo": 1197,
    "awayPostgameElo": 1145,
    "excitementIndex": 4.4424370493,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643761,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-17T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 14067,
    "venueId": 3971,
    "venue": "University Stadium (NM)",
    "homeId": 167,
    "homeTeam": "New Mexico",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 38,
    "homeLineScores": [
      7,
      7,
      14,
      10
    ],
    "homePostgameWinProbability": 0.38932960123114607,
    "homePregameElo": 1263,
    "homePostgameElo": 1269,
    "awayId": 265,
    "awayTeam": "Washington State",
    "awayClassification": "fbs",
    "awayConference": "Pac-12",
    "awayPoints": 35,
    "awayLineScores": [
      14,
      14,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.610670398768854,
    "awayPregameElo": 1606,
    "awayPostgameElo": 1600,
    "excitementIndex": 8.4413070753,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636924,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-17T03:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 62704,
    "venueId": 3801,
    "venue": "LaVell Edwards Stadium",
    "homeId": 252,
    "homeTeam": "BYU",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 13,
    "homeLineScores": [
      0,
      10,
      3,
      0
    ],
    "homePostgameWinProbability": 0.16761438578764792,
    "homePregameElo": 1674,
    "homePostgameElo": 1667,
    "awayId": 2305,
    "awayTeam": "Kansas",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 17,
    "awayLineScores": [
      7,
      3,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.832385614212352,
    "awayPregameElo": 1664,
    "awayPostgameElo": 1671,
    "excitementIndex": 4.8504609167,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643762,
    "season": 2024,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2024-11-17T03:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 30386,
    "venueId": 6501,
    "venue": "Allegiant Stadium",
    "homeId": 2439,
    "homeTeam": "UNLV",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 41,
    "homeLineScores": [
      7,
      21,
      10,
      3
    ],
    "homePostgameWinProbability": 0.9493838644492044,
    "homePregameElo": 1650,
    "homePostgameElo": 1665,
    "awayId": 21,
    "awayTeam": "San Diego State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      6,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.05061613555079558,
    "awayPregameElo": 1298,
    "awayPostgameElo": 1283,
    "excitementIndex": 3.2116589972,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644769,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-20T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 6768,
    "venueId": 3696,
    "venue": "Dix Stadium",
    "homeId": 2309,
    "homeTeam": "Kent State",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 17,
    "homeLineScores": [
      7,
      3,
      0,
      7
    ],
    "homePostgameWinProbability": 0.08535054685631888,
    "homePregameElo": 835,
    "homePostgameElo": 805,
    "awayId": 2006,
    "awayTeam": "Akron",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 38,
    "awayLineScores": [
      10,
      13,
      15,
      0
    ],
    "awayPostgameWinProbability": 0.9146494531436811,
    "awayPregameElo": 1055,
    "awayPostgameElo": 1085,
    "excitementIndex": 2.9314566807,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644770,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-20T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 13102,
    "venueId": 3786,
    "venue": "Kelly/Shorts Stadium",
    "homeId": 2117,
    "homeTeam": "Central Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 16,
    "homeLineScores": [
      7,
      6,
      0,
      3
    ],
    "homePostgameWinProbability": 0.9359869054029619,
    "homePregameElo": 1091,
    "homePostgameElo": 1094,
    "awayId": 2711,
    "awayTeam": "Western Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.06401309459703808,
    "awayPregameElo": 1249,
    "awayPostgameElo": 1246,
    "excitementIndex": 7.6227191691,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644690,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-20T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 5891,
    "venueId": 3996,
    "venue": "Yager Stadium",
    "homeId": 193,
    "homeTeam": "Miami (OH)",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 20,
    "homeLineScores": [
      7,
      10,
      0,
      3
    ],
    "homePostgameWinProbability": 0.8467448377644089,
    "homePregameElo": 1544,
    "homePostgameElo": 1558,
    "awayId": 2459,
    "awayTeam": "Northern Illinois",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 9,
    "awayLineScores": [
      0,
      3,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.1532551622355911,
    "awayPregameElo": 1464,
    "awayPostgameElo": 1450,
    "excitementIndex": 5.0882015895,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644773,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-21T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 14543,
    "venueId": 3739,
    "venue": "Glass Bowl",
    "homeId": 2649,
    "homeTeam": "Toledo",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 7,
    "homeLineScores": [
      0,
      7,
      0,
      0
    ],
    "homePostgameWinProbability": 0.09089421557767635,
    "homePregameElo": 1495,
    "homePostgameElo": 1459,
    "awayId": 195,
    "awayTeam": "Ohio",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 24,
    "awayLineScores": [
      0,
      0,
      7,
      17
    ],
    "awayPostgameWinProbability": 0.9091057844223236,
    "awayPregameElo": 1546,
    "awayPostgameElo": 1582,
    "excitementIndex": 5.8681395512,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644772,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-21T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 12004,
    "venueId": 3912,
    "venue": "Rynearson Stadium",
    "homeId": 2199,
    "homeTeam": "Eastern Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 20,
    "homeLineScores": [
      0,
      0,
      13,
      7
    ],
    "homePostgameWinProbability": 0.23655525915298456,
    "homePregameElo": 1225,
    "homePostgameElo": 1183,
    "awayId": 2084,
    "awayTeam": "Buffalo",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 37,
    "awayLineScores": [
      8,
      9,
      6,
      14
    ],
    "awayPostgameWinProbability": 0.7634447408470154,
    "awayPregameElo": 1217,
    "awayPostgameElo": 1259,
    "excitementIndex": 3.3164404777,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401634772,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-22T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 34591,
    "venueId": 721,
    "venue": "Bobby Dodd Stadium",
    "homeId": 59,
    "homeTeam": "Georgia Tech",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 30,
    "homeLineScores": [
      7,
      6,
      3,
      14
    ],
    "homePostgameWinProbability": 0.5960285342364573,
    "homePregameElo": 1577,
    "homePostgameElo": 1575,
    "awayId": 152,
    "awayTeam": "NC State",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 29,
    "awayLineScores": [
      7,
      0,
      0,
      22
    ],
    "awayPostgameWinProbability": 0.4039714657635427,
    "awayPregameElo": 1499,
    "awayPostgameElo": 1501,
    "excitementIndex": 7.9663405124,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645374,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20121,
    "venueId": 3604,
    "venue": "Alamodome",
    "homeId": 2636,
    "homeTeam": "UTSA",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 51,
    "homeLineScores": [
      7,
      21,
      10,
      13
    ],
    "homePostgameWinProbability": 0.9982099081136507,
    "homePregameElo": 1463,
    "homePostgameElo": 1479,
    "awayId": 218,
    "awayTeam": "Temple",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 27,
    "awayLineScores": [
      3,
      14,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.0017900918863492654,
    "awayPregameElo": 1042,
    "awayPostgameElo": 1026,
    "excitementIndex": 4.875712441,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628558,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 57558,
    "venueId": 3936,
    "venue": "Spartan Stadium",
    "homeId": 127,
    "homeTeam": "Michigan State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 24,
    "homeLineScores": [
      7,
      17,
      0,
      0
    ],
    "homePostgameWinProbability": 0.6159163024647112,
    "homePregameElo": 1365,
    "homePostgameElo": 1364,
    "awayId": 2509,
    "awayTeam": "Purdue",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 17,
    "awayLineScores": [
      3,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.3840836975352888,
    "awayPregameElo": 1172,
    "awayPostgameElo": 1173,
    "excitementIndex": 5.7660290117,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643767,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T03:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 13671,
    "venueId": 3935,
    "venue": "CEFCU Stadium",
    "homeId": 23,
    "homeTeam": "San Jos\u00e9 State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 16,
    "homeLineScores": [
      0,
      16,
      0,
      0
    ],
    "homePostgameWinProbability": 0.01981939901137126,
    "homePregameElo": 1489,
    "homePostgameElo": 1481,
    "awayId": 2439,
    "awayTeam": "UNLV",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 27,
    "awayLineScores": [
      3,
      7,
      10,
      7
    ],
    "awayPostgameWinProbability": 0.9801806009886287,
    "awayPregameElo": 1665,
    "awayPostgameElo": 1673,
    "excitementIndex": 6.9363993185,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635612,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 37801,
    "venueId": 3615,
    "venue": "Alumni Stadium (Chestnut Hill, MA)",
    "homeId": 103,
    "homeTeam": "Boston College",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 41,
    "homeLineScores": [
      3,
      21,
      3,
      14
    ],
    "homePostgameWinProbability": 0.9970125994666024,
    "homePregameElo": 1441,
    "homePostgameElo": 1506,
    "awayId": 153,
    "awayTeam": "North Carolina",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      7,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.002987400533397633,
    "awayPregameElo": 1608,
    "awayPostgameElo": 1543,
    "excitementIndex": 4.4230952661,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635518,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 35453,
    "venueId": 1964,
    "venue": "JMA Wireless Dome",
    "homeId": 183,
    "homeTeam": "Syracuse",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 31,
    "homeLineScores": [
      7,
      14,
      3,
      7
    ],
    "homePostgameWinProbability": 0.9947143910183219,
    "homePregameElo": 1425,
    "homePostgameElo": 1434,
    "awayId": 41,
    "awayTeam": "UConn",
    "awayClassification": "fbs",
    "awayConference": "FBS Independents",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      7,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.005285608981678069,
    "awayPregameElo": 1423,
    "awayPostgameElo": 1414,
    "excitementIndex": 6.3584075537,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635619,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 36305,
    "venueId": 3923,
    "venue": "Scott Stadium",
    "homeId": 258,
    "homeTeam": "Virginia",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 7,
    "homeLineScores": [
      0,
      0,
      0,
      7
    ],
    "homePostgameWinProbability": 0.0005945321856068563,
    "homePregameElo": 1399,
    "homePostgameElo": 1375,
    "awayId": 2567,
    "awayTeam": "SMU",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 33,
    "awayLineScores": [
      7,
      10,
      3,
      13
    ],
    "awayPostgameWinProbability": 0.9994054678143931,
    "awayPregameElo": 1806,
    "awayPostgameElo": 1830,
    "excitementIndex": 2.5273731561,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635618,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 64210,
    "venueId": 3948,
    "venue": "Hard Rock Stadium",
    "homeId": 2390,
    "homeTeam": "Miami",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 42,
    "homeLineScores": [
      10,
      10,
      0,
      22
    ],
    "homePostgameWinProbability": 0.9988990788133469,
    "homePregameElo": 1858,
    "homePostgameElo": 1877,
    "awayId": 154,
    "awayTeam": "Wake Forest",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 14,
    "awayLineScores": [
      7,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0011009211866530588,
    "awayPregameElo": 1357,
    "awayPostgameElo": 1338,
    "excitementIndex": 7.4806055202,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628556,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 30214,
    "venueId": 3665,
    "venue": "SECU Stadium",
    "homeId": 120,
    "homeTeam": "Maryland",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 13,
    "homeLineScores": [
      0,
      0,
      6,
      7
    ],
    "homePostgameWinProbability": 0.04890251986657082,
    "homePregameElo": 1453,
    "homePostgameElo": 1447,
    "awayId": 2294,
    "awayTeam": "Iowa",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 29,
    "awayLineScores": [
      3,
      10,
      6,
      10
    ],
    "awayPostgameWinProbability": 0.9510974801334292,
    "awayPregameElo": 1780,
    "awayPostgameElo": 1786,
    "excitementIndex": 3.935895694,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628554,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 47524,
    "venueId": 6577,
    "venue": "SHI Stadium",
    "homeId": 164,
    "homeTeam": "Rutgers",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 31,
    "homeLineScores": [
      3,
      14,
      0,
      14
    ],
    "homePostgameWinProbability": 0.22714076645233058,
    "homePregameElo": 1472,
    "homePostgameElo": 1468,
    "awayId": 356,
    "awayTeam": "Illinois",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 38,
    "awayLineScores": [
      0,
      9,
      6,
      23
    ],
    "awayPostgameWinProbability": 0.7728592335476694,
    "awayPregameElo": 1593,
    "awayPostgameElo": 1597,
    "excitementIndex": 9.5060148834,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628429,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 89942,
    "venueId": 3634,
    "venue": "Ben Hill Griffin Stadium",
    "homeId": 57,
    "homeTeam": "Florida",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 24,
    "homeLineScores": [
      0,
      14,
      3,
      7
    ],
    "homePostgameWinProbability": 0.9088706931211737,
    "homePregameElo": 1634,
    "homePostgameElo": 1667,
    "awayId": 145,
    "awayTeam": "Ole Miss",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      14,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.09112930687882626,
    "awayPregameElo": 2010,
    "awayPostgameElo": 1977,
    "excitementIndex": 8.5089973208,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641005,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16312,
    "venueId": 3662,
    "venue": "AmFirst Stadium",
    "homeId": 55,
    "homeTeam": "Jacksonville State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 21,
    "homeLineScores": [
      7,
      7,
      0,
      7
    ],
    "homePostgameWinProbability": 0.9851385956019506,
    "homePregameElo": 1640,
    "homePostgameElo": 1641,
    "awayId": 2534,
    "awayTeam": "Sam Houston",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 11,
    "awayLineScores": [
      0,
      3,
      8,
      0
    ],
    "awayPostgameWinProbability": 0.014861404398049394,
    "awayPregameElo": 1413,
    "awayPostgameElo": 1412,
    "excitementIndex": 5.6381419293,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628555,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 105751,
    "venueId": 3861,
    "venue": "Ohio Stadium",
    "homeId": 194,
    "homeTeam": "Ohio State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 38,
    "homeLineScores": [
      0,
      14,
      14,
      10
    ],
    "homePostgameWinProbability": 0.9943035860926716,
    "homePregameElo": 2086,
    "homePostgameElo": 2120,
    "awayId": 84,
    "awayTeam": "Indiana",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 15,
    "awayLineScores": [
      7,
      0,
      0,
      8
    ],
    "awayPostgameWinProbability": 0.005696413907328446,
    "awayPregameElo": 1876,
    "awayPostgameElo": 1842,
    "excitementIndex": 3.6017334987,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628430,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T17:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 93033,
    "venueId": 3917,
    "venue": "Sanford Stadium",
    "homeId": 61,
    "homeTeam": "Georgia",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 59,
    "homeLineScores": [
      7,
      21,
      17,
      14
    ],
    "homePostgameWinProbability": 0.833138177677892,
    "homePregameElo": 2029,
    "homePostgameElo": 2023,
    "awayId": 113,
    "awayTeam": "Massachusetts",
    "awayClassification": "fbs",
    "awayConference": "FBS Independents",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      7,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.166861822322108,
    "awayPregameElo": 1017,
    "awayPostgameElo": 1023,
    "excitementIndex": 3.4536139842,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628435,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 101915,
    "venueId": 3853,
    "venue": "Neyland Stadium",
    "homeId": 2633,
    "homeTeam": "Tennessee",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 56,
    "homeLineScores": [
      0,
      28,
      21,
      7
    ],
    "homePostgameWinProbability": 0.9986035506607549,
    "homePregameElo": 1908,
    "homePostgameElo": 1979,
    "awayId": 2638,
    "awayTeam": "UTEP",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0013964493392450983,
    "awayPregameElo": 1165,
    "awayPostgameElo": 1094,
    "excitementIndex": 5.7425869558,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401640996,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 17930,
    "venueId": 3992,
    "venue": "Williams Stadium (VA)",
    "homeId": 2335,
    "homeTeam": "Liberty",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 38,
    "homeLineScores": [
      0,
      21,
      7,
      10
    ],
    "homePostgameWinProbability": 0.9980392195185619,
    "homePregameElo": 1545,
    "homePostgameElo": 1576,
    "awayId": 98,
    "awayTeam": "Western Kentucky",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      7,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.001960780481438107,
    "awayPregameElo": 1482,
    "awayPostgameElo": 1451,
    "excitementIndex": 6.9397913966,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635616,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T18:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 43711,
    "venueId": 3697,
    "venue": "Doak Campbell Stadium",
    "homeId": 52,
    "homeTeam": "Florida State",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 41,
    "homeLineScores": [
      0,
      17,
      14,
      10
    ],
    "homePostgameWinProbability": 0.9988011823371064,
    "homePregameElo": 1353,
    "homePostgameElo": 1353,
    "awayId": 2127,
    "awayTeam": "Charleston Southern",
    "awayClassification": "fcs",
    "awayConference": "Big South-OVC",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.0011988176628936476,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.3942707608,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645373,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16181,
    "venueId": 7221,
    "venue": "Protective Stadium",
    "homeId": 5,
    "homeTeam": "UAB",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 40,
    "homeLineScores": [
      14,
      13,
      0,
      13
    ],
    "homePostgameWinProbability": 0.998814359056721,
    "homePregameElo": 1145,
    "homePostgameElo": 1231,
    "awayId": 242,
    "awayTeam": "Rice",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 14,
    "awayLineScores": [
      14,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0011856409432789983,
    "awayPregameElo": 1301,
    "awayPostgameElo": 1215,
    "excitementIndex": 5.3822916934,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644774,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 7116,
    "venueId": 3919,
    "venue": "Scheumann Stadium",
    "homeId": 2050,
    "homeTeam": "Ball State",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 13,
    "homeLineScores": [
      0,
      7,
      0,
      6
    ],
    "homePostgameWinProbability": 0.005146142392136814,
    "homePregameElo": 1115,
    "homePostgameElo": 1089,
    "awayId": 189,
    "awayTeam": "Bowling Green",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 38,
    "awayLineScores": [
      7,
      3,
      18,
      10
    ],
    "awayPostgameWinProbability": 0.9948538576078632,
    "awayPregameElo": 1472,
    "awayPostgameElo": 1498,
    "excitementIndex": 3.6784536429,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643836,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 34012,
    "venueId": 3792,
    "venue": "Kidd Brewer Stadium",
    "homeId": 2026,
    "homeTeam": "App State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 34,
    "homeLineScores": [
      0,
      24,
      7,
      3
    ],
    "homePostgameWinProbability": 0.9597617954496301,
    "homePregameElo": 1332,
    "homePostgameElo": 1405,
    "awayId": 256,
    "awayTeam": "James Madison",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 20,
    "awayLineScores": [
      7,
      10,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.04023820455036986,
    "awayPregameElo": 1780,
    "awayPostgameElo": 1707,
    "excitementIndex": 6.1415880256,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641027,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 10123,
    "venueId": 3725,
    "venue": "Johnny \"Red\" Floyd Stadium",
    "homeId": 2393,
    "homeTeam": "Middle Tennessee",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 21,
    "homeLineScores": [
      0,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.028019728992069188,
    "homePregameElo": 1144,
    "homePostgameElo": 1104,
    "awayId": 166,
    "awayTeam": "New Mexico State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 36,
    "awayLineScores": [
      10,
      3,
      13,
      10
    ],
    "awayPostgameWinProbability": 0.9719802710079308,
    "awayPregameElo": 1097,
    "awayPostgameElo": 1137,
    "excitementIndex": 4.8354313983,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643841,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20074,
    "venueId": 3815,
    "venue": "M. M. Roberts Stadium",
    "homeId": 2572,
    "homeTeam": "Southern Miss",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 14,
    "homeLineScores": [
      8,
      3,
      0,
      3
    ],
    "homePostgameWinProbability": 0.0007325958791700735,
    "homePregameElo": 948,
    "homePostgameElo": 961,
    "awayId": 6,
    "awayTeam": "South Alabama",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 35,
    "awayLineScores": [
      0,
      14,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.9992674041208299,
    "awayPregameElo": 1621,
    "awayPostgameElo": 1608,
    "excitementIndex": 4.3223525767,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645371,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 15066,
    "venueId": 3715,
    "venue": "FAU Stadium",
    "homeId": 2226,
    "homeTeam": "Florida Atlantic",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 27,
    "homeLineScores": [
      3,
      7,
      10,
      7
    ],
    "homePostgameWinProbability": 0.7874519151169872,
    "homePregameElo": 1123,
    "homePostgameElo": 1095,
    "awayId": 2429,
    "awayTeam": "Charlotte",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 39,
    "awayLineScores": [
      10,
      6,
      10,
      13
    ],
    "awayPostgameWinProbability": 0.2125480848830128,
    "awayPregameElo": 1101,
    "awayPostgameElo": 1129,
    "excitementIndex": 6.210340242,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636935,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 42977,
    "venueId": 3616,
    "venue": "Amon G. Carter Stadium",
    "homeId": 2628,
    "homeTeam": "TCU",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 49,
    "homeLineScores": [
      14,
      7,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9897123020256314,
    "homePregameElo": 1578,
    "homePostgameElo": 1614,
    "awayId": 12,
    "awayTeam": "Arizona",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 28,
    "awayLineScores": [
      7,
      6,
      0,
      15
    ],
    "awayPostgameWinProbability": 0.01028769797436857,
    "awayPregameElo": 1440,
    "awayPostgameElo": 1404,
    "excitementIndex": 4.7549952564,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643839,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 14029,
    "venueId": 3625,
    "venue": "Centennial Bank Stadium",
    "homeId": 2032,
    "homeTeam": "Arkansas State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 28,
    "homeLineScores": [
      7,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.7236342121276668,
    "homePregameElo": 1235,
    "homePostgameElo": 1241,
    "awayId": 2433,
    "awayTeam": "UL Monroe",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.27636578787233324,
    "awayPregameElo": 1166,
    "awayPostgameElo": 1160,
    "excitementIndex": 6.5147873776,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401640987,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 6210,
    "venueId": 4899,
    "venue": "Fifth Third Stadium",
    "homeId": 338,
    "homeTeam": "Kennesaw State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 27,
    "homeLineScores": [
      3,
      14,
      0,
      10
    ],
    "homePostgameWinProbability": 0.18940278006243344,
    "homePregameElo": 1230,
    "homePostgameElo": 1233,
    "awayId": 2229,
    "awayTeam": "Florida International",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 26,
    "awayLineScores": [
      0,
      20,
      6,
      0
    ],
    "awayPostgameWinProbability": 0.8105972199375666,
    "awayPregameElo": 1300,
    "awayPostgameElo": 1297,
    "excitementIndex": 7.7000071702,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628559,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 44266,
    "venueId": 3953,
    "venue": "Huntington Bank Stadium",
    "homeId": 135,
    "homeTeam": "Minnesota",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 25,
    "homeLineScores": [
      7,
      12,
      3,
      3
    ],
    "homePostgameWinProbability": 0.3936757829996285,
    "homePregameElo": 1590,
    "homePostgameElo": 1606,
    "awayId": 213,
    "awayTeam": "Penn State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 26,
    "awayLineScores": [
      0,
      16,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.6063242170003715,
    "awayPregameElo": 1987,
    "awayPostgameElo": 1971,
    "excitementIndex": 5.9747051446,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636934,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 52202,
    "venueId": 3646,
    "venue": "Boone Pickens Stadium",
    "homeId": 197,
    "homeTeam": "Oklahoma State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 48,
    "homeLineScores": [
      7,
      7,
      14,
      20
    ],
    "homePostgameWinProbability": 0.37191522066444943,
    "homePregameElo": 1375,
    "homePostgameElo": 1372,
    "awayId": 2641,
    "awayTeam": "Texas Tech",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 56,
    "awayLineScores": [
      14,
      7,
      14,
      21
    ],
    "awayPostgameWinProbability": 0.6280847793355506,
    "awayPregameElo": 1537,
    "awayPostgameElo": 1540,
    "excitementIndex": 7.5014400752,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636937,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 40722,
    "venueId": 3842,
    "venue": "Milan Puskar Stadium",
    "homeId": 277,
    "homeTeam": "West Virginia",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 31,
    "homeLineScores": [
      14,
      7,
      7,
      3
    ],
    "homePostgameWinProbability": 0.3870661633047699,
    "homePregameElo": 1529,
    "homePostgameElo": 1553,
    "awayId": 2116,
    "awayTeam": "UCF",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.6129338366952302,
    "awayPregameElo": 1620,
    "awayPostgameElo": 1596,
    "excitementIndex": 4.4217794942,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628436,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 102811,
    "venueId": 3910,
    "venue": "DKR-Texas Memorial Stadium",
    "homeId": 251,
    "homeTeam": "Texas",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 31,
    "homeLineScores": [
      7,
      17,
      0,
      7
    ],
    "homePostgameWinProbability": 0.9965531842080707,
    "homePregameElo": 2071,
    "homePostgameElo": 2063,
    "awayId": 96,
    "awayTeam": "Kentucky",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      7,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.003446815791929292,
    "awayPregameElo": 1537,
    "awayPostgameElo": 1545,
    "excitementIndex": 5.0504497603,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628557,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 109830,
    "venueId": 3558,
    "venue": "Michigan Stadium",
    "homeId": 130,
    "homeTeam": "Michigan",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 50,
    "homeLineScores": [
      10,
      7,
      14,
      19
    ],
    "homePostgameWinProbability": 0.9975037396874484,
    "homePregameElo": 1777,
    "homePostgameElo": 1867,
    "awayId": 77,
    "awayTeam": "Northwestern",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 6,
    "awayLineScores": [
      0,
      6,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.002496260312551568,
    "awayPregameElo": 1486,
    "awayPostgameElo": 1396,
    "excitementIndex": 3.4773768545,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635613,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 52428,
    "venueId": 3831,
    "venue": "California Memorial Stadium",
    "homeId": 25,
    "homeTeam": "California",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 24,
    "homeLineScores": [
      0,
      7,
      3,
      14
    ],
    "homePostgameWinProbability": 0.8187295997031043,
    "homePregameElo": 1610,
    "homePostgameElo": 1606,
    "awayId": 24,
    "awayTeam": "Stanford",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 21,
    "awayLineScores": [
      14,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.18127040029689567,
    "awayPregameElo": 1168,
    "awayPostgameElo": 1172,
    "excitementIndex": 4.8024372895,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643837,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 14556,
    "venueId": 3654,
    "venue": "Brooks Stadium (SC)",
    "homeId": 324,
    "homeTeam": "Coastal Carolina",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 6,
    "homeLineScores": [
      3,
      0,
      3,
      0
    ],
    "homePostgameWinProbability": 0.031203776914788393,
    "homePregameElo": 1386,
    "homePostgameElo": 1335,
    "awayId": 290,
    "awayTeam": "Georgia Southern",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 26,
    "awayLineScores": [
      10,
      3,
      0,
      13
    ],
    "awayPostgameWinProbability": 0.9687962230852116,
    "awayPregameElo": 1386,
    "awayPostgameElo": 1437,
    "excitementIndex": 5.1594818848,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635614,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 80300,
    "venueId": 3836,
    "venue": "Memorial Stadium (Clemson, SC)",
    "homeId": 228,
    "homeTeam": "Clemson",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 51,
    "homeLineScores": [
      14,
      21,
      10,
      6
    ],
    "homePostgameWinProbability": 0.9989669468883322,
    "homePregameElo": 1824,
    "homePostgameElo": 1824,
    "awayId": 2643,
    "awayTeam": "The Citadel",
    "awayClassification": "fcs",
    "awayConference": "Southern",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.0010330531116677921,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.4320682979,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636930,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 55400,
    "venueId": 3947,
    "venue": "Mountain America Stadium",
    "homeId": 9,
    "homeTeam": "Arizona State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 28,
    "homeLineScores": [
      7,
      14,
      7,
      0
    ],
    "homePostgameWinProbability": 0.8767034844197439,
    "homePregameElo": 1608,
    "homePostgameElo": 1615,
    "awayId": 252,
    "awayTeam": "BYU",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 23,
    "awayLineScores": [
      0,
      3,
      14,
      6
    ],
    "awayPostgameWinProbability": 0.12329651558025612,
    "awayPregameElo": 1667,
    "awayPostgameElo": 1660,
    "excitementIndex": 5.3435381132,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636932,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 56470,
    "venueId": 3622,
    "venue": "GEHA Field at Arrowhead Stadium",
    "homeId": 2305,
    "homeTeam": "Kansas",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 37,
    "homeLineScores": [
      10,
      13,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9969567747278307,
    "homePregameElo": 1671,
    "homePostgameElo": 1714,
    "awayId": 38,
    "awayTeam": "Colorado",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      14,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.00304322527216927,
    "awayPregameElo": 1684,
    "awayPostgameElo": 1641,
    "excitementIndex": 5.0171919651,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645375,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 27623,
    "venueId": 3886,
    "venue": "Raymond James Stadium",
    "homeId": 58,
    "homeTeam": "South Florida",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 63,
    "homeLineScores": [
      28,
      14,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9989188929407493,
    "homePregameElo": 1420,
    "homePostgameElo": 1457,
    "awayId": 202,
    "awayTeam": "Tulsa",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 30,
    "awayLineScores": [
      0,
      7,
      0,
      23
    ],
    "awayPostgameWinProbability": 0.0010811070592506855,
    "awayPregameElo": 971,
    "awayPostgameElo": 934,
    "excitementIndex": 2.5536432679,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643766,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 12583,
    "venueId": 3905,
    "venue": "Maverik Stadium",
    "homeId": 328,
    "homeTeam": "Utah State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 41,
    "homeLineScores": [
      0,
      14,
      7,
      20
    ],
    "homePostgameWinProbability": 0.9985195200770841,
    "homePregameElo": 1321,
    "homePostgameElo": 1367,
    "awayId": 21,
    "awayTeam": "San Diego State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 20,
    "awayLineScores": [
      3,
      10,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.0014804799229158894,
    "awayPregameElo": 1283,
    "awayPostgameElo": 1237,
    "excitementIndex": 6.1729697376,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628560,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 86923,
    "venueId": 3834,
    "venue": "Memorial Stadium (Lincoln, NE)",
    "homeId": 158,
    "homeTeam": "Nebraska",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 44,
    "homeLineScores": [
      7,
      17,
      10,
      10
    ],
    "homePostgameWinProbability": 0.8939495444892308,
    "homePregameElo": 1459,
    "homePostgameElo": 1524,
    "awayId": 275,
    "awayTeam": "Wisconsin",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 25,
    "awayLineScores": [
      7,
      3,
      7,
      8
    ],
    "awayPostgameWinProbability": 0.10605045551076919,
    "awayPregameElo": 1659,
    "awayPostgameElo": 1594,
    "excitementIndex": 4.201190015,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645372,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 17387,
    "venueId": 3825,
    "venue": "DATCU Stadium",
    "homeId": 249,
    "homeTeam": "North Texas",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 28,
    "homeLineScores": [
      14,
      7,
      7,
      0
    ],
    "homePostgameWinProbability": 0.06481296643458724,
    "homePregameElo": 1400,
    "homePostgameElo": 1373,
    "awayId": 151,
    "awayTeam": "East Carolina",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 40,
    "awayLineScores": [
      0,
      7,
      24,
      9
    ],
    "awayPostgameWinProbability": 0.9351870335654128,
    "awayPregameElo": 1391,
    "awayPostgameElo": 1418,
    "excitementIndex": 5.8323354016,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635617,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 49441,
    "venueId": 3873,
    "venue": "L&N Federal Credit Union Stadium",
    "homeId": 97,
    "homeTeam": "Louisville",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 37,
    "homeLineScores": [
      10,
      17,
      10,
      0
    ],
    "homePostgameWinProbability": 0.9986454166487777,
    "homePregameElo": 1715,
    "homePostgameElo": 1767,
    "awayId": 221,
    "awayTeam": "Pittsburgh",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 9,
    "awayLineScores": [
      0,
      0,
      7,
      2
    ],
    "awayPostgameWinProbability": 0.0013545833512222938,
    "awayPregameElo": 1531,
    "awayPostgameElo": 1479,
    "excitementIndex": 3.162664048,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628434,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 79078,
    "venueId": 3994,
    "venue": "Williams-Brice Stadium",
    "homeId": 2579,
    "homeTeam": "South Carolina",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 56,
    "homeLineScores": [
      7,
      14,
      14,
      21
    ],
    "homePostgameWinProbability": 0.9988939582781906,
    "homePregameElo": 1827,
    "homePostgameElo": 1827,
    "awayId": 2747,
    "awayTeam": "Wofford",
    "awayClassification": "fcs",
    "awayConference": "Southern",
    "awayPoints": 12,
    "awayLineScores": [
      3,
      6,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.001106041721809392,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 5.0921718838,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628427,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 66041,
    "venueId": 3887,
    "venue": "Razorback Stadium",
    "homeId": 8,
    "homeTeam": "Arkansas",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 35,
    "homeLineScores": [
      0,
      14,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9978082504753316,
    "homePregameElo": 1547,
    "homePostgameElo": 1574,
    "awayId": 2348,
    "awayTeam": "Louisiana Tech",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.002191749524668385,
    "awayPregameElo": 1321,
    "awayPostgameElo": 1294,
    "excitementIndex": 6.40634552,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628432,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T21:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 47824,
    "venueId": 3693,
    "venue": "Davis Wade Stadium",
    "homeId": 344,
    "homeTeam": "Mississippi State",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 20,
    "homeLineScores": [
      10,
      3,
      7,
      0
    ],
    "homePostgameWinProbability": 0.0008143081951796834,
    "homePregameElo": 1362,
    "homePostgameElo": 1348,
    "awayId": 142,
    "awayTeam": "Missouri",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 39,
    "awayLineScores": [
      14,
      14,
      3,
      8
    ],
    "awayPostgameWinProbability": 0.9991856918048203,
    "awayPregameElo": 1684,
    "awayPostgameElo": 1698,
    "excitementIndex": 3.4778164696,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643840,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-23T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 15501,
    "venueId": 3666,
    "venue": "Cajun Field",
    "homeId": 309,
    "homeTeam": "Louisiana",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 51,
    "homeLineScores": [
      7,
      27,
      3,
      14
    ],
    "homePostgameWinProbability": 0.9356443974601732,
    "homePregameElo": 1618,
    "homePostgameElo": 1652,
    "awayId": 2653,
    "awayTeam": "Troy",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 30,
    "awayLineScores": [
      14,
      0,
      8,
      8
    ],
    "awayPostgameWinProbability": 0.06435560253982675,
    "awayPregameElo": 1466,
    "awayPostgameElo": 1432,
    "excitementIndex": 4.729033844,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643764,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-24T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 18094,
    "venueId": 3984,
    "venue": "War Memorial Stadium",
    "homeId": 2751,
    "homeTeam": "Wyoming",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 13,
    "homeLineScores": [
      3,
      7,
      0,
      3
    ],
    "homePostgameWinProbability": 0.7212125149793001,
    "homePregameElo": 1260,
    "homePostgameElo": 1283,
    "awayId": 68,
    "awayTeam": "Boise State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 17,
    "awayLineScores": [
      7,
      3,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.27878748502069994,
    "awayPregameElo": 1770,
    "awayPostgameElo": 1747,
    "excitementIndex": 7.5855508451,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628572,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-24T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 38008,
    "venueId": 3893,
    "venue": "Reser Stadium",
    "homeId": 204,
    "homeTeam": "Oregon State",
    "homeClassification": "fbs",
    "homeConference": "Pac-12",
    "homePoints": 41,
    "homeLineScores": [
      7,
      14,
      10,
      10
    ],
    "homePostgameWinProbability": 0.27376107445477166,
    "homePregameElo": 1356,
    "homePostgameElo": 1360,
    "awayId": 265,
    "awayTeam": "Washington State",
    "awayClassification": "fbs",
    "awayConference": "Pac-12",
    "awayPoints": 38,
    "awayLineScores": [
      7,
      10,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.7262389255452284,
    "awayPregameElo": 1600,
    "awayPostgameElo": 1596,
    "excitementIndex": 7.658751011,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401640959,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-24T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": false,
    "attendance": 47342,
    "venueId": 4102,
    "venue": "Yankee Stadium",
    "homeId": 87,
    "homeTeam": "Notre Dame",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 49,
    "homeLineScores": [
      14,
      14,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9989435155454186,
    "homePregameElo": 2115,
    "homePostgameElo": 2165,
    "awayId": 349,
    "awayTeam": "Army",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.0010564844545813967,
    "awayPregameElo": 1661,
    "awayPostgameElo": 1611,
    "excitementIndex": 2.6373925698,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643842,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-24T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 18271,
    "venueId": 3644,
    "venue": "Bobcat Stadium (TX)",
    "homeId": 326,
    "homeTeam": "Texas State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 44,
    "homeLineScores": [
      14,
      7,
      0,
      23
    ],
    "homePostgameWinProbability": 0.06184990509359186,
    "homePregameElo": 1693,
    "homePostgameElo": 1635,
    "awayId": 2247,
    "awayTeam": "Georgia State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 52,
    "awayLineScores": [
      14,
      24,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.9381500949064081,
    "awayPregameElo": 1238,
    "awayPostgameElo": 1296,
    "excitementIndex": 3.6713008688,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636931,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-24T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 34166,
    "venueId": 4728,
    "venue": "TDECU Stadium",
    "homeId": 248,
    "homeTeam": "Houston",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 10,
    "homeLineScores": [
      7,
      0,
      0,
      3
    ],
    "homePostgameWinProbability": 0.2133737052761575,
    "homePregameElo": 1306,
    "homePostgameElo": 1309,
    "awayId": 239,
    "awayTeam": "Baylor",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 20,
    "awayLineScores": [
      7,
      10,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.7866262947238425,
    "awayPregameElo": 1591,
    "awayPostgameElo": 1588,
    "excitementIndex": 4.999600321,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628433,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-24T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 84053,
    "venueId": 3835,
    "venue": "Memorial Stadium (Norman, OK)",
    "homeId": 201,
    "homeTeam": "Oklahoma",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 24,
    "homeLineScores": [
      0,
      10,
      14,
      0
    ],
    "homePostgameWinProbability": 0.9979876881477157,
    "homePregameElo": 1678,
    "homePostgameElo": 1780,
    "awayId": 333,
    "awayTeam": "Alabama",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 3,
    "awayLineScores": [
      3,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.002012311852284343,
    "awayPregameElo": 2113,
    "awayPostgameElo": 2011,
    "excitementIndex": 4.1536928647,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643838,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-24T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 18083,
    "venueId": 3918,
    "venue": "S.B. Ballard Stadium",
    "homeId": 295,
    "homeTeam": "Old Dominion",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 35,
    "homeLineScores": [
      0,
      7,
      21,
      7
    ],
    "homePostgameWinProbability": 0.6173487362334923,
    "homePregameElo": 1486,
    "homePostgameElo": 1473,
    "awayId": 276,
    "awayTeam": "Marshall",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 42,
    "awayLineScores": [
      3,
      14,
      10,
      15
    ],
    "awayPostgameWinProbability": 0.3826512637665077,
    "awayPregameElo": 1489,
    "awayPostgameElo": 1502,
    "excitementIndex": 6.9754188366,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628428,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-24T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 88043,
    "venueId": 3785,
    "venue": "Jordan-Hare Stadium",
    "homeId": 2,
    "homeTeam": "Auburn",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 43,
    "homeLineScores": [
      14,
      7,
      7,
      3,
      7,
      3,
      0,
      2
    ],
    "homePostgameWinProbability": 0.5423385562984405,
    "homePregameElo": 1604,
    "homePostgameElo": 1607,
    "awayId": 245,
    "awayTeam": "Texas A&M",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 41,
    "awayLineScores": [
      0,
      7,
      14,
      10,
      7,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.4576614437015595,
    "awayPregameElo": 1770,
    "awayPostgameElo": 1767,
    "excitementIndex": 9.219958917,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636936,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-24T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 52152,
    "venueId": 587,
    "venue": "Rice-Eccles Stadium",
    "homeId": 254,
    "homeTeam": "Utah",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 28,
    "homeLineScores": [
      3,
      10,
      0,
      15
    ],
    "homePostgameWinProbability": 0.8462294608654207,
    "homePregameElo": 1515,
    "homePostgameElo": 1524,
    "awayId": 66,
    "awayTeam": "Iowa State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      10,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.15377053913457928,
    "awayPregameElo": 1746,
    "awayPostgameElo": 1737,
    "excitementIndex": 6.295511082,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628431,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-24T00:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 102086,
    "venueId": 3958,
    "venue": "Tiger Stadium (LA)",
    "homeId": 99,
    "homeTeam": "LSU",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 24,
    "homeLineScores": [
      7,
      7,
      7,
      3
    ],
    "homePostgameWinProbability": 0.9215569106403879,
    "homePregameElo": 1764,
    "homePostgameElo": 1757,
    "awayId": 238,
    "awayTeam": "Vanderbilt",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 17,
    "awayLineScores": [
      7,
      0,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.07844308935961208,
    "awayPregameElo": 1446,
    "awayPostgameElo": 1453,
    "excitementIndex": 4.8747119749,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635615,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-24T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 22462,
    "venueId": 3982,
    "venue": "Wallace Wade Stadium",
    "homeId": 150,
    "homeTeam": "Duke",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 31,
    "homeLineScores": [
      14,
      7,
      10,
      0
    ],
    "homePostgameWinProbability": 0.9072339610133376,
    "homePregameElo": 1597,
    "homePostgameElo": 1599,
    "awayId": 259,
    "awayTeam": "Virginia Tech",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 28,
    "awayLineScores": [
      7,
      10,
      0,
      11
    ],
    "awayPostgameWinProbability": 0.09276603898666236,
    "awayPregameElo": 1658,
    "awayPostgameElo": 1656,
    "excitementIndex": 8.334691174,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636933,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-24T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 50988,
    "venueId": 3636,
    "venue": "Bill Snyder Family Stadium",
    "homeId": 2306,
    "homeTeam": "Kansas State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 41,
    "homeLineScores": [
      10,
      17,
      0,
      14
    ],
    "homePostgameWinProbability": 0.9958220506202534,
    "homePregameElo": 1731,
    "homePostgameElo": 1772,
    "awayId": 2132,
    "awayTeam": "Cincinnati",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 15,
    "awayLineScores": [
      0,
      3,
      6,
      6
    ],
    "awayPostgameWinProbability": 0.004177949379746582,
    "awayPregameElo": 1506,
    "awayPostgameElo": 1465,
    "excitementIndex": 3.0258991048,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643763,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-24T03:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 12228,
    "venueId": 3816,
    "venue": "Mackay Stadium",
    "homeId": 2440,
    "homeTeam": "Nevada",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 19,
    "homeLineScores": [
      0,
      6,
      6,
      7
    ],
    "homePostgameWinProbability": 0.12469034617243689,
    "homePregameElo": 1196,
    "homePostgameElo": 1204,
    "awayId": 2005,
    "awayTeam": "Air Force",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 22,
    "awayLineScores": [
      0,
      7,
      0,
      15
    ],
    "awayPostgameWinProbability": 0.8753096538275631,
    "awayPregameElo": 1406,
    "awayPostgameElo": 1398,
    "excitementIndex": 6.9270209058,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643765,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-24T03:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 39543,
    "venueId": 3660,
    "venue": "Valley Children's Stadium",
    "homeId": 278,
    "homeTeam": "Fresno State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 28,
    "homeLineScores": [
      7,
      21,
      0,
      0
    ],
    "homePostgameWinProbability": 0.8797291371909506,
    "homePregameElo": 1511,
    "homePostgameElo": 1511,
    "awayId": 36,
    "awayTeam": "Colorado State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 22,
    "awayLineScores": [
      7,
      0,
      7,
      8
    ],
    "awayPostgameWinProbability": 0.12027086280904942,
    "awayPregameElo": 1366,
    "awayPostgameElo": 1366,
    "excitementIndex": 5.6302113159,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628561,
    "season": 2024,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2024-11-24T03:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 59473,
    "venueId": 1056,
    "venue": "Rose Bowl",
    "homeId": 26,
    "homeTeam": "UCLA",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 13,
    "homeLineScores": [
      3,
      0,
      10,
      0
    ],
    "homePostgameWinProbability": 0.921876989457655,
    "homePregameElo": 1466,
    "homePostgameElo": 1476,
    "awayId": 30,
    "awayTeam": "USC",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 19,
    "awayLineScores": [
      3,
      6,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.07812301054234505,
    "awayPregameElo": 1761,
    "awayPostgameElo": 1751,
    "excitementIndex": 6.0413408276,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644776,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-27T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 11916,
    "venueId": 3965,
    "venue": "UB Stadium",
    "homeId": 2084,
    "homeTeam": "Buffalo",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 43,
    "homeLineScores": [
      13,
      13,
      7,
      10
    ],
    "homePostgameWinProbability": 0.9986797157103546,
    "homePregameElo": 1259,
    "homePostgameElo": 1304,
    "awayId": 2309,
    "awayTeam": "Kent State",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.0013202842896453681,
    "awayPregameElo": 805,
    "awayPostgameElo": 760,
    "excitementIndex": 3.0737114671,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644775,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-27T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 4716,
    "venueId": 3768,
    "venue": "InfoCision Stadium",
    "homeId": 2006,
    "homeTeam": "Akron",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 21,
    "homeLineScores": [
      7,
      0,
      0,
      7,
      7
    ],
    "homePostgameWinProbability": 0.2844975789747403,
    "homePregameElo": 1085,
    "homePostgameElo": 1118,
    "awayId": 2649,
    "awayTeam": "Toledo",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      0,
      0,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.7155024210252596,
    "awayPregameElo": 1459,
    "awayPostgameElo": 1426,
    "excitementIndex": 7.1114876651,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645376,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-29T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 25021,
    "venueId": 4729,
    "venue": "Yulman Stadium",
    "homeId": 2655,
    "homeTeam": "Tulane",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 24,
    "homeLineScores": [
      10,
      0,
      0,
      14
    ],
    "homePostgameWinProbability": 0.044377860509926904,
    "homePregameElo": 1874,
    "homePostgameElo": 1829,
    "awayId": 235,
    "awayTeam": "Memphis",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 34,
    "awayLineScores": [
      7,
      10,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.9556221394900731,
    "awayPregameElo": 1621,
    "awayPostgameElo": 1666,
    "excitementIndex": 4.2262920592,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645379,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-29T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 35663,
    "venueId": 3699,
    "venue": "Dowdy-Ficklen Stadium",
    "homeId": 151,
    "homeTeam": "East Carolina",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 20,
    "homeLineScores": [
      0,
      3,
      0,
      17
    ],
    "homePostgameWinProbability": 0.006420098891402485,
    "homePregameElo": 1418,
    "homePostgameElo": 1392,
    "awayId": 2426,
    "awayTeam": "Navy",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 34,
    "awayLineScores": [
      0,
      0,
      14,
      20
    ],
    "awayPostgameWinProbability": 0.9935799011085975,
    "awayPregameElo": 1477,
    "awayPostgameElo": 1503,
    "excitementIndex": 5.6325040367,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644691,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-29T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 9345,
    "venueId": 3700,
    "venue": "Doyt L. Perry Stadium",
    "homeId": 189,
    "homeTeam": "Bowling Green",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 12,
    "homeLineScores": [
      0,
      5,
      0,
      7
    ],
    "homePostgameWinProbability": 0.011332963568387195,
    "homePregameElo": 1498,
    "homePostgameElo": 1466,
    "awayId": 193,
    "awayTeam": "Miami (OH)",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 28,
    "awayLineScores": [
      7,
      7,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.9886670364316128,
    "awayPregameElo": 1558,
    "awayPostgameElo": 1590,
    "excitementIndex": 3.8709650579,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643769,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-29T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 37264,
    "venueId": 3653,
    "venue": "Albertsons Stadium",
    "homeId": 68,
    "homeTeam": "Boise State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 34,
    "homeLineScores": [
      14,
      7,
      6,
      7
    ],
    "homePostgameWinProbability": 0.9418541814960487,
    "homePregameElo": 1747,
    "homePostgameElo": 1748,
    "awayId": 204,
    "awayTeam": "Oregon State",
    "awayClassification": "fbs",
    "awayConference": "Pac-12",
    "awayPoints": 18,
    "awayLineScores": [
      0,
      7,
      3,
      8
    ],
    "awayPostgameWinProbability": 0.058145818503951285,
    "awayPregameElo": 1360,
    "awayPostgameElo": 1359,
    "excitementIndex": 4.511954859,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628568,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-29T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 76059,
    "venueId": 347,
    "venue": "Camp Randall Stadium",
    "homeId": 275,
    "homeTeam": "Wisconsin",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 7,
    "homeLineScores": [
      0,
      0,
      7,
      0
    ],
    "homePostgameWinProbability": 0.0009386543860333801,
    "homePregameElo": 1594,
    "homePostgameElo": 1554,
    "awayId": 135,
    "awayTeam": "Minnesota",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      7,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.9990613456139666,
    "awayPregameElo": 1606,
    "awayPostgameElo": 1646,
    "excitementIndex": 3.3258566397,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644777,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-29T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 11804,
    "venueId": 3876,
    "venue": "Peden Stadium",
    "homeId": 195,
    "homeTeam": "Ohio",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 42,
    "homeLineScores": [
      14,
      7,
      14,
      7
    ],
    "homePostgameWinProbability": 0.998880141430811,
    "homePregameElo": 1582,
    "homePostgameElo": 1585,
    "awayId": 2050,
    "awayTeam": "Ball State",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.0011198585691889473,
    "awayPregameElo": 1089,
    "awayPostgameElo": 1086,
    "excitementIndex": 5.7309179002,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636938,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-29T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 51030,
    "venueId": 3726,
    "venue": "Folsom Field",
    "homeId": 38,
    "homeTeam": "Colorado",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 52,
    "homeLineScores": [
      21,
      0,
      17,
      14
    ],
    "homePostgameWinProbability": 0.9989571361132871,
    "homePregameElo": 1641,
    "homePostgameElo": 1762,
    "awayId": 197,
    "awayTeam": "Oklahoma State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0010428638867129303,
    "awayPregameElo": 1372,
    "awayPostgameElo": 1251,
    "excitementIndex": 2.7476275523,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628442,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-29T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 67896,
    "venueId": 3974,
    "venue": "Vaught-Hemingway Stadium",
    "homeId": 145,
    "homeTeam": "Ole Miss",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 26,
    "homeLineScores": [
      10,
      7,
      3,
      6
    ],
    "homePostgameWinProbability": 0.9791243711500325,
    "homePregameElo": 1977,
    "homePostgameElo": 1956,
    "awayId": 344,
    "awayTeam": "Mississippi State",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 14,
    "awayLineScores": [
      14,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.02087562884996752,
    "awayPregameElo": 1348,
    "awayPostgameElo": 1369,
    "excitementIndex": 6.7842309695,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643770,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-29T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 24772,
    "venueId": 5388,
    "venue": "Canvas Stadium",
    "homeId": 36,
    "homeTeam": "Colorado State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 42,
    "homeLineScores": [
      0,
      13,
      0,
      29
    ],
    "homePostgameWinProbability": 0.23687846901861767,
    "homePregameElo": 1366,
    "homePostgameElo": 1371,
    "awayId": 328,
    "awayTeam": "Utah State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 37,
    "awayLineScores": [
      13,
      3,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.7631215309813824,
    "awayPregameElo": 1367,
    "awayPostgameElo": 1362,
    "excitementIndex": 8.1634958871,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401640997,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-29T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 8651,
    "venueId": 3647,
    "venue": "Elliott T. Bowers Stadium",
    "homeId": 2534,
    "homeTeam": "Sam Houston",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 20,
    "homeLineScores": [
      3,
      14,
      3,
      0
    ],
    "homePostgameWinProbability": 0.8588682212916633,
    "homePregameElo": 1412,
    "homePostgameElo": 1415,
    "awayId": 2335,
    "awayTeam": "Liberty",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 18,
    "awayLineScores": [
      2,
      7,
      0,
      9
    ],
    "awayPostgameWinProbability": 0.1411317787083367,
    "awayPregameElo": 1576,
    "awayPostgameElo": 1573,
    "excitementIndex": 5.6355656693,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643843,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-29T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 15569,
    "venueId": 6526,
    "venue": "Hancock Whitney Stadium",
    "homeId": 6,
    "homeTeam": "South Alabama",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 38,
    "homeLineScores": [
      14,
      14,
      7,
      3
    ],
    "homePostgameWinProbability": 0.21619645942292331,
    "homePregameElo": 1608,
    "homePostgameElo": 1597,
    "awayId": 326,
    "awayTeam": "Texas State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 45,
    "awayLineScores": [
      14,
      7,
      10,
      14
    ],
    "awayPostgameWinProbability": 0.7838035405770767,
    "awayPregameElo": 1635,
    "awayPostgameElo": 1646,
    "excitementIndex": 6.3088466293,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635625,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-29T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 19117,
    "venueId": 3935,
    "venue": "CEFCU Stadium",
    "homeId": 23,
    "homeTeam": "San Jos\u00e9 State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 34,
    "homeLineScores": [
      0,
      17,
      10,
      7
    ],
    "homePostgameWinProbability": 0.2736914275899505,
    "homePregameElo": 1481,
    "homePostgameElo": 1478,
    "awayId": 24,
    "awayTeam": "Stanford",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 31,
    "awayLineScores": [
      3,
      7,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.7263085724100495,
    "awayPregameElo": 1172,
    "awayPostgameElo": 1175,
    "excitementIndex": 7.035871014,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628439,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 93033,
    "venueId": 3917,
    "venue": "Sanford Stadium",
    "homeId": 61,
    "homeTeam": "Georgia",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 44,
    "homeLineScores": [
      0,
      0,
      6,
      21,
      7,
      6,
      0,
      0,
      2,
      0,
      0,
      2
    ],
    "homePostgameWinProbability": 0.2112126985931276,
    "homePregameElo": 2023,
    "homePostgameElo": 2017,
    "awayId": 59,
    "awayTeam": "Georgia Tech",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 42,
    "awayLineScores": [
      3,
      14,
      0,
      10,
      7,
      6,
      0,
      0,
      2,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.7887873014068724,
    "awayPregameElo": 1575,
    "awayPostgameElo": 1581,
    "excitementIndex": 5.6413344753,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628562,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 69250,
    "venueId": 3793,
    "venue": "Kinnick Stadium",
    "homeId": 2294,
    "homeTeam": "Iowa",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 13,
    "homeLineScores": [
      0,
      0,
      3,
      10
    ],
    "homePostgameWinProbability": 0.060828858245351496,
    "homePregameElo": 1786,
    "homePostgameElo": 1784,
    "awayId": 158,
    "awayTeam": "Nebraska",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 10,
    "awayLineScores": [
      3,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.9391711417546486,
    "awayPregameElo": 1524,
    "awayPostgameElo": 1526,
    "excitementIndex": 6.8061849771,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636939,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 40747,
    "venueId": 3652,
    "venue": "FBC Mortgage Stadium",
    "homeId": 2116,
    "homeTeam": "UCF",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 14,
    "homeLineScores": [
      0,
      7,
      0,
      7
    ],
    "homePostgameWinProbability": 0.12002435906985308,
    "homePregameElo": 1596,
    "homePostgameElo": 1557,
    "awayId": 254,
    "awayTeam": "Utah",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 28,
    "awayLineScores": [
      3,
      10,
      0,
      15
    ],
    "awayPostgameWinProbability": 0.8799756409301469,
    "awayPregameElo": 1524,
    "awayPostgameElo": 1563,
    "excitementIndex": 5.3843456843,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628444,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 81500,
    "venueId": 3836,
    "venue": "Memorial Stadium (Clemson, SC)",
    "homeId": 228,
    "homeTeam": "Clemson",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 14,
    "homeLineScores": [
      0,
      7,
      7,
      0
    ],
    "homePostgameWinProbability": 0.1823213457225503,
    "homePregameElo": 1815,
    "homePostgameElo": 1811,
    "awayId": 2579,
    "awayTeam": "South Carolina",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      7,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.8176786542774497,
    "awayPregameElo": 1828,
    "awayPostgameElo": 1832,
    "excitementIndex": 7.3032535022,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643848,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 15006,
    "venueId": 3817,
    "venue": "Malone Stadium",
    "homeId": 2433,
    "homeTeam": "UL Monroe",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 23,
    "homeLineScores": [
      3,
      10,
      3,
      7
    ],
    "homePostgameWinProbability": 0.07179862294126547,
    "homePregameElo": 1160,
    "homePostgameElo": 1172,
    "awayId": 309,
    "awayTeam": "Louisiana",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 37,
    "awayLineScores": [
      6,
      7,
      7,
      17
    ],
    "awayPostgameWinProbability": 0.9282013770587345,
    "awayPregameElo": 1652,
    "awayPostgameElo": 1640,
    "excitementIndex": 5.6767894603,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635622,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 24776,
    "venueId": 3630,
    "venue": "Allegacy Federal Credit Union Stadium",
    "homeId": 154,
    "homeTeam": "Wake Forest",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 17,
    "homeLineScores": [
      0,
      10,
      7,
      0
    ],
    "homePostgameWinProbability": 0.6958491086454279,
    "homePregameElo": 1338,
    "homePostgameElo": 1346,
    "awayId": 150,
    "awayTeam": "Duke",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 23,
    "awayLineScores": [
      0,
      3,
      7,
      13
    ],
    "awayPostgameWinProbability": 0.3041508913545721,
    "awayPregameElo": 1599,
    "awayPostgameElo": 1591,
    "excitementIndex": 8.1532737621,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645381,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": null,
    "venueId": 3806,
    "venue": "Lincoln Financial Field",
    "homeId": 218,
    "homeTeam": "Temple",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 17,
    "homeLineScores": [
      3,
      14,
      0,
      0
    ],
    "homePostgameWinProbability": 0.007678029612514481,
    "homePregameElo": 1026,
    "homePostgameElo": 1038,
    "awayId": 249,
    "awayTeam": "North Texas",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 24,
    "awayLineScores": [
      17,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.9923219703874855,
    "awayPregameElo": 1373,
    "awayPostgameElo": 1361,
    "excitementIndex": 6.3887081142,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628446,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 28934,
    "venueId": 3973,
    "venue": "FirstBank Stadium",
    "homeId": 238,
    "homeTeam": "Vanderbilt",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 23,
    "homeLineScores": [
      17,
      0,
      0,
      6
    ],
    "homePostgameWinProbability": 0.0007556686111774126,
    "homePregameElo": 1453,
    "homePostgameElo": 1469,
    "awayId": 2633,
    "awayTeam": "Tennessee",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 36,
    "awayLineScores": [
      7,
      17,
      9,
      3
    ],
    "awayPostgameWinProbability": 0.9992443313888226,
    "awayPregameElo": 1979,
    "awayPostgameElo": 1963,
    "excitementIndex": 3.8925994934,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628563,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 26378,
    "venueId": 4250,
    "venue": "Wrigley Field",
    "homeId": 77,
    "homeTeam": "Northwestern",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 28,
    "homeLineScores": [
      10,
      0,
      10,
      8
    ],
    "homePostgameWinProbability": 0.02321332900381131,
    "homePregameElo": 1396,
    "homePostgameElo": 1397,
    "awayId": 356,
    "awayTeam": "Illinois",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 38,
    "awayLineScores": [
      7,
      7,
      14,
      10
    ],
    "awayPostgameWinProbability": 0.9767866709961887,
    "awayPregameElo": 1597,
    "awayPostgameElo": 1596,
    "excitementIndex": 4.3141013947,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401629038,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 10365,
    "venueId": 3985,
    "venue": "Warren McGuirk Alumni Stadium",
    "homeId": 113,
    "homeTeam": "Massachusetts",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 42,
    "homeLineScores": [
      14,
      14,
      0,
      14
    ],
    "homePostgameWinProbability": 0.7042563147039983,
    "homePregameElo": 1023,
    "homePostgameElo": 1040,
    "awayId": 41,
    "awayTeam": "UConn",
    "awayClassification": "fbs",
    "awayConference": "FBS Independents",
    "awayPoints": 47,
    "awayLineScores": [
      14,
      13,
      6,
      14
    ],
    "awayPostgameWinProbability": 0.2957436852960017,
    "awayPregameElo": 1414,
    "awayPostgameElo": 1397,
    "excitementIndex": 6.5079667639,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628566,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 106005,
    "venueId": 3861,
    "venue": "Ohio Stadium",
    "homeId": 194,
    "homeTeam": "Ohio State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 10,
    "homeLineScores": [
      3,
      7,
      0,
      0
    ],
    "homePostgameWinProbability": 0.5312440212481095,
    "homePregameElo": 2120,
    "homePostgameElo": 2099,
    "awayId": 130,
    "awayTeam": "Michigan",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      10,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.46875597875189046,
    "awayPregameElo": 1867,
    "awayPostgameElo": 1888,
    "excitementIndex": 5.8773789703,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645378,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 22120,
    "venueId": 3841,
    "venue": "Michie Stadium",
    "homeId": 349,
    "homeTeam": "Army",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 29,
    "homeLineScores": [
      7,
      6,
      3,
      13
    ],
    "homePostgameWinProbability": 0.9204104546089289,
    "homePregameElo": 1611,
    "homePostgameElo": 1611,
    "awayId": 2636,
    "awayTeam": "UTSA",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      3,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.0795895453910711,
    "awayPregameElo": 1479,
    "awayPostgameElo": 1479,
    "excitementIndex": 7.9327251907,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636945,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 52785,
    "venueId": 3784,
    "venue": "Jones AT&T Stadium",
    "homeId": 2641,
    "homeTeam": "Texas Tech",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 52,
    "homeLineScores": [
      6,
      29,
      7,
      10
    ],
    "homePostgameWinProbability": 0.9985769484963855,
    "homePregameElo": 1540,
    "homePostgameElo": 1647,
    "awayId": 277,
    "awayTeam": "West Virginia",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 15,
    "awayLineScores": [
      3,
      0,
      6,
      6
    ],
    "awayPostgameWinProbability": 0.0014230515036145475,
    "awayPregameElo": 1553,
    "awayPostgameElo": 1446,
    "excitementIndex": 2.9471723932,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636941,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 36585,
    "venueId": 4727,
    "venue": "McLane Stadium",
    "homeId": 239,
    "homeTeam": "Baylor",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 45,
    "homeLineScores": [
      14,
      7,
      21,
      3
    ],
    "homePostgameWinProbability": 0.9768985872440337,
    "homePregameElo": 1588,
    "homePostgameElo": 1677,
    "awayId": 2305,
    "awayTeam": "Kansas",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 17,
    "awayLineScores": [
      7,
      3,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.023101412755966333,
    "awayPregameElo": 1714,
    "awayPostgameElo": 1625,
    "excitementIndex": 3.8086096618,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628440,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 58612,
    "venueId": 3683,
    "venue": "Kroger Field",
    "homeId": 96,
    "homeTeam": "Kentucky",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 14,
    "homeLineScores": [
      0,
      0,
      7,
      7
    ],
    "homePostgameWinProbability": 0.04744836669828061,
    "homePregameElo": 1545,
    "homePostgameElo": 1498,
    "awayId": 97,
    "awayTeam": "Louisville",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 41,
    "awayLineScores": [
      7,
      13,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.9525516333017194,
    "awayPregameElo": 1767,
    "awayPostgameElo": 1814,
    "excitementIndex": 2.8261398088,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644780,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T18:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": null,
    "venueId": 3980,
    "venue": "Waldo Stadium",
    "homeId": 2711,
    "homeTeam": "Western Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 26,
    "homeLineScores": [
      0,
      16,
      7,
      3
    ],
    "homePostgameWinProbability": 0.9105388555960335,
    "homePregameElo": 1246,
    "homePostgameElo": 1254,
    "awayId": 2199,
    "awayTeam": "Eastern Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 18,
    "awayLineScores": [
      0,
      0,
      15,
      3
    ],
    "awayPostgameWinProbability": 0.08946114440396646,
    "awayPregameElo": 1183,
    "awayPostgameElo": 1175,
    "excitementIndex": 6.2258019605,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643845,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 12606,
    "venueId": 4246,
    "venue": "Center Parc Stadium",
    "homeId": 2247,
    "homeTeam": "Georgia State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 27,
    "homeLineScores": [
      0,
      10,
      9,
      8
    ],
    "homePostgameWinProbability": 0.0011097833109109014,
    "homePregameElo": 1296,
    "homePostgameElo": 1247,
    "awayId": 324,
    "awayTeam": "Coastal Carolina",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 48,
    "awayLineScores": [
      7,
      10,
      14,
      17
    ],
    "awayPostgameWinProbability": 0.9988902166890891,
    "awayPregameElo": 1335,
    "awayPostgameElo": 1384,
    "excitementIndex": 4.1119588589,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645382,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16430,
    "venueId": 3895,
    "venue": "Rice Stadium",
    "homeId": 242,
    "homeTeam": "Rice",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 35,
    "homeLineScores": [
      17,
      10,
      8,
      0
    ],
    "homePostgameWinProbability": 0.6985070029587165,
    "homePregameElo": 1215,
    "homePostgameElo": 1239,
    "awayId": 58,
    "awayTeam": "South Florida",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 28,
    "awayLineScores": [
      7,
      0,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.3014929970412835,
    "awayPregameElo": 1457,
    "awayPostgameElo": 1433,
    "excitementIndex": 5.1192951089,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643849,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 19521,
    "venueId": 3975,
    "venue": "Veterans Memorial Stadium (AL)",
    "homeId": 2653,
    "homeTeam": "Troy",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 52,
    "homeLineScores": [
      10,
      7,
      14,
      21
    ],
    "homePostgameWinProbability": 0.9984693597815943,
    "homePregameElo": 1432,
    "homePostgameElo": 1464,
    "awayId": 2572,
    "awayTeam": "Southern Miss",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 20,
    "awayLineScores": [
      8,
      0,
      6,
      6
    ],
    "awayPostgameWinProbability": 0.0015306402184056545,
    "awayPregameElo": 961,
    "awayPostgameElo": 929,
    "excitementIndex": 5.5417416996,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401640988,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 8962,
    "venueId": 2031,
    "venue": "Pitbull Stadium",
    "homeId": 2229,
    "homeTeam": "Florida International",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 35,
    "homeLineScores": [
      14,
      14,
      0,
      7
    ],
    "homePostgameWinProbability": 0.9719740921508259,
    "homePregameElo": 1297,
    "homePostgameElo": 1308,
    "awayId": 2393,
    "awayTeam": "Middle Tennessee",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 24,
    "awayLineScores": [
      0,
      17,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.028025907849174136,
    "awayPregameElo": 1104,
    "awayPostgameElo": 1093,
    "excitementIndex": 5.1268858168,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635620,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 29704,
    "venueId": 3615,
    "venue": "Alumni Stadium (Chestnut Hill, MA)",
    "homeId": 103,
    "homeTeam": "Boston College",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 34,
    "homeLineScores": [
      6,
      14,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9320899715386084,
    "homePregameElo": 1506,
    "homePostgameElo": 1524,
    "awayId": 221,
    "awayTeam": "Pittsburgh",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 23,
    "awayLineScores": [
      0,
      10,
      7,
      6
    ],
    "awayPostgameWinProbability": 0.0679100284613916,
    "awayPregameElo": 1479,
    "awayPostgameElo": 1461,
    "excitementIndex": 6.4826142012,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643847,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 13584,
    "venueId": 3625,
    "venue": "Centennial Bank Stadium",
    "homeId": 2032,
    "homeTeam": "Arkansas State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 32,
    "homeLineScores": [
      7,
      7,
      15,
      3
    ],
    "homePostgameWinProbability": 0.004222369704036244,
    "homePregameElo": 1241,
    "homePostgameElo": 1243,
    "awayId": 295,
    "awayTeam": "Old Dominion",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 40,
    "awayLineScores": [
      14,
      7,
      19,
      0
    ],
    "awayPostgameWinProbability": 0.9957776302959638,
    "awayPregameElo": 1473,
    "awayPostgameElo": 1471,
    "excitementIndex": 4.1250573731,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628570,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 35018,
    "venueId": 1056,
    "venue": "Rose Bowl",
    "homeId": 26,
    "homeTeam": "UCLA",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 20,
    "homeLineScores": [
      3,
      3,
      7,
      7
    ],
    "homePostgameWinProbability": 0.8719021228065362,
    "homePregameElo": 1476,
    "homePostgameElo": 1488,
    "awayId": 278,
    "awayTeam": "Fresno State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      10,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.12809787719346377,
    "awayPregameElo": 1511,
    "awayPostgameElo": 1499,
    "excitementIndex": 8.346909493,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628571,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 73241,
    "venueId": 477,
    "venue": "Los Angeles Memorial Coliseum",
    "homeId": 30,
    "homeTeam": "USC",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 35,
    "homeLineScores": [
      0,
      14,
      7,
      14
    ],
    "homePostgameWinProbability": 0.002167694477008406,
    "homePregameElo": 1751,
    "homePostgameElo": 1756,
    "awayId": 87,
    "awayTeam": "Notre Dame",
    "awayClassification": "fbs",
    "awayConference": "FBS Independents",
    "awayPoints": 49,
    "awayLineScores": [
      7,
      7,
      21,
      14
    ],
    "awayPostgameWinProbability": 0.9978323055229916,
    "awayPregameElo": 2165,
    "awayPostgameElo": 2160,
    "excitementIndex": 6.406879225,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635621,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 33178,
    "venueId": 3735,
    "venue": "Gerald J. Ford Stadium",
    "homeId": 2567,
    "homeTeam": "SMU",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 38,
    "homeLineScores": [
      14,
      7,
      0,
      17
    ],
    "homePostgameWinProbability": 0.99779013392185,
    "homePregameElo": 1830,
    "homePostgameElo": 1890,
    "awayId": 25,
    "awayTeam": "California",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 6,
    "awayLineScores": [
      0,
      0,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.0022098660781499913,
    "awayPregameElo": 1606,
    "awayPostgameElo": 1546,
    "excitementIndex": 3.0794154021,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628567,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 50038,
    "venueId": 3936,
    "venue": "Spartan Stadium",
    "homeId": 127,
    "homeTeam": "Michigan State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 14,
    "homeLineScores": [
      7,
      0,
      0,
      7
    ],
    "homePostgameWinProbability": 0.04693542637151268,
    "homePregameElo": 1364,
    "homePostgameElo": 1303,
    "awayId": 164,
    "awayTeam": "Rutgers",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 41,
    "awayLineScores": [
      10,
      13,
      8,
      10
    ],
    "awayPostgameWinProbability": 0.9530645736284873,
    "awayPregameElo": 1468,
    "awayPostgameElo": 1529,
    "excitementIndex": 2.4519777937,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645380,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 15243,
    "venueId": 3674,
    "venue": "Chapman Stadium",
    "homeId": 202,
    "homeTeam": "Tulsa",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 16,
    "homeLineScores": [
      2,
      7,
      7,
      0
    ],
    "homePostgameWinProbability": 0.0003588341836969184,
    "homePregameElo": 934,
    "homePostgameElo": 812,
    "awayId": 2226,
    "awayTeam": "Florida Atlantic",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 63,
    "awayLineScores": [
      7,
      35,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.9996411658163031,
    "awayPregameElo": 1095,
    "awayPostgameElo": 1217,
    "excitementIndex": 2.2469855782,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628443,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 62621,
    "venueId": 3838,
    "venue": "Memorial Stadium",
    "homeId": 142,
    "homeTeam": "Missouri",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 28,
    "homeLineScores": [
      7,
      0,
      3,
      18
    ],
    "homePostgameWinProbability": 0.7171060630184782,
    "homePregameElo": 1698,
    "homePostgameElo": 1701,
    "awayId": 8,
    "awayTeam": "Arkansas",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.28289393698152177,
    "awayPregameElo": 1574,
    "awayPostgameElo": 1571,
    "excitementIndex": 8.103636049,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628437,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 100077,
    "venueId": 3657,
    "venue": "Bryant-Denny Stadium",
    "homeId": 333,
    "homeTeam": "Alabama",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 28,
    "homeLineScores": [
      7,
      7,
      14,
      0
    ],
    "homePostgameWinProbability": 0.9855541427962963,
    "homePregameElo": 2011,
    "homePostgameElo": 2007,
    "awayId": 2,
    "awayTeam": "Auburn",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      6,
      8,
      0
    ],
    "awayPostgameWinProbability": 0.014445857203703727,
    "awayPregameElo": 1607,
    "awayPostgameElo": 1611,
    "excitementIndex": 4.2747989352,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635623,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 40486,
    "venueId": 1964,
    "venue": "JMA Wireless Dome",
    "homeId": 183,
    "homeTeam": "Syracuse",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 42,
    "homeLineScores": [
      0,
      14,
      21,
      7
    ],
    "homePostgameWinProbability": 0.42545169040070274,
    "homePregameElo": 1434,
    "homePostgameElo": 1452,
    "awayId": 2390,
    "awayTeam": "Miami",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 38,
    "awayLineScores": [
      14,
      7,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.5745483095992973,
    "awayPregameElo": 1877,
    "awayPostgameElo": 1859,
    "excitementIndex": 7.7483994146,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628565,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 104044,
    "venueId": 3632,
    "venue": "Beaver Stadium",
    "homeId": 213,
    "homeTeam": "Penn State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 44,
    "homeLineScores": [
      3,
      28,
      0,
      13
    ],
    "homePostgameWinProbability": 0.9979505941918048,
    "homePregameElo": 1971,
    "homePostgameElo": 2011,
    "awayId": 120,
    "awayTeam": "Maryland",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 7,
    "awayLineScores": [
      7,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.002049405808195237,
    "awayPregameElo": 1447,
    "awayPostgameElo": 1407,
    "excitementIndex": 3.4070132564,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636940,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 49813,
    "venueId": 3619,
    "venue": "Arizona Stadium",
    "homeId": 12,
    "homeTeam": "Arizona",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 7,
    "homeLineScores": [
      0,
      0,
      7,
      0
    ],
    "homePostgameWinProbability": 0.0003264983132494968,
    "homePregameElo": 1404,
    "homePostgameElo": 1307,
    "awayId": 9,
    "awayTeam": "Arizona State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 49,
    "awayLineScores": [
      14,
      21,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.9996735016867505,
    "awayPregameElo": 1615,
    "awayPostgameElo": 1712,
    "excitementIndex": 1.4601853389,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635624,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 50500,
    "venueId": 3787,
    "venue": "Kenan Stadium",
    "homeId": 153,
    "homeTeam": "North Carolina",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 30,
    "homeLineScores": [
      0,
      6,
      14,
      10
    ],
    "homePostgameWinProbability": 0.06387239155893788,
    "homePregameElo": 1543,
    "homePostgameElo": 1531,
    "awayId": 152,
    "awayTeam": "NC State",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 35,
    "awayLineScores": [
      7,
      0,
      6,
      22
    ],
    "awayPostgameWinProbability": 0.9361276084410621,
    "awayPregameElo": 1501,
    "awayPostgameElo": 1513,
    "excitementIndex": 7.7781583966,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401644779,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 5843,
    "venueId": 3764,
    "venue": "Huskie Stadium",
    "homeId": 2459,
    "homeTeam": "Northern Illinois",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 24,
    "homeLineScores": [
      19,
      2,
      3,
      0
    ],
    "homePostgameWinProbability": 0.8113495378916382,
    "homePregameElo": 1450,
    "homePostgameElo": 1441,
    "awayId": 2117,
    "awayTeam": "Central Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 16,
    "awayLineScores": [
      0,
      16,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.18865046210836178,
    "awayPregameElo": 1094,
    "awayPostgameElo": 1103,
    "excitementIndex": 5.7512354549,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401645377,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 8091,
    "venueId": 4418,
    "venue": "Jerry Richardson Stadium",
    "homeId": 2429,
    "homeTeam": "Charlotte",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 29,
    "homeLineScores": [
      7,
      6,
      6,
      10
    ],
    "homePostgameWinProbability": 0.21553316826469893,
    "homePregameElo": 1129,
    "homePostgameElo": 1131,
    "awayId": 5,
    "awayTeam": "UAB",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 27,
    "awayLineScores": [
      0,
      14,
      0,
      13
    ],
    "awayPostgameWinProbability": 0.7844668317353011,
    "awayPregameElo": 1231,
    "awayPostgameElo": 1229,
    "excitementIndex": 8.5144862831,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641031,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 15358,
    "venueId": 3601,
    "venue": "Aggie Memorial Stadium",
    "homeId": 166,
    "homeTeam": "New Mexico State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 35,
    "homeLineScores": [
      17,
      7,
      0,
      11
    ],
    "homePostgameWinProbability": 0.2301922011985636,
    "homePregameElo": 1137,
    "homePostgameElo": 1120,
    "awayId": 2638,
    "awayTeam": "UTEP",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 42,
    "awayLineScores": [
      7,
      7,
      14,
      14
    ],
    "awayPostgameWinProbability": 0.7698077988014365,
    "awayPregameElo": 1094,
    "awayPostgameElo": 1111,
    "excitementIndex": 6.1515474424,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641014,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 14686,
    "venueId": 3776,
    "venue": "Joe Aillet Stadium",
    "homeId": 2348,
    "homeTeam": "Louisiana Tech",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 33,
    "homeLineScores": [
      7,
      10,
      9,
      7
    ],
    "homePostgameWinProbability": 0.9986963903527133,
    "homePregameElo": 1294,
    "homePostgameElo": 1377,
    "awayId": 338,
    "awayTeam": "Kennesaw State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0013036096472867076,
    "awayPregameElo": 1233,
    "awayPostgameElo": 1150,
    "excitementIndex": 3.2926980818,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401641006,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 6547,
    "venueId": 3796,
    "venue": "Houchens Industries-L.T. Smith Stadium",
    "homeId": 98,
    "homeTeam": "Western Kentucky",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 19,
    "homeLineScores": [
      7,
      3,
      3,
      6
    ],
    "homePostgameWinProbability": 0.19183090268586367,
    "homePregameElo": 1451,
    "homePostgameElo": 1454,
    "awayId": 55,
    "awayTeam": "Jacksonville State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 17,
    "awayLineScores": [
      3,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.8081690973141363,
    "awayPregameElo": 1641,
    "awayPostgameElo": 1638,
    "excitementIndex": 9.0447421074,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636943,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 30021,
    "venueId": 3854,
    "venue": "Nippert Stadium",
    "homeId": 2132,
    "homeTeam": "Cincinnati",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 13,
    "homeLineScores": [
      0,
      7,
      0,
      6
    ],
    "homePostgameWinProbability": 0.3942468214453031,
    "homePregameElo": 1465,
    "homePostgameElo": 1463,
    "awayId": 2628,
    "awayTeam": "TCU",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 20,
    "awayLineScores": [
      7,
      13,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.6057531785546969,
    "awayPregameElo": 1614,
    "awayPostgameElo": 1616,
    "excitementIndex": 3.9373857194,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643844,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 23383,
    "venueId": 3608,
    "venue": "Allen E. Paulson Stadium",
    "homeId": 290,
    "homeTeam": "Georgia Southern",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 29,
    "homeLineScores": [
      8,
      7,
      0,
      14
    ],
    "homePostgameWinProbability": 0.7951370003122996,
    "homePregameElo": 1437,
    "homePostgameElo": 1449,
    "awayId": 2026,
    "awayTeam": "App State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      6,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.2048629996877004,
    "awayPregameElo": 1405,
    "awayPostgameElo": 1393,
    "excitementIndex": 7.3852553367,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643773,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-11-30T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 17088,
    "venueId": 3820,
    "venue": "Gesa Field",
    "homeId": 265,
    "homeTeam": "Washington State",
    "homeClassification": "fbs",
    "homeConference": "Pac-12",
    "homePoints": 14,
    "homeLineScores": [
      7,
      7,
      0,
      0
    ],
    "homePostgameWinProbability": 0.9130285102065202,
    "homePregameElo": 1596,
    "homePostgameElo": 1578,
    "awayId": 2751,
    "awayTeam": "Wyoming",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 15,
    "awayLineScores": [
      3,
      3,
      3,
      6
    ],
    "awayPostgameWinProbability": 0.0869714897934798,
    "awayPregameElo": 1283,
    "awayPostgameElo": 1301,
    "excitementIndex": 6.7087693058,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628441,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-12-01T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 99364,
    "venueId": 3958,
    "venue": "Tiger Stadium (LA)",
    "homeId": 99,
    "homeTeam": "LSU",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 37,
    "homeLineScores": [
      7,
      17,
      7,
      6
    ],
    "homePostgameWinProbability": 0.9624359723437104,
    "homePregameElo": 1757,
    "homePostgameElo": 1806,
    "awayId": 201,
    "awayTeam": "Oklahoma",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 17,
    "awayLineScores": [
      7,
      10,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.037564027656289634,
    "awayPregameElo": 1780,
    "awayPostgameElo": 1731,
    "excitementIndex": 5.4091587247,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628438,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-12-01T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 55107,
    "venueId": 3697,
    "venue": "Doak Campbell Stadium",
    "homeId": 52,
    "homeTeam": "Florida State",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 11,
    "homeLineScores": [
      0,
      0,
      3,
      8
    ],
    "homePostgameWinProbability": 0.029456870835404783,
    "homePregameElo": 1383,
    "homePostgameElo": 1363,
    "awayId": 57,
    "awayTeam": "Florida",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      7,
      3,
      14
    ],
    "awayPostgameWinProbability": 0.9705431291645952,
    "awayPregameElo": 1667,
    "awayPostgameElo": 1687,
    "excitementIndex": 3.7815068548,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628564,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-12-01T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 53082,
    "venueId": 3830,
    "venue": "Memorial Stadium (Bloomington, IN)",
    "homeId": 84,
    "homeTeam": "Indiana",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 66,
    "homeLineScores": [
      7,
      21,
      17,
      21
    ],
    "homePostgameWinProbability": 0.9989508103754811,
    "homePregameElo": 1842,
    "homePostgameElo": 1954,
    "awayId": 2509,
    "awayTeam": "Purdue",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0010491896245189425,
    "awayPregameElo": 1173,
    "awayPostgameElo": 1061,
    "excitementIndex": 3.5743261982,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628569,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-12-01T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 59603,
    "venueId": 3626,
    "venue": "Autzen Stadium",
    "homeId": 2483,
    "homeTeam": "Oregon",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 49,
    "homeLineScores": [
      7,
      21,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9986945484596655,
    "homePregameElo": 2029,
    "homePostgameElo": 2060,
    "awayId": 264,
    "awayTeam": "Washington",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 21,
    "awayLineScores": [
      3,
      11,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.0013054515403344569,
    "awayPregameElo": 1654,
    "awayPostgameElo": 1623,
    "excitementIndex": 3.4620579277,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636944,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-12-01T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 56228,
    "venueId": 3772,
    "venue": "Jack Trice Stadium",
    "homeId": 66,
    "homeTeam": "Iowa State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 29,
    "homeLineScores": [
      7,
      17,
      0,
      5
    ],
    "homePostgameWinProbability": 0.046366059193549615,
    "homePregameElo": 1737,
    "homePostgameElo": 1751,
    "awayId": 2306,
    "awayTeam": "Kansas State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      7,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.9536339408064504,
    "awayPregameElo": 1772,
    "awayPostgameElo": 1758,
    "excitementIndex": 8.79215449,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401628445,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-12-01T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 109028,
    "venueId": 3795,
    "venue": "Kyle Field",
    "homeId": 245,
    "homeTeam": "Texas A&M",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 7,
    "homeLineScores": [
      0,
      0,
      7,
      0
    ],
    "homePostgameWinProbability": 0.05825409787499234,
    "homePregameElo": 1767,
    "homePostgameElo": 1771,
    "awayId": 251,
    "awayTeam": "Texas",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 17,
    "awayLineScores": [
      7,
      10,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.9417459021250076,
    "awayPregameElo": 2063,
    "awayPostgameElo": 2059,
    "excitementIndex": 3.2865833859,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643772,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-12-01T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 40122,
    "venueId": 6501,
    "venue": "Allegiant Stadium",
    "homeId": 2439,
    "homeTeam": "UNLV",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 38,
    "homeLineScores": [
      10,
      14,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9972477283362406,
    "homePregameElo": 1673,
    "homePostgameElo": 1685,
    "awayId": 2440,
    "awayTeam": "Nevada",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 14,
    "awayLineScores": [
      7,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.0027522716637593536,
    "awayPregameElo": 1204,
    "awayPostgameElo": 1192,
    "excitementIndex": 4.0523778842,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643846,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-12-01T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 23341,
    "venueId": 3651,
    "venue": "Bridgeforth Stadium",
    "homeId": 256,
    "homeTeam": "James Madison",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 33,
    "homeLineScores": [
      14,
      3,
      0,
      7,
      3,
      6
    ],
    "homePostgameWinProbability": 0.9707049378406948,
    "homePregameElo": 1707,
    "homePostgameElo": 1692,
    "awayId": 276,
    "awayTeam": "Marshall",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 35,
    "awayLineScores": [
      0,
      0,
      17,
      7,
      3,
      8
    ],
    "awayPostgameWinProbability": 0.02929506215930522,
    "awayPregameElo": 1502,
    "awayPostgameElo": 1517,
    "excitementIndex": 5.7902123187,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401635640,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-12-01T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 65632,
    "venueId": 3799,
    "venue": "Lane Stadium",
    "homeId": 259,
    "homeTeam": "Virginia Tech",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 37,
    "homeLineScores": [
      10,
      10,
      10,
      7
    ],
    "homePostgameWinProbability": 0.9966864315234232,
    "homePregameElo": 1656,
    "homePostgameElo": 1675,
    "awayId": 258,
    "awayTeam": "Virginia",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      3,
      8,
      6
    ],
    "awayPostgameWinProbability": 0.0033135684765768225,
    "awayPregameElo": 1375,
    "awayPostgameElo": 1356,
    "excitementIndex": 3.7440119529,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401636942,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-12-01T03:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 59213,
    "venueId": 3801,
    "venue": "LaVell Edwards Stadium",
    "homeId": 252,
    "homeTeam": "BYU",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 30,
    "homeLineScores": [
      7,
      14,
      3,
      6
    ],
    "homePostgameWinProbability": 0.885255685922113,
    "homePregameElo": 1660,
    "homePostgameElo": 1656,
    "awayId": 248,
    "awayTeam": "Houston",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 18,
    "awayLineScores": [
      7,
      3,
      0,
      8
    ],
    "awayPostgameWinProbability": 0.11474431407788699,
    "awayPregameElo": 1309,
    "awayPostgameElo": 1313,
    "excitementIndex": 6.2953126879,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643768,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-12-01T03:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 18045,
    "venueId": 7311,
    "venue": "Snapdragon Stadium",
    "homeId": 21,
    "homeTeam": "San Diego State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 20,
    "homeLineScores": [
      7,
      7,
      0,
      6
    ],
    "homePostgameWinProbability": 0.00039645170331632367,
    "homePregameElo": 1237,
    "homePostgameElo": 1228,
    "awayId": 2005,
    "awayTeam": "Air Force",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 31,
    "awayLineScores": [
      14,
      3,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.9996035482966836,
    "awayPregameElo": 1398,
    "awayPostgameElo": 1407,
    "excitementIndex": 3.7986871713,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401643771,
    "season": 2024,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2024-12-01T04:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 12046,
    "venueId": 7220,
    "venue": "Clarence T.C. Ching Athletics Complex",
    "homeId": 62,
    "homeTeam": "Hawai'i",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 38,
    "homeLineScores": [
      7,
      14,
      10,
      7
    ],
    "homePostgameWinProbability": 0.37522559818728757,
    "homePregameElo": 1114,
    "homePostgameElo": 1136,
    "awayId": 167,
    "awayTeam": "New Mexico",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 30,
    "awayLineScores": [
      0,
      9,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.6247744018127124,
    "awayPregameElo": 1269,
    "awayPostgameElo": 1247,
    "excitementIndex": 6.2034023619,
    "highlights": "",
    "notes": null
  },
  {
    "id": 401673466,
    "season": 2024,
    "week": 15,
    "seasonType": "regular",
    "startDate": "2024-12-07T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 15628,
    "venueId": 3662,
    "venue": "AmFirst Stadium",
    "homeId": 55,
    "homeTeam": "Jacksonville State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 52,
    "homeLineScores": [
      14,
      14,
      10,
      14
    ],
    "homePostgameWinProbability": 0.9988904852113052,
    "homePregameElo": 1638,
    "homePostgameElo": 1729,
    "awayId": 98,
    "awayTeam": "Western Kentucky",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 12,
    "awayLineScores": [
      3,
      3,
      6,
      0
    ],
    "awayPostgameWinProbability": 0.0011095147886948098,
    "awayPregameElo": 1454,
    "awayPostgameElo": 1363,
    "excitementIndex": 4.2917622329,
    "highlights": "",
    "notes": "Conference USA Championship"
  },
  {
    "id": 401673462,
    "season": 2024,
    "week": 15,
    "seasonType": "regular",
    "startDate": "2024-12-07T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 14016,
    "venueId": 3841,
    "venue": "Michie Stadium",
    "homeId": 349,
    "homeTeam": "Army",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 35,
    "homeLineScores": [
      7,
      14,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9987863316744908,
    "homePregameElo": 1611,
    "homePostgameElo": 1686,
    "awayId": 2655,
    "awayTeam": "Tulane",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.0012136683255091762,
    "awayPregameElo": 1829,
    "awayPostgameElo": 1754,
    "excitementIndex": 2.782052003,
    "highlights": "",
    "notes": "American Athletic Championship"
  },
  {
    "id": 401673468,
    "season": 2024,
    "week": 15,
    "seasonType": "regular",
    "startDate": "2024-12-07T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 36663,
    "venueId": 3653,
    "venue": "Albertsons Stadium",
    "homeId": 68,
    "homeTeam": "Boise State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 21,
    "homeLineScores": [
      7,
      14,
      0,
      0
    ],
    "homePostgameWinProbability": 0.9841156820163207,
    "homePregameElo": 1748,
    "homePostgameElo": 1771,
    "awayId": 2439,
    "awayTeam": "UNLV",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.015884317983679286,
    "awayPregameElo": 1685,
    "awayPostgameElo": 1662,
    "excitementIndex": 5.2087786463,
    "highlights": "",
    "notes": "Mountain West Championship"
  },
  {
    "id": 401673465,
    "season": 2024,
    "week": 15,
    "seasonType": "regular",
    "startDate": "2024-12-07T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 55889,
    "venueId": 3687,
    "venue": "AT&T Stadium",
    "homeId": 9,
    "homeTeam": "Arizona State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 45,
    "homeLineScores": [
      10,
      14,
      21,
      0
    ],
    "homePostgameWinProbability": 0.9982412367788673,
    "homePregameElo": 1712,
    "homePostgameElo": 1792,
    "awayId": 66,
    "awayTeam": "Iowa State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 19,
    "awayLineScores": [
      7,
      3,
      0,
      9
    ],
    "awayPostgameWinProbability": 0.0017587632211326643,
    "awayPregameElo": 1751,
    "awayPostgameElo": 1671,
    "excitementIndex": 3.6565589863,
    "highlights": "",
    "notes": "Dr Pepper Big 12 Championship"
  },
  {
    "id": 401673467,
    "season": 2024,
    "week": 15,
    "seasonType": "regular",
    "startDate": "2024-12-07T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 15478,
    "venueId": 3727,
    "venue": "Ford Field",
    "homeId": 193,
    "homeTeam": "Miami (OH)",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 3,
    "homeLineScores": [
      3,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0.0009088165316644812,
    "homePregameElo": 1590,
    "homePostgameElo": 1496,
    "awayId": 195,
    "awayTeam": "Ohio",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 38,
    "awayLineScores": [
      7,
      14,
      10,
      7
    ],
    "awayPostgameWinProbability": 0.9990911834683355,
    "awayPregameElo": 1585,
    "awayPostgameElo": 1679,
    "excitementIndex": 2.1715313375,
    "highlights": "",
    "notes": "MAC Championship"
  },
  {
    "id": 401673469,
    "season": 2024,
    "week": 15,
    "seasonType": "regular",
    "startDate": "2024-12-07T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 74916,
    "venueId": 5348,
    "venue": "Mercedes-Benz Stadium",
    "homeId": 251,
    "homeTeam": "Texas",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 19,
    "homeLineScores": [
      3,
      3,
      0,
      10,
      3
    ],
    "homePostgameWinProbability": 0.19901744021264575,
    "homePregameElo": 2059,
    "homePostgameElo": 2057,
    "awayId": 61,
    "awayTeam": "Georgia",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 22,
    "awayLineScores": [
      0,
      3,
      10,
      3,
      6
    ],
    "awayPostgameWinProbability": 0.8009825597873542,
    "awayPregameElo": 2017,
    "awayPostgameElo": 2019,
    "excitementIndex": 9.0988909313,
    "highlights": "",
      "notes": "SEC Championship",
  },
  {
    "id": 401673470,
    "season": 2024,
    "week": 15,
    "seasonType": "regular",
    "startDate": "2024-12-08T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20067,
    "venueId": 3666,
    "venue": "Cajun Field",
    "homeId": 309,
    "homeTeam": "Louisiana",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 3,
    "homeLineScores": [
      3,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0.0028983592708610043,
    "homePregameElo": 1640,
    "homePostgameElo": 1546,
    "awayId": 276,
    "awayTeam": "Marshall",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      10,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.997101640729139,
    "awayPregameElo": 1517,
    "awayPostgameElo": 1611,
    "excitementIndex": 2.851599545,
    "highlights": "",
    "notes": "Sun Belt Championship"
  },
  {
    "id": 401673463,
    "season": 2024,
    "week": 15,
    "seasonType": "regular",
    "startDate": "2024-12-08T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 53808,
    "venueId": 3628,
    "venue": "Bank of America Stadium",
    "homeId": 2567,
    "homeTeam": "SMU",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 31,
    "homeLineScores": [
      7,
      0,
      7,
      17
    ],
    "homePostgameWinProbability": 0.5723337698666536,
    "homePregameElo": 1890,
    "homePostgameElo": 1886,
    "awayId": 228,
    "awayTeam": "Clemson",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 34,
    "awayLineScores": [
      21,
      3,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.42766623013334637,
    "awayPregameElo": 1811,
    "awayPostgameElo": 1815,
    "excitementIndex": 6.6590010605,
    "highlights": "",
    "notes": "ACC Championship"
  },
  {
    "id": 401673464,
    "season": 2024,
    "week": 15,
    "seasonType": "regular",
    "startDate": "2024-12-08T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 67469,
    "venueId": 3812,
    "venue": "Lucas Oil Stadium",
    "homeId": 2483,
    "homeTeam": "Oregon",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 45,
    "homeLineScores": [
      14,
      17,
      7,
      7
    ],
    "homePostgameWinProbability": 0.5853470565045124,
    "homePregameElo": 2060,
    "homePostgameElo": 2075,
    "awayId": 213,
    "awayTeam": "Penn State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 37,
    "awayLineScores": [
      10,
      14,
      0,
      13
    ],
    "awayPostgameWinProbability": 0.41465294349548765,
    "awayPregameElo": 2011,
    "awayPostgameElo": 1996,
    "excitementIndex": 6.1133501347,
    "highlights": "",
    "notes": "Big Ten Championship"
  },
  {
    "id": 401645383,
    "season": 2024,
    "week": 16,
    "seasonType": "regular",
    "startDate": "2024-12-14T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 60726,
    "venueId": 3719,
    "venue": "Northwest Stadium",
    "homeId": 349,
    "homeTeam": "Army",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 13,
    "homeLineScores": [
      0,
      7,
      3,
      3
    ],
    "homePostgameWinProbability": 0.027815874756800134,
    "homePregameElo": 1686,
    "homePostgameElo": 1630,
    "awayId": 2426,
    "awayTeam": "Navy",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      7,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.9721841252431999,
    "awayPregameElo": 1503,
    "awayPostgameElo": 1559,
    "excitementIndex": 3.2772498733,
    "highlights": "",
    "notes": null
  }
]